// This is an autogenerated file and should not be edited manually
export type PathArgs = {
  d: string;
  fill?: string;
  fillRule?: 'nonzero' | 'evenodd';
};

export type ColorIconDefinition = {
  paths: Array<PathArgs>;
};
export type MonoIconDefinition = {
  paths: Array<string | Omit<PathArgs, 'fill'>>;
};
export type IconSetDefinitions = {
  building_home: MonoIconDefinition;
  lightbulb: MonoIconDefinition;
  dashboard: MonoIconDefinition;
  heatmaps: MonoIconDefinition;
  recordings: MonoIconDefinition;
  feedback: MonoIconDefinition;
  surveys: MonoIconDefinition;
  trends: MonoIconDefinition;
  building_home_alt: MonoIconDefinition;
  lightbulb_alt: MonoIconDefinition;
  dashboard_alt: MonoIconDefinition;
  heatmaps_alt: MonoIconDefinition;
  recordings_alt: MonoIconDefinition;
  feedback_alt: MonoIconDefinition;
  surveys_alt: MonoIconDefinition;
  trends_alt: MonoIconDefinition;
  user_multiple: MonoIconDefinition;
  funnels: MonoIconDefinition;
  user_multiple_alt: MonoIconDefinition;
  funnels_alt: MonoIconDefinition;
  caret_left: MonoIconDefinition;
  caret_right: MonoIconDefinition;
  caret_down: MonoIconDefinition;
  caret_up: MonoIconDefinition;
  arrow_left: MonoIconDefinition;
  arrow_right: MonoIconDefinition;
  arrow_down: MonoIconDefinition;
  arrow_up: MonoIconDefinition;
  caret_left_alt: MonoIconDefinition;
  caret_right_alt: MonoIconDefinition;
  caret_down_alt: MonoIconDefinition;
  caret_up_alt: MonoIconDefinition;
  arrow_left_alt: MonoIconDefinition;
  arrow_right_alt: MonoIconDefinition;
  arrow_down_alt: MonoIconDefinition;
  arrow_up_alt: MonoIconDefinition;
  chevron_left: MonoIconDefinition;
  chevron_right: MonoIconDefinition;
  chevron_bottom: MonoIconDefinition;
  chevron_top: MonoIconDefinition;
  arrow_left_alone: MonoIconDefinition;
  arrow_right_alone: MonoIconDefinition;
  arrow_down_alone: MonoIconDefinition;
  arrow_up_alone: MonoIconDefinition;
  download: MonoIconDefinition;
  upload: MonoIconDefinition;
  transfer: MonoIconDefinition;
  flow: MonoIconDefinition;
  expand_left: MonoIconDefinition;
  expand_right: MonoIconDefinition;
  expand_down: MonoIconDefinition;
  expand_up: MonoIconDefinition;
  maximize: MonoIconDefinition;
  maximize_simple: MonoIconDefinition;
  minimize: MonoIconDefinition;
  minimize_simple: MonoIconDefinition;
  position_bottom_left: MonoIconDefinition;
  position_bottom_right: MonoIconDefinition;
  position_middle_left: MonoIconDefinition;
  position_middle_right: MonoIconDefinition;
  browser: MonoIconDefinition;
  date_time: MonoIconDefinition;
  code_dev: MonoIconDefinition;
  code_tracking: MonoIconDefinition;
  device_tablet: MonoIconDefinition;
  device_phone: MonoIconDefinition;
  device_desktop: MonoIconDefinition;
  unknown: MonoIconDefinition;
  device_multiple: MonoIconDefinition;
  user_single: MonoIconDefinition;
  team: MonoIconDefinition;
  user_success: MonoIconDefinition;
  user_attribute: MonoIconDefinition;
  user_add: MonoIconDefinition;
  user_single_alt: MonoIconDefinition;
  team_alt: MonoIconDefinition;
  menu_kebab: MonoIconDefinition;
  menu_kebab_alt: MonoIconDefinition;
  menu_kebab_horizontal: MonoIconDefinition;
  menu_kebab_horizontal_alt: MonoIconDefinition;
  lock: MonoIconDefinition;
  lock_open: MonoIconDefinition;
  list: MonoIconDefinition;
  hamburger: MonoIconDefinition;
  plus: MonoIconDefinition;
  minus: MonoIconDefinition;
  percent: MonoIconDefinition;
  hashtag: MonoIconDefinition;
  grid_1: MonoIconDefinition;
  grid_2: MonoIconDefinition;
  table: MonoIconDefinition;
  table_cols: MonoIconDefinition;
  film: MonoIconDefinition;
  search: MonoIconDefinition;
  zoom_in: MonoIconDefinition;
  zoom_out: MonoIconDefinition;
  toggles: MonoIconDefinition;
  cog: MonoIconDefinition;
  bell: MonoIconDefinition;
  email: MonoIconDefinition;
  page_empty: MonoIconDefinition;
  page_full: MonoIconDefinition;
  page_new: MonoIconDefinition;
  page_delete: MonoIconDefinition;
  duplicate: MonoIconDefinition;
  scale_up: MonoIconDefinition;
  scale_down: MonoIconDefinition;
  open_new_window: MonoIconDefinition;
  business: MonoIconDefinition;
  selected: MonoIconDefinition;
  close: MonoIconDefinition;
  response: MonoIconDefinition;
  trash: MonoIconDefinition;
  tray_empty: MonoIconDefinition;
  user_profile: MonoIconDefinition;
  server: MonoIconDefinition;
  comment: MonoIconDefinition;
  question: MonoIconDefinition;
  book_manual: MonoIconDefinition;
  book_address: MonoIconDefinition;
  form: MonoIconDefinition;
  form_valid: MonoIconDefinition;
  gift: MonoIconDefinition;
  box: MonoIconDefinition;
  copy: MonoIconDefinition;
  boolean: MonoIconDefinition;
  code: MonoIconDefinition;
  layers: MonoIconDefinition;
  key: MonoIconDefinition;
  image: MonoIconDefinition;
  camera: MonoIconDefinition;
  recordings_old: MonoIconDefinition;
  number: MonoIconDefinition;
  id: MonoIconDefinition;
  ip: MonoIconDefinition;
  string: MonoIconDefinition;
  metric: MonoIconDefinition;
  checkbox: MonoIconDefinition;
  event: MonoIconDefinition;
  date: MonoIconDefinition;
  chart_bar: MonoIconDefinition;
  chart_bar_horizontal: MonoIconDefinition;
  chart_line: MonoIconDefinition;
  chat_line_alt: MonoIconDefinition;
  chart_multiple: MonoIconDefinition;
  security: MonoIconDefinition;
  legal: MonoIconDefinition;
  navigate: MonoIconDefinition;
  lightning: MonoIconDefinition;
  puzzle: MonoIconDefinition;
  pencil: MonoIconDefinition;
  location: MonoIconDefinition;
  scissors: MonoIconDefinition;
  share: MonoIconDefinition;
  funnel: MonoIconDefinition;
  credit_card: MonoIconDefinition;
  building_business: MonoIconDefinition;
  building_agency: MonoIconDefinition;
  blog: MonoIconDefinition;
  audio: MonoIconDefinition;
  mute: MonoIconDefinition;
  announcement: MonoIconDefinition;
  bug: MonoIconDefinition;
  forward: MonoIconDefinition;
  directions: MonoIconDefinition;
  directions_alt: MonoIconDefinition;
  question_cards: MonoIconDefinition;
  tag: MonoIconDefinition;
  chat: MonoIconDefinition;
  highlight: MonoIconDefinition;
  send: MonoIconDefinition;
  continuous_capture: MonoIconDefinition;
  block: MonoIconDefinition;
  crosshair: MonoIconDefinition;
  off: MonoIconDefinition;
  chart_pie: MonoIconDefinition;
  site: MonoIconDefinition;
  time: MonoIconDefinition;
  time_back: MonoIconDefinition;
  stopwatch: MonoIconDefinition;
  target: MonoIconDefinition;
  target_hit: MonoIconDefinition;
  hidden: MonoIconDefinition;
  hidden_off: MonoIconDefinition;
  maintenance: MonoIconDefinition;
  trophy: MonoIconDefinition;
  book_open: MonoIconDefinition;
  thumbs_up_down: MonoIconDefinition;
  help: MonoIconDefinition;
  info: MonoIconDefinition;
  check: MonoIconDefinition;
  warning: MonoIconDefinition;
  star_empty: MonoIconDefinition;
  sidebar_right_close: MonoIconDefinition;
  sidebar_right_open: MonoIconDefinition;
  circle: MonoIconDefinition;
  webhooks: MonoIconDefinition;
  receipt: MonoIconDefinition;
  plug: MonoIconDefinition;
  help_alt: MonoIconDefinition;
  info_alt: MonoIconDefinition;
  check_alt: MonoIconDefinition;
  warning_alt: MonoIconDefinition;
  star_filled: MonoIconDefinition;
  sidebar_right_close_alt: MonoIconDefinition;
  sidebar_right_open_alt: MonoIconDefinition;
  circle_alt: MonoIconDefinition;
  user_avatar: MonoIconDefinition;
  thumbs_up: MonoIconDefinition;
  thumbs_down: MonoIconDefinition;
  pin: MonoIconDefinition;
  heart: MonoIconDefinition;
  crown: MonoIconDefinition;
  user_avatar_alt: MonoIconDefinition;
  thumbs_up_filled: MonoIconDefinition;
  thumbs_down_filled: MonoIconDefinition;
  pin_filled: MonoIconDefinition;
  heart_alt: MonoIconDefinition;
  crown_alt: MonoIconDefinition;
  time_alt: MonoIconDefinition;
  sun: MonoIconDefinition;
  moon: MonoIconDefinition;
  sparkle: MonoIconDefinition;
  flame: MonoIconDefinition;
  dead: MonoIconDefinition;
  rocketship: MonoIconDefinition;
  diamond: MonoIconDefinition;
  special_offer: MonoIconDefinition;
  record: MonoIconDefinition;
  play: MonoIconDefinition;
  pause: MonoIconDefinition;
  stop: MonoIconDefinition;
  rewind: MonoIconDefinition;
  previous: MonoIconDefinition;
  next: MonoIconDefinition;
  fast_forward: MonoIconDefinition;
  record_alt: MonoIconDefinition;
  play_alt: MonoIconDefinition;
  pause_alt: MonoIconDefinition;
  stop_alt: MonoIconDefinition;
  rewind_alt: MonoIconDefinition;
  previous_alt: MonoIconDefinition;
  next_alt: MonoIconDefinition;
  fast_forward_alt: MonoIconDefinition;
  jump_back: MonoIconDefinition;
  jump_back_10: MonoIconDefinition;
  jump_forward_10: MonoIconDefinition;
  jump_forward: MonoIconDefinition;
  shuffle: MonoIconDefinition;
  replay: MonoIconDefinition;
  replay_once: MonoIconDefinition;
  uturn: MonoIconDefinition;
  text_field_tall: MonoIconDefinition;
  text_field_short: MonoIconDefinition;
  text: MonoIconDefinition;
  select: MonoIconDefinition;
  rating_scale: MonoIconDefinition;
  radio_button: MonoIconDefinition;
  nps: MonoIconDefinition;
  tab: MonoIconDefinition;
  scroll: MonoIconDefinition;
  key_press: MonoIconDefinition;
  window_resize: MonoIconDefinition;
  finger_tap: MonoIconDefinition;
  rage_click: MonoIconDefinition;
  mad_mouse: MonoIconDefinition;
  cursor_click: MonoIconDefinition;
  cursor_move: MonoIconDefinition;
  cursor_select: MonoIconDefinition;
  bold: MonoIconDefinition;
  italic: MonoIconDefinition;
  underline: MonoIconDefinition;
  strikethrough: MonoIconDefinition;
  hyperlink: MonoIconDefinition;
  clear_formatting: MonoIconDefinition;
  translate: MonoIconDefinition;
  hate_smiley: MonoIconDefinition;
  dislike_smiley: MonoIconDefinition;
  neutral_smiley: MonoIconDefinition;
  like_smiley: MonoIconDefinition;
  love_smiley: MonoIconDefinition;
  hate_smiley_alt: MonoIconDefinition;
  dislike_smiley_alt: MonoIconDefinition;
  neutral_smiley_alt: MonoIconDefinition;
  like_smiley_alt: MonoIconDefinition;
  love_smiley_alt: MonoIconDefinition;
  hate: MonoIconDefinition;
  dislike: MonoIconDefinition;
  neutral: MonoIconDefinition;
  like: MonoIconDefinition;
  love: MonoIconDefinition;
  hate_alt: MonoIconDefinition;
  dislike_alt: MonoIconDefinition;
  neutral_alt: MonoIconDefinition;
  like_alt: MonoIconDefinition;
  love_alt: MonoIconDefinition;
  hotjar: MonoIconDefinition;
  npm: MonoIconDefinition;
  share_alt: MonoIconDefinition;
  support: MonoIconDefinition;
  chart_stacked: MonoIconDefinition;
  billing_usd: MonoIconDefinition;
  billing_gbp: MonoIconDefinition;
  billing_eur: MonoIconDefinition;
  billing_card: MonoIconDefinition;
  money_back_usd: MonoIconDefinition;
  money_back_eur: MonoIconDefinition;
  money_back_gbp: MonoIconDefinition;
  dropdown_caret: MonoIconDefinition;
  error: MonoIconDefinition;
  error_alt: MonoIconDefinition;
  android: ColorIconDefinition;
  apple: ColorIconDefinition;
  blackberry: ColorIconDefinition;
  linux: ColorIconDefinition;
  windows: ColorIconDefinition;
  ubuntu: ColorIconDefinition;
  chrome: ColorIconDefinition;
  chromium: ColorIconDefinition;
  edge: ColorIconDefinition;
  firefox: ColorIconDefinition;
  ms_ie: ColorIconDefinition;
  opera: ColorIconDefinition;
  safari: ColorIconDefinition;
  facebook: ColorIconDefinition;
  twitter: ColorIconDefinition;
  linkedin: ColorIconDefinition;
  slack: ColorIconDefinition;
  figma: ColorIconDefinition;
  zeroheight: ColorIconDefinition;
  storybook: ColorIconDefinition;
  miro: ColorIconDefinition;
  google: ColorIconDefinition;
  gmail: ColorIconDefinition;
  google_drive: ColorIconDefinition;
  google_analytics: ColorIconDefinition;
  google_tag_manager: ColorIconDefinition;
  google_optimize: ColorIconDefinition;
  google_optimize_alt: ColorIconDefinition;
  jira: ColorIconDefinition;
  confluence: ColorIconDefinition;
  trello: ColorIconDefinition;
  outlook: ColorIconDefinition;
  microsoft_teams: ColorIconDefinition;
  excel: ColorIconDefinition;
  optimizely: ColorIconDefinition;
  optimizely_alt: ColorIconDefinition;
  gitlab: ColorIconDefinition;
  omniconvert: ColorIconDefinition;
  segment: ColorIconDefinition;
  zapier_small: ColorIconDefinition;
  zapier: ColorIconDefinition;
  hubspot: ColorIconDefinition;
  woo_commerce: ColorIconDefinition;
  squarespace: ColorIconDefinition;
  magento: ColorIconDefinition;
  drupal: ColorIconDefinition;
  click_funnel: ColorIconDefinition;
  prestashop: ColorIconDefinition;
  shopify: ColorIconDefinition;
  wordpress: ColorIconDefinition;
  wix: ColorIconDefinition;
  mixpanel: ColorIconDefinition;
  unbounce: ColorIconDefinition;
  unbounce_alt: ColorIconDefinition;
  bug_label: ColorIconDefinition;
  ui_ux_issue_label: ColorIconDefinition;
  confusion_label: ColorIconDefinition;
  frustration_label: ColorIconDefinition;
  success_label: ColorIconDefinition;
  conversion_label: ColorIconDefinition;
};

export const icons: IconSetDefinitions = {
  building_home: {
    paths: [
      {
        d: 'M7.574.133a.75.75 0 0 1 .852 0l7.25 5A.75.75 0 0 1 15 6.457V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V6.457a.75.75 0 0 1-.676-1.324l7.25-5ZM2.5 5.455 2.5 5.5V13a.5.5 0 0 0 .5.5h2V9.25a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v4.25h2a.5.5 0 0 0 .5-.5V5.5l.001-.045-5.5-3.794-5.502 3.794ZM9.5 13.5V10h-3v3.5h3Z',
        fillRule: 'evenodd',
      },
    ],
  },
  lightbulb: {
    paths: [
      {
        d: 'M10.891 12.454a1 1 0 0 1-.437.437C10.24 13 9.96 13 9.4 13H6.6c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C5 12.24 5 11.96 5 11.4v-.203A6.012 6.012 0 0 1 2 6a6 6 0 1 1 9 5.197v.203c0 .56 0 .84-.109 1.054ZM10 10.032a4.501 4.501 0 1 0-4 0V11.5h1.25V8.503H6.5a.75.75 0 0 1 0-1.5h3a.75.75 0 1 1 0 1.5h-.75V11.5H10v-1.468Z',
        fillRule: 'evenodd',
      },
      'M5.75 14.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z',
    ],
  },
  dashboard: {
    paths: [
      {
        d: 'M5 2.5h-.8c-.585 0-.933.001-1.191.022-.158.013-.224.03-.242.036a.5.5 0 0 0-.21.209 1.254 1.254 0 0 0-.035.242c-.02.258-.022.606-.022 1.191V7a29.704 29.704 0 0 0 .003.497l.057.001c.121.002.262.002.44.002h2a29.704 29.704 0 0 0 .497-.003l.001-.057C5.5 7.319 5.5 7.178 5.5 7V3a29.704 29.704 0 0 0-.003-.497l-.057-.001A29.704 29.704 0 0 0 5 2.5Zm-3.782-.408C1 2.52 1 3.08 1 4.2V7c0 .7 0 1.05.136 1.317.12.236.311.427.547.547C1.95 9 2.3 9 3 9h2c.7 0 1.05 0 1.317-.136a1.25 1.25 0 0 0 .547-.547C7 8.05 7 7.7 7 7V3c0-.7 0-1.05-.136-1.317a1.25 1.25 0 0 0-.547-.547C6.05 1 5.7 1 5 1h-.8c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M13 8.5h-2a29.701 29.701 0 0 0-.497.003l-.001.057c-.002.121-.002.262-.002.44v4c0 .178 0 .319.002.44l.001.057.057.001c.121.002.262.002.44.002h.8c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .21-.209c.005-.018.022-.084.035-.242.02-.258.022-.606.022-1.191V9c0-.178 0-.319-.002-.44l-.001-.057-.057-.001A29.701 29.701 0 0 0 13 8.5Zm-3.864-.817C9 7.95 9 8.3 9 9v4c0 .7 0 1.05.136 1.318.12.235.311.426.547.546C9.95 15 10.3 15 11 15h.8c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C15 13.48 15 12.92 15 11.8V9c0-.7 0-1.05-.136-1.317a1.25 1.25 0 0 0-.546-.547C14.05 7 13.7 7 13 7h-2c-.7 0-1.05 0-1.317.136a1.25 1.25 0 0 0-.547.547Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M5 11.5H2.923c-.16 0-.286 0-.394.002h-.027v.027c-.002.108-.002.234-.002.394 0 .524 0 .836.018 1.069.01.143.024.203.029.22a.5.5 0 0 0 .242.241c.016.005.076.019.22.029.231.017.544.018 1.068.018H5c.178 0 .319 0 .44-.002l.057-.001.001-.057c.002-.121.002-.262.002-.44v-1a29.701 29.701 0 0 0-.003-.497l-.057-.001C5.319 11.5 5.178 11.5 5 11.5Zm-2.216 1.952h.002-.002Zm-.236-.236v-.002.002ZM1.11 10.737c-.11.245-.11.559-.11 1.186 0 1.004 0 1.506.176 1.898a2 2 0 0 0 1.003 1.003c.392.176.894.176 1.898.176H5c.7 0 1.05 0 1.317-.136a1.25 1.25 0 0 0 .547-.546C7 14.05 7 13.7 7 13v-1c0-.7 0-1.05-.136-1.318a1.25 1.25 0 0 0-.547-.546C6.05 10 5.7 10 5 10H2.923c-.628 0-.941 0-1.186.11a1.25 1.25 0 0 0-.627.627Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M11.923 2.5H11a29.701 29.701 0 0 0-.497.003l-.001.057c-.002.121-.002.262-.002.44v1c0 .178 0 .319.002.44l.001.057.057.001c.121.002.262.002.44.002h2.077a29.461 29.461 0 0 0 .421-.002v-.027c.002-.108.002-.234.002-.394 0-.524 0-.837-.018-1.069a1.265 1.265 0 0 0-.029-.22.5.5 0 0 0-.242-.241 1.271 1.271 0 0 0-.22-.029 16.615 16.615 0 0 0-1.068-.018Zm1.293.048h-.002.002Zm-4.08-.865C9 1.95 9 2.3 9 3v1c0 .7 0 1.05.136 1.317.12.236.311.427.547.547C9.95 6 10.3 6 11 6h2.077c.627 0 .941 0 1.186-.11a1.25 1.25 0 0 0 .627-.627c.11-.245.11-.558.11-1.186 0-1.004 0-1.506-.176-1.898a2 2 0 0 0-1.003-1.003C13.429 1 12.927 1 11.923 1H11c-.7 0-1.05 0-1.317.136a1.25 1.25 0 0 0-.547.547Z',
        fillRule: 'evenodd',
      },
    ],
  },
  heatmaps: {
    paths: [
      {
        d: 'M1.5 8A6.5 6.5 0 0 0 8 14.5h5.156c.522 0 .824-.001 1.045-.02.093-.007.144-.016.166-.02a.277.277 0 0 0 .092-.093c.005-.022.014-.073.022-.166.018-.221.019-.523.019-1.045V8a6.5 6.5 0 1 0-13 0ZM16 13.156V8a8 8 0 1 0-8 8h5.156c.995 0 1.493 0 1.873-.194.335-.17.607-.442.777-.777.194-.38.194-.878.194-1.873Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M12.056 10.556a1.5 1.5 0 0 1-1.5 1.5H8c-1.111 0-2.143-.397-2.9-1.155C4.341 10.143 3.943 9.11 3.943 8c0-1.05.322-2.09 1.078-2.878C5.787 4.322 6.845 3.944 8 3.944c1.155 0 2.213.38 2.979 1.178.755.788 1.077 1.829 1.077 2.878v2.556ZM10.556 8c0-1.5-.908-2.556-2.556-2.556C6.352 5.444 5.444 6.5 5.444 8S6.5 10.556 8 10.556h2.556V8Z',
        fillRule: 'evenodd',
      },
    ],
  },
  recordings: {
    paths: [
      {
        d: 'M13.288 1.771c-.254-.02-.585-.021-1.088-.021H8.875a.75.75 0 0 1 0-1.5h3.355c.464 0 .858 0 1.18.026.339.028.665.088.975.246a2.5 2.5 0 0 1 1.093 1.093c.158.31.218.636.246.975.026.322.026.716.026 1.18v7.789c-.002.033-.003.078-.007.134a6.092 6.092 0 0 1-.043.453 5.86 5.86 0 0 1-.354 1.382c-.204.512-.528 1.069-1.047 1.501-.532.444-1.228.721-2.099.721-1.698 0-2.944-1.06-3.93-1.9l-.034-.029c-1.086-.924-1.876-1.571-2.86-1.571-.996 0-1.685.42-2.254 1.023-.443.469-.77.992-1.103 1.525-.128.205-.258.412-.395.618a.75.75 0 1 1-1.248-.832c.091-.137.192-.298.302-.474.35-.562.798-1.28 1.353-1.867.774-.82 1.835-1.493 3.344-1.493 1.573 0 2.762 1.015 3.714 1.827l.119.102c1.065.906 1.91 1.571 2.992 1.571.53 0 .883-.16 1.139-.373.268-.224.47-.542.615-.905.144-.362.22-.735.259-1.024a4.568 4.568 0 0 0 .037-.429V3.8c0-.502 0-.834-.021-1.088-.02-.246-.055-.352-.088-.416a1 1 0 0 0-.437-.437c-.064-.033-.17-.068-.416-.088ZM1.345 1.345a.75.75 0 0 1 .767-.182l5.25 1.75a.75.75 0 0 1 .293 1.242l-1.22 1.22 2.533 2.532a.75.75 0 0 1-1.06 1.06L5.374 6.437l-1.22 1.22a.75.75 0 0 1-1.241-.294l-1.75-5.25a.75.75 0 0 1 .18-.767ZM3.06 3.06l.892 2.676 1.784-1.784L3.06 3.06Z',
        fillRule: 'evenodd',
      },
    ],
  },
  feedback: {
    paths: [
      {
        d: 'M3.47 4.72A.75.75 0 0 1 4 4.5h8a.75.75 0 0 1 .75.75 4.75 4.75 0 1 1-9.5 0 .75.75 0 0 1 .22-.53ZM4.837 6a3.251 3.251 0 0 0 6.326 0H4.837Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M12.8 1.5H3.2c-.585 0-.933.001-1.191.022-.158.013-.224.03-.242.036a.5.5 0 0 0-.21.209 1.254 1.254 0 0 0-.035.242c-.02.258-.022.606-.022 1.191V13.64l.176-.21.697-.827.037-.044c.13-.156.345-.414.624-.609a2.5 2.5 0 0 1 .785-.365c.33-.088.664-.086.868-.085H12.8c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .21-.209c.005-.018.022-.084.035-.242.02-.258.022-.606.022-1.191V3.2c0-.585-.001-.933-.022-1.191a1.252 1.252 0 0 0-.036-.242.5.5 0 0 0-.209-.21 1.255 1.255 0 0 0-.242-.035c-.258-.02-.606-.022-1.191-.022ZM.218 1.092C0 1.52 0 2.08 0 3.2v10.166c0 1.352 0 2.028.257 2.313a1 1 0 0 0 .881.321c.38-.052.815-.57 1.686-1.603l.697-.828c.176-.209.264-.314.372-.389.095-.066.201-.116.314-.146C4.334 13 4.47 13 4.744 13H12.8c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C16 11.48 16 10.92 16 9.8V3.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 0 13.92 0 12.8 0H3.2C2.08 0 1.52 0 1.092.218a2 2 0 0 0-.874.874Z',
        fillRule: 'evenodd',
      },
    ],
  },
  surveys: {
    paths: [
      {
        d: 'M11.969 6.664a.75.75 0 0 1 .117 1.055l-4 5a.75.75 0 0 1-1.116.061l-2-2a.75.75 0 1 1 1.06-1.06l1.408 1.407 3.476-4.346a.75.75 0 0 1 1.055-.117Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M1.75 3a.75.75 0 0 1 .75.75V14a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3.75a.75.75 0 0 1 1.5 0V14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3.75A.75.75 0 0 1 1.75 3Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M4.775 1C4.891.43 5.395 0 6 0h4c.605 0 1.11.43 1.225 1h.15C12.273 1 13 1.728 13 2.625v.625A1.75 1.75 0 0 1 11.25 5h-6.5A1.75 1.75 0 0 1 3 3.25v-.625C3 1.728 3.728 1 4.625 1h.15Zm1.45.5c-.116.57-.62 1-1.225 1h-.375a.125.125 0 0 0-.125.125v.625c0 .138.112.25.25.25h6.5a.25.25 0 0 0 .25-.25v-.625a.125.125 0 0 0-.125-.125H11a1.25 1.25 0 0 1-1.225-1h-3.55Z',
        fillRule: 'evenodd',
      },
    ],
  },
  trends: {
    paths: [
      {
        d: 'M11.8 2.5H4.2c-.585 0-.933.001-1.191.022-.158.013-.224.03-.242.036a.5.5 0 0 0-.21.209 1.254 1.254 0 0 0-.035.242c-.02.258-.022.606-.022 1.191v7.6c0 .585.001.933.022 1.191.013.158.03.224.036.242a.5.5 0 0 0 .209.21c.018.005.084.022.242.035.258.02.606.022 1.191.022h7.6c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .21-.209c.005-.018.022-.084.035-.242.02-.258.022-.606.022-1.191V4.2c0-.585-.001-.933-.022-1.191a1.252 1.252 0 0 0-.036-.242.5.5 0 0 0-.209-.21 1.255 1.255 0 0 0-.242-.035c-.258-.02-.606-.022-1.191-.022ZM1.218 2.092C1 2.52 1 3.08 1 4.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C2.52 15 3.08 15 4.2 15h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C15 13.48 15 12.92 15 11.8V4.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C13.48 1 12.92 1 11.8 1H4.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M5.547 7.23a1.25 1.25 0 0 1 1.918-.402l1.753 1.46 1.597-3.593a.75.75 0 0 1 1.37.61L10.455 9.2a1.25 1.25 0 0 1-1.943.453l-1.765-1.47-1.576 3.152a.75.75 0 0 1-1.342-.67l1.718-3.436Z',
        fillRule: 'evenodd',
      },
    ],
  },
  building_home_alt: {
    paths: [
      {
        d: 'M8.426.133a.75.75 0 0 0-.852 0l-7.25 5A.75.75 0 0 0 1 6.457V13a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6.457a.75.75 0 0 0 .676-1.324l-7.25-5ZM10 13.5V10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v3.5h4Z',
        fillRule: 'evenodd',
      },
    ],
  },
  lightbulb_alt: {
    paths: [
      {
        d: 'M10.866 12.5a.97.97 0 0 0 .025-.046C11 12.24 11 11.96 11 11.4v-.203a6 6 0 1 0-6 0v.203c0 .56 0 .84.109 1.054a.998.998 0 0 0 .437.437C5.76 13 6.04 13 6.6 13h.65V8.5H6.5a.75.75 0 0 1 0-1.5h3a.75.75 0 0 1 0 1.5h-.75V13h.65c.56 0 .84 0 1.054-.109a1 1 0 0 0 .412-.391Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M5 15.25a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Z',
        fillRule: 'evenodd',
      },
    ],
  },
  dashboard_alt: {
    paths: [
      'M1 4.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C2.52 1 3.08 1 4.2 1H5c.7 0 1.05 0 1.317.136.236.12.427.311.547.547C7 1.95 7 2.3 7 3v4c0 .7 0 1.05-.136 1.317a1.25 1.25 0 0 1-.547.547C6.05 9 5.7 9 5 9H3c-.7 0-1.05 0-1.317-.136a1.25 1.25 0 0 1-.547-.547C1 8.05 1 7.7 1 7V4.2Z',
      'M9 9c0-.7 0-1.05.136-1.317a1.25 1.25 0 0 1 .547-.547C9.95 7 10.3 7 11 7h2c.7 0 1.05 0 1.318.136.235.12.426.311.546.547C15 7.95 15 8.3 15 9v2.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C13.48 15 12.92 15 11.8 15H11c-.7 0-1.05 0-1.317-.136a1.25 1.25 0 0 1-.547-.546C9 14.05 9 13.7 9 13V9Z',
      'M1 11.923c0-.627 0-.941.11-1.186a1.25 1.25 0 0 1 .627-.627c.245-.11.558-.11 1.186-.11H5c.7 0 1.05 0 1.317.136.236.12.427.311.547.546C7 10.95 7 11.3 7 12v1c0 .7 0 1.05-.136 1.318a1.25 1.25 0 0 1-.547.546C6.05 15 5.7 15 5 15h-.923c-1.004 0-1.506 0-1.898-.176a2 2 0 0 1-1.003-1.003C1 13.429 1 12.927 1 11.923Z',
      'M9 3c0-.7 0-1.05.136-1.317a1.25 1.25 0 0 1 .547-.547C9.95 1 10.3 1 11 1h.923c1.004 0 1.506 0 1.898.176a2 2 0 0 1 1.003 1.003c.176.392.176.894.176 1.898 0 .628 0 .941-.11 1.186a1.25 1.25 0 0 1-.627.627c-.245.11-.559.11-1.186.11H11c-.7 0-1.05 0-1.317-.136a1.25 1.25 0 0 1-.547-.547C9 5.05 9 4.7 9 4V3Z',
    ],
  },
  heatmaps_alt: {
    paths: [
      {
        d: 'M16 13.156V8a8 8 0 1 0-8 8h5.156c.995 0 1.493 0 1.873-.194.335-.17.607-.442.777-.777.194-.38.194-.878.194-1.873ZM12 12V8a4 4 0 1 0-4 4h4Z',
        fillRule: 'evenodd',
      },
    ],
  },
  recordings_alt: {
    paths: [
      'M12.239 0H8.875a1 1 0 0 0 0 2H12.2c.507 0 .826 0 1.068.02.23.02.3.05.322.062a.75.75 0 0 1 .328.328c.012.022.043.092.061.322.02.242.02.561.02 1.068v7.713c0 .017 0 .044-.003.08a4.282 4.282 0 0 1-.031.322 4.115 4.115 0 0 1-.244.964c-.135.338-.316.617-.543.806-.209.174-.506.315-.978.315-.975 0-1.752-.594-2.83-1.511l-.142-.122c-.937-.8-2.187-1.867-3.853-1.867-1.595 0-2.718.716-3.526 1.571-.572.606-1.03 1.34-1.379 1.899l-.004.007c-.111.178-.21.335-.298.468a1 1 0 0 0 1.664 1.11c.14-.21.27-.419.398-.623v-.002c.336-.536.65-1.038 1.073-1.486.535-.566 1.162-.944 2.072-.944.433 0 .832.14 1.263.403.436.265.89.644 1.436 1.108l.055.048c.974.829 2.28 1.941 4.07 1.941.929 0 1.682-.297 2.26-.779.56-.467.905-1.063 1.12-1.6a6.101 6.101 0 0 0 .368-1.442 6.323 6.323 0 0 0 .052-.613V3.761c0-.457 0-.86-.026-1.192-.03-.354-.094-.716-.273-1.067A2.75 2.75 0 0 0 14.498.3c-.351-.18-.714-.244-1.067-.273A15.687 15.687 0 0 0 12.239 0Z',
      'M2.112 1.164a.75.75 0 0 0-.949.948l1.75 5.25a.75.75 0 0 0 1.242.293l1.22-1.22 2.532 2.533a.75.75 0 0 0 1.06-1.06L6.436 5.374l1.22-1.22a.75.75 0 0 0-.293-1.241l-5.25-1.75Z',
    ],
  },
  feedback_alt: {
    paths: [
      {
        d: 'M0 3.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C1.52 0 2.08 0 3.2 0h9.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 1.52 16 2.08 16 3.2v6.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 13 13.92 13 12.8 13H4.744c-.273 0-.41 0-.537.034-.113.03-.219.08-.314.146-.108.075-.196.18-.372.39l-.697.827c-.87 1.034-1.306 1.55-1.686 1.603a1 1 0 0 1-.881-.321C0 15.394 0 14.718 0 13.366V3.2ZM11.001 5c.553 0 1.012.455.876.99a4.002 4.002 0 0 1-7.754 0C3.987 5.455 4.446 5 5 5H11Z',
        fillRule: 'evenodd',
      },
    ],
  },
  surveys_alt: {
    paths: [
      {
        d: 'M2 3h.5v1a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V3h.5c.5 0 1 .5 1 1v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V4c0-.5.5-1 1-1ZM12.086 7.72a.75.75 0 0 0-1.172-.937l-3.476 4.345L6.03 9.72a.75.75 0 0 0-1.06 1.06l2 2a.75.75 0 0 0 1.116-.061l4-5Z',
        fillRule: 'evenodd',
      },
      'M10.5.75A.75.75 0 0 0 9.75 0h-3.5a.75.75 0 0 0-.75.75.75.75 0 0 1-.75.75H4.5a1 1 0 0 0-1 1V3a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-.5a1 1 0 0 0-1-1h-.25a.75.75 0 0 1-.75-.75Z',
    ],
  },
  trends_alt: {
    paths: [
      {
        d: 'M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2H3Zm4.465 5.828a1.25 1.25 0 0 0-1.918.401l-1.718 3.436a.75.75 0 1 0 1.342.67l1.576-3.153 1.765 1.47a1.25 1.25 0 0 0 1.942-.452l1.731-3.895a.75.75 0 1 0-1.37-.61L9.218 8.29 7.465 6.828Z',
        fillRule: 'evenodd',
      },
    ],
  },
  user_multiple: {
    paths: [
      {
        d: 'M6 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM4.5 4a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z',
        fillRule: 'evenodd',
      },
      'M9.88 2.505A1.5 1.5 0 1 1 10 5.5.75.75 0 0 0 10 7a3 3 0 1 0-.238-5.99.75.75 0 1 0 .118 1.495Z',
      {
        d: 'M.105 13.118C.623 10.338 3.028 8 6 8c2.972 0 5.377 2.338 5.895 5.118C12.1 14.217 11.17 15 10.25 15h-8.5C.83 15-.1 14.217.105 13.118ZM6 9.5c-2.154 0-4.016 1.725-4.42 3.893-.003.014-.001.02 0 .022a.071.071 0 0 0 .017.027c.026.028.08.058.153.058h8.5c.073 0 .127-.03.153-.058a.07.07 0 0 0 .018-.026c0-.003.002-.008 0-.023C10.016 11.225 8.154 9.5 6 9.5Z',
        fillRule: 'evenodd',
      },
      'M12.307 8.498a.75.75 0 0 0-.614 1.368c1.383.62 2.437 1.97 2.727 3.527.003.015.001.02 0 .023a.072.072 0 0 1-.017.026.213.213 0 0 1-.153.058h-.5a.75.75 0 0 0 0 1.5h.5c.92 0 1.85-.783 1.645-1.882-.377-2.024-1.742-3.792-3.588-4.62Z',
    ],
  },
  funnels: {
    paths: [
      {
        d: 'M3.5 13V3a29.704 29.704 0 0 0-.003-.497l-.057-.001A29.704 29.704 0 0 0 3 2.5a29.704 29.704 0 0 0-.497.003l-.001.057C2.5 2.681 2.5 2.822 2.5 3v10a29.701 29.701 0 0 0 .003.497l.057.001c.121.002.262.002.44.002s.319 0 .44-.002l.057-.001.001-.057c.002-.121.002-.262.002-.44ZM1.136 1.683C1 1.95 1 2.3 1 3v10c0 .7 0 1.05.136 1.318.12.235.311.426.547.546C1.95 15 2.3 15 3 15s1.05 0 1.317-.136a1.25 1.25 0 0 0 .547-.546C5 14.05 5 13.7 5 13V3c0-.7 0-1.05-.136-1.317a1.25 1.25 0 0 0-.547-.547C4.05 1 3.7 1 3 1s-1.05 0-1.317.136a1.25 1.25 0 0 0-.547.547Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M8.5 13V6a29.704 29.704 0 0 0-.003-.497l-.057-.001A29.704 29.704 0 0 0 8 5.5a29.704 29.704 0 0 0-.497.003l-.001.057C7.5 5.681 7.5 5.822 7.5 6v7a29.701 29.701 0 0 0 .003.497l.057.001c.121.002.262.002.44.002s.319 0 .44-.002l.057-.001.001-.057c.002-.121.002-.262.002-.44ZM6.136 4.683C6 4.95 6 5.3 6 6v7c0 .7 0 1.05.136 1.318.12.235.311.426.547.546C6.95 15 7.3 15 8 15s1.05 0 1.317-.136a1.25 1.25 0 0 0 .547-.546C10 14.05 10 13.7 10 13V6c0-.7 0-1.05-.136-1.317a1.25 1.25 0 0 0-.547-.547C9.05 4 8.7 4 8 4s-1.05 0-1.317.136a1.25 1.25 0 0 0-.547.547Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M13.5 13v-3c0-.178 0-.319-.002-.44l-.001-.057-.057-.001A29.701 29.701 0 0 0 13 9.5a29.701 29.701 0 0 0-.497.003l-.001.057c-.002.121-.002.262-.002.44v3c0 .178 0 .319.002.44l.001.057.057.001c.121.002.262.002.44.002s.319 0 .44-.002l.057-.001.001-.057c.002-.121.002-.262.002-.44Zm-2.364-4.317C11 8.95 11 9.3 11 10v3c0 .7 0 1.05.136 1.318.12.235.311.426.546.546C11.95 15 12.3 15 13 15c.7 0 1.05 0 1.318-.136a1.25 1.25 0 0 0 .546-.546C15 14.05 15 13.7 15 13v-3c0-.7 0-1.05-.136-1.317a1.25 1.25 0 0 0-.546-.547C14.05 8 13.7 8 13 8c-.7 0-1.05 0-1.318.136a1.25 1.25 0 0 0-.546.547Z',
        fillRule: 'evenodd',
      },
    ],
  },
  user_multiple_alt: {
    paths: [
      {
        d: 'M6 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z',
        fillRule: 'evenodd',
      },
      'M9.88 2.505A1.5 1.5 0 1 1 10 5.5.75.75 0 0 0 10 7a3 3 0 1 0-.238-5.99.75.75 0 1 0 .118 1.495Z',
      {
        d: 'M.105 13.118C.623 10.338 3.028 8 6 8c2.972 0 5.377 2.338 5.895 5.118C12.1 14.217 11.17 15 10.25 15h-8.5C.83 15-.1 14.217.105 13.118Z',
        fillRule: 'evenodd',
      },
      'M12.307 8.498a.75.75 0 0 0-.614 1.368c1.383.62 2.437 1.97 2.727 3.527.003.015.001.02 0 .023a.072.072 0 0 1-.017.026.213.213 0 0 1-.153.058h-.5a.75.75 0 0 0 0 1.5h.5c.92 0 1.85-.783 1.645-1.882-.377-2.024-1.742-3.792-3.588-4.62Z',
    ],
  },
  funnels_alt: {
    paths: [
      {
        d: 'M1.136 1.683C1 1.95 1 2.3 1 3v10c0 .7 0 1.05.136 1.318.12.235.311.426.547.546C1.95 15 2.3 15 3 15s1.05 0 1.317-.136a1.25 1.25 0 0 0 .547-.546C5 14.05 5 13.7 5 13V3c0-.7 0-1.05-.136-1.317a1.25 1.25 0 0 0-.547-.547C4.05 1 3.7 1 3 1s-1.05 0-1.317.136a1.25 1.25 0 0 0-.547.547Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M6.136 4.683C6 4.95 6 5.3 6 6v7c0 .7 0 1.05.136 1.318.12.235.311.426.547.546C6.95 15 7.3 15 8 15s1.05 0 1.317-.136a1.25 1.25 0 0 0 .547-.546C10 14.05 10 13.7 10 13V6c0-.7 0-1.05-.136-1.317a1.25 1.25 0 0 0-.547-.547C9.05 4 8.7 4 8 4s-1.05 0-1.317.136a1.25 1.25 0 0 0-.547.547Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M11.136 8.683C11 8.95 11 9.3 11 10v3c0 .7 0 1.05.136 1.318.12.235.311.426.546.546C11.95 15 12.3 15 13 15c.7 0 1.05 0 1.318-.136a1.25 1.25 0 0 0 .546-.546C15 14.05 15 13.7 15 13v-3c0-.7 0-1.05-.136-1.317a1.25 1.25 0 0 0-.546-.547C14.05 8 13.7 8 13 8c-.7 0-1.05 0-1.318.136a1.25 1.25 0 0 0-.546.547Z',
        fillRule: 'evenodd',
      },
    ],
  },
  caret_left: {
    paths: [
      {
        d: 'M10.325 3.324A.75.75 0 0 1 10.75 4v8a.75.75 0 0 1-1.219.586l-5-4a.75.75 0 0 1 0-1.172l5-4a.75.75 0 0 1 .794-.09ZM9.25 5.56 6.2 8l3.05 2.44V5.56Z',
        fillRule: 'evenodd',
      },
    ],
  },
  caret_right: {
    paths: [
      {
        d: 'M5.675 12.676A.75.75 0 0 1 5.25 12V4a.75.75 0 0 1 1.219-.586l5 4a.75.75 0 0 1 0 1.172l-5 4a.75.75 0 0 1-.794.09ZM6.75 10.44 9.8 8 6.75 5.56v4.88Z',
        fillRule: 'evenodd',
      },
    ],
  },
  caret_down: {
    paths: [
      {
        d: 'M3.324 5.675A.75.75 0 0 1 4 5.25h8a.75.75 0 0 1 .586 1.219l-4 5a.75.75 0 0 1-1.172 0l-4-5a.75.75 0 0 1-.09-.794ZM5.56 6.75 8 9.8l2.44-3.05H5.56Z',
        fillRule: 'evenodd',
      },
    ],
  },
  caret_up: {
    paths: [
      {
        d: 'M3.324 10.325A.75.75 0 0 0 4 10.75h8a.75.75 0 0 0 .586-1.219l-4-5a.75.75 0 0 0-1.172 0l-4 5a.75.75 0 0 0-.09.794ZM5.56 9.25 8 6.2l2.44 3.05H5.56Z',
        fillRule: 'evenodd',
      },
    ],
  },
  arrow_left: {
    paths: [
      {
        d: 'M8 14.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13ZM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M7.53 11.53a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 0-1.06l3-3a.75.75 0 0 1 1.06 1.06L5.81 7.25H12a.75.75 0 0 1 0 1.5H5.81l1.72 1.72a.75.75 0 0 1 0 1.06Z',
        fillRule: 'evenodd',
      },
    ],
  },
  arrow_right: {
    paths: [
      {
        d: 'M8 14.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13ZM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M8.47 4.47a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 0 1-1.06-1.06l1.72-1.72H4a.75.75 0 0 1 0-1.5h6.19L8.47 5.53a.75.75 0 0 1 0-1.06Z',
        fillRule: 'evenodd',
      },
    ],
  },
  arrow_down: {
    paths: [
      {
        d: 'M8 14.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13ZM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M11.53 8.47a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 0 1 1.06-1.06l1.72 1.72V4a.75.75 0 0 1 1.5 0v6.19l1.72-1.72a.75.75 0 0 1 1.06 0Z',
        fillRule: 'evenodd',
      },
    ],
  },
  arrow_up: {
    paths: [
      {
        d: 'M8 14.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13ZM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M4.47 7.53a.75.75 0 0 1 0-1.06l3-3a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1-1.06 1.06L8.75 5.81V12a.75.75 0 0 1-1.5 0V5.81L5.53 7.53a.75.75 0 0 1-1.06 0Z',
        fillRule: 'evenodd',
      },
    ],
  },
  caret_left_alt: {
    paths: [
      'm9.419 11.87-4.28-3.056a1 1 0 0 1 0-1.628L9.42 4.13A1 1 0 0 1 11 4.943v6.114a1 1 0 0 1-1.581.814Z',
    ],
  },
  caret_right_alt: {
    paths: [
      'm7.081 4.13 4.28 3.056a1 1 0 0 1 0 1.628L7.08 11.87a1 1 0 0 1-1.581-.813V4.943a1 1 0 0 1 1.581-.814Z',
    ],
  },
  caret_down_alt: {
    paths: [
      'm11.87 6.581-3.056 4.28a1 1 0 0 1-1.628 0L4.13 6.58A1 1 0 0 1 4.943 5h6.114a1 1 0 0 1 .813 1.581Z',
    ],
  },
  caret_up_alt: {
    paths: [
      'm4.13 9.419 3.056-4.28a1 1 0 0 1 1.628 0l3.057 4.28A1 1 0 0 1 11.057 11H4.943a1 1 0 0 1-.814-1.581Z',
    ],
  },
  arrow_left_alt: {
    paths: [
      {
        d: 'M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-9.53 3.53a.75.75 0 0 0 1.06-1.06L5.81 8.75H12a.75.75 0 0 0 0-1.5H5.81l1.72-1.72a.75.75 0 0 0-1.06-1.06l-3 3a.75.75 0 0 0 0 1.06l3 3Z',
        fillRule: 'evenodd',
      },
    ],
  },
  arrow_right_alt: {
    paths: [
      {
        d: 'M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM9.53 4.47a.75.75 0 0 0-1.06 1.06l1.72 1.72H4a.75.75 0 0 0 0 1.5h6.19l-1.72 1.72a.75.75 0 1 0 1.06 1.06l3-3a.75.75 0 0 0 0-1.06l-3-3Z',
        fillRule: 'evenodd',
      },
    ],
  },
  arrow_down_alt: {
    paths: [
      {
        d: 'M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-4.47 1.53a.75.75 0 0 0-1.06-1.06l-1.72 1.72V4a.75.75 0 0 0-1.5 0v6.19L5.53 8.47a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l3-3Z',
        fillRule: 'evenodd',
      },
    ],
  },
  arrow_up_alt: {
    paths: [
      {
        d: 'M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM4.47 6.47a.75.75 0 0 0 1.06 1.06l1.72-1.72V12a.75.75 0 0 0 1.5 0V5.81l1.72 1.72a.75.75 0 1 0 1.06-1.06l-3-3a.75.75 0 0 0-1.06 0l-3 3Z',
        fillRule: 'evenodd',
      },
    ],
  },
  chevron_left: {
    paths: [
      {
        d: 'M11.53 15.53a.75.75 0 0 1-1.06 0l-7-7a.75.75 0 0 1 0-1.06l7-7a.75.75 0 1 1 1.06 1.06L5.06 8l6.47 6.47a.75.75 0 0 1 0 1.06Z',
        fillRule: 'evenodd',
      },
    ],
  },
  chevron_right: {
    paths: [
      {
        d: 'M4.47.47a.75.75 0 0 1 1.06 0l7 7a.75.75 0 0 1 0 1.06l-7 7a.75.75 0 0 1-1.06-1.06L10.94 8 4.47 1.53a.75.75 0 0 1 0-1.06Z',
        fillRule: 'evenodd',
      },
    ],
  },
  chevron_bottom: {
    paths: [
      {
        d: 'M15.53 4.47a.75.75 0 0 1 0 1.06l-7 7a.75.75 0 0 1-1.06 0l-7-7a.75.75 0 0 1 1.06-1.06L8 10.94l6.47-6.47a.75.75 0 0 1 1.06 0Z',
        fillRule: 'evenodd',
      },
    ],
  },
  chevron_top: {
    paths: [
      {
        d: 'M.47 11.53a.75.75 0 0 1 0-1.06l7-7a.75.75 0 0 1 1.06 0l7 7a.75.75 0 1 1-1.06 1.06L8 5.06l-6.47 6.47a.75.75 0 0 1-1.06 0Z',
        fillRule: 'evenodd',
      },
    ],
  },
  arrow_left_alone: {
    paths: [
      {
        d: 'M7.122 13.538a.75.75 0 0 1-1.06-.016l-4.85-5a.75.75 0 0 1 0-1.044l4.85-5a.75.75 0 1 1 1.076 1.044L3.522 7.25H14.25a.75.75 0 0 1 0 1.5H3.522l3.616 3.728a.75.75 0 0 1-.016 1.06Z',
        fillRule: 'evenodd',
      },
    ],
  },
  arrow_right_alone: {
    paths: [
      {
        d: 'M8.878 2.462a.75.75 0 0 1 1.06.016l4.85 5a.75.75 0 0 1 0 1.044l-4.85 5a.75.75 0 0 1-1.076-1.044l3.616-3.728H1.75a.75.75 0 0 1 0-1.5h10.728L8.862 3.522a.75.75 0 0 1 .016-1.06Z',
        fillRule: 'evenodd',
      },
    ],
  },
  arrow_down_alone: {
    paths: [
      {
        d: 'M13.538 8.878a.75.75 0 0 1-.016 1.06l-5 4.85a.75.75 0 0 1-1.044 0l-5-4.85a.75.75 0 1 1 1.044-1.076l3.728 3.616V1.75a.75.75 0 0 1 1.5 0v10.728l3.728-3.616a.75.75 0 0 1 1.06.016Z',
        fillRule: 'evenodd',
      },
    ],
  },
  arrow_up_alone: {
    paths: [
      {
        d: 'M2.462 7.122a.75.75 0 0 1 .016-1.06l5-4.85a.75.75 0 0 1 1.044 0l5 4.85a.75.75 0 0 1-1.044 1.076L8.75 3.522V14.25a.75.75 0 0 1-1.5 0V3.522L3.522 7.138a.75.75 0 0 1-1.06-.016Z',
        fillRule: 'evenodd',
      },
    ],
  },
  download: {
    paths: [
      {
        d: 'M12.53 6.47a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 1.06-1.06l2.72 2.72V1a.75.75 0 0 1 1.5 0v8.19l2.72-2.72a.75.75 0 0 1 1.06 0Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M1 9.25a.75.75 0 0 1 .75.75v1.8c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h7.6c.572 0 .957 0 1.252-.025.288-.023.425-.065.516-.111a1.25 1.25 0 0 0 .546-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253V10a.75.75 0 0 1 1.5 0v1.83c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.201 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.17c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 .55 14.25c-.172-.338-.24-.694-.27-1.074-.03-.365-.03-.81-.03-1.345V10A.75.75 0 0 1 1 9.25Z',
        fillRule: 'evenodd',
      },
    ],
  },
  upload: {
    paths: [
      {
        d: 'M3.47 5.53a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1-1.06 1.06L8.75 2.81V11a.75.75 0 0 1-1.5 0V2.81L4.53 5.53a.75.75 0 0 1-1.06 0Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M1 9.25a.75.75 0 0 1 .75.75v1.8c0 .572 0 .957.025 1.252.023.288.065.425.111.516.12.235.311.426.547.546.09.046.227.088.514.111.296.024.68.025 1.253.025h7.6c.572 0 .957 0 1.252-.025.288-.023.425-.065.516-.111a1.25 1.25 0 0 0 .546-.546c.046-.091.088-.228.111-.515.024-.296.025-.68.025-1.253V10a.75.75 0 0 1 1.5 0v1.83c0 .535 0 .98-.03 1.345-.03.38-.098.736-.27 1.073a2.751 2.751 0 0 1-1.201 1.202c-.338.172-.694.24-1.074.27-.365.03-.81.03-1.345.03H4.17c-.535 0-.98 0-1.345-.03-.38-.03-.736-.098-1.073-.27A2.75 2.75 0 0 1 .55 14.25c-.172-.338-.24-.694-.27-1.074-.03-.365-.03-.81-.03-1.345V10A.75.75 0 0 1 1 9.25Z',
        fillRule: 'evenodd',
      },
    ],
  },
  transfer: {
    paths: [
      {
        d: 'M7 15.75a.75.75 0 0 1-.75-.75v-5a.75.75 0 0 1 1.5 0v3.19l6.72-6.72a.75.75 0 1 1 1.06 1.06l-6.72 6.72H12a.75.75 0 0 1 0 1.5H7Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M9 .25a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0V2.81L1.53 9.53A.75.75 0 0 1 .47 8.47l6.72-6.72H4a.75.75 0 0 1 0-1.5h5Z',
        fillRule: 'evenodd',
      },
    ],
  },
  flow: {
    paths: [
      {
        d: 'M.25 1A.75.75 0 0 1 1 .25h12A2.75 2.75 0 0 1 15.75 3v1A2.75 2.75 0 0 1 13 6.75H3c-.69 0-1.25.56-1.25 1.25v2c0 .69.56 1.25 1.25 1.25h10.19l-1.72-1.72a.75.75 0 0 1 1.06-1.06l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l1.72-1.72H3A2.75 2.75 0 0 1 .25 10V8A2.75 2.75 0 0 1 3 5.25h10c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H1A.75.75 0 0 1 .25 1Z',
        fillRule: 'evenodd',
      },
    ],
  },
  expand_left: {
    paths: [
      {
        d: 'M8.53 12.53a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 1.06L5.81 7.25H15a.75.75 0 0 1 0 1.5H5.81l2.72 2.72a.75.75 0 0 1 0 1.06Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M1 2.25a.75.75 0 0 1 .75.75v10a.75.75 0 0 1-1.5 0V3A.75.75 0 0 1 1 2.25Z',
        fillRule: 'evenodd',
      },
    ],
  },
  expand_right: {
    paths: [
      {
        d: 'M7.47 3.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06-1.06l2.72-2.72H1a.75.75 0 0 1 0-1.5h9.19L7.47 4.53a.75.75 0 0 1 0-1.06Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M15 2.25a.75.75 0 0 1 .75.75v10a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75Z',
        fillRule: 'evenodd',
      },
    ],
  },
  expand_down: {
    paths: [
      {
        d: 'M12.53 7.47a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 1.06-1.06l2.72 2.72V1a.75.75 0 0 1 1.5 0v9.19l2.72-2.72a.75.75 0 0 1 1.06 0Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M2.25 15a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75Z',
        fillRule: 'evenodd',
      },
    ],
  },
  expand_up: {
    paths: [
      {
        d: 'M3.47 8.53a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1-1.06 1.06L8.75 5.81V15a.75.75 0 0 1-1.5 0V5.81L4.53 8.53a.75.75 0 0 1-1.06 0Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M2.25 1A.75.75 0 0 1 3 .25h10a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 1Z',
        fillRule: 'evenodd',
      },
    ],
  },
  maximize: {
    paths: [
      {
        d: 'M10.25 1A.75.75 0 0 1 11 .25h4a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V2.81l-3.72 3.72a.75.75 0 1 1-1.06-1.06l3.72-3.72H11a.75.75 0 0 1-.75-.75Zm-10 0A.75.75 0 0 1 1 .25h4a.75.75 0 0 1 0 1.5H2.81l3.72 3.72a.75.75 0 0 1-1.06 1.06L1.75 2.81V5a.75.75 0 0 1-1.5 0V1Zm9.22 8.47a.75.75 0 0 1 1.06 0l3.72 3.72V11a.75.75 0 0 1 1.5 0v4a.75.75 0 0 1-.75.75h-4a.75.75 0 0 1 0-1.5h2.19l-3.72-3.72a.75.75 0 0 1 0-1.06Zm-2.94 0a.75.75 0 0 1 0 1.06l-3.72 3.72H5a.75.75 0 0 1 0 1.5H1A.75.75 0 0 1 .25 15v-4a.75.75 0 0 1 1.5 0v2.19l3.72-3.72a.75.75 0 0 1 1.06 0Z',
        fillRule: 'evenodd',
      },
    ],
  },
  maximize_simple: {
    paths: [
      {
        d: 'M10.25 1A.75.75 0 0 1 11 .25h4a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V2.81l-3.72 3.72a.75.75 0 1 1-1.06-1.06l3.72-3.72H11a.75.75 0 0 1-.75-.75ZM6.53 9.47a.75.75 0 0 1 0 1.06l-3.72 3.72H5a.75.75 0 0 1 0 1.5H1A.75.75 0 0 1 .25 15v-4a.75.75 0 0 1 1.5 0v2.19l3.72-3.72a.75.75 0 0 1 1.06 0Z',
        fillRule: 'evenodd',
      },
    ],
  },
  minimize: {
    paths: [
      {
        d: 'M6.75 6a.75.75 0 0 1-.75.75H2a.75.75 0 0 1 0-1.5h2.19L.47 1.53A.75.75 0 0 1 1.53.47l3.72 3.72V2a.75.75 0 0 1 1.5 0v4Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M6.75 10A.75.75 0 0 0 6 9.25H2a.75.75 0 0 0 0 1.5h2.19L.47 14.47a.75.75 0 1 0 1.06 1.06l3.72-3.72V14a.75.75 0 0 0 1.5 0v-4Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M9.25 6c0 .414.336.75.75.75h4a.75.75 0 0 0 0-1.5h-2.19l3.72-3.72A.75.75 0 0 0 14.47.47l-3.72 3.72V2a.75.75 0 0 0-1.5 0v4Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M9.25 10a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5h-2.19l3.72 3.72a.75.75 0 1 1-1.06 1.06l-3.72-3.72V14a.75.75 0 0 1-1.5 0v-4Z',
        fillRule: 'evenodd',
      },
    ],
  },
  minimize_simple: {
    paths: [
      {
        d: 'M6.75 10A.75.75 0 0 0 6 9.25H2a.75.75 0 0 0 0 1.5h2.19L.47 14.47a.75.75 0 1 0 1.06 1.06l3.72-3.72V14a.75.75 0 0 0 1.5 0v-4Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M9.25 6c0 .414.336.75.75.75h4a.75.75 0 0 0 0-1.5h-2.19l3.72-3.72A.75.75 0 0 0 14.47.47l-3.72 3.72V2a.75.75 0 0 0-1.5 0v4Z',
        fillRule: 'evenodd',
      },
    ],
  },
  position_bottom_left: {
    paths: [
      'M2.609 9.046C2.5 9.26 2.5 9.54 2.5 10.1v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.109.494.109 1.054.109h2.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437c.109-.214.109-.494.109-1.054v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C7.74 8.5 7.46 8.5 6.9 8.5H4.1c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437Z',
      {
        d: 'M0 4.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C1.52 1 2.08 1 3.2 1h9.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 2.52 16 3.08 16 4.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 15 13.92 15 12.8 15H3.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C0 13.48 0 12.92 0 11.8V4.2Zm3.2-1.7h9.6c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.02.258.022.606.022 1.191v7.6c0 .585-.001.933-.022 1.191-.013.158-.03.224-.036.242a.5.5 0 0 1-.209.21 1.253 1.253 0 0 1-.242.035c-.258.02-.606.022-1.191.022H3.2c-.585 0-.933-.001-1.191-.022a1.253 1.253 0 0 1-.242-.036.5.5 0 0 1-.21-.209 1.255 1.255 0 0 1-.035-.242c-.02-.258-.022-.606-.022-1.191V4.2c0-.585.001-.933.022-1.191.013-.158.03-.224.036-.242a.5.5 0 0 1 .209-.21c.018-.005.084-.022.242-.035.258-.02.606-.022 1.191-.022Zm11.038.06-.003-.002a.03.03 0 0 1 .003.001Zm.203.202v.003-.003Zm0 10.476v-.003a.014.014 0 0 1 0 .003Zm-.203.203h-.003.003Zm-12.476 0h.003-.003Zm-.203-.203v-.003.003Zm0-10.476v.003-.003Zm.203-.203h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  position_bottom_right: {
    paths: [
      'M7.609 9.046C7.5 9.26 7.5 9.54 7.5 10.1v.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.109.494.109 1.054.109h2.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437c.109-.214.109-.494.109-1.054v-.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C12.74 8.5 12.46 8.5 11.9 8.5H9.1c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437Z',
      {
        d: 'M0 4.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C1.52 1 2.08 1 3.2 1h9.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 2.52 16 3.08 16 4.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 15 13.92 15 12.8 15H3.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C0 13.48 0 12.92 0 11.8V4.2Zm3.2-1.7h9.6c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.02.258.022.606.022 1.191v7.6c0 .585-.001.933-.022 1.191-.013.158-.03.224-.036.242a.5.5 0 0 1-.209.21 1.253 1.253 0 0 1-.242.035c-.258.02-.606.022-1.191.022H3.2c-.585 0-.933-.001-1.191-.022a1.253 1.253 0 0 1-.242-.036.5.5 0 0 1-.21-.209 1.255 1.255 0 0 1-.035-.242c-.02-.258-.022-.606-.022-1.191V4.2c0-.585.001-.933.022-1.191.013-.158.03-.224.036-.242a.5.5 0 0 1 .209-.21c.018-.005.084-.022.242-.035.258-.02.606-.022 1.191-.022Zm11.038.06-.003-.002a.03.03 0 0 1 .003.001Zm.203.202v.003-.003Zm0 10.476v-.003a.014.014 0 0 1 0 .003Zm-.203.203h-.003.003Zm-12.476 0h.003-.003Zm-.203-.203v-.003.003Zm0-10.476v.003-.003Zm.203-.203h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  position_middle_left: {
    paths: [
      {
        d: 'M12.8 2.5H3.2c-.585 0-.933.001-1.191.022-.158.013-.224.03-.242.036a.5.5 0 0 0-.21.209 1.254 1.254 0 0 0-.035.242c-.02.258-.022.606-.022 1.191v7.6c0 .585.001.933.022 1.191.013.158.03.224.036.242a.5.5 0 0 0 .209.21c.018.005.084.022.242.035.258.02.606.022 1.191.022h9.6c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .21-.209c.005-.018.022-.084.035-.242.02-.258.022-.606.022-1.191V4.2c0-.585-.001-.933-.022-1.191a1.252 1.252 0 0 0-.036-.242.5.5 0 0 0-.209-.21 1.255 1.255 0 0 0-.242-.035c-.258-.02-.606-.022-1.191-.022ZM.218 2.092C0 2.52 0 3.08 0 4.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C1.52 15 2.08 15 3.2 15h9.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C16 13.48 16 12.92 16 11.8V4.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 1 13.92 1 12.8 1H3.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874Z',
        fillRule: 'evenodd',
      },
      'M2.5 7.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C3.26 6 3.54 6 4.1 6h2.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437C8.5 6.76 8.5 7.04 8.5 7.6v.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C7.74 10 7.46 10 6.9 10H4.1c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C2.5 9.24 2.5 8.96 2.5 8.4v-.8Z',
    ],
  },
  position_middle_right: {
    paths: [
      {
        d: 'M12.8 2.5H3.2c-.585 0-.933.001-1.191.022-.158.013-.224.03-.242.036a.5.5 0 0 0-.21.209 1.254 1.254 0 0 0-.035.242c-.02.258-.022.606-.022 1.191v7.6c0 .585.001.933.022 1.191.013.158.03.224.036.242a.5.5 0 0 0 .209.21c.018.005.084.022.242.035.258.02.606.022 1.191.022h9.6c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .21-.209c.005-.018.022-.084.035-.242.02-.258.022-.606.022-1.191V4.2c0-.585-.001-.933-.022-1.191a1.252 1.252 0 0 0-.036-.242.5.5 0 0 0-.209-.21 1.255 1.255 0 0 0-.242-.035c-.258-.02-.606-.022-1.191-.022ZM.218 2.092C0 2.52 0 3.08 0 4.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C1.52 15 2.08 15 3.2 15h9.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C16 13.48 16 12.92 16 11.8V4.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 1 13.92 1 12.8 1H3.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874Z',
        fillRule: 'evenodd',
      },
      'M7.5 7.6c0-.56 0-.84.109-1.054a1 1 0 0 1 .437-.437C8.26 6 8.54 6 9.1 6h2.8c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437c.109.214.109.494.109 1.054v.8c0 .56 0 .84-.109 1.054a1 1 0 0 1-.437.437C12.74 10 12.46 10 11.9 10H9.1c-.56 0-.84 0-1.054-.109a1 1 0 0 1-.437-.437C7.5 9.24 7.5 8.96 7.5 8.4v-.8Z',
    ],
  },
  browser: {
    paths: [
      'M3.5 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
      'M7 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
      {
        d: 'M0 4.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C1.52 1 2.08 1 3.2 1h9.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 2.52 16 3.08 16 4.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 15 13.92 15 12.8 15H3.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C0 13.48 0 12.92 0 11.8V4.2Zm3.2-1.7h9.6c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.02.258.022.606.022 1.191v1.3h-13V4.2c0-.585.001-.933.022-1.191.013-.158.03-.224.036-.242a.5.5 0 0 1 .209-.21c.018-.005.084-.022.242-.035.258-.02.606-.022 1.191-.022ZM1.5 7v4.8c0 .585.001.933.022 1.191.013.158.03.224.036.242a.5.5 0 0 0 .209.21c.018.005.084.022.242.035.258.02.606.022 1.191.022h9.6c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .21-.209c.005-.018.022-.084.035-.242.02-.258.022-.606.022-1.191V7h-13Zm12.738-4.44-.003-.002a.03.03 0 0 1 .003.001Zm.203.202v.003-.003Zm0 10.476v-.003a.014.014 0 0 1 0 .003Zm-.203.203h-.003.003Zm-12.476 0h.003-.003Zm-.203-.203Zm0-10.476v.003-.003Zm.203-.203h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  date_time: {
    paths: [
      {
        d: 'M2.722 1c-.326 0-.615 0-.854.02-.255.02-.519.067-.776.198a2 2 0 0 0-.874.874 2.032 2.032 0 0 0-.198.776c-.02.24-.02.528-.02.854v8.556c0 .326 0 .615.02.854.02.255.067.519.198.776a2 2 0 0 0 .874.874c.257.131.521.178.776.198.24.02.528.02.854.02H6.5a.75.75 0 0 0 0-1.5H2.75c-.362 0-.59 0-.76-.014-.162-.014-.207-.035-.217-.04a.5.5 0 0 1-.218-.219c-.006-.01-.027-.055-.04-.217-.014-.17-.015-.398-.015-.76v-6.5h13V7A.75.75 0 0 0 16 7V3.722c0-.326 0-.615-.02-.854a2.032 2.032 0 0 0-.198-.776 2 2 0 0 0-.874-.874 2.033 2.033 0 0 0-.776-.198c-.24-.02-.528-.02-.854-.02H2.722ZM14.5 4.25v-.5c0-.362 0-.59-.014-.76-.014-.162-.035-.207-.04-.217a.5.5 0 0 0-.219-.219c-.01-.005-.055-.026-.217-.04-.17-.013-.398-.014-.76-.014H2.75c-.362 0-.59 0-.76.015-.162.013-.207.034-.217.04a.5.5 0 0 0-.218.218c-.006.01-.027.055-.04.217-.014.17-.015.398-.015.76v.5h13Z',
        fillRule: 'evenodd',
      },
      'M13.03 12.03a.75.75 0 1 0-1.06-1.06l-.5.5a.75.75 0 1 0 1.06 1.06l.5-.5Z',
      {
        d: 'M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-1.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z',
        fillRule: 'evenodd',
      },
    ],
  },
  code_dev: {
    paths: [
      'M3.47 6.97a.75.75 0 0 1 1.06 0l2 2a.75.75 0 0 1 0 1.06l-2 2a.75.75 0 0 1-1.06-1.06L4.94 9.5 3.47 8.03a.75.75 0 0 1 0-1.06Z',
      'M9.5 8.75a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z',
      {
        d: 'M0 4.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C1.52 1 2.08 1 3.2 1h9.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 2.52 16 3.08 16 4.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 15 13.92 15 12.8 15H3.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C0 13.48 0 12.92 0 11.8V4.2Zm3.2-1.7h9.6c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.02.258.022.606.022 1.191v.05h-13V4.2c0-.585.001-.933.022-1.191.013-.158.03-.224.036-.242a.5.5 0 0 1 .209-.21c.018-.005.084-.022.242-.035.258-.02.606-.022 1.191-.022ZM1.5 5.75v6.05c0 .585.001.933.022 1.191.013.158.03.224.036.242a.5.5 0 0 0 .209.21c.018.005.084.022.242.035.258.02.606.022 1.191.022h9.6c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .21-.209c.005-.018.022-.084.035-.242.02-.258.022-.606.022-1.191V5.75h-13Zm12.738-3.19-.003-.002a.03.03 0 0 1 .003.001Zm.203.202v.003-.003Zm0 10.476v-.003a.014.014 0 0 1 0 .003Zm-.203.203h-.003.003Zm-12.476 0h.003-.003Zm-.203-.203Zm0-10.476v.003-.003Zm.203-.203h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  code_tracking: {
    paths: [
      'M9.47 6.97a.75.75 0 0 1 1.06 0l2 2a.75.75 0 0 1 0 1.06l-2 2a.75.75 0 1 1-1.06-1.06l1.47-1.47-1.47-1.47a.75.75 0 0 1 0-1.06Z',
      'M5.47 6.97a.75.75 0 0 1 1.06 1.06L5.06 9.5l1.47 1.47a.75.75 0 1 1-1.06 1.06l-2-2a.75.75 0 0 1 0-1.06l2-2Z',
      {
        d: 'M0 4.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C1.52 1 2.08 1 3.2 1h9.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 2.52 16 3.08 16 4.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 15 13.92 15 12.8 15H3.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C0 13.48 0 12.92 0 11.8V4.2Zm3.2-1.7h9.6c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.02.258.022.606.022 1.191v.05h-13V4.2c0-.585.001-.933.022-1.191.013-.158.03-.224.036-.242a.5.5 0 0 1 .209-.21c.018-.005.084-.022.242-.035.258-.02.606-.022 1.191-.022ZM1.5 5.75v6.05c0 .585.001.933.022 1.191.013.158.03.224.036.242a.5.5 0 0 0 .209.21c.018.005.084.022.242.035.258.02.606.022 1.191.022h9.6c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .21-.209c.005-.018.022-.084.035-.242.02-.258.022-.606.022-1.191V5.75h-13Zm12.738-3.19-.003-.002a.03.03 0 0 1 .003.001Zm.203.202v.003-.003Zm0 10.476v-.003a.014.014 0 0 1 0 .003Zm-.203.203h-.003.003Zm-12.476 0h.003-.003Zm-.203-.203Zm0-10.476v.003-.003Zm.203-.203h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  device_tablet: {
    paths: [
      'M4.75 7a.75.75 0 1 0-1.5 0v2a.75.75 0 0 0 1.5 0V7Z',
      {
        d: 'M2.722 1c-.326 0-.615 0-.854.02-.255.02-.519.067-.776.198a2 2 0 0 0-.874.874 2.032 2.032 0 0 0-.198.776c-.02.24-.02.528-.02.854v8.556c0 .326 0 .615.02.854.02.255.067.519.198.776a2 2 0 0 0 .874.874c.257.131.521.178.776.198.24.02.528.02.854.02h10.556c.326 0 .615 0 .854-.02.255-.02.519-.067.776-.198a2 2 0 0 0 .874-.874c.131-.257.178-.521.198-.776.02-.24.02-.528.02-.854V3.722c0-.326 0-.615-.02-.854a2.032 2.032 0 0 0-.198-.776 2 2 0 0 0-.874-.874 2.033 2.033 0 0 0-.776-.198c-.24-.02-.528-.02-.854-.02H2.722Zm-.949 1.554c.01-.005.055-.026.217-.04.17-.013.398-.014.76-.014h10.5c.362 0 .59 0 .76.015.162.013.207.034.217.04a.5.5 0 0 1 .218.218c.006.01.027.055.04.217.014.17.015.398.015.76v8.5c0 .362 0 .59-.014.76-.014.162-.035.207-.04.217a.5.5 0 0 1-.219.218c-.01.006-.055.027-.217.04-.17.014-.398.015-.76.015H2.75c-.362 0-.59 0-.76-.014-.162-.014-.207-.035-.217-.04a.5.5 0 0 1-.218-.219c-.006-.01-.027-.055-.04-.217-.014-.17-.015-.398-.015-.76v-8.5c0-.362 0-.59.015-.76.013-.162.034-.207.04-.217a.5.5 0 0 1 .218-.219Z',
        fillRule: 'evenodd',
      },
    ],
  },
  device_phone: {
    paths: [
      'M7 3.25a.75.75 0 0 0 0 1.5h2a.75.75 0 1 0 0-1.5H7Z',
      {
        d: 'M3.722 0c-.326 0-.615 0-.854.02-.255.02-.519.067-.776.198a2 2 0 0 0-.874.874 2.032 2.032 0 0 0-.198.776c-.02.24-.02.528-.02.854v10.556c0 .326 0 .615.02.854.02.255.067.519.198.776a2 2 0 0 0 .874.874c.257.131.521.178.776.198.24.02.528.02.854.02h8.556c.326 0 .615 0 .854-.02.255-.02.519-.067.776-.198a2 2 0 0 0 .874-.874c.131-.257.178-.521.198-.776.02-.24.02-.528.02-.854V2.722c0-.326 0-.615-.02-.854a2.032 2.032 0 0 0-.198-.776 2 2 0 0 0-.874-.874 2.033 2.033 0 0 0-.776-.198c-.24-.02-.528-.02-.854-.02H3.722Zm-.949 1.554c.01-.005.055-.026.217-.04.17-.013.398-.014.76-.014h8.5c.362 0 .59 0 .76.015.162.013.207.034.217.04a.5.5 0 0 1 .218.218c.006.01.027.055.04.217.014.17.015.398.015.76v10.5c0 .362 0 .59-.014.76-.014.162-.035.207-.04.217a.5.5 0 0 1-.219.218c-.01.006-.055.027-.217.04-.17.014-.398.015-.76.015h-8.5c-.362 0-.59 0-.76-.014-.162-.014-.207-.035-.217-.04a.5.5 0 0 1-.219-.219c-.005-.01-.026-.055-.04-.217-.013-.17-.014-.398-.014-.76V2.75c0-.362 0-.59.015-.76.013-.162.034-.207.04-.217a.5.5 0 0 1 .218-.218Z',
        fillRule: 'evenodd',
      },
    ],
  },
  device_desktop: {
    paths: [
      {
        d: 'M2.722 1h10.556c.326 0 .615 0 .854.02.255.02.519.067.776.198a2 2 0 0 1 .874.874c.131.257.178.521.198.776.02.24.02.528.02.854v6.556c0 .326 0 .615-.02.854-.02.255-.067.519-.198.776a2 2 0 0 1-.874.874 2.032 2.032 0 0 1-.776.198c-.24.02-.528.02-.854.02h-3.27l.6 1.5H12a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1 0-1.5h1.392l.6-1.5h-3.27c-.326 0-.615 0-.854-.02a2.032 2.032 0 0 1-.776-.198 2 2 0 0 1-.874-.874 2.033 2.033 0 0 1-.198-.776c-.02-.24-.02-.528-.02-.854V3.722c0-.326 0-.615.02-.854.02-.255.067-.519.198-.776a2 2 0 0 1 .874-.874c.257-.131.521-.178.776-.198.24-.02.528-.02.854-.02Zm4.286 13.5h1.984l-.5-1.25h-.984l-.5 1.25ZM1.99 2.515c-.162.013-.207.034-.217.04a.5.5 0 0 0-.218.218c-.006.01-.027.055-.04.217-.014.17-.015.398-.015.76v6.5c0 .362 0 .59.015.76.013.162.034.207.04.217a.5.5 0 0 0 .218.218c.01.006.055.027.217.04.17.014.398.015.76.015h10.5c.362 0 .59 0 .76-.014.162-.014.207-.035.217-.04a.5.5 0 0 0 .218-.219c.006-.01.027-.055.04-.217.014-.17.015-.398.015-.76v-6.5c0-.362 0-.59-.014-.76-.014-.162-.035-.207-.04-.217a.5.5 0 0 0-.219-.219c-.01-.005-.055-.026-.217-.04-.17-.013-.398-.014-.76-.014H2.75c-.362 0-.59 0-.76.015Z',
        fillRule: 'evenodd',
      },
    ],
  },
  unknown: {
    paths: [
      'M7.98 1.5c-.642 0-1.137.43-1.247.945a.75.75 0 0 1-1.467-.313C5.531.891 6.666 0 7.98 0c1.494 0 2.77 1.162 2.77 2.673 0 1.25-.873 2.26-2.02 2.573v.004a.75.75 0 0 1-1.5 0v-.654a.75.75 0 0 1 .75-.75c.736 0 1.27-.56 1.27-1.173S8.716 1.5 7.98 1.5Z',
      {
        d: 'M2.722 1H3a.75.75 0 1 1 0 1.5h-.25c-.362 0-.59 0-.76.015-.162.013-.207.034-.217.04a.5.5 0 0 0-.218.218c-.006.01-.027.055-.04.217-.014.17-.015.398-.015.76v6.5c0 .362 0 .59.015.76.013.162.034.207.04.217a.5.5 0 0 0 .218.218c.01.006.055.027.217.04.17.014.398.015.76.015h10.5c.362 0 .59 0 .76-.014.162-.014.207-.035.217-.04a.5.5 0 0 0 .218-.219c.006-.01.027-.055.04-.217.014-.17.015-.398.015-.76v-6.5c0-.362 0-.59-.014-.76-.014-.162-.035-.207-.04-.217a.5.5 0 0 0-.219-.219c-.01-.005-.055-.026-.217-.04-.17-.013-.398-.014-.76-.014H13A.75.75 0 0 1 13 1h.278c.326 0 .615 0 .854.02.255.02.519.067.776.198a2 2 0 0 1 .874.874c.131.257.178.521.198.776.02.24.02.528.02.854v6.556c0 .326 0 .615-.02.854-.02.255-.067.519-.198.776a2 2 0 0 1-.874.874 2.032 2.032 0 0 1-.776.198c-.24.02-.528.02-.854.02h-3.27l.6 1.5H12a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1 0-1.5h1.392l.6-1.5h-3.27c-.326 0-.615 0-.854-.02a2.032 2.032 0 0 1-.776-.198 2 2 0 0 1-.874-.874 2.033 2.033 0 0 1-.198-.776c-.02-.24-.02-.528-.02-.854V3.722c0-.326 0-.615.02-.854.02-.255.067-.519.198-.776a2 2 0 0 1 .874-.874c.257-.131.521-.178.776-.198.24-.02.528-.02.854-.02Zm4.286 13.5h1.984l-.5-1.25h-.984l-.5 1.25Z',
        fillRule: 'evenodd',
      },
      'M8 8.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
    ],
  },
  device_multiple: {
    paths: [
      'M12 5.5A.75.75 0 0 0 12 7h1a.75.75 0 0 0 0-1.5h-1Z',
      {
        d: 'M11.722 0h1.556c.326 0 .615 0 .854.02.255.02.519.067.776.198a2 2 0 0 1 .874.874c.131.257.178.521.198.776.02.24.02.528.02.854v3.556c0 .326 0 .615-.02.854-.02.255-.067.519-.198.776a2 2 0 0 1-.874.874 2.033 2.033 0 0 1-.776.198c-.24.02-.528.02-.854.02h-1.556c-.326 0-.615 0-.854-.02a2.033 2.033 0 0 1-.776-.198 2 2 0 0 1-.874-.874 2.032 2.032 0 0 1-.198-.776C9 6.892 9 6.604 9 6.278V2.722c0-.326 0-.615.02-.854.02-.255.067-.519.198-.776a2 2 0 0 1 .874-.874c.257-.131.521-.178.776-.198.24-.02.528-.02.854-.02Zm-.732 1.515c-.162.013-.207.034-.217.04a.5.5 0 0 0-.218.218c-.006.01-.027.055-.04.217-.014.17-.015.398-.015.76v3.5c0 .362 0 .59.014.76.014.162.035.207.04.217a.5.5 0 0 0 .219.219c.01.005.055.026.217.04.17.013.398.014.76.014h1.5c.362 0 .59 0 .76-.015.162-.013.207-.034.217-.04a.5.5 0 0 0 .218-.218c.006-.01.027-.055.04-.217.014-.17.015-.398.015-.76v-3.5c0-.362 0-.59-.014-.76-.014-.162-.035-.207-.04-.217a.5.5 0 0 0-.219-.218c-.01-.006-.055-.027-.217-.04-.17-.014-.398-.015-.76-.015h-1.5c-.362 0-.59 0-.76.015Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M2.722 1H7.25a.75.75 0 1 1 0 1.5h-4.5c-.362 0-.59 0-.76.015-.162.013-.207.034-.217.04a.5.5 0 0 0-.218.218c-.006.01-.027.055-.04.217-.014.17-.015.398-.015.76v6.5c0 .362 0 .59.015.76.013.162.034.207.04.217a.5.5 0 0 0 .218.218c.01.006.055.027.217.04.17.014.398.015.76.015h10.5c.362 0 .59 0 .76-.014.162-.014.207-.035.217-.04a.5.5 0 0 0 .218-.219c.006-.01.027-.055.04-.217.014-.17.015-.398.015-.76v-.029a.75.75 0 0 1 1.5 0v.057c0 .326 0 .615-.02.854-.02.255-.067.519-.198.776a2 2 0 0 1-.874.874 2.032 2.032 0 0 1-.776.198c-.24.02-.528.02-.854.02h-3.27l.6 1.5H12a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1 0-1.5h1.392l.6-1.5h-3.27c-.326 0-.615 0-.854-.02a2.032 2.032 0 0 1-.776-.198 2 2 0 0 1-.874-.874 2.033 2.033 0 0 1-.198-.776c-.02-.24-.02-.528-.02-.854V3.722c0-.326 0-.615.02-.854.02-.255.067-.519.198-.776a2 2 0 0 1 .874-.874c.257-.131.521-.178.776-.198.24-.02.528-.02.854-.02Zm5.77 12.25.5 1.25H7.008l.5-1.25h.984Z',
        fillRule: 'evenodd',
      },
    ],
  },
  user_single: {
    paths: [
      {
        d: 'M8 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM6.5 4a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M8 8c-2.972 0-5.377 2.338-5.895 5.118C1.9 14.217 2.83 15 3.75 15h8.5c.92 0 1.85-.783 1.645-1.882C13.377 10.338 10.972 8 8 8Zm-4.42 5.393C3.984 11.225 5.846 9.5 8 9.5s4.016 1.725 4.42 3.893c.003.014.001.02 0 .022a.071.071 0 0 1-.017.027.213.213 0 0 1-.153.058h-8.5a.213.213 0 0 1-.153-.058.072.072 0 0 1-.018-.026c0-.003-.002-.008 0-.023Z',
        fillRule: 'evenodd',
      },
    ],
  },
  team: {
    paths: [
      {
        d: 'M8 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM5 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M2.25 4a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM0 4.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M13.75 4a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm-2.25.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M8 9.5c-2.154 0-4.016 1.725-4.42 3.893-.003.014-.001.02 0 .022a.071.071 0 0 0 .017.027c.026.028.08.058.153.058h8.5c.073 0 .127-.03.153-.058a.073.073 0 0 0 .018-.026c0-.003.002-.008 0-.023C12.015 11.225 10.153 9.5 8 9.5Zm-5.895 3.618C2.623 10.338 5.028 8 8 8c2.972 0 5.377 2.338 5.895 5.118C14.1 14.217 13.17 15 12.25 15h-8.5c-.92 0-1.85-.783-1.645-1.882Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M3 8.75c-.643 0-1.233.29-1.653.754A.75.75 0 0 1 .235 8.496 3.736 3.736 0 0 1 3 7.25c.442 0 .866.08 1.26.225a.75.75 0 0 1-.52 1.408A2.138 2.138 0 0 0 3 8.75Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M13 8.75c-.26 0-.508.047-.74.133a.75.75 0 1 1-.52-1.408A3.638 3.638 0 0 1 13 7.25c1.105 0 2.088.5 2.765 1.246a.75.75 0 1 1-1.112 1.008A2.237 2.237 0 0 0 13 8.75Z',
        fillRule: 'evenodd',
      },
    ],
  },
  user_success: {
    paths: [
      {
        d: 'M5 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z',
        fillRule: 'evenodd',
      },
      'M8 9.5c-2.154 0-4.016 1.725-4.42 3.893-.003.014-.001.02 0 .022a.071.071 0 0 0 .017.027c.026.028.08.058.153.058H8A.75.75 0 0 1 8 15H3.75c-.92 0-1.85-.783-1.645-1.882C2.623 10.338 5.028 8 8 8c1.048 0 2.03.294 2.88.794a.75.75 0 1 1-.76 1.293A4.168 4.168 0 0 0 8 9.5Z',
      'M15.786 11.469a.75.75 0 1 0-1.172-.938l-2.676 3.346-1.408-1.407a.75.75 0 1 0-1.06 1.06l2 2a.75.75 0 0 0 1.116-.061l3.2-4Z',
    ],
  },
  user_attribute: {
    paths: [
      {
        d: 'M5 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z',
        fillRule: 'evenodd',
      },
      'M8 9.5c-2.154 0-4.016 1.725-4.42 3.893-.003.014-.001.02 0 .022a.071.071 0 0 0 .017.027c.026.028.08.058.153.058H8A.75.75 0 0 1 8 15H3.75c-.92 0-1.85-.783-1.645-1.882C2.623 10.338 5.028 8 8 8c1.048 0 2.03.294 2.88.794a.75.75 0 1 1-.76 1.293A4.168 4.168 0 0 0 8 9.5Z',
      {
        d: 'M11.25 11.5a.75.75 0 0 0-.586.281l-1 1.25a.75.75 0 0 0 0 .938l1 1.25a.75.75 0 0 0 .586.281h4a.75.75 0 0 0 .75-.75v-2.5a.75.75 0 0 0-.75-.75h-4Zm-.04 2 .4-.5h2.89v1h-2.89l-.4-.5Z',
        fillRule: 'evenodd',
      },
    ],
  },
  user_add: {
    paths: [
      {
        d: 'M8 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM6.5 4a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z',
        fillRule: 'evenodd',
      },
      'M3.58 13.393C3.984 11.225 5.846 9.5 8 9.5c.763 0 1.484.213 2.12.587a.75.75 0 1 0 .76-1.293A5.667 5.667 0 0 0 8 8c-2.972 0-5.377 2.338-5.895 5.118C1.9 14.217 2.83 15 3.75 15H8a.75.75 0 0 0 0-1.5H3.75a.213.213 0 0 1-.153-.058.072.072 0 0 1-.018-.026c0-.003-.002-.008 0-.023Z',
      'M13 10a.75.75 0 0 1 .75.75v1.5h1.5a.75.75 0 0 1 0 1.5h-1.5v1.5a.75.75 0 0 1-1.5 0v-1.5h-1.5a.75.75 0 0 1 0-1.5h1.5v-1.5A.75.75 0 0 1 13 10Z',
    ],
  },
  user_single_alt: {
    paths: [
      {
        d: 'M8 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M8 8c-2.972 0-5.377 2.338-5.895 5.118C1.9 14.217 2.83 15 3.75 15h8.5c.92 0 1.85-.783 1.645-1.882C13.377 10.338 10.972 8 8 8Z',
        fillRule: 'evenodd',
      },
    ],
  },
  team_alt: {
    paths: [
      {
        d: 'M5 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M2.25 4a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM0 4.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M13.75 4a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm-2.25.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M2.105 13.118C2.623 10.338 5.028 8 8 8c2.972 0 5.377 2.338 5.895 5.118C14.1 14.217 13.17 15 12.25 15h-8.5c-.92 0-1.85-.783-1.645-1.882Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M3 8.75c-.643 0-1.233.29-1.653.754A.75.75 0 0 1 .235 8.496 3.736 3.736 0 0 1 3 7.25c.442 0 .866.08 1.26.225a.75.75 0 0 1-.52 1.408A2.138 2.138 0 0 0 3 8.75Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M13 8.75c-.26 0-.508.047-.74.133a.75.75 0 1 1-.52-1.408A3.638 3.638 0 0 1 13 7.25c1.105 0 2.088.5 2.765 1.246a.75.75 0 1 1-1.112 1.008A2.237 2.237 0 0 0 13 8.75Z',
        fillRule: 'evenodd',
      },
    ],
  },
  menu_kebab: {
    paths: [
      {
        d: 'M8 1.5A.75.75 0 1 0 8 3a.75.75 0 0 0 0-1.5Zm-2.25.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Zm2.25 5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM5.75 8a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Zm1.5 5.75a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0ZM8 11.5A2.25 2.25 0 1 0 8 16a2.25 2.25 0 0 0 0-4.5Z',
        fillRule: 'evenodd',
      },
    ],
  },
  menu_kebab_alt: {
    paths: [
      'M9.5 1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z',
      'M9.5 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z',
      'M9.5 14.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z',
    ],
  },
  menu_kebab_horizontal: {
    paths: [
      {
        d: 'M14.5 8A.75.75 0 1 0 13 8a.75.75 0 0 0 1.5 0Zm-.75-2.25a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5ZM8.75 8a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0ZM8 5.75a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5Zm-5.75 1.5a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5ZM4.5 8A2.25 2.25 0 1 0 0 8a2.25 2.25 0 0 0 4.5 0Z',
        fillRule: 'evenodd',
      },
    ],
  },
  menu_kebab_horizontal_alt: {
    paths: [
      'M14.5 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z',
      'M8 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z',
      'M1.5 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z',
    ],
  },
  lock: {
    paths: [
      'M9 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
      {
        d: 'M4 5V4a4 4 0 1 1 8 0v1c.988 0 1.506.013 1.908.218a2 2 0 0 1 .874.874C15 6.52 15 7.08 15 8.2v4.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C13.48 16 12.92 16 11.8 16H4.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C1 14.48 1 13.92 1 12.8V8.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C2.494 5.013 3.012 5.001 4 5Zm3.11-.002H5.5V4a2.5 2.5 0 0 1 5 0v.998H7.11ZM11.8 6.5H4.2c-.585 0-.933.001-1.191.022-.158.013-.224.03-.242.036a.5.5 0 0 0-.21.209 1.254 1.254 0 0 0-.035.242c-.02.258-.022.606-.022 1.191v4.6c0 .585.001.933.022 1.191.013.158.03.224.036.242a.5.5 0 0 0 .209.21c.018.005.084.022.242.035.258.02.606.022 1.191.022h7.6c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .21-.209c.005-.018.022-.084.035-.242.02-.258.022-.606.022-1.191V8.2c0-.585-.001-.933-.022-1.191a1.252 1.252 0 0 0-.036-.242.5.5 0 0 0-.209-.21 1.255 1.255 0 0 0-.242-.035c-.258-.02-.606-.022-1.191-.022Zm1.64.262.002.003-.002-.003Zm0 7.476.002-.003a.012.012 0 0 1-.002.003Zm-.202.203h-.003.003Zm-10.476 0h.003-.003Zm-.203-.203v-.003.003Zm.203-7.679h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  lock_open: {
    paths: [
      'M9 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
      {
        d: 'M5.5 4a2.5 2.5 0 0 1 4.63-1.309.75.75 0 1 0 1.278-.786A4 4 0 0 0 4 4v1c-.988 0-1.506.013-1.908.218a2 2 0 0 0-.874.874C1 6.52 1 7.08 1 8.2v4.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C2.52 16 3.08 16 4.2 16h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C15 14.48 15 13.92 15 12.8V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C13.48 5 12.92 5 11.8 5H5.5V4ZM4.2 6.5c-.585 0-.933.001-1.191.022-.158.013-.224.03-.242.036a.5.5 0 0 0-.21.209 1.254 1.254 0 0 0-.035.242c-.02.258-.022.606-.022 1.191v4.6c0 .585.001.933.022 1.191.013.158.03.224.036.242a.5.5 0 0 0 .209.21c.018.005.084.022.242.035.258.02.606.022 1.191.022h7.6c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .21-.209c.005-.018.022-.084.035-.242.02-.258.022-.606.022-1.191V8.2c0-.585-.001-.933-.022-1.191a1.252 1.252 0 0 0-.036-.242.5.5 0 0 0-.209-.21 1.255 1.255 0 0 0-.242-.035c-.258-.02-.606-.022-1.191-.022H4.2Zm9.24.262.002.003-.002-.003Zm0 7.476.002-.003a.012.012 0 0 1-.002.003Zm-.202.203h-.003.003Zm-10.476 0h.003-.003Zm-.203-.203v-.003.003Zm.203-7.679h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  list: {
    paths: [
      {
        d: 'M4 8a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H4.75A.75.75 0 0 1 4 8Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M4 2a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H4.75A.75.75 0 0 1 4 2Z',
        fillRule: 'evenodd',
      },
      'M2 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
      'M2 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
      'M2 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
      {
        d: 'M4 14a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H4.75A.75.75 0 0 1 4 14Z',
        fillRule: 'evenodd',
      },
    ],
  },
  hamburger: {
    paths: [
      {
        d: 'M0 8a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 8Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M0 14.25a.75.75 0 0 1 .75-.75h14.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M0 1.75A.75.75 0 0 1 .75 1h14.5a.75.75 0 0 1 0 1.5H.75A.75.75 0 0 1 0 1.75Z',
        fillRule: 'evenodd',
      },
    ],
  },
  plus: {
    paths: [
      {
        d: 'M.75 8a.75.75 0 0 1 .75-.75h5.75V1.5a.75.75 0 1 1 1.5 0v5.75h5.75a.75.75 0 0 1 0 1.5H8.75v5.75a.75.75 0 0 1-1.5 0V8.75H1.5A.75.75 0 0 1 .75 8Z',
        fillRule: 'evenodd',
      },
    ],
  },
  minus: {
    paths: [
      {
        d: 'M.25 8A.75.75 0 0 1 1 7.25h14a.75.75 0 0 1 0 1.5H1A.75.75 0 0 1 .25 8Z',
        fillRule: 'evenodd',
      },
    ],
  },
  percent: {
    paths: [
      {
        d: 'M14.53 1.47a.75.75 0 0 1 0 1.06l-12 12a.75.75 0 0 1-1.06-1.06l12-12a.75.75 0 0 1 1.06 0Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M4 2.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM1.25 4a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M12 10.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5ZM9.25 12a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0Z',
        fillRule: 'evenodd',
      },
    ],
  },
  hashtag: {
    paths: [
      {
        d: 'M13.157.267a.75.75 0 0 1 .576.89l-3 14a.75.75 0 0 1-1.466-.314l3-14a.75.75 0 0 1 .89-.576Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M6.855.267a.75.75 0 0 1 .576.89l-3 14a.75.75 0 0 1-1.466-.314l3-14a.75.75 0 0 1 .89-.576Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M.25 11a.75.75 0 0 1 .75-.75h14a.75.75 0 0 1 0 1.5H1A.75.75 0 0 1 .25 11Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M.25 5A.75.75 0 0 1 1 4.25h14a.75.75 0 0 1 0 1.5H1A.75.75 0 0 1 .25 5Z',
        fillRule: 'evenodd',
      },
    ],
  },
  grid_1: {
    paths: [
      {
        d: 'M3.008 5.484c.216.015.506.016.992.016s.776 0 .992-.016c.134-.009.19-.02.205-.025a.5.5 0 0 0 .262-.262 1.28 1.28 0 0 0 .025-.205C5.5 4.776 5.5 4.486 5.5 4s0-.776-.016-.992a1.28 1.28 0 0 0-.025-.205.5.5 0 0 0-.262-.262 1.28 1.28 0 0 0-.205-.025A16.58 16.58 0 0 0 4 2.5c-.486 0-.776 0-.992.016a1.28 1.28 0 0 0-.205.025.5.5 0 0 0-.262.262 1.28 1.28 0 0 0-.025.205A16.58 16.58 0 0 0 2.5 4c0 .486 0 .776.016.992.009.134.02.19.025.205a.5.5 0 0 0 .262.262c.014.004.071.016.205.025Zm-1.856-3.25C1 2.603 1 3.069 1 4s0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C2.602 7 3.068 7 4 7c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C7 5.398 7 4.932 7 4c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C5.398 1 4.932 1 4 1c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M3.008 13.484c.216.015.506.016.992.016s.776 0 .992-.016c.134-.009.19-.02.205-.025a.5.5 0 0 0 .262-.262 1.28 1.28 0 0 0 .025-.205c.015-.216.016-.506.016-.992s0-.776-.016-.992a1.28 1.28 0 0 0-.025-.205.5.5 0 0 0-.262-.262 1.287 1.287 0 0 0-.205-.025A16.516 16.516 0 0 0 4 10.5c-.486 0-.776 0-.992.016-.134.009-.19.02-.205.025a.5.5 0 0 0-.262.262 1.28 1.28 0 0 0-.025.205c-.015.216-.016.506-.016.992s0 .776.016.992c.009.134.02.19.025.205a.5.5 0 0 0 .262.262c.014.004.071.016.205.025Zm-1.856-3.25C1 10.603 1 11.069 1 12s0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C2.602 15 3.068 15 4 15c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C7 13.398 7 12.932 7 12c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C5.398 9 4.932 9 4 9c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M11.008 5.484c.216.015.506.016.992.016s.776 0 .992-.016c.134-.009.19-.02.205-.025a.5.5 0 0 0 .262-.262c.004-.014.016-.071.025-.205.015-.216.016-.506.016-.992s0-.776-.016-.992a1.287 1.287 0 0 0-.025-.205.5.5 0 0 0-.262-.262 1.28 1.28 0 0 0-.205-.025A16.579 16.579 0 0 0 12 2.5c-.486 0-.776 0-.992.016a1.28 1.28 0 0 0-.205.025.5.5 0 0 0-.262.262 1.287 1.287 0 0 0-.025.205c-.015.216-.016.506-.016.992s0 .776.016.992c.009.134.02.19.025.205a.5.5 0 0 0 .262.262c.014.004.071.016.205.025Zm-1.856-3.25C9 2.603 9 3.069 9 4s0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C10.602 7 11.068 7 12 7c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C15 5.398 15 4.932 15 4c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C13.398 1 12.932 1 12 1c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M11.008 13.484c.216.015.506.016.992.016s.776 0 .992-.016c.134-.009.19-.02.205-.025a.5.5 0 0 0 .262-.262c.004-.014.016-.071.025-.205.015-.216.016-.506.016-.992s0-.776-.016-.992a1.287 1.287 0 0 0-.025-.205.5.5 0 0 0-.262-.262 1.287 1.287 0 0 0-.205-.025A16.515 16.515 0 0 0 12 10.5c-.486 0-.776 0-.992.016-.134.009-.19.02-.205.025a.5.5 0 0 0-.262.262 1.287 1.287 0 0 0-.025.205c-.015.216-.016.506-.016.992s0 .776.016.992c.009.134.02.19.025.205a.5.5 0 0 0 .262.262c.014.004.071.016.205.025Zm-1.856-3.25C9 10.603 9 11.069 9 12s0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C10.602 15 11.068 15 12 15c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C15 13.398 15 12.932 15 12c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C13.398 9 12.932 9 12 9c-.932 0-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083Z',
        fillRule: 'evenodd',
      },
    ],
  },
  grid_2: {
    paths: [
      {
        d: 'M1.218 2.092C1 2.52 1 3.08 1 4.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C2.52 15 3.08 15 4.2 15h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C15 13.48 15 12.92 15 11.8V4.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C13.48 1 12.92 1 11.8 1H4.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874ZM11.8 2.5h-1.05v2.75h2.75V4.2c0-.585-.001-.933-.022-1.191a1.252 1.252 0 0 0-.036-.242.5.5 0 0 0-.209-.21 1.255 1.255 0 0 0-.242-.035c-.258-.02-.606-.022-1.191-.022Zm1.7 4.25h-2.75v2.5h2.75v-2.5Zm-4.25-1.5V2.5h-2.5v2.75h2.5Zm-2.5 1.5h2.5v2.5h-2.5v-2.5Zm-1.5-1.5V2.5H4.2c-.585 0-.933.001-1.191.022-.158.013-.224.03-.242.036a.5.5 0 0 0-.21.209 1.254 1.254 0 0 0-.035.242c-.02.258-.022.606-.022 1.191v1.05h2.75ZM2.5 6.75h2.75v2.5H2.5v-2.5Zm4.25 4h2.5v2.75h-2.5v-2.75Zm5.05 2.75h-1.05v-2.75h2.75v1.05c0 .585-.001.933-.022 1.191-.013.158-.03.224-.036.242a.5.5 0 0 1-.209.21 1.253 1.253 0 0 1-.242.035c-.258.02-.606.022-1.191.022Zm-9.3-2.75h2.75v2.75H4.2c-.585 0-.933-.001-1.191-.022a1.253 1.253 0 0 1-.242-.036.5.5 0 0 1-.21-.209 1.255 1.255 0 0 1-.035-.242c-.02-.258-.022-.606-.022-1.191v-1.05Zm10.738-8.19-.003-.002.003.001Zm.203.202v.003-.003Zm0 10.476v-.003.003Zm-.203.203h-.003.003Zm-10.476 0h.003-.003Zm-.203-.203Zm0-10.476v.003-.003Zm.203-.203h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  table: {
    paths: [
      {
        d: 'M1 4.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C2.52 1 3.08 1 4.2 1h7.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C15 2.52 15 3.08 15 4.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C13.48 15 12.92 15 11.8 15H4.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C1 13.48 1 12.92 1 11.8V4.2Zm3.2-1.7h7.6c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.02.258.022.606.022 1.191v.05h-11V4.2c0-.585.001-.933.022-1.191.013-.158.03-.224.036-.242a.5.5 0 0 1 .209-.21c.018-.005.084-.022.242-.035.258-.02.606-.022 1.191-.022ZM2.5 5.75v3h4.75v-3H2.5Zm6.25 0v3h4.75v-3H8.75Zm0 4.5h4.75v1.55c0 .585-.001.933-.022 1.191-.013.158-.03.224-.036.242a.5.5 0 0 1-.209.21 1.253 1.253 0 0 1-.242.035c-.258.02-.606.022-1.191.022H8.75v-3.25Zm-6.25 0h4.75v3.25H4.2c-.585 0-.933-.001-1.191-.022a1.253 1.253 0 0 1-.242-.036.5.5 0 0 1-.21-.209 1.255 1.255 0 0 1-.035-.242c-.02-.258-.022-.606-.022-1.191v-1.55Zm10.738-7.69-.003-.002.003.001Zm.203.202v.003-.003Zm0 10.476v-.003.003Zm-.203.203h-.003.003Zm-10.476 0h.003-.003Zm-.203-.203Zm0-10.476v.003-.003Zm.203-.203h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  table_cols: {
    paths: [
      {
        d: 'M1 4.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C2.52 1 3.08 1 4.2 1h7.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C15 2.52 15 3.08 15 4.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C13.48 15 12.92 15 11.8 15H4.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C1 13.48 1 12.92 1 11.8V4.2Zm3.2-1.7h7.6c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.02.258.022.606.022 1.191v.05h-11V4.2c0-.585.001-.933.022-1.191.013-.158.03-.224.036-.242a.5.5 0 0 1 .209-.21c.018-.005.084-.022.242-.035.258-.02.606-.022 1.191-.022ZM2.5 5.75v6.05c0 .585.001.933.022 1.191.013.158.03.224.036.242a.5.5 0 0 0 .209.21c.018.005.084.022.242.035.258.02.606.022 1.191.022h1.05V5.75H2.5Zm4.25 0v7.75h2.5V5.75h-2.5Zm4 0v7.75h1.05c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .21-.209c.005-.018.022-.084.035-.242.02-.258.022-.606.022-1.191V5.75h-2.75Zm2.488-3.19-.003-.002.003.001Zm.203.202v.003-.003Zm0 10.476v-.003.003Zm-.203.203h-.003.003Zm-10.476 0h.003-.003Zm-.203-.203Zm0-10.476v.003-.003Zm.203-.203h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  film: {
    paths: [
      'M0 15.25V.75a.75.75 0 1 1 1.5 0v14.5a.75.75 0 0 1-1.5 0Z',
      {
        d: 'M3 3.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C4.52 0 5.08 0 6.2 0h3.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C13 1.52 13 2.08 13 3.2v.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C11.48 7 10.92 7 9.8 7H6.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C3 5.48 3 4.92 3 3.8v-.6Zm3.2-1.7h3.6c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.02.258.022.606.022 1.191v.6c0 .585-.001.933-.022 1.191-.013.158-.03.224-.036.242a.5.5 0 0 1-.209.21 1.255 1.255 0 0 1-.242.035c-.258.02-.606.022-1.191.022H6.2c-.585 0-.933-.001-1.191-.022a1.254 1.254 0 0 1-.242-.036.5.5 0 0 1-.21-.209 1.254 1.254 0 0 1-.035-.242C4.502 4.733 4.5 4.385 4.5 3.8v-.6c0-.585.001-.933.022-1.191.013-.158.03-.224.036-.242a.5.5 0 0 1 .209-.21c.018-.005.084-.022.242-.035.258-.02.606-.022 1.191-.022Zm5.038.06-.003-.002.003.001Zm.203.202v.003-.003Zm0 3.476v-.003.003Zm-.203.203h-.003.003Zm-6.476 0h.003a.022.022 0 0 1-.003 0Zm-.203-.203v-.003.003Zm0-3.476v.003-.003Zm.203-.203h.003-.003Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M3 12.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C4.52 9 5.08 9 6.2 9h3.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C13 10.52 13 11.08 13 12.2v.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C11.48 16 10.92 16 9.8 16H6.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C3 14.48 3 13.92 3 12.8v-.6Zm3.2-1.7h3.6c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.02.258.022.606.022 1.191v.6c0 .585-.001.933-.022 1.191-.013.158-.03.224-.036.242a.5.5 0 0 1-.209.21 1.253 1.253 0 0 1-.242.035c-.258.02-.606.022-1.191.022H6.2c-.585 0-.933-.001-1.191-.022a1.252 1.252 0 0 1-.242-.036.5.5 0 0 1-.21-.209 1.255 1.255 0 0 1-.035-.242c-.02-.258-.022-.606-.022-1.191v-.6c0-.585.001-.933.022-1.191.013-.158.03-.224.036-.242a.5.5 0 0 1 .209-.21c.018-.005.084-.022.242-.035.258-.02.606-.022 1.191-.022Zm5.038.06-.003-.002.003.002Zm.203.202v.003-.003Zm0 3.476v-.003a.012.012 0 0 1 0 .003Zm-.203.203h-.003.003Zm-6.476 0h.003-.003Zm-.203-.203v-.003.003Zm0-3.476Zm.203-.203h.003-.003Z',
        fillRule: 'evenodd',
      },
      'M14.5.75v14.5a.75.75 0 0 0 1.5 0V.75a.75.75 0 0 0-1.5 0Z',
    ],
  },
  search: {
    paths: [
      {
        d: 'M11.391 12.452a7 7 0 1 1 1.06-1.06l3.33 3.328a.75.75 0 1 1-1.061 1.06l-3.329-3.328ZM12.5 7a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z',
        fillRule: 'evenodd',
      },
    ],
  },
  zoom_in: {
    paths: [
      'M7 3.25a.75.75 0 0 1 .75.75v2.25H10a.75.75 0 0 1 0 1.5H7.75V10a.75.75 0 0 1-1.5 0V7.75H4a.75.75 0 0 1 0-1.5h2.25V4A.75.75 0 0 1 7 3.25Z',
      {
        d: 'M11.391 12.452a7 7 0 1 1 1.06-1.06l3.33 3.328a.75.75 0 1 1-1.061 1.06l-3.329-3.328ZM12.5 7a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z',
        fillRule: 'evenodd',
      },
    ],
  },
  zoom_out: {
    paths: [
      'M4 6.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5H4Z',
      {
        d: 'M7 14c1.663 0 3.19-.58 4.391-1.548l3.329 3.328a.75.75 0 1 0 1.06-1.06l-3.328-3.329A7 7 0 1 0 7 14Zm0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z',
        fillRule: 'evenodd',
      },
    ],
  },
  toggles: {
    paths: [
      {
        d: 'M0 3a2.25 2.25 0 0 1 4.372-.75H15a.75.75 0 0 1 0 1.5H4.372A2.25 2.25 0 0 1 0 3Zm2.25-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M.25 8A.75.75 0 0 1 1 7.25h4.878a2.25 2.25 0 0 1 4.244 0H15a.75.75 0 0 1 0 1.5h-4.878a2.251 2.251 0 0 1-4.244 0H1A.75.75 0 0 1 .25 8Zm7 0a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M11.628 12.25a2.251 2.251 0 1 1 0 1.5H1a.75.75 0 0 1 0-1.5h10.628Zm2.122 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z',
        fillRule: 'evenodd',
      },
    ],
  },
  cog: {
    paths: [
      {
        d: 'M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM9.5 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M5.748 1.606c1.04-1.665 3.464-1.665 4.504 0a2.655 2.655 0 0 0 2.16 1.247c1.961.068 3.173 2.167 2.252 3.9a2.655 2.655 0 0 0 0 2.494c.921 1.733-.29 3.832-2.252 3.9a2.655 2.655 0 0 0-2.16 1.247c-1.04 1.665-3.464 1.665-4.504 0a2.655 2.655 0 0 0-2.16-1.247c-1.961-.068-3.173-2.167-2.251-3.9a2.655 2.655 0 0 0 0-2.494c-.922-1.733.29-3.832 2.251-3.9a2.655 2.655 0 0 0 2.16-1.247ZM3.64 4.352A4.155 4.155 0 0 0 7.02 2.4a1.155 1.155 0 0 1 1.96 0 4.155 4.155 0 0 0 3.38 1.952c.853.03 1.38.943.98 1.696a4.154 4.154 0 0 0 0 3.904 1.155 1.155 0 0 1-.98 1.696A4.155 4.155 0 0 0 8.98 13.6a1.155 1.155 0 0 1-1.96 0 4.155 4.155 0 0 0-3.38-1.952 1.155 1.155 0 0 1-.98-1.696c.65-1.22.65-2.683 0-3.904a1.155 1.155 0 0 1 .98-1.696Z',
        fillRule: 'evenodd',
      },
    ],
  },
  bell: {
    paths: [
      'M7.25.75A.75.75 0 0 1 8 0c1.615 0 2.956.52 3.888 1.529.924 1 1.362 2.388 1.362 3.971 0 .877.237 2.216.835 3.03l.005.006c.018.02.041.049.07.084.055.07.13.17.215.298.17.254.384.622.572 1.09.257.643.165 1.365-.127 1.917-.293.556-.867 1.075-1.666 1.075H8a.75.75 0 0 1 0-1.5h5.154c.085 0 .223-.053.34-.274.117-.224.13-.485.06-.662a4.194 4.194 0 0 0-.57-1.013C12.1 8.436 11.75 6.901 11.75 5.5c0-1.317-.362-2.303-.963-2.953C10.193 1.905 9.285 1.5 8 1.5a.75.75 0 0 1-.75-.75Z',
      'M8.75.75A.75.75 0 0 0 8 0C6.385 0 5.044.52 4.112 1.529c-.924 1-1.362 2.388-1.362 3.971 0 .877-.237 2.216-.835 3.03l-.005.006c-.018.02-.041.049-.069.084-.056.07-.13.17-.216.298-.17.254-.384.622-.571 1.09-.258.643-.165 1.365.126 1.917.293.556.867 1.075 1.666 1.075H8a.75.75 0 0 0 0-1.5H2.846c-.085 0-.223-.053-.34-.274-.117-.224-.13-.485-.06-.662.212-.53.47-.886.57-1.013C3.901 8.436 4.25 6.901 4.25 5.5c0-1.317.362-2.303.963-2.953C5.807 1.905 6.716 1.5 8 1.5a.75.75 0 0 0 .75-.75Z',
      {
        d: 'M5.41 14.1a.75.75 0 0 1 1.052-.129c.424.332.957.529 1.538.529.58 0 1.114-.197 1.538-.529a.75.75 0 0 1 .924 1.182A3.986 3.986 0 0 1 8 16a3.986 3.986 0 0 1-2.462-.847.75.75 0 0 1-.129-1.053Z',
        fillRule: 'evenodd',
      },
    ],
  },
  email: {
    paths: [
      {
        d: 'M0 4.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C1.52 1 2.08 1 3.2 1h9.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 2.52 16 3.08 16 4.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 15 13.92 15 12.8 15H3.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C0 13.48 0 12.92 0 11.8V4.2Zm3.2-1.7h9.6c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.01.116.015.25.018.415L8 7.136 1.504 3.424c.003-.165.009-.3.018-.415.013-.158.03-.224.036-.242a.5.5 0 0 1 .209-.21c.018-.005.084-.022.242-.035.258-.02.606-.022 1.191-.022ZM1.5 5.15v6.65c0 .585.001.933.022 1.191.013.158.03.224.036.242a.5.5 0 0 0 .209.21c.018.005.084.022.242.035.258.02.606.022 1.191.022h9.6c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .21-.209c.005-.018.022-.084.035-.242.02-.258.022-.606.022-1.191V5.15L8.372 8.65a.75.75 0 0 1-.744 0L1.5 5.15Zm12.738-2.59-.003-.002a.03.03 0 0 1 .003.001Zm.203.202v.003-.003Zm0 10.476v-.003a.014.014 0 0 1 0 .003Zm-.203.203h-.003.003Zm-12.476 0h.003-.003Zm-.203-.203v-.003.003Zm0-10.476v.003-.003Zm.203-.203h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  page_empty: {
    paths: [
      {
        d: 'M8.986.06C8.742 0 8.492 0 8.232 0h-4.51c-.326 0-.615 0-.854.02-.255.02-.519.067-.776.198a2 2 0 0 0-.874.874 2.032 2.032 0 0 0-.198.776c-.02.24-.02.528-.02.854v10.556c0 .326 0 .615.02.854.02.255.067.519.198.776a2 2 0 0 0 .874.874c.257.131.521.178.776.198.24.02.528.02.854.02h8.556c.326 0 .615 0 .854-.02.255-.02.519-.067.776-.198a2 2 0 0 0 .874-.874c.131-.257.178-.521.198-.776.02-.24.02-.528.02-.854V7.062c0-.238 0-.466-.05-.69a2 2 0 0 0-.22-.556c-.115-.198-.271-.365-.434-.538L10.143.83C9.965.639 9.794.456 9.584.32a2 2 0 0 0-.598-.26ZM8.25 1.5h-4.5c-.362 0-.59 0-.76.015-.162.013-.207.034-.217.04a.5.5 0 0 0-.219.218c-.005.01-.026.055-.04.217-.013.17-.014.398-.014.76v10.5c0 .362 0 .59.015.76.013.162.034.207.04.217a.5.5 0 0 0 .218.218c.01.006.055.027.217.04.17.014.398.015.76.015h8.5c.362 0 .59 0 .76-.015.162-.013.207-.034.217-.04a.5.5 0 0 0 .218-.218c.006-.01.027-.055.04-.217.014-.17.015-.398.015-.76V7.116c0-.229-.002-.32-.006-.366H10A1.75 1.75 0 0 1 8.25 5V1.5Zm3.968 3.75L9.75 2.607V5c0 .138.112.25.25.25h2.218Z',
        fillRule: 'evenodd',
      },
    ],
  },
  page_full: {
    paths: [
      'M5 11.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5H5Z',
      'M4.25 8A.75.75 0 0 1 5 7.25h6a.75.75 0 0 1 0 1.5H5A.75.75 0 0 1 4.25 8Z',
      'M5 3.25a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5H5Z',
      {
        d: 'M8.232 0c.261 0 .511 0 .754.06a2 2 0 0 1 .598.26c.21.136.38.319.559.51l4.153 4.448c.163.173.319.34.434.538a2 2 0 0 1 .22.557c.05.223.05.451.05.69v6.215c0 .326 0 .615-.02.854-.02.255-.067.519-.198.776a2 2 0 0 1-.874.874 2.034 2.034 0 0 1-.776.198c-.24.02-.528.02-.854.02H3.722c-.326 0-.615 0-.854-.02a2.033 2.033 0 0 1-.776-.198 2 2 0 0 1-.874-.874 2.033 2.033 0 0 1-.198-.776c-.02-.24-.02-.528-.02-.854V2.722c0-.326 0-.615.02-.854.02-.255.067-.519.198-.776a2 2 0 0 1 .874-.874c.257-.131.521-.178.776-.199C3.108 0 3.396 0 3.722 0h4.51Zm-.06 1.5h.078V5c0 .966.784 1.75 1.75 1.75h3.494c.004.046.006.137.006.366v6.134c0 .362 0 .59-.014.76-.014.162-.035.207-.04.217a.5.5 0 0 1-.219.218c-.01.006-.055.027-.217.04-.17.014-.398.015-.76.015h-8.5c-.362 0-.59 0-.76-.015-.162-.013-.207-.034-.217-.04a.5.5 0 0 1-.219-.218c-.005-.01-.026-.055-.04-.217-.013-.17-.014-.398-.014-.76V2.75c0-.362 0-.59.015-.76.013-.162.034-.207.04-.217a.5.5 0 0 1 .218-.219c.01-.005.055-.026.217-.04.17-.013.398-.014.76-.014h4.423ZM9.75 2.607l2.468 2.643H10A.25.25 0 0 1 9.75 5V2.607Z',
        fillRule: 'evenodd',
      },
    ],
  },
  page_new: {
    paths: [
      {
        d: 'M8.25 1.5h-4.5c-.362 0-.59 0-.76.015-.162.013-.207.034-.217.04a.5.5 0 0 0-.219.218c-.005.01-.026.055-.04.217-.013.17-.014.398-.014.76V8A.75.75 0 1 1 1 8V2.722c0-.326 0-.615.02-.854.02-.255.067-.519.198-.776a2 2 0 0 1 .874-.874c.257-.131.521-.178.776-.199C3.108 0 3.396 0 3.722 0h4.51c.261 0 .511 0 .754.06a2 2 0 0 1 .598.26c.21.136.38.319.559.51l4.153 4.448c.163.173.319.34.434.538a2 2 0 0 1 .22.557c.05.223.05.451.05.69v6.215c0 .326 0 .615-.02.854-.02.255-.067.519-.198.776a2 2 0 0 1-.874.874 2.034 2.034 0 0 1-.776.198c-.24.02-.528.02-.854.02H8a.75.75 0 0 1 0-1.5h4.25c.362 0 .59 0 .76-.015.162-.013.207-.034.217-.04a.5.5 0 0 0 .218-.218c.006-.01.027-.055.04-.217.014-.17.015-.398.015-.76V7.116c0-.229-.002-.32-.006-.366H10A1.75 1.75 0 0 1 8.25 5V1.5Zm3.968 3.75L9.75 2.607V5c0 .138.112.25.25.25h2.218Z',
        fillRule: 'evenodd',
      },
      'M3.75 10.75a.75.75 0 0 0-1.5 0v1.5H.75a.75.75 0 0 0 0 1.5h1.5v1.5a.75.75 0 0 0 1.5 0v-1.5h1.5a.75.75 0 0 0 0-1.5h-1.5v-1.5Z',
    ],
  },
  page_delete: {
    paths: [
      {
        d: 'M8.173 1.5h.077V5c0 .966.784 1.75 1.75 1.75h3.494c.004.046.006.137.006.366v6.134c0 .362 0 .59-.014.76-.014.162-.035.207-.04.217a.5.5 0 0 1-.219.218c-.01.006-.055.027-.217.04-.17.014-.398.015-.76.015H8A.75.75 0 0 0 8 16h4.278c.326 0 .615 0 .854-.02.255-.02.519-.067.776-.198a2 2 0 0 0 .874-.874c.131-.257.178-.521.198-.776.02-.24.02-.528.02-.854V7.062c0-.238 0-.466-.05-.69a2 2 0 0 0-.22-.556c-.115-.198-.271-.365-.434-.538L10.143.83C9.965.639 9.794.456 9.584.32a2 2 0 0 0-.598-.26C8.742 0 8.492 0 8.232 0h-4.51c-.326 0-.615 0-.854.02-.255.02-.519.067-.776.198a2 2 0 0 0-.874.874 2.032 2.032 0 0 0-.198.776c-.02.24-.02.528-.02.854V8a.75.75 0 0 0 1.5 0V2.75c0-.362 0-.59.015-.76.013-.162.034-.207.04-.217a.5.5 0 0 1 .218-.219c.01-.005.055-.026.217-.04.17-.013.398-.014.76-.014h4.423ZM9.75 2.607l2.468 2.643H10A.25.25 0 0 1 9.75 5V2.607Z',
        fillRule: 'evenodd',
      },
      'M1.28 10.72a.75.75 0 0 0-1.06 1.06l1.47 1.47-1.47 1.47a.75.75 0 1 0 1.06 1.06l1.47-1.47 1.47 1.47a.75.75 0 0 0 1.06-1.06l-1.47-1.47 1.47-1.47a.75.75 0 0 0-1.06-1.06l-1.47 1.47-1.47-1.47Z',
    ],
  },
  duplicate: {
    paths: [
      {
        d: 'M4.218 1.092C4 1.52 4 2.08 4 3.2v7.4c0 .84 0 1.26.163 1.581a1.5 1.5 0 0 0 .656.655c.32.164.74.164 1.581.164h5.4c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C15 11.48 15 10.92 15 9.8V6.245c0-.46 0-.69-.05-.909a2 2 0 0 0-.214-.55c-.11-.195-.266-.364-.577-.704l-2.791-3.044c-.35-.383-.526-.574-.735-.71a1.999 1.999 0 0 0-.604-.266C9.787 0 9.528 0 9.01 0H7.2C6.08 0 5.52 0 5.092.218a2 2 0 0 0-.874.874ZM6.4 11.5h5.4c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .21-.209c.005-.018.022-.084.035-.242.02-.258.022-.606.022-1.191V6.75H10a1.75 1.75 0 0 1-1.659-1.191l-.97 2.97L6.4 11.5Zm0 0c-.445 0-.688-.001-.863-.015l-.02-.002-.002-.02A12.277 12.277 0 0 1 5.5 10.6V3.2c0-.585.001-.933.022-1.191.013-.158.03-.224.036-.242a.5.5 0 0 1 .209-.21c.018-.005.084-.022.242-.035.258-.02.606-.022 1.191-.022h1.05V5c0 .195.032.382.09.557l-.97 2.971L6.4 11.5Zm6.653-6.404.141.154H10A.25.25 0 0 1 9.75 5V1.548a.5.5 0 0 1 .06.034c.007.005.03.023.082.074.082.082.186.194.37.395l2.791 3.045ZM5.56 1.762v.003-.003Zm.203-.203h.003-.003Zm7.679 9.68v-.004.003Zm-.203.201-.003.002.003-.002Z',
        fillRule: 'evenodd',
      },
      'M2.5 4.25a.75.75 0 1 0-1.5 0v9.028c0 .326 0 .615.02.854.02.255.067.519.198.776a2 2 0 0 0 .874.874c.257.131.521.178.776.198.24.02.528.02.854.02h9.028a.75.75 0 0 0 0-1.5h-9c-.362 0-.59 0-.76-.014-.162-.014-.207-.035-.217-.04a.5.5 0 0 1-.219-.219c-.005-.01-.026-.055-.04-.217-.013-.17-.014-.398-.014-.76v-9Z',
    ],
  },
  scale_up: {
    paths: [
      'M12 3.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V5.81L7.53 9.53a.75.75 0 0 1-1.06-1.06l3.72-3.72H8a.75.75 0 0 1 0-1.5h4Z',
      {
        d: 'M3.218 1.092C3 1.52 3 2.08 3 3.2v6.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 13 5.08 13 6.2 13h6.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C16 11.48 16 10.92 16 9.8V3.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 0 13.92 0 12.8 0H6.2C5.08 0 4.52 0 4.092.218a2 2 0 0 0-.874.874ZM12.8 1.5H6.2c-.585 0-.933.001-1.191.022-.158.013-.224.03-.242.036a.5.5 0 0 0-.21.209 1.255 1.255 0 0 0-.035.242c-.02.258-.022.606-.022 1.191v6.6c0 .585.001.933.022 1.191.013.158.03.224.036.242a.5.5 0 0 0 .209.21c.018.005.084.022.242.035.258.02.606.022 1.191.022h6.6c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .21-.209c.005-.018.022-.084.035-.242.02-.258.022-.606.022-1.191V3.2c0-.585-.001-.933-.022-1.191a1.252 1.252 0 0 0-.036-.242.5.5 0 0 0-.209-.21 1.255 1.255 0 0 0-.242-.035c-.258-.02-.606-.022-1.191-.022Zm1.438.06-.003-.002.003.001Zm.203.202v.003-.003Zm0 9.476v-.003.003Zm-.203.203Zm-9.476 0h.003-.003Zm-.203-.203v-.003.003Zm0-9.476v.003-.003Zm.203-.203Z',
        fillRule: 'evenodd',
      },
      'M1.5 4.25a.75.75 0 0 0-1.5 0v7.83c0 .535 0 .98.03 1.345.03.38.098.736.27 1.073A2.75 2.75 0 0 0 1.502 15.7c.337.172.693.24 1.073.27.365.03.81.03 1.345.03h7.83a.75.75 0 0 0 0-1.5h-7.8c-.572 0-.957 0-1.253-.025-.287-.023-.424-.065-.514-.111a1.25 1.25 0 0 1-.547-.546c-.046-.091-.088-.228-.111-.515-.024-.296-.025-.68-.025-1.253v-7.8Z',
    ],
  },
  scale_down: {
    paths: [
      'M7 9.75A.75.75 0 0 1 6.25 9V5a.75.75 0 0 1 1.5 0v2.19l3.72-3.72a.75.75 0 1 1 1.06 1.06L8.81 8.25H11a.75.75 0 0 1 0 1.5H7Z',
      {
        d: 'M3.218 1.092C3 1.52 3 2.08 3 3.2v6.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C4.52 13 5.08 13 6.2 13h6.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C16 11.48 16 10.92 16 9.8V3.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 0 13.92 0 12.8 0H6.2C5.08 0 4.52 0 4.092.218a2 2 0 0 0-.874.874ZM12.8 1.5H6.2c-.585 0-.933.001-1.191.022-.158.013-.224.03-.242.036a.5.5 0 0 0-.21.209 1.255 1.255 0 0 0-.035.242c-.02.258-.022.606-.022 1.191v6.6c0 .585.001.933.022 1.191.013.158.03.224.036.242a.5.5 0 0 0 .209.21c.018.005.084.022.242.035.258.02.606.022 1.191.022h6.6c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .21-.209c.005-.018.022-.084.035-.242.02-.258.022-.606.022-1.191V3.2c0-.585-.001-.933-.022-1.191a1.252 1.252 0 0 0-.036-.242.5.5 0 0 0-.209-.21 1.255 1.255 0 0 0-.242-.035c-.258-.02-.606-.022-1.191-.022Zm1.438.06-.003-.002.003.001Zm.203.202v.003-.003Zm0 9.476v-.003.003Zm-.203.203Zm-9.476 0h.003-.003Zm-.203-.203v-.003.003Zm0-9.476v.003-.003Zm.203-.203Z',
        fillRule: 'evenodd',
      },
      'M1.5 4.25a.75.75 0 0 0-1.5 0v7.83c0 .535 0 .98.03 1.345.03.38.098.736.27 1.073A2.75 2.75 0 0 0 1.502 15.7c.337.172.693.24 1.073.27.365.03.81.03 1.345.03h7.83a.75.75 0 0 0 0-1.5h-7.8c-.572 0-.957 0-1.253-.025-.287-.023-.424-.065-.514-.111a1.25 1.25 0 0 1-.547-.546c-.046-.091-.088-.228-.111-.515-.024-.296-.025-.68-.025-1.253v-7.8Z',
    ],
  },
  open_new_window: {
    paths: [
      'M11.25 5.5a.75.75 0 0 0-.75-.75h-4a.75.75 0 0 0 0 1.5h2.19L4.97 9.97a.75.75 0 1 0 1.06 1.06l3.72-3.72V9.5a.75.75 0 0 0 1.5 0v-4Z',
      {
        d: 'M1 4.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C2.52 1 3.08 1 4.2 1h7.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C15 2.52 15 3.08 15 4.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C13.48 15 12.92 15 11.8 15H4.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C1 13.48 1 12.92 1 11.8V4.2Zm3.2-1.7h7.6c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.02.258.022.606.022 1.191v7.6c0 .585-.001.933-.022 1.191-.013.158-.03.224-.036.242a.5.5 0 0 1-.209.21 1.253 1.253 0 0 1-.242.035c-.258.02-.606.022-1.191.022H4.2c-.585 0-.933-.001-1.191-.022a1.253 1.253 0 0 1-.242-.036.5.5 0 0 1-.21-.209 1.255 1.255 0 0 1-.035-.242c-.02-.258-.022-.606-.022-1.191V4.2c0-.585.001-.933.022-1.191.013-.158.03-.224.036-.242a.5.5 0 0 1 .209-.21c.018-.005.084-.022.242-.035.258-.02.606-.022 1.191-.022Zm9.038.06-.003-.002.003.001Zm.203.202v.003-.003Zm0 10.476v-.003.003Zm-.203.203h-.003.003Zm-10.476 0h.003-.003Zm-.203-.203v-.003.003Zm0-10.476v.003-.003Zm.203-.203h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  business: {
    paths: [
      'M5 6a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 5 6Z',
      'M11.75 6.75a.75.75 0 0 0-1.5 0v4.5a.75.75 0 0 0 1.5 0v-4.5Z',
      {
        d: 'M4 3c0-.988.013-1.506.218-1.908a2 2 0 0 1 .874-.874C5.52 0 6.08 0 7.2 0h1.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874c.205.402.217.92.218 1.908h.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 4.52 16 5.08 16 6.2v5.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 15 13.92 15 12.8 15H3.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C0 13.48 0 12.92 0 11.8V6.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C1.52 3 2.08 3 3.2 3H4Zm3.2-1.5h1.6c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.018.227.021.524.022.991h-5c0-.467.004-.764.022-.991.013-.158.03-.224.036-.242a.5.5 0 0 1 .209-.21c.018-.005.084-.022.242-.035.258-.02.606-.022 1.191-.022Zm-4 3c-.585 0-.933.001-1.191.022-.158.013-.224.03-.242.036a.5.5 0 0 0-.21.209 1.254 1.254 0 0 0-.035.242c-.02.258-.022.606-.022 1.191v5.6c0 .585.001.933.022 1.191.013.158.03.224.036.242a.5.5 0 0 0 .209.21c.018.005.084.022.242.035.258.02.606.022 1.191.022h9.6c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .21-.209c.005-.018.022-.084.035-.242.02-.258.022-.606.022-1.191V6.2c0-.585-.001-.933-.022-1.191a1.252 1.252 0 0 0-.036-.242.5.5 0 0 0-.209-.21 1.255 1.255 0 0 0-.242-.035c-.258-.02-.606-.022-1.191-.022H3.2Zm11.038.06-.003-.002.003.001Zm.203.202v.003-.003Zm0 8.476v-.003.003Zm-.203.203h-.003.003Zm-12.476 0h.003-.003Zm-.203-.203v-.003.003Zm0-8.476v.003-.003Zm.203-.203h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  selected: {
    paths: [
      {
        d: 'M14.469 2.414a.75.75 0 0 1 .117 1.055l-8 10a.75.75 0 0 1-1.116.061l-4-4a.75.75 0 0 1 1.06-1.06l3.408 3.407 7.476-9.345a.75.75 0 0 1 1.055-.118Z',
        fillRule: 'evenodd',
      },
    ],
  },
  close: {
    paths: [
      {
        d: 'M1.97 1.97a.75.75 0 0 1 1.06 0L8 6.94l4.97-4.97a.75.75 0 1 1 1.06 1.06L9.06 8l4.97 4.97a.75.75 0 1 1-1.06 1.06L8 9.06l-4.97 4.97a.75.75 0 0 1-1.06-1.06L6.94 8 1.97 3.03a.75.75 0 0 1 0-1.06Z',
        fillRule: 'evenodd',
      },
    ],
  },
  response: {
    paths: [
      {
        d: 'M5.955 0h4.09c.187 0 .36 0 .518.025a2 2 0 0 1 1.42.975h.295c.326 0 .615 0 .854.02.255.02.519.067.776.198a2 2 0 0 1 .874.874c.131.257.178.521.198.776.02.24.02.528.02.854v9.556c0 .326 0 .615-.02.854-.02.255-.067.519-.198.776a2 2 0 0 1-.874.874 2.034 2.034 0 0 1-.776.198c-.24.02-.528.02-.854.02H3.722c-.326 0-.615 0-.854-.02a2.033 2.033 0 0 1-.776-.198 2 2 0 0 1-.874-.874 2.033 2.033 0 0 1-.198-.776c-.02-.24-.02-.528-.02-.854V3.722c0-.326 0-.615.02-.854.02-.255.067-.519.198-.776a2 2 0 0 1 .874-.874c.257-.131.521-.178.776-.198.24-.02.528-.02.854-.02H4.018a2 2 0 0 1 1.42-.975C5.594 0 5.767 0 5.954 0ZM3.751 2.5H3.75c-.362 0-.59 0-.76.015-.162.013-.207.034-.217.04a.5.5 0 0 0-.219.218c-.005.01-.026.055-.04.217-.013.17-.014.398-.014.76v9.5c0 .362 0 .59.015.76.013.162.034.207.04.217a.5.5 0 0 0 .218.218c.01.006.055.027.217.04.17.014.398.015.76.015h8.5c.362 0 .59 0 .76-.015.162-.013.207-.034.217-.04a.5.5 0 0 0 .218-.218c.006-.01.027-.055.04-.217.014-.17.015-.398.015-.76v-9.5c0-.362 0-.59-.014-.76-.014-.162-.035-.207-.04-.217a.5.5 0 0 0-.219-.219c-.01-.005-.055-.026-.217-.04a10.54 10.54 0 0 0-.76-.014h-.001a2 2 0 0 1-1.686 1.975c-.158.025-.331.025-.518.025h-4.09c-.186 0-.36 0-.518-.025A2 2 0 0 1 3.751 2.5ZM6 1.5c-.26 0-.304.002-.328.006a.5.5 0 0 0-.416.416 3.076 3.076 0 0 0-.006.328c0 .26.002.304.006.328a.5.5 0 0 0 .416.416C5.696 2.998 5.739 3 6 3h4c.26 0 .304-.002.328-.006a.5.5 0 0 0 .416-.416 3.04 3.04 0 0 0 .006-.328 3.04 3.04 0 0 0-.01-.35.5.5 0 0 0-.412-.394A3.076 3.076 0 0 0 10 1.5H6ZM4.25 7A.75.75 0 0 1 5 6.25h6a.75.75 0 0 1 0 1.5H5A.75.75 0 0 1 4.25 7Zm0 4a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75Z',
        fillRule: 'evenodd',
      },
    ],
  },
  trash: {
    paths: [
      'M12 4.5c0 .01 0 .728 0 0Z',
      'M6.75 6.25a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0v-6Z',
      'M10.75 6.25a.75.75 0 0 0-1.5 0v6a.75.75 0 0 0 1.5 0v-6Z',
      {
        d: 'M11.874 3a4.002 4.002 0 0 0-7.748 0H.75a.75.75 0 0 0 0 1.5H2v8.778c0 .326 0 .615.02.854.02.255.067.519.198.776a2 2 0 0 0 .874.874c.257.131.521.178.776.198.24.02.528.02.854.02h6.556c.326 0 .615 0 .854-.02.255-.02.519-.067.776-.198a2 2 0 0 0 .874-.874c.131-.257.178-.521.198-.776.02-.24.02-.528.02-.854V4.5h1.25a.75.75 0 0 0 0-1.5h-3.376ZM3.5 4.5H4v.28-.28h8.5v8.75c0 .362 0 .59-.014.76-.014.162-.035.207-.04.217a.5.5 0 0 1-.219.218c-.01.006-.055.027-.217.04-.17.014-.398.015-.76.015h-6.5c-.362 0-.59 0-.76-.014-.162-.014-.207-.035-.217-.04a.5.5 0 0 1-.219-.219c-.005-.01-.026-.055-.04-.217a10.54 10.54 0 0 1-.014-.76V4.5Zm6.79-1.502a2.5 2.5 0 0 0-4.581 0h4.582Z',
        fillRule: 'evenodd',
      },
    ],
  },
  tray_empty: {
    paths: [
      {
        d: 'M0 4.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C1.52 1 2.08 1 3.2 1h9.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 2.52 16 3.08 16 4.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 15 13.92 15 12.8 15H3.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C0 13.48 0 12.92 0 11.8V4.2Zm3.2-1.7h9.6c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.02.258.022.606.022 1.191v3.05h-1.916c-.22 0-.409 0-.561.007-.15.006-.328.021-.502.077l-.021.007c-.075.023-.2.063-.316.13a1.614 1.614 0 0 0-.272.205l-.017.015a1.553 1.553 0 0 0-.223.258c-.059.082-.123.18-.19.289-.135.215-.312.514-.538.895l-.006.01a2.249 2.249 0 0 1-3.876 0l-.006-.01c-.226-.38-.403-.68-.537-.895a5.735 5.735 0 0 0-.19-.29 1.552 1.552 0 0 0-.224-.257l-.017-.015c-.058-.052-.156-.14-.272-.206-.116-.066-.241-.106-.316-.13l-.021-.006a1.914 1.914 0 0 0-.502-.077c-.152-.007-.341-.007-.56-.007H1.5V4.2c0-.585.001-.933.022-1.191.013-.158.03-.224.036-.242a.5.5 0 0 1 .209-.21c.018-.005.084-.022.242-.035.258-.02.606-.022 1.191-.022ZM1.5 8.75v3.05c0 .585.001.933.022 1.191.013.158.03.224.036.242a.5.5 0 0 0 .209.21c.018.005.084.022.242.035.258.02.606.022 1.191.022h9.6c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .21-.209c.005-.018.022-.084.035-.242.02-.258.022-.606.022-1.191V8.75h-1.9c-.24 0-.396 0-.51.005-.076.004-.11.009-.118.01l-.042.013-.018.016a4.34 4.34 0 0 0-.159.24c-.124.197-.29.48-.524.873a3.749 3.749 0 0 1-6.458 0c-.233-.393-.4-.676-.524-.874a4.333 4.333 0 0 0-.16-.24l-.017-.015-.041-.013c-.008-.001-.043-.006-.118-.01-.115-.005-.27-.005-.511-.005H1.5Zm12.738-6.19-.003-.002a.03.03 0 0 1 .003.001Zm.203.202v.003-.003Zm0 10.476v-.003a.014.014 0 0 1 0 .003Zm-.203.203h-.003.003Zm-12.476 0h.003-.003Zm-.203-.203v-.003.003Zm0-10.476v.003-.003Zm.203-.203h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  user_profile: {
    paths: [
      {
        d: 'M5 5.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5ZM3.75 8a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z',
        fillRule: 'evenodd',
      },
      'M8.75 7a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3A.75.75 0 0 1 8.75 7Z',
      'M9.5 8.25a.75.75 0 0 0 0 1.5h1a.75.75 0 0 0 0-1.5h-1Z',
      {
        d: 'M0 4.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C1.52 1 2.08 1 3.2 1h9.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 2.52 16 3.08 16 4.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 15 13.92 15 12.8 15H3.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C0 13.48 0 12.92 0 11.8V4.2Zm3.2-1.7h9.6c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.02.258.022.606.022 1.191v7.6c0 .585-.001.933-.022 1.191-.013.158-.03.224-.036.242a.5.5 0 0 1-.209.21 1.253 1.253 0 0 1-.242.035c-.258.02-.606.022-1.191.022H3.2c-.585 0-.933-.001-1.191-.022a1.253 1.253 0 0 1-.242-.036.5.5 0 0 1-.21-.209 1.255 1.255 0 0 1-.035-.242c-.02-.258-.022-.606-.022-1.191V4.2c0-.585.001-.933.022-1.191.013-.158.03-.224.036-.242a.5.5 0 0 1 .209-.21c.018-.005.084-.022.242-.035.258-.02.606-.022 1.191-.022Zm11.038.06-.003-.002a.03.03 0 0 1 .003.001Zm.203.202v.003-.003Zm0 10.476v-.003a.014.014 0 0 1 0 .003Zm-.203.203h-.003.003Zm-12.476 0h.003-.003Zm-.203-.203Zm0-10.476v.003-.003Zm.203-.203h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  server: {
    paths: [
      'M3.25 5A.75.75 0 0 1 4 4.25h.5a.75.75 0 0 1 0 1.5H4A.75.75 0 0 1 3.25 5Z',
      'M7.25 5A.75.75 0 0 1 8 4.25h4a.75.75 0 0 1 0 1.5H8A.75.75 0 0 1 7.25 5Z',
      'M4 10.25a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 0-1.5H4Z',
      'M8 10.25a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5H8Z',
      {
        d: 'M0 4.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C1.52 1 2.08 1 3.2 1h9.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 2.52 16 3.08 16 4.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 15 13.92 15 12.8 15H3.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C0 13.48 0 12.92 0 11.8V4.2Zm3.2-1.7h9.6c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.02.258.022.606.022 1.191v3.05h-13V4.2c0-.585.001-.933.022-1.191.013-.158.03-.224.036-.242a.5.5 0 0 1 .209-.21c.018-.005.084-.022.242-.035.258-.02.606-.022 1.191-.022ZM1.5 8.75v3.05c0 .585.001.933.022 1.191.013.158.03.224.036.242a.5.5 0 0 0 .209.21c.018.005.084.022.242.035.258.02.606.022 1.191.022h9.6c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .21-.209c.005-.018.022-.084.035-.242.02-.258.022-.606.022-1.191V8.75h-13Zm12.738-6.19-.003-.002a.03.03 0 0 1 .003.001Zm.203.202v.003-.003Zm0 10.476v-.003a.014.014 0 0 1 0 .003Zm-.203.203h-.003.003Zm-12.476 0h.003-.003Zm-.203-.203Zm0-10.476v.003-.003Zm.203-.203h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  comment: {
    paths: [
      'M3.75 6a.75.75 0 0 1 .75-.75h7a.75.75 0 0 1 0 1.5h-7A.75.75 0 0 1 3.75 6Z',
      'M4.5 8.25a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5h-3Z',
      {
        d: 'M3.722 1h8.556c.326 0 .615 0 .854.02.255.02.519.067.776.198a2 2 0 0 1 .874.874c.131.257.178.521.198.776.02.24.02.528.02.854v7.556c0 .326 0 .615-.02.854-.02.255-.067.519-.198.776a2 2 0 0 1-.874.874 2.032 2.032 0 0 1-.776.198c-.24.02-.528.02-.854.02H4.76c-.314 0-.358.004-.393.012a.501.501 0 0 0-.135.051c-.031.018-.067.044-.302.253L2.248 15.81A.75.75 0 0 1 1 15.25V3.722c0-.326 0-.615.02-.854.02-.255.067-.519.198-.776a2 2 0 0 1 .874-.874c.257-.131.521-.178.776-.198.24-.02.528-.02.854-.02ZM2.99 2.515c-.162.013-.207.034-.217.04a.5.5 0 0 0-.219.218c-.005.01-.026.055-.04.217-.013.17-.014.398-.014.76v9.83l.472-.42c.171-.152.336-.299.53-.407.169-.094.351-.164.54-.206.217-.048.437-.047.667-.047h7.541c.362 0 .59 0 .76-.014.162-.014.207-.035.217-.04a.5.5 0 0 0 .218-.219c.006-.01.027-.055.04-.217.014-.17.015-.398.015-.76v-7.5c0-.362 0-.59-.014-.76-.014-.162-.035-.207-.04-.217a.5.5 0 0 0-.219-.219c-.01-.005-.055-.026-.217-.04-.17-.013-.398-.014-.76-.014h-8.5c-.362 0-.59 0-.76.015Z',
        fillRule: 'evenodd',
      },
    ],
  },
  question: {
    paths: [
      'M7.98 4.75c-.642 0-1.137.43-1.247.945a.75.75 0 0 1-1.467-.313c.265-1.241 1.4-2.132 2.714-2.132 1.494 0 2.77 1.162 2.77 2.673 0 1.25-.873 2.26-2.02 2.573V8.5a.75.75 0 0 1-1.5 0v-.654a.75.75 0 0 1 .75-.75c.736 0 1.27-.56 1.27-1.173S8.716 4.75 7.98 4.75Z',
      'M8 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
      {
        d: 'M3.722 1h8.556c.326 0 .615 0 .854.02.255.02.519.067.776.198a2 2 0 0 1 .874.874c.131.257.178.521.198.776.02.24.02.528.02.854v7.556c0 .326 0 .615-.02.854-.02.255-.067.519-.198.776a2 2 0 0 1-.874.874 2.032 2.032 0 0 1-.776.198c-.24.02-.528.02-.854.02H4.76c-.314 0-.358.004-.393.012a.501.501 0 0 0-.135.051c-.031.018-.067.044-.302.253L2.248 15.81A.75.75 0 0 1 1 15.25V3.722c0-.326 0-.615.02-.854.02-.255.067-.519.198-.776a2 2 0 0 1 .874-.874c.257-.131.521-.178.776-.198.24-.02.528-.02.854-.02ZM2.99 2.515c-.162.013-.207.034-.217.04a.5.5 0 0 0-.219.218c-.005.01-.026.055-.04.217-.013.17-.014.398-.014.76v9.83l.472-.42c.171-.152.336-.299.53-.407.169-.094.351-.164.54-.206.217-.048.437-.047.667-.047h7.541c.362 0 .59 0 .76-.014.162-.014.207-.035.217-.04a.5.5 0 0 0 .218-.219c.006-.01.027-.055.04-.217.014-.17.015-.398.015-.76v-7.5c0-.362 0-.59-.014-.76-.014-.162-.035-.207-.04-.217a.5.5 0 0 0-.219-.219c-.01-.005-.055-.026-.217-.04-.17-.013-.398-.014-.76-.014h-8.5c-.362 0-.59 0-.76.015Z',
        fillRule: 'evenodd',
      },
    ],
  },
  book_manual: {
    paths: [
      'M7.75 3.25a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5h-3.5Z',
      {
        d: 'M1.218 1.092C1 1.52 1 2.08 1 3.2v9.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C2.52 16 3.08 16 4.2 16h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C15 14.48 15 13.92 15 12.8V3.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C13.48 0 12.92 0 11.8 0H4.2C3.08 0 2.52 0 2.092.218a2 2 0 0 0-.874.874ZM11.8 1.5H5.75v13h6.05c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .21-.209c.005-.018.022-.084.035-.242.02-.258.022-.606.022-1.191V3.2c0-.585-.001-.933-.022-1.191a1.252 1.252 0 0 0-.036-.242.5.5 0 0 0-.209-.21 1.255 1.255 0 0 0-.242-.035c-.258-.02-.606-.022-1.191-.022Zm-7.6 0h.05v13H4.2c-.585 0-.933-.001-1.191-.022a1.253 1.253 0 0 1-.242-.036.5.5 0 0 1-.21-.209 1.255 1.255 0 0 1-.035-.242c-.02-.258-.022-.606-.022-1.191V3.2c0-.585.001-.933.022-1.191.013-.158.03-.224.036-.242a.5.5 0 0 1 .209-.21c.018-.005.084-.022.242-.035.258-.02.606-.022 1.191-.022Zm9.038.06-.003-.002.003.001Zm.203.202v.003-.003Zm0 12.476v-.003.003Zm-.203.203h-.003.003Zm-10.476 0h.003-.003Zm-.203-.203v-.003.003Zm0-12.476v.003-.003Zm.203-.203h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  book_address: {
    paths: [
      'M7 4a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 0 1.5h-3.5A.75.75 0 0 1 7 4Z',
      {
        d: 'M1 12.75v.05c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C2.52 16 3.08 16 4.2 16h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C15 14.48 15 13.92 15 12.8V3.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C13.48 0 12.92 0 11.8 0H4.2C3.08 0 2.52 0 2.092.218a2 2 0 0 0-.874.874C1 1.52 1 2.08 1 3.2v2.05H.75a.75.75 0 0 0 0 1.5H1v1.5H.75a.75.75 0 0 0 0 1.5H1v1.5H.75a.75.75 0 0 0 0 1.5H1ZM11.8 1.5H4.2c-.585 0-.933.001-1.191.022-.158.013-.224.03-.242.036a.5.5 0 0 0-.21.209 1.254 1.254 0 0 0-.035.242c-.02.258-.022.606-.022 1.191v2.05h.75a.75.75 0 0 1 0 1.5H2.5v1.5h.75a.75.75 0 0 1 0 1.5H2.5v1.5h.75a.75.75 0 0 1 0 1.5H2.5v.05c0 .585.001.933.022 1.191.013.158.03.224.036.242a.5.5 0 0 0 .209.21c.018.005.084.022.242.035.258.02.606.022 1.191.022h7.6c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .21-.209c.005-.018.022-.084.035-.242.02-.258.022-.606.022-1.191V3.2c0-.585-.001-.933-.022-1.191a1.252 1.252 0 0 0-.036-.242.5.5 0 0 0-.209-.21 1.255 1.255 0 0 0-.242-.035c-.258-.02-.606-.022-1.191-.022Zm1.438.06Zm.203.202v.003-.003Zm0 12.476v-.003.003Zm-.203.203h-.003.003Zm-10.476 0h.003-.003Zm-.203-.203v-.003.003Zm0-12.476v.003-.003Zm.203-.203h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  form: {
    paths: [
      {
        d: 'M4.2 1.5h7.6c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.02.258.022.606.022 1.191v9.6c0 .585-.001.933-.022 1.191-.013.158-.03.224-.036.242a.5.5 0 0 1-.209.21 1.253 1.253 0 0 1-.242.035c-.258.02-.606.022-1.191.022H4.2c-.585 0-.933-.001-1.191-.022a1.253 1.253 0 0 1-.242-.036.5.5 0 0 1-.21-.209 1.255 1.255 0 0 1-.035-.242c-.02-.258-.022-.606-.022-1.191V3.2c0-.585.001-.933.022-1.191.013-.158.03-.224.036-.242a.5.5 0 0 1 .209-.21c.018-.005.084-.022.242-.035.258-.02.606-.022 1.191-.022Zm9.038.06-.003-.002.003.001Zm.203.202v.003-.003Zm0 12.476v-.003.003Zm-.203.203h-.003.003Zm-10.476 0h.003-.003Zm-.203-.203v-.003.003Zm0-12.476v.003-.003Zm.203-.203h.003-.003ZM1 3.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C2.52 0 3.08 0 4.2 0h7.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C15 1.52 15 2.08 15 3.2v9.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C13.48 16 12.92 16 11.8 16H4.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C1 14.48 1 13.92 1 12.8V3.2Zm4 .05a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5H5ZM4.25 8A.75.75 0 0 1 5 7.25h6a.75.75 0 0 1 0 1.5H5A.75.75 0 0 1 4.25 8ZM5 11.25a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5H5Z',
        fillRule: 'evenodd',
      },
    ],
  },
  form_valid: {
    paths: [
      'M3.722 0h8.556c.326 0 .615 0 .854.02.255.02.519.067.776.198a2 2 0 0 1 .874.874c.131.257.178.521.198.776.02.24.02.528.02.854V8a.75.75 0 0 1-1.5 0V2.75c0-.362 0-.59-.014-.76-.014-.162-.035-.207-.04-.217a.5.5 0 0 0-.219-.218c-.01-.006-.055-.027-.217-.04-.17-.014-.398-.015-.76-.015h-8.5c-.362 0-.59 0-.76.015-.162.013-.207.034-.217.04a.5.5 0 0 0-.219.218c-.005.01-.026.055-.04.217-.013.17-.014.398-.014.76v10.5c0 .362 0 .59.015.76.013.162.034.207.04.217a.5.5 0 0 0 .218.218c.01.006.055.027.217.04.17.014.398.015.76.015H8A.75.75 0 0 1 8 16H3.722c-.326 0-.615 0-.854-.02a2.032 2.032 0 0 1-.776-.198 2 2 0 0 1-.874-.874 2.033 2.033 0 0 1-.198-.776c-.02-.24-.02-.528-.02-.854V2.722c0-.326 0-.615.02-.854.02-.255.067-.519.198-.776a2 2 0 0 1 .874-.874c.257-.131.521-.178.776-.198.24-.02.528-.02.854-.02Z',
      'M4.25 4A.75.75 0 0 1 5 3.25h4a.75.75 0 0 1 0 1.5H5A.75.75 0 0 1 4.25 4Z',
      'M5 7.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5H5Z',
      'M4.25 12a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75Z',
      'M15.836 11.719a.75.75 0 0 0-1.172-.938l-2.676 3.346-1.008-1.007a.75.75 0 1 0-1.06 1.06l1.6 1.6a.75.75 0 0 0 1.116-.061l3.2-4Z',
    ],
  },
  gift: {
    paths: [
      {
        d: 'M5.45.15a.75.75 0 0 0-.9 1.2l.867.65H3.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C0 3.52 0 4.08 0 5.2v.6c0 1.12 0 1.68.218 2.108.07.137.146.273.222.41.278.5.56 1.007.56 1.566V11.8c0 1.12 0 2.68.218 3.108a2 2 0 0 0 .874.874C2.52 16 3.08 16 4.2 16h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C15 14.48 15 12.92 15 11.8V9.884c0-.56.282-1.067.56-1.566.076-.137.152-.273.222-.41C16 7.48 16 6.92 16 5.8v-.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 2 13.92 2 12.8 2h-2.217l.867-.65a.75.75 0 1 0-.9-1.2L8.083 2h-.166L5.45.15ZM1.5 5.2c0-.585.001-.933.022-1.191.013-.158.03-.224.036-.242a.5.5 0 0 1 .209-.21c.018-.005.084-.022.242-.035.258-.02.606-.022 1.191-.022h4.05v3.75H1.566l-.008-.017a1.25 1.25 0 0 1-.036-.242C1.502 6.733 1.5 6.385 1.5 5.8v-.6Zm7.25 2.05V3.5h4.05c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.02.258.022.606.022 1.191v.6c0 .585-.001.933-.022 1.191-.013.159-.03.225-.036.242l-.008.017H8.75Zm-6.448 1.5H7.25v5.75H4.2c-.585 0-.933-.001-1.191-.022a1.252 1.252 0 0 1-.242-.036.5.5 0 0 1-.174-.152 2.242 2.242 0 0 1-.015-.094 7.73 7.73 0 0 1-.052-.652A39.44 39.44 0 0 1 2.5 11.8V9.884c0-.424-.085-.806-.198-1.134Zm6.448 0v5.75h3.05c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .174-.152c.004-.023.01-.054.015-.094.022-.16.04-.38.052-.652.026-.542.026-1.176.026-1.744V9.884c0-.424.085-.806.198-1.134H8.75Z',
        fillRule: 'evenodd',
      },
    ],
  },
  box: {
    paths: [
      'M5.25 11a.75.75 0 0 1 .75-.75h4a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75Z',
      {
        d: 'M1.092 1.218C1.52 1 2.08 1 3.2 1h9.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 2.52 16 3.08 16 4.2v.6c0 1.12 0 1.68-.218 2.108-.07.137-.146.273-.222.41-.278.5-.56 1.007-.56 1.566V11.8c0 1.12 0 2.68-.218 3.108a2 2 0 0 1-.874.874C13.48 16 12.92 16 11.8 16H4.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C1 14.48 1 12.92 1 11.8V8.884c0-.56-.282-1.067-.56-1.566-.076-.137-.152-.273-.222-.41C0 6.48 0 5.92 0 4.8v-.6c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874Zm.43 1.79c-.02.259-.022.607-.022 1.192v.6c0 .585.001.933.022 1.191.013.159.03.225.036.242l.008.017h12.868l.008-.017c.006-.017.023-.083.036-.242.02-.258.022-.606.022-1.191v-.6c0-.585-.001-.933-.022-1.191a1.253 1.253 0 0 0-.036-.242.5.5 0 0 0-.209-.21 1.255 1.255 0 0 0-.242-.035c-.258-.02-.606-.022-1.191-.022H3.2c-.585 0-.933.001-1.191.022-.158.013-.224.03-.242.036a.5.5 0 0 0-.21.209 1.254 1.254 0 0 0-.035.242ZM13.698 7.75H2.302c.113.328.198.71.198 1.134V11.8c0 .568 0 1.202.026 1.744.012.271.03.491.052.652.006.04.01.071.015.094a.5.5 0 0 0 .174.152c.018.006.084.023.242.036.258.02.606.022 1.191.022h7.6c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .174-.152c.004-.023.01-.054.015-.094.022-.16.04-.38.052-.652.026-.542.026-1.176.026-1.744V8.884c0-.424.085-.806.198-1.134ZM1.559 2.762v.003-.003Zm.203-.203h.003-.003Zm12.476 0h-.003.003Zm.203.203v.003-.003Zm0 3.476v-.003.003Zm-1.203 8.202-.003.002.003-.002Zm-10.476 0 .003.002-.003-.002ZM1.559 6.239v-.003.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  copy: {
    paths: [
      'M3.722 1c-.326 0-.615 0-.854.02-.255.02-.519.067-.776.198a2 2 0 0 0-.874.874 2.032 2.032 0 0 0-.198.776c-.02.24-.02.528-.02.854v4.056c0 .326 0 .615.02.854.02.255.067.519.198.776a2 2 0 0 0 .874.874c.257.131.521.178.776.198.24.02.528.02.854.02H4A.75.75 0 0 0 4 9h-.25c-.362 0-.59 0-.76-.015-.162-.013-.207-.034-.217-.04a.5.5 0 0 1-.219-.218c-.005-.01-.026-.055-.04-.217-.013-.17-.014-.398-.014-.76v-4c0-.362 0-.59.015-.76.013-.162.034-.207.04-.217a.5.5 0 0 1 .218-.219c.01-.005.055-.026.217-.04.17-.013.398-.014.76-.014h4c.362 0 .59 0 .76.015.162.013.207.034.217.04a.5.5 0 0 1 .219.218c.005.01.026.055.04.217.013.17.014.398.014.76V4a.75.75 0 1 0 1.5 0v-.278c0-.326 0-.615-.02-.854a2.032 2.032 0 0 0-.198-.776 2 2 0 0 0-.874-.874 2.032 2.032 0 0 0-.776-.198C8.392 1 8.104 1 7.778 1H3.722Z',
      {
        d: 'M8.222 5.5c-.326 0-.615 0-.854.02-.255.02-.519.067-.776.198a2 2 0 0 0-.874.874 2.032 2.032 0 0 0-.198.776c-.02.24-.02.528-.02.854v4.056c0 .326 0 .615.02.854.02.255.067.519.198.776a2 2 0 0 0 .874.874c.257.131.521.178.776.198.24.02.528.02.854.02h4.056c.326 0 .615 0 .854-.02.255-.02.519-.067.776-.198a2 2 0 0 0 .874-.874c.131-.257.178-.521.198-.776.02-.24.02-.528.02-.854V8.222c0-.326 0-.615-.02-.854a2.032 2.032 0 0 0-.198-.776 2 2 0 0 0-.874-.874 2.033 2.033 0 0 0-.776-.198c-.24-.02-.528-.02-.854-.02H8.222Zm-.949 1.554c.01-.005.055-.026.217-.04.17-.013.398-.014.76-.014h4c.362 0 .59 0 .76.015.162.013.207.034.217.04a.5.5 0 0 1 .218.218c.006.01.027.055.04.217.014.17.015.398.015.76v4c0 .362 0 .59-.014.76-.014.162-.035.207-.04.217a.5.5 0 0 1-.219.218c-.01.006-.055.027-.217.04-.17.014-.398.015-.76.015h-4c-.362 0-.59 0-.76-.014-.162-.014-.207-.035-.217-.04a.5.5 0 0 1-.218-.219c-.006-.01-.027-.055-.04-.217C7 12.84 7 12.612 7 12.25v-4c0-.362 0-.59.015-.76.013-.162.034-.207.04-.217a.5.5 0 0 1 .218-.218Z',
        fillRule: 'evenodd',
      },
    ],
  },
  boolean: {
    paths: [
      'M5 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
      {
        d: 'M1 4a3 3 0 0 1 3-3h8a3 3 0 1 1 0 6H4a3 3 0 0 1-3-3Zm3-1.5h8a1.5 1.5 0 0 1 0 3H4a1.5 1.5 0 1 1 0-3Z',
        fillRule: 'evenodd',
      },
      'M12 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
      {
        d: 'M1 12a3 3 0 0 1 3-3h8a3 3 0 1 1 0 6H4a3 3 0 0 1-3-3Zm3-1.5h8a1.5 1.5 0 0 1 0 3H4a1.5 1.5 0 0 1 0-3Z',
        fillRule: 'evenodd',
      },
    ],
  },
  code: {
    paths: [
      {
        d: 'M6.28 12.53a.75.75 0 0 1-1.06 0l-4-4a.75.75 0 0 1 0-1.06l4-4a.75.75 0 0 1 1.06 1.06L2.81 8l3.47 3.47a.75.75 0 0 1 0 1.06Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M9.72 3.47a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 1 1-1.06-1.06L13.19 8 9.72 4.53a.75.75 0 0 1 0-1.06Z',
        fillRule: 'evenodd',
      },
    ],
  },
  layers: {
    paths: [
      {
        d: 'M7.665 1.08a.75.75 0 0 1 .67 0l6 3a.75.75 0 0 1 0 1.34l-6 3a.75.75 0 0 1-.67 0l-6-3a.75.75 0 0 1 0-1.34l6-3ZM3.677 4.75 8 6.911l4.323-2.161L8 2.589 3.677 4.75Z',
        fillRule: 'evenodd',
      },
      'M1.33 7.665a.75.75 0 0 1 1.005-.336L8 10.162l5.665-2.833a.75.75 0 1 1 .67 1.342l-6 3a.75.75 0 0 1-.67 0l-6-3a.75.75 0 0 1-.336-1.006Z',
      'M2.335 10.58a.75.75 0 1 0-.67 1.34l6 3a.75.75 0 0 0 .67 0l6-3a.75.75 0 1 0-.67-1.34L8 13.411l-5.665-2.833Z',
    ],
  },
  key: {
    paths: [
      {
        d: 'M14.06 3a.75.75 0 0 0-1.09-1.03L7.248 7.69a4 4 0 1 0 1.06 1.06L11 6.062l.97.97a.75.75 0 1 0 1.06-1.061L12.06 5l.94-.94 1.47 1.47a.75.75 0 1 0 1.06-1.06L14.06 3ZM7.5 11a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z',
        fillRule: 'evenodd',
      },
    ],
  },
  image: {
    paths: [
      {
        d: 'M10.5 3.25a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM9.75 5.5a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M3.722 1c-.326 0-.615 0-.854.02-.255.02-.519.067-.776.198a2 2 0 0 0-.874.874 2.032 2.032 0 0 0-.198.776c-.02.24-.02.528-.02.854v8.556c0 .326 0 .615.02.854.02.255.067.519.198.776a2 2 0 0 0 .874.874c.257.131.521.178.776.198.24.02.528.02.854.02h8.556c.326 0 .615 0 .854-.02.255-.02.519-.067.776-.198a2 2 0 0 0 .874-.874c.131-.257.178-.521.198-.776.02-.24.02-.528.02-.854V3.722c0-.326 0-.615-.02-.854a2.032 2.032 0 0 0-.198-.776 2 2 0 0 0-.874-.874 2.033 2.033 0 0 0-.776-.198c-.24-.02-.528-.02-.854-.02H3.722Zm-.949 1.554c.01-.005.055-.026.217-.04.17-.013.398-.014.76-.014h8.5c.362 0 .59 0 .76.015.162.013.207.034.217.04a.5.5 0 0 1 .218.218c.006.01.027.055.04.217.014.17.015.398.015.76v6.742a4.745 4.745 0 0 0-1.5-.242c-.733 0-1.428.166-2.05.464A5.246 5.246 0 0 0 5.5 8.25c-1.115 0-2.15.348-3 .941V3.75c0-.362 0-.59.015-.76.013-.162.034-.207.04-.217a.5.5 0 0 1 .218-.219ZM2.5 11.23v1.02c0 .362 0 .59.015.76.013.162.034.207.04.217a.5.5 0 0 0 .218.218c.01.006.055.027.217.04.17.014.398.015.76.015h5.5a3.75 3.75 0 0 0-6.667-2.357.75.75 0 0 1-.083.087Zm8.25 2.27h1.5c.362 0 .59 0 .76-.014.162-.014.207-.035.217-.04a.5.5 0 0 0 .218-.219c.006-.01.027-.055.04-.217.014-.17.015-.398.015-.76v-.134a3.233 3.233 0 0 0-1.5-.366c-.52 0-1.008.121-1.442.337.125.45.192.923.192 1.413Z',
        fillRule: 'evenodd',
      },
    ],
  },
  camera: {
    paths: [
      {
        d: 'M8 5a3.75 3.75 0 1 0 0 7.5A3.75 3.75 0 0 0 8 5ZM5.75 8.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M6.772 1c-.25 0-.488 0-.721.055a2 2 0 0 0-.578.24c-.204.125-.373.294-.55.47l-.868.869c-.241.241-.279.272-.312.292a.5.5 0 0 1-.144.06c-.038.01-.086.014-.427.014h-.45c-.326 0-.615 0-.854.02-.255.02-.519.067-.776.198a2 2 0 0 0-.874.874 2.032 2.032 0 0 0-.198.776c-.02.24-.02.528-.02.854v6.556c0 .326 0 .615.02.854.02.255.067.519.198.776a2 2 0 0 0 .874.874c.257.131.521.178.776.198.24.02.528.02.854.02h10.556c.326 0 .615 0 .854-.02.255-.02.519-.067.776-.198a2 2 0 0 0 .874-.874c.131-.257.178-.521.198-.776.02-.24.02-.528.02-.854V5.722c0-.326 0-.615-.02-.854a2.032 2.032 0 0 0-.198-.776 2 2 0 0 0-.874-.874 2.033 2.033 0 0 0-.776-.199C13.892 3 13.604 3 13.278 3h-.45c-.341 0-.39-.005-.427-.014a.501.501 0 0 1-.144-.06c-.033-.02-.071-.05-.313-.292l-.867-.868c-.177-.177-.345-.346-.55-.471a2 2 0 0 0-.578-.24C9.716 1 9.477 1 9.228 1H6.772Zm-.371 1.514c.038-.01.086-.014.427-.014h2.344c.341 0 .39.005.427.014a.5.5 0 0 1 .144.06c.033.02.071.05.313.292l.868.868c.176.177.345.346.549.471.179.11.374.19.578.24.233.056.472.055.721.055h.478c.362 0 .59 0 .76.015.162.013.207.034.217.04a.5.5 0 0 1 .218.218c.006.01.027.055.04.217.014.17.015.398.015.76v6.5c0 .362 0 .59-.014.76-.014.162-.035.207-.04.217a.5.5 0 0 1-.219.218c-.01.006-.055.027-.217.04-.17.014-.398.015-.76.015H2.75c-.362 0-.59 0-.76-.015-.162-.013-.207-.034-.217-.04a.5.5 0 0 1-.218-.218c-.006-.01-.027-.055-.04-.217-.014-.17-.015-.398-.015-.76v-6.5c0-.362 0-.59.015-.76.013-.162.034-.207.04-.217a.5.5 0 0 1 .218-.219c.01-.005.055-.026.217-.04.17-.013.398-.014.76-.014h.478c.25 0 .488 0 .721-.055a2 2 0 0 0 .578-.24c.204-.125.373-.294.55-.47l.868-.869c.241-.241.279-.272.312-.292a.5.5 0 0 1 .144-.06Z',
        fillRule: 'evenodd',
      },
    ],
  },
  recordings_old: {
    paths: [
      {
        d: 'M2.722 2c-.326 0-.615 0-.854.02-.255.02-.519.067-.776.198a2 2 0 0 0-.874.874 2.032 2.032 0 0 0-.198.776c-.02.24-.02.528-.02.854v6.556c0 .326 0 .615.02.854.02.255.067.519.198.776a2 2 0 0 0 .874.874c.257.131.521.178.776.198.24.02.528.02.854.02h5.556c.326 0 .615 0 .854-.02.255-.02.519-.067.776-.198a2 2 0 0 0 .874-.874c.131-.257.178-.521.198-.776.02-.24.02-.528.02-.854V4.722c0-.326 0-.615-.02-.854a2.032 2.032 0 0 0-.198-.776 2 2 0 0 0-.874-.874 2.032 2.032 0 0 0-.776-.198C8.892 2 8.604 2 8.278 2H2.722Zm-.949 1.554c.01-.005.055-.026.217-.04.17-.013.398-.014.76-.014h5.5c.362 0 .59 0 .76.015.162.013.207.034.217.04a.5.5 0 0 1 .219.218c.005.01.026.055.04.217.013.17.014.398.014.76v6.5c0 .362 0 .59-.015.76-.013.162-.034.207-.04.217a.5.5 0 0 1-.218.218c-.01.006-.055.027-.217.04-.17.014-.398.015-.76.015h-5.5c-.362 0-.59 0-.76-.014-.162-.014-.207-.035-.217-.04a.5.5 0 0 1-.218-.219c-.006-.01-.027-.055-.04-.217-.014-.17-.015-.398-.015-.76v-6.5c0-.362 0-.59.015-.76.013-.162.034-.207.04-.217a.5.5 0 0 1 .218-.219Z',
        fillRule: 'evenodd',
      },
      'M16 4.75a.75.75 0 0 0-1.06-.683l-2.75 1.25a.75.75 0 1 0 .62 1.366l1.69-.768v4.17l-1.69-.768a.75.75 0 1 0-.62 1.366l2.75 1.25A.75.75 0 0 0 16 11.25v-6.5Z',
    ],
  },
  number: {
    paths: [
      'M9 5.5a.75.75 0 0 0-1.28-.53l-1.5 1.5a.75.75 0 0 0 1.06 1.06l.22-.22v1.94h-.75a.75.75 0 0 0 0 1.5H9.5a.75.75 0 0 0 0-1.5H9V5.5Z',
      {
        d: 'M1 4.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C2.52 1 3.08 1 4.2 1h7.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C15 2.52 15 3.08 15 4.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C13.48 15 12.92 15 11.8 15H4.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C1 13.48 1 12.92 1 11.8V4.2Zm3.2-1.7h7.6c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.02.258.022.606.022 1.191v7.6c0 .585-.001.933-.022 1.191-.013.158-.03.224-.036.242a.5.5 0 0 1-.209.21 1.253 1.253 0 0 1-.242.035c-.258.02-.606.022-1.191.022H4.2c-.585 0-.933-.001-1.191-.022a1.253 1.253 0 0 1-.242-.036.5.5 0 0 1-.21-.209 1.255 1.255 0 0 1-.035-.242c-.02-.258-.022-.606-.022-1.191V4.2c0-.585.001-.933.022-1.191.013-.158.03-.224.036-.242a.5.5 0 0 1 .209-.21c.018-.005.084-.022.242-.035.258-.02.606-.022 1.191-.022Zm9.038.06-.003-.002.003.001Zm.203.202v.003-.003Zm0 10.476v-.003.003Zm-.203.203h-.003.003Zm-10.476 0h.003-.003Zm-.203-.203v-.003.003Zm0-10.476v.003-.003Zm.203-.203h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  id: {
    paths: [
      {
        d: 'M11.8 2.5H4.2c-.585 0-.933.001-1.191.022-.158.013-.224.03-.242.036a.5.5 0 0 0-.21.209 1.254 1.254 0 0 0-.035.242c-.02.258-.022.606-.022 1.191v7.6c0 .585.001.933.022 1.191.013.158.03.224.036.242a.5.5 0 0 0 .209.21c.018.005.084.022.242.035.258.02.606.022 1.191.022h7.6c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .21-.209c.005-.018.022-.084.035-.242.02-.258.022-.606.022-1.191V4.2c0-.585-.001-.933-.022-1.191a1.252 1.252 0 0 0-.036-.242.5.5 0 0 0-.209-.21 1.255 1.255 0 0 0-.242-.035c-.258-.02-.606-.022-1.191-.022ZM1.218 2.092C1 2.52 1 3.08 1 4.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C2.52 15 3.08 15 4.2 15h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C15 13.48 15 12.92 15 11.8V4.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C13.48 1 12.92 1 11.8 1H4.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M5 4.75a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5A.75.75 0 0 1 5 4.75Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M8 4.75H8.057l.132.006a6.699 6.699 0 0 1 1.813.35c.503.18 1.061.467 1.5.937.453.486.748 1.137.748 1.957 0 .82-.295 1.47-.749 1.957-.438.47-.995.757-1.499.937a6.692 6.692 0 0 1-1.814.35L8 11.25a.75.75 0 0 1-.75-.75v-5A.75.75 0 0 1 8 4.75Zm.75 4.924c.233-.04.493-.102.748-.193.372-.133.689-.314.907-.547.202-.217.345-.504.345-.934 0-.43-.143-.717-.345-.934-.218-.233-.535-.414-.907-.547a4.566 4.566 0 0 0-.748-.193v3.348Z',
        fillRule: 'evenodd',
      },
    ],
  },
  ip: {
    paths: [
      'M5 4.75a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5A.75.75 0 0 1 5 4.75Z',
      {
        d: 'M9.623 9.24a5.22 5.22 0 0 1-.873.065V10.5a.75.75 0 1 1-1.5 0v-5a.75.75 0 0 1 .627-.74l.163-.022c.095-.012.228-.025.387-.034a5.55 5.55 0 0 1 1.196.056c.44.073.963.231 1.388.586.457.38.739.938.739 1.654s-.282 1.273-.739 1.654c-.425.355-.948.513-1.388.586Zm-.246-3a3.734 3.734 0 0 0-.627-.046v1.611c.198.002.416-.01.627-.045.31-.052.537-.144.674-.258.106-.088.199-.218.199-.502 0-.284-.093-.414-.199-.502-.137-.114-.364-.206-.674-.258Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M1.218 2.092C1 2.52 1 3.08 1 4.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C2.52 15 3.08 15 4.2 15h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C15 13.48 15 12.92 15 11.8V4.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C13.48 1 12.92 1 11.8 1H4.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874ZM11.8 2.5H4.2c-.585 0-.933.001-1.191.022-.158.013-.224.03-.242.036a.5.5 0 0 0-.21.209 1.254 1.254 0 0 0-.035.242c-.02.258-.022.606-.022 1.191v7.6c0 .585.001.933.022 1.191.013.158.03.224.036.242a.5.5 0 0 0 .209.21c.018.005.084.022.242.035.258.02.606.022 1.191.022h7.6c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .21-.209c.005-.018.022-.084.035-.242.02-.258.022-.606.022-1.191V4.2c0-.585-.001-.933-.022-1.191a1.252 1.252 0 0 0-.036-.242.5.5 0 0 0-.209-.21 1.255 1.255 0 0 0-.242-.035c-.258-.02-.606-.022-1.191-.022Zm1.438.06-.003-.002.003.001Zm.203.202v.003-.003Zm0 10.476v-.003.003Zm-.203.203h-.003.003Zm-10.476 0h.003-.003ZM2.559 2.76v.004-.003Zm.203-.202h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  string: {
    paths: [
      {
        d: 'M8 4.25a.75.75 0 0 1 .683.44l2.5 5.5a.75.75 0 0 1-1.366.62l-.482-1.06h-2.67l-.482 1.06a.75.75 0 0 1-1.366-.62l2.5-5.5A.75.75 0 0 1 8 4.25Zm-.653 4h1.306L8 6.812 7.347 8.25Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M1.218 2.092C1 2.52 1 3.08 1 4.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C2.52 15 3.08 15 4.2 15h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C15 13.48 15 12.92 15 11.8V4.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C13.48 1 12.92 1 11.8 1H4.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874ZM11.8 2.5H4.2c-.585 0-.933.001-1.191.022-.158.013-.224.03-.242.036a.5.5 0 0 0-.21.209 1.254 1.254 0 0 0-.035.242c-.02.258-.022.606-.022 1.191v7.6c0 .585.001.933.022 1.191.013.158.03.224.036.242a.5.5 0 0 0 .209.21c.018.005.084.022.242.035.258.02.606.022 1.191.022h7.6c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .21-.209c.005-.018.022-.084.035-.242.02-.258.022-.606.022-1.191V4.2c0-.585-.001-.933-.022-1.191a1.252 1.252 0 0 0-.036-.242.5.5 0 0 0-.209-.21 1.255 1.255 0 0 0-.242-.035c-.258-.02-.606-.022-1.191-.022Zm1.438.06-.003-.002.003.001Zm.203.202v.003-.003Zm0 10.476v-.003.003Zm-.203.203h-.003.003Zm-10.476 0h.003-.003Zm-.203-.203Zm0-10.476v.003-.003Zm.203-.203h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  metric: {
    paths: [
      {
        d: 'M4.2 2.5h7.6c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.02.258.022.606.022 1.191v7.6c0 .585-.001.933-.022 1.191-.013.158-.03.224-.036.242a.5.5 0 0 1-.209.21 1.253 1.253 0 0 1-.242.035c-.258.02-.606.022-1.191.022H4.2c-.585 0-.933-.001-1.191-.022a1.253 1.253 0 0 1-.242-.036.5.5 0 0 1-.21-.209 1.255 1.255 0 0 1-.035-.242c-.02-.258-.022-.606-.022-1.191V4.2c0-.585.001-.933.022-1.191.013-.158.03-.224.036-.242a.5.5 0 0 1 .209-.21c.018-.005.084-.022.242-.035.258-.02.606-.022 1.191-.022Zm9.038.06-.003-.002.003.001Zm.203.202v.003-.003Zm0 10.476v-.003.003Zm-.203.203h-.003.003Zm-10.476 0h.003-.003Zm-.203-.203v-.003.003Zm0-10.476v.003-.003Zm.203-.203h.003-.003ZM1 4.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C2.52 1 3.08 1 4.2 1h7.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C15 2.52 15 3.08 15 4.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C13.48 15 12.92 15 11.8 15H4.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C1 13.48 1 12.92 1 11.8V4.2Zm10.53 1.33a.75.75 0 0 0-1.06-1.06l-6 6a.75.75 0 1 0 1.06 1.06l6-6ZM5.5 4.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm-2.25.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Zm6.5 5a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Zm.75-2.25a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z',
        fillRule: 'evenodd',
      },
    ],
  },
  checkbox: {
    paths: [
      'M11.586 5.969a.75.75 0 0 0-1.172-.937L6.938 9.377 5.53 7.97a.75.75 0 1 0-1.06 1.06l2 2a.75.75 0 0 0 1.116-.061l4-5Z',
      {
        d: 'M1 4.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C2.52 1 3.08 1 4.2 1h7.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C15 2.52 15 3.08 15 4.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C13.48 15 12.92 15 11.8 15H4.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C1 13.48 1 12.92 1 11.8V4.2Zm3.2-1.7h7.6c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.02.258.022.606.022 1.191v7.6c0 .585-.001.933-.022 1.191-.013.158-.03.224-.036.242a.5.5 0 0 1-.209.21 1.253 1.253 0 0 1-.242.035c-.258.02-.606.022-1.191.022H4.2c-.585 0-.933-.001-1.191-.022a1.253 1.253 0 0 1-.242-.036.5.5 0 0 1-.21-.209 1.255 1.255 0 0 1-.035-.242c-.02-.258-.022-.606-.022-1.191V4.2c0-.585.001-.933.022-1.191.013-.158.03-.224.036-.242a.5.5 0 0 1 .209-.21c.018-.005.084-.022.242-.035.258-.02.606-.022 1.191-.022Zm9.038.06-.003-.002.003.001Zm.203.202v.003-.003Zm0 10.476v-.003.003Zm-.203.203h-.003.003Zm-10.476 0h.003-.003Zm-.203-.203v-.003.003Zm0-10.476v.003-.003Zm.203-.203h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  event: {
    paths: [
      'M10.886 7.719a.75.75 0 0 0-1.172-.937l-2.676 3.345L6.03 9.12a.75.75 0 1 0-1.06 1.06l1.6 1.6a.75.75 0 0 0 1.116-.061l3.2-4Z',
      {
        d: 'M5.75.75a.75.75 0 0 0-1.5 0V1H4.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C1 2.52 1 3.08 1 4.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C2.52 15 3.08 15 4.2 15h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C15 13.48 15 12.92 15 11.8V4.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C13.48 1 12.92 1 11.8 1h-.05V.75a.75.75 0 0 0-1.5 0V1h-4.5V.75ZM10.25 3v-.5h-4.5V3a.75.75 0 0 1-1.5 0v-.5H4.2c-.585 0-.933.001-1.191.022-.158.013-.224.03-.242.036a.5.5 0 0 0-.21.209 1.254 1.254 0 0 0-.035.242c-.02.258-.022.606-.022 1.191v.05h11V4.2c0-.585-.001-.933-.022-1.191a1.252 1.252 0 0 0-.036-.242.5.5 0 0 0-.209-.21 1.255 1.255 0 0 0-.242-.035c-.258-.02-.606-.022-1.191-.022h-.05V3a.75.75 0 0 1-1.5 0ZM2.5 11.8V5.75h11v6.05c0 .585-.001.933-.022 1.191-.013.158-.03.224-.036.242a.5.5 0 0 1-.209.21 1.253 1.253 0 0 1-.242.035c-.258.02-.606.022-1.191.022H4.2c-.585 0-.933-.001-1.191-.022a1.253 1.253 0 0 1-.242-.036.5.5 0 0 1-.21-.209 1.255 1.255 0 0 1-.035-.242c-.02-.258-.022-.606-.022-1.191Zm10.738-9.24-.003-.002.003.001Zm.203.202v.003-.003Zm0 10.476v-.003.003Zm-.203.203h-.003.003Zm-10.476 0h.003-.003Zm-.203-.203v-.003.003Zm0-10.476v.003-.003Zm.203-.203h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  date: {
    paths: [
      {
        d: 'M5 0a.75.75 0 0 1 .75.75V1h4.5V.75a.75.75 0 0 1 1.5 0V1h.05c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C15 2.52 15 3.08 15 4.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C13.48 15 12.92 15 11.8 15H4.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C1 13.48 1 12.92 1 11.8V4.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C2.52 1 3.08 1 4.2 1h.05V.75A.75.75 0 0 1 5 0Zm5.25 2.5V3a.75.75 0 0 0 1.5 0v-.5h.05c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.02.258.022.606.022 1.191v.05h-11V4.2c0-.585.001-.933.022-1.191.013-.158.03-.224.036-.242a.5.5 0 0 1 .209-.21c.018-.005.084-.022.242-.035.258-.02.606-.022 1.191-.022h.05V3a.75.75 0 0 0 1.5 0v-.5h4.5ZM2.5 5.75v6.05c0 .585.001.933.022 1.191.013.158.03.224.036.242a.5.5 0 0 0 .209.21c.018.005.084.022.242.035.258.02.606.022 1.191.022h7.6c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .21-.209c.005-.018.022-.084.035-.242.02-.258.022-.606.022-1.191V5.75h-11Zm10.738-3.19-.003-.002.003.001Zm.203.202v.003-.003Zm0 10.473v.003-.003Zm-.203.206h-.003.003Zm-10.476 0h.003-.003Zm-.203-.203v-.003.003Zm0-10.476v.003-.003Zm.203-.203h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  chart_bar: {
    paths: [
      {
        d: 'M.75 0a.75.75 0 0 1 .75.75V13.5H3V4.41c0-.373-.001-.723.098-1.028a2 2 0 0 1 1.284-1.284c.305-.1.655-.099 1.028-.098h.18c.373 0 .723-.001 1.028.098a2 2 0 0 1 1.284 1.284c.1.305.099.655.098 1.028v9.09h1.5V8.91c0-.373-.001-.723.098-1.028a2 2 0 0 1 1.284-1.284c.305-.1.655-.099 1.028-.098h.18c.373 0 .723-.001 1.028.098a2 2 0 0 1 1.284 1.284c.1.305.099.655.098 1.028v4.59h.75a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75V.75A.75.75 0 0 1 .75 0ZM5.5 3.5c-.524 0-.608.01-.655.025a.5.5 0 0 0-.32.32c-.016.047-.025.131-.025.655v9h2v-9c0-.524-.01-.608-.024-.654a.5.5 0 0 0-.321-.321C6.108 3.509 6.024 3.5 5.5 3.5Zm5.845 4.525C11.393 8.009 11.476 8 12 8s.608.01.655.025a.5.5 0 0 1 .32.32c.016.047.025.131.025.655v4.5h-2V9c0-.524.01-.608.024-.654a.5.5 0 0 1 .322-.321Z',
        fillRule: 'evenodd',
      },
    ],
  },
  chart_bar_horizontal: {
    paths: [
      {
        d: 'M.75 0a.75.75 0 0 1 .75.75V1h9.34c.373 0 .723-.001 1.028.098a2 2 0 0 1 1.284 1.284c.1.305.099.655.098 1.028v.18c0 .373.001.723-.098 1.028a2 2 0 0 1-1.284 1.284c-.305.1-.655.099-1.028.098H1.5v1h4.84c.373 0 .723-.001 1.028.098a2 2 0 0 1 1.284 1.284c.1.305.099.655.098 1.028v.18c0 .373.001.723-.098 1.028a2 2 0 0 1-1.284 1.284c-.305.1-.655.099-1.028.098H1.5v1.5h13.75a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75V.75A.75.75 0 0 1 .75 0Zm11 3.5c0-.524-.01-.608-.024-.655a.5.5 0 0 0-.321-.32c-.047-.016-.131-.025-.655-.025h-9v2h9c.524 0 .608-.01.655-.025a.5.5 0 0 0 .32-.32c.016-.047.025-.131.025-.655ZM7.226 8.845c.015.047.024.131.024.655s-.01.608-.024.655a.5.5 0 0 1-.321.32c-.047.016-.131.025-.655.025h-4.5v-2h4.5c.524 0 .608.01.655.024a.5.5 0 0 1 .32.321Z',
        fillRule: 'evenodd',
      },
    ],
  },
  chart_line: {
    paths: [
      'M1.5.75a.75.75 0 0 0-1.5 0v13.5c0 .414.336.75.75.75h14.5a.75.75 0 0 0 0-1.5H1.5V.75Z',
      'M14.53 5.53a.75.75 0 0 0-1.06-1.06l-3.353 3.353-1.493-2.239A.75.75 0 0 0 7.47 5.47l-4 4a.75.75 0 1 0 1.06 1.06l3.353-3.353 1.493 2.239a.75.75 0 0 0 1.154.114l4-4Z',
    ],
  },
  chat_line_alt: {
    paths: [
      'M.75 0a.75.75 0 0 1 .75.75V13.5h1.75V7a.75.75 0 0 1 1.5 0v6.5h2.5V10a.75.75 0 0 1 1.5 0v3.5h2.5V8a.75.75 0 0 1 1.5 0v5.5h2.5a.75.75 0 0 1 0 1.5H.75a.75.75 0 0 1-.75-.75V.75A.75.75 0 0 1 .75 0Z',
      'M3.436 3.006a.75.75 0 0 1 1.058-.07l3.589 3.14 4.531-2.72a.75.75 0 0 1 .986.194l1.5 2a.75.75 0 1 1-1.2.9l-1.094-1.459-4.42 2.652a.75.75 0 0 1-.88-.079l-4-3.5a.75.75 0 0 1-.07-1.058Z',
    ],
  },
  chart_multiple: {
    paths: [
      'M4 3a.75.75 0 0 0 0 1.5h4A.75.75 0 0 0 8 3H4Z',
      'M3.25 6.25A.75.75 0 0 1 4 5.5h6A.75.75 0 0 1 10 7H4a.75.75 0 0 1-.75-.75Z',
      'M8.624 8.584A.75.75 0 0 0 7.47 8.47l-3.5 3.5a.75.75 0 1 0 1.06 1.06l2.853-2.853 1.493 2.239a.75.75 0 0 0 1.154.114l1.5-1.5a.75.75 0 1 0-1.06-1.06l-.853.853-1.493-2.239Z',
      {
        d: 'M1 3.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C2.52 0 3.08 0 4.2 0h7.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C15 1.52 15 2.08 15 3.2v9.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C13.48 16 12.92 16 11.8 16H4.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C1 14.48 1 13.92 1 12.8V3.2Zm3.2-1.7h7.6c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.02.258.022.606.022 1.191v9.6c0 .585-.001.933-.022 1.191-.013.158-.03.224-.036.242a.5.5 0 0 1-.209.21 1.253 1.253 0 0 1-.242.035c-.258.02-.606.022-1.191.022H4.2c-.585 0-.933-.001-1.191-.022a1.253 1.253 0 0 1-.242-.036.5.5 0 0 1-.21-.209 1.255 1.255 0 0 1-.035-.242c-.02-.258-.022-.606-.022-1.191V3.2c0-.585.001-.933.022-1.191.013-.158.03-.224.036-.242a.5.5 0 0 1 .209-.21c.018-.005.084-.022.242-.035.258-.02.606-.022 1.191-.022Zm9.038.06-.003-.002.003.001Zm.203.202v.003-.003Zm0 12.476v-.003.003Zm-.203.203h-.003.003Zm-10.476 0h.003-.003Zm-.203-.203v-.003.003Zm0-12.476v.003-.003Zm.203-.203h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  security: {
    paths: [
      {
        d: 'M5.751 6.275c.006-.349.04-.87.253-1.339.142-.313.37-.624.726-.852.355-.226.783-.334 1.27-.334s.915.108 1.27.334c.357.228.584.539.726.852.212.47.247.99.253 1.339A1.25 1.25 0 0 1 11.25 7.5v3c0 .69-.56 1.25-1.25 1.25H6c-.69 0-1.25-.56-1.25-1.25v-3c0-.605.43-1.11 1.001-1.225Zm2.996-.025H7.253c.007-.268.033-.509.118-.696a.442.442 0 0 1 .165-.205c.066-.042.2-.099.464-.099.263 0 .398.057.464.1a.442.442 0 0 1 .165.204c.085.187.11.428.118.696ZM6.25 7.75v2.5h3.5v-2.5h-3.5Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M8.65.375a.75.75 0 0 0-1.3 0 1.884 1.884 0 0 1-.174.217c-.15.162-.407.397-.812.64-.805.483-2.23 1.018-4.614 1.018A.75.75 0 0 0 1 3v5.5c0 1.024.403 2.001.955 2.859.556.862 1.295 1.653 2.048 2.32a14.81 14.81 0 0 0 2.217 1.628c.337.199.655.363.934.48.25.106.56.213.846.213.285 0 .595-.107.846-.213.28-.117.597-.281.934-.48.674-.398 1.463-.96 2.217-1.628.753-.667 1.492-1.458 2.047-2.32C14.598 10.5 15 9.524 15 8.5V3a.75.75 0 0 0-.75-.75c-2.384 0-3.81-.535-4.614-1.018a3.682 3.682 0 0 1-.812-.64 1.886 1.886 0 0 1-.175-.217ZM8 1.884c-.22.2-.505.419-.864.634-.964.579-2.44 1.115-4.636 1.215V8.5c0 .633.253 1.328.716 2.046.46.714 1.097 1.404 1.781 2.01.683.605 1.395 1.11 1.986 1.46.296.175.552.305.752.388.153.065.236.086.263.093h.004c.027-.007.11-.028.263-.093.2-.083.456-.213.752-.388.591-.35 1.303-.855 1.986-1.46.684-.606 1.32-1.296 1.78-2.01.464-.718.717-1.413.717-2.046V3.733c-2.196-.1-3.672-.636-4.636-1.215A5.521 5.521 0 0 1 8 1.884Z',
        fillRule: 'evenodd',
      },
    ],
  },
  legal: {
    paths: [
      'M4.25 7A.75.75 0 0 1 5 6.25h6a.75.75 0 0 1 0 1.5H5A.75.75 0 0 1 4.25 7Z',
      'M7 9.25a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5H7Z',
      {
        d: 'M8.65.375a.75.75 0 0 0-1.3 0 1.884 1.884 0 0 1-.174.217c-.15.162-.407.397-.812.64-.805.483-2.23 1.018-4.614 1.018A.75.75 0 0 0 1 3v5.5c0 1.024.403 2.001.955 2.859.556.862 1.295 1.653 2.048 2.32a14.81 14.81 0 0 0 2.217 1.628c.337.199.655.363.934.48.25.106.56.213.846.213.285 0 .595-.107.846-.213.28-.117.597-.281.934-.48.674-.398 1.463-.96 2.217-1.628.753-.667 1.492-1.458 2.047-2.32C14.598 10.5 15 9.524 15 8.5V3a.75.75 0 0 0-.75-.75c-2.384 0-3.81-.535-4.614-1.018a3.682 3.682 0 0 1-.812-.64 1.886 1.886 0 0 1-.175-.217ZM8 1.884c-.22.2-.505.419-.864.634-.964.579-2.44 1.115-4.636 1.215V8.5c0 .633.253 1.328.716 2.046.46.714 1.097 1.404 1.781 2.01.683.605 1.395 1.11 1.986 1.46.296.175.552.305.752.388.153.065.236.086.263.093h.004c.027-.007.11-.028.263-.093.2-.083.456-.213.752-.388.591-.35 1.303-.855 1.986-1.46.684-.606 1.32-1.296 1.78-2.01.464-.718.717-1.413.717-2.046V3.733c-2.196-.1-3.672-.636-4.636-1.215A5.521 5.521 0 0 1 8 1.884Z',
        fillRule: 'evenodd',
      },
    ],
  },
  navigate: {
    paths: [
      {
        d: 'M12.82.635c1.578-.547 3.092.967 2.545 2.545L11.41 14.588c-.688 1.985-3.58 1.702-3.87-.378l-.678-4.858a.25.25 0 0 0-.213-.213L1.79 8.46C-.29 8.17-.573 5.278 1.41 4.59L12.82.634Zm1.127 2.054a.5.5 0 0 0-.636-.636L1.903 6.007c-.496.172-.425.895.095.968l4.858.678a1.75 1.75 0 0 1 1.491 1.491l.678 4.858c.073.52.796.591.968.095l3.954-11.408Z',
        fillRule: 'evenodd',
      },
    ],
  },
  lightning: {
    paths: [
      {
        d: 'M4.316.443A.75.75 0 0 1 5 0h6a.75.75 0 0 1 .657 1.112L9.926 4.25h4.324a.75.75 0 0 1 .53 1.28L4.53 15.78a.75.75 0 0 1-1.25-.74l1.841-6.29H1.75a.75.75 0 0 1-.684-1.057l3.25-7.25ZM5.486 1.5 2.908 7.25h3.214a.75.75 0 0 1 .72.96l-1.298 4.436 6.895-6.896H8.655a.75.75 0 0 1-.657-1.112L9.73 1.5H5.486Z',
        fillRule: 'evenodd',
      },
    ],
  },
  puzzle: {
    paths: [
      {
        d: 'M7 1.5a1.25 1.25 0 0 0-.827 2.188A.75.75 0 0 1 5.677 5H3a.5.5 0 0 0-.5.5v.795a2.75 2.75 0 0 1 0 5.41V13a.5.5 0 0 0 .5.5h1.295a2.75 2.75 0 0 1 5.41 0h.795a.5.5 0 0 0 .5-.5v-2.677a.75.75 0 0 1 1.312-.496 1.25 1.25 0 1 0 0-1.653A.75.75 0 0 1 11 7.676V5.5a.5.5 0 0 0-.5-.5H8.323a.75.75 0 0 1-.496-1.312A1.25 1.25 0 0 0 7 1.5ZM4.25 2.75a2.75 2.75 0 1 1 5.396.75h.854a2 2 0 0 1 2 2v.854a2.75 2.75 0 1 1 0 5.293V13a2 2 0 0 1-2 2H8.985a.75.75 0 0 1-.745-.843 1.25 1.25 0 1 0-2.48 0 .75.75 0 0 1-.745.843H3a2 2 0 0 1-2-2v-2.015a.75.75 0 0 1 .843-.745 1.25 1.25 0 1 0 0-2.48A.75.75 0 0 1 1 7.015V5.5a2 2 0 0 1 2-2h1.354a2.75 2.75 0 0 1-.104-.75Z',
        fillRule: 'evenodd',
      },
    ],
  },
  pencil: {
    paths: [
      {
        d: 'M14.886 2.575c.23.23.435.435.59.618.166.195.32.415.408.689.131.402.131.834 0 1.236-.089.274-.242.494-.408.69-.155.182-.36.386-.59.617l-7.81 7.81c-.176.176-.344.345-.549.47-.179.11-.374.19-.578.24-.233.056-.472.055-.721.055H1.75a.75.75 0 0 1-.75-.75v-3.477c0-.25 0-.49.055-.722a2 2 0 0 1 .24-.578c.125-.204.294-.373.47-.55l7.81-7.809c.23-.23.435-.435.618-.59.195-.165.415-.32.69-.408a2 2 0 0 1 1.235 0c.274.089.494.243.69.408.182.155.386.36.617.59l1.46 1.461Zm-.428 1.77c-.004-.01-.02-.057-.125-.181-.111-.13-.271-.292-.527-.548l-1.422-1.421a10.537 10.537 0 0 0-.548-.527c-.124-.106-.17-.122-.181-.126a.5.5 0 0 0-.31 0c-.01.004-.057.02-.181.126-.13.11-.291.27-.548.527l-.18.18 3.19 3.19.18-.181c.256-.256.416-.417.527-.548.105-.124.121-.17.125-.181a.5.5 0 0 0 0-.31Zm-1.894 2.28-6.508 6.509c-.242.241-.28.272-.312.292a.499.499 0 0 1-.145.06c-.037.01-.086.014-.427.014H2.5V10.83c0-.342.005-.39.014-.428a.5.5 0 0 1 .06-.144c.02-.033.05-.071.292-.312l6.51-6.51 3.188 3.19Z',
        fillRule: 'evenodd',
      },
    ],
  },
  location: {
    paths: [
      {
        d: 'M8 3.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5ZM6.75 6a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M7.566 15.862 8 15.25l-.434.612a.75.75 0 0 0 .868 0L8 15.25l.434.612.002-.002.004-.003.015-.01a8.441 8.441 0 0 0 .256-.19 23.708 23.708 0 0 0 2.835-2.549C13.06 11.5 14.75 9.188 14.75 6.75c0-2.336-.9-4.05-2.232-5.168C11.206.482 9.527 0 8 0 6.473 0 4.794.482 3.482 1.582 2.15 2.699 1.25 4.414 1.25 6.75c0 2.437 1.69 4.75 3.204 6.358a23.699 23.699 0 0 0 3.09 2.738l.016.011.004.003.002.002ZM2.75 6.75c0-1.914.72-3.2 1.696-4.02C5.445 1.894 6.766 1.5 8 1.5c1.235 0 2.555.393 3.553 1.23.978.82 1.697 2.106 1.697 4.02 0 1.813-1.31 3.75-2.796 5.33A22.172 22.172 0 0 1 8 14.31a22.179 22.179 0 0 1-2.454-2.231C4.06 10.5 2.75 8.563 2.75 6.75Z',
        fillRule: 'evenodd',
      },
    ],
  },
  scissors: {
    paths: [
      {
        d: 'M4.925 6.855a3 3 0 1 1 1.35-.899L7.96 7.095l5.87-3.966a.75.75 0 1 1 .84 1.242L9.3 8.001l5.37 3.628a.75.75 0 1 1-.84 1.242L7.96 8.905l-1.685 1.139a3 3 0 1 1-1.35-.899L6.62 8 4.925 6.855Zm-.364-1.463a1.5 1.5 0 1 1 .214-.107.749.749 0 0 0-.214.107ZM5.5 12a1.5 1.5 0 1 1-.939-1.391.75.75 0 0 0 .214.107A1.5 1.5 0 0 1 5.5 12Z',
        fillRule: 'evenodd',
      },
    ],
  },
  share: {
    paths: [
      'M4.47 3.22a.75.75 0 0 0 1.06 1.06l1.72-1.72v7.19a.75.75 0 0 0 1.5 0V2.56l1.72 1.72a.75.75 0 1 0 1.06-1.06l-3-3a.75.75 0 0 0-1.06 0l-3 3Z',
      'M3.722 6c-.326 0-.615 0-.854.02-.255.02-.519.067-.776.198a2 2 0 0 0-.874.874 2.032 2.032 0 0 0-.198.776c-.02.24-.02.528-.02.854v4.556c0 .326 0 .615.02.854.02.255.067.519.198.776a2 2 0 0 0 .874.874c.257.131.521.178.776.198.24.02.528.02.854.02h8.556c.326 0 .615 0 .854-.02.255-.02.519-.067.776-.198a2 2 0 0 0 .874-.874c.131-.257.178-.521.198-.776.02-.24.02-.528.02-.854V8.722c0-.326 0-.615-.02-.854a2.032 2.032 0 0 0-.198-.776 2 2 0 0 0-.874-.874 2.033 2.033 0 0 0-.776-.198c-.24-.02-.528-.02-.854-.02H11.5a.75.75 0 0 0 0 1.5h.75c.363 0 .59 0 .76.015.162.013.207.034.217.04a.5.5 0 0 1 .218.218c.006.01.027.055.04.217.014.17.015.398.015.76v4.5c0 .362 0 .59-.014.76-.014.162-.035.207-.04.217a.5.5 0 0 1-.219.218c-.01.006-.055.027-.217.04-.17.014-.398.015-.76.015h-8.5c-.362 0-.59 0-.76-.014-.162-.014-.207-.035-.217-.04a.5.5 0 0 1-.219-.219c-.005-.01-.026-.055-.04-.217-.013-.17-.014-.398-.014-.76v-4.5c0-.362 0-.59.015-.76.013-.162.034-.207.04-.217a.5.5 0 0 1 .218-.218c.01-.006.055-.027.217-.04.17-.014.398-.015.76-.015h.75a.75.75 0 1 0 0-1.5h-.778Z',
    ],
  },
  funnel: {
    paths: [
      {
        d: 'M3.776 1h8.448c.5 0 .927 0 1.26.03.328.03.719.098 1.037.35.416.332.659.835.66 1.367 0 .406-.19.754-.37 1.03-.183.28-.448.614-.759 1.005L10.684 9.03a6.572 6.572 0 0 0-.132.17c-.024.032-.027.04-.025.036a.252.252 0 0 0-.022.063 6.246 6.246 0 0 0-.005.259v3.18c0 .24.001.496-.07.74a1.75 1.75 0 0 1-.303.589c-.158.2-.367.35-.563.488l-.048.035-.329.234c-.384.275-.714.51-.99.673-.276.16-.62.324-1.012.31a1.75 1.75 0 0 1-1.32-.68c-.24-.311-.307-.685-.336-1.003-.03-.32-.03-.725-.03-1.197V9.557l-.001-.215-.003-.044a.25.25 0 0 0-.022-.063c.002.004-.001-.004-.025-.036a6.208 6.208 0 0 0-.132-.17L1.948 4.782c-.311-.391-.576-.725-.76-1.005-.18-.276-.37-.624-.369-1.03a1.75 1.75 0 0 1 .66-1.366c.318-.253.709-.32 1.037-.35C2.849 1 3.276 1 3.776 1ZM2.4 2.566a.25.25 0 0 0-.08.165c.007.02.034.086.123.224.142.216.363.496.702.923l3.346 4.22.025.03c.103.13.214.269.295.429.07.14.122.288.154.442.035.176.035.353.035.518v3.374c0 .517 0 .853.023 1.096.014.152.033.217.04.235a.25.25 0 0 0 .162.084 1.08 1.08 0 0 0 .214-.105c.21-.123.484-.318.905-.618l.3-.215c.129-.092.202-.144.255-.186a.46.46 0 0 0 .048-.043.25.25 0 0 0 .043-.083.475.475 0 0 0 .006-.064C9 12.925 9 12.835 9 12.677v-3.16c0-.165 0-.342.035-.518a1.75 1.75 0 0 1 .154-.442 2.554 2.554 0 0 1 .32-.46l3.346-4.219c.339-.427.56-.707.701-.923.09-.138.117-.204.124-.224a.25.25 0 0 0-.08-.165 1.158 1.158 0 0 0-.252-.042c-.257-.023-.614-.024-1.16-.024H3.812c-.545 0-.902 0-1.16.024a1.157 1.157 0 0 0-.251.042Z',
        fillRule: 'evenodd',
      },
    ],
  },
  credit_card: {
    paths: [
      'M8.75 10a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5h-3.5Z',
      {
        d: 'M.218 3.092C0 3.52 0 4.08 0 5.2v5.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C1.52 14 2.08 14 3.2 14h9.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C16 12.48 16 11.92 16 10.8V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 2 13.92 2 12.8 2H3.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874ZM12.8 3.5H3.2c-.585 0-.933.001-1.191.022-.158.013-.224.03-.242.036a.5.5 0 0 0-.21.209 1.254 1.254 0 0 0-.035.242c-.02.258-.022.606-.022 1.191v.3h13v-.3c0-.585-.001-.933-.022-1.191a1.252 1.252 0 0 0-.036-.242.5.5 0 0 0-.209-.21 1.255 1.255 0 0 0-.242-.035c-.258-.02-.606-.022-1.191-.022ZM1.5 10.8V7h13v3.8c0 .585-.001.933-.022 1.191-.013.158-.03.224-.036.242a.5.5 0 0 1-.209.21 1.253 1.253 0 0 1-.242.035c-.258.02-.606.022-1.191.022H3.2c-.585 0-.933-.001-1.191-.022a1.253 1.253 0 0 1-.242-.036.5.5 0 0 1-.21-.209 1.255 1.255 0 0 1-.035-.242c-.02-.258-.022-.606-.022-1.191Zm12.738-7.24-.003-.002a.03.03 0 0 1 .003.001Zm.203.202v.003-.003Zm0 8.476v-.003a.014.014 0 0 1 0 .003Zm-.203.203h-.003.003Zm-12.476 0h.003-.003Zm-.203-.204s0 .001 0 0Zm0-8.475v.003-.003Zm.203-.203h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  building_business: {
    paths: [
      'M3.75 4.25a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75Z',
      'M4.5 7a.75.75 0 0 0 0 1.5h2a.75.75 0 1 0 0-1.5h-2Z',
      'M8.75 4.25a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5h-2a.75.75 0 0 1-.75-.75Z',
      'M9.5 7a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5h-2Z',
      {
        d: 'M3.722 0c-.326 0-.615 0-.854.02-.255.02-.519.067-.776.198a2 2 0 0 0-.874.874 2.032 2.032 0 0 0-.198.776c-.02.24-.02.528-.02.854v10.556c0 .326 0 .615.02.854.02.255.067.519.198.776a2 2 0 0 0 .874.874c.257.131.521.178.776.198.24.02.528.02.854.02h8.556c.326 0 .615 0 .854-.02.255-.02.519-.067.776-.198a2 2 0 0 0 .874-.874c.131-.257.178-.521.198-.776.02-.24.02-.528.02-.854V2.722c0-.326 0-.615-.02-.854a2.032 2.032 0 0 0-.198-.776 2 2 0 0 0-.874-.874 2.033 2.033 0 0 0-.776-.198c-.24-.02-.528-.02-.854-.02H3.722ZM10 14.5h2.25c.362 0 .59 0 .76-.014.162-.014.207-.035.217-.04a.5.5 0 0 0 .218-.219c.006-.01.027-.055.04-.217.014-.17.015-.398.015-.76V2.75c0-.362 0-.59-.014-.76-.014-.162-.035-.207-.04-.217a.5.5 0 0 0-.219-.218c-.01-.006-.055-.027-.217-.04-.17-.014-.398-.015-.76-.015h-8.5c-.362 0-.59 0-.76.015-.162.013-.207.034-.217.04a.5.5 0 0 0-.219.218c-.005.01-.026.055-.04.217-.013.17-.014.398-.014.76v10.5c0 .362 0 .59.015.76.013.162.034.207.04.217a.5.5 0 0 0 .218.218c.01.006.055.027.217.04.17.014.398.015.76.015H6v-2.75a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v2.75Zm-2.5 0v-2h1v2h-1Z',
        fillRule: 'evenodd',
      },
    ],
  },
  building_agency: {
    paths: [
      'M4.25 5.25A.75.75 0 0 1 5 4.5h2A.75.75 0 0 1 7 6H5a.75.75 0 0 1-.75-.75Z',
      'M5 7a.75.75 0 0 0 0 1.5h2A.75.75 0 0 0 7 7H5Z',
      {
        d: 'M5.484.391a2 2 0 0 1 1.032 0c.388.104.722.36 1.072.63l.082.062 2.303 1.761c.235.18.46.35.628.575.147.197.257.419.323.655.077.27.076.552.076.848V7h1.278c.326 0 .615 0 .854.02.255.02.519.067.776.198a2 2 0 0 1 .874.874c.131.257.178.521.198.776.02.24.02.528.02.854v3.556c0 .326 0 .615-.02.854-.02.255-.067.519-.198.776a2 2 0 0 1-.874.874 2.032 2.032 0 0 1-.776.198c-.24.02-.528.02-.854.02H3.722c-.326 0-.615 0-.854-.02a2.032 2.032 0 0 1-.776-.198 2 2 0 0 1-.874-.874 2.033 2.033 0 0 1-.199-.776c-.02-.24-.02-.528-.02-.854V4.922c0-.296 0-.578.076-.848a2 2 0 0 1 .324-.655c.168-.224.392-.396.627-.575l2.303-1.76.082-.064c.35-.269.684-.525 1.073-.629Zm.645 1.45a.5.5 0 0 0-.258 0c-.061.016-.141.06-.63.434l-2.25 1.72c-.323.247-.365.287-.391.323a.5.5 0 0 0-.081.164c-.012.043-.02.1-.02.506v8.262c0 .362.001.59.015.76.014.162.035.207.04.217a.5.5 0 0 0 .219.218c.01.006.055.027.217.04.17.014.397.015.76.015H4v-2.75a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 .75.75v2.75h1.5V4.988c0-.405-.007-.463-.019-.506a.5.5 0 0 0-.08-.164c-.028-.036-.07-.076-.392-.323l-2.25-1.72c-.489-.374-.57-.418-.63-.434Zm6.88 6.674a10.54 10.54 0 0 0-.759-.015H11v6h1.25c.362 0 .59 0 .76-.014.162-.014.207-.035.217-.04a.5.5 0 0 0 .218-.219c.006-.01.027-.055.04-.217.014-.17.015-.398.015-.76v-3.5c0-.362 0-.59-.014-.76-.014-.162-.035-.207-.04-.217a.5.5 0 0 0-.219-.218c-.01-.006-.055-.027-.217-.04ZM5.5 14.5v-2h1v2h-1Z',
        fillRule: 'evenodd',
      },
    ],
  },
  blog: {
    paths: [
      {
        d: 'M3.722 0H10a.75.75 0 0 1 0 1.5H5.75v13H9A.75.75 0 0 1 9 16H3.722c-.326 0-.615 0-.854-.02a2.032 2.032 0 0 1-.776-.198 2 2 0 0 1-.874-.874 2.033 2.033 0 0 1-.198-.776c-.02-.24-.02-.528-.02-.854V2.722c0-.326 0-.615.02-.854.02-.255.067-.519.198-.776a2 2 0 0 1 .874-.874c.257-.131.521-.178.776-.198.24-.02.528-.02.854-.02Zm.028 1.5h.5v13h-.5c-.362 0-.59 0-.76-.014-.162-.014-.207-.035-.217-.04a.5.5 0 0 1-.219-.219c-.005-.01-.026-.055-.04-.217-.013-.17-.014-.398-.014-.76V2.75c0-.362 0-.59.015-.76.013-.162.034-.207.04-.217a.5.5 0 0 1 .218-.218c.01-.006.055-.027.217-.04.17-.014.398-.015.76-.015Z',
        fillRule: 'evenodd',
      },
      'M7.75 3.25a.75.75 0 0 0 0 1.5h1a.75.75 0 1 0 0-1.5h-1Z',
      {
        d: 'M10 4a.75.75 0 0 1 .102-.378l1.75-3a.75.75 0 0 1 1.296 0l1.75 3A.75.75 0 0 1 15 4v9.5a2.5 2.5 0 0 1-5 0V4Zm3.5 8.75v.75a1 1 0 1 1-2 0v-.75h2Zm0-1.5h-2V4.203l1-1.715 1 1.715v7.047Z',
        fillRule: 'evenodd',
      },
    ],
  },
  audio: {
    paths: [
      {
        d: 'M3.04 5c.142-.146.306-.273.476-.403l2.225-1.72c.39-.301.723-.558 1.002-.736.276-.176.623-.359 1.026-.354a1.75 1.75 0 0 1 1.354.665c.25.316.317.702.347 1.027.03.33.03.751.03 1.244v6.554c0 .493 0 .914-.03 1.244-.03.325-.097.711-.347 1.027a1.75 1.75 0 0 1-1.354.665c-.403.005-.75-.178-1.026-.354-.279-.178-.612-.435-1.002-.736l-2.225-1.72c-.17-.13-.334-.257-.475-.403h-.319c-.326 0-.615 0-.854-.02a2.032 2.032 0 0 1-.776-.198 2 2 0 0 1-.874-.874 2.032 2.032 0 0 1-.198-.776C0 8.892 0 8.604 0 8.278v-.556c0-.326 0-.615.02-.854.02-.255.067-.519.198-.776a2 2 0 0 1 .874-.874c.257-.131.521-.178.776-.198.24-.02.528-.02.854-.02h.319Zm3.59-.914c.426-.33.704-.544.92-.68.135-.087.201-.112.22-.119a.25.25 0 0 1 .165.081c.006.02.026.087.041.247C8 3.87 8 4.22 8 4.758v6.484c0 .538 0 .89-.024 1.143-.015.16-.035.228-.041.247a.25.25 0 0 1-.165.08 1.14 1.14 0 0 1-.22-.118c-.216-.136-.494-.35-.92-.68l-2.144-1.657c-.32-.246-.36-.287-.387-.323a.5.5 0 0 1-.08-.163C4.007 9.731 4 9.68 4 9.356V6.644c0-.324.007-.376.019-.415a.5.5 0 0 1 .08-.163c.026-.036.068-.077.387-.323L6.63 4.086ZM2.5 6.513V6.5c-.223.001-.382.004-.51.015-.162.013-.207.034-.217.04a.5.5 0 0 0-.218.218c-.006.01-.027.055-.04.217-.014.17-.015.398-.015.76v.5c0 .362 0 .59.015.76.013.162.034.207.04.217a.5.5 0 0 0 .218.219c.01.005.055.026.217.04.128.01.287.013.51.014V6.513Z',
        fillRule: 'evenodd',
      },
      'M11.038 10.59a.75.75 0 0 1-.129-1.052c.332-.424.53-.957.53-1.538 0-.58-.198-1.114-.53-1.538a.75.75 0 0 1 1.182-.924c.53.679.847 1.535.847 2.462 0 .928-.317 1.783-.847 2.462a.75.75 0 0 1-1.053.129Z',
      'M12.755 11.437a.75.75 0 0 0 .99 1.126C15.12 11.353 16 9.773 16 8c0-1.773-.88-3.353-2.255-4.563a.75.75 0 1 0-.99 1.126C13.886 5.559 14.5 6.756 14.5 8c0 1.244-.614 2.44-1.745 3.437Z',
    ],
  },
  mute: {
    paths: [
      {
        d: 'M3.516 4.597c-.17.13-.334.257-.475.403h-.319c-.326 0-.615 0-.854.02-.255.02-.519.067-.776.198a2 2 0 0 0-.874.874 2.032 2.032 0 0 0-.198.776c-.02.24-.02.528-.02.854v.556c0 .326 0 .615.02.854.02.255.067.519.198.776a2 2 0 0 0 .874.874c.257.131.521.178.776.198.24.02.528.02.854.02h.319c.14.146.305.273.475.403l2.225 1.72c.39.301.723.559 1.002.736.276.176.623.359 1.026.354a1.75 1.75 0 0 0 1.354-.665c.25-.316.317-.702.347-1.027.03-.33.03-.751.03-1.244V4.723c0-.493 0-.914-.03-1.244-.03-.325-.097-.711-.347-1.027a1.75 1.75 0 0 0-1.354-.665c-.403-.005-.75.178-1.026.354-.279.177-.612.435-1.002.736l-2.225 1.72Zm4.033-1.191c-.215.136-.493.35-.919.68L4.486 5.743c-.32.246-.36.287-.387.323a.5.5 0 0 0-.08.163c-.012.04-.018.091-.019.415v2.712c0 .324.007.376.019.415a.5.5 0 0 0 .08.163c.026.036.068.077.387.323l2.144 1.657c.426.33.704.543.92.68.135.087.201.112.22.119a.25.25 0 0 0 .165-.081c.006-.02.026-.087.041-.247C8 12.13 8 11.78 8 11.242V4.758c0-.538 0-.89-.024-1.143a1.139 1.139 0 0 0-.041-.247.25.25 0 0 0-.165-.08 1.138 1.138 0 0 0-.22.118ZM2.5 6.5v3c-.223-.001-.382-.004-.51-.015-.162-.013-.207-.034-.217-.04a.5.5 0 0 1-.218-.218c-.006-.01-.027-.055-.04-.217-.014-.17-.015-.398-.015-.76v-.5c0-.362 0-.59.015-.76.013-.162.034-.207.04-.217a.5.5 0 0 1 .218-.218c.01-.006.055-.027.217-.04.128-.01.287-.014.51-.015Z',
        fillRule: 'evenodd',
      },
      'M11.78 5.72a.75.75 0 1 0-1.06 1.06l1.47 1.47-1.47 1.47a.75.75 0 1 0 1.06 1.06l1.47-1.47 1.47 1.47a.75.75 0 1 0 1.06-1.06l-1.47-1.47 1.47-1.47a.75.75 0 0 0-1.06-1.06l-1.47 1.47-1.47-1.47Z',
    ],
  },
  announcement: {
    paths: [
      {
        d: 'M6.11 4.58c-.3.124-.588.243-.83.42H3.723c-.326 0-.615 0-.854.02-.255.02-.519.067-.776.198a2 2 0 0 0-.874.874 2.032 2.032 0 0 0-.198.776c-.02.24-.02.528-.02.854v.556c0 .326 0 .615.02.854.02.255.067.519.198.776a2 2 0 0 0 .874.874c.253.13.514.176.765.198a3.985 3.985 0 0 0-.07 2.303c.24.896.768 1.64 1.456 2.159a.75.75 0 1 0 .902-1.198 2.486 2.486 0 0 1-.909-1.35 2.486 2.486 0 0 1 .113-1.622.748.748 0 0 0 .06-.272h.871c.242.177.53.296.83.42l.082.035 5.032 2.097c.436.181.81.337 1.12.435.32.1.673.173 1.043.1a2 2 0 0 0 1.275-.85c.21-.313.278-.667.308-1.001.03-.325.03-.73.03-1.202V4.966c0-.472 0-.877-.03-1.202-.03-.334-.098-.688-.308-1.001a2 2 0 0 0-1.275-.85c-.37-.073-.723 0-1.043.1-.31.098-.684.254-1.12.436L6.192 4.545l-.083.034Zm6.683-1.135c-.237.074-.547.203-1.024.401l-5 2.083c-.499.208-.567.249-.609.288a.5.5 0 0 0-.13.194c-.018.052-.03.127-.03.631v1.916c0 .504.012.58.03.631a.5.5 0 0 0 .13.194c.042.04.11.08.61.287l5 2.084c.476.198.786.327 1.024.401.234.074.3.061.303.06a.5.5 0 0 0 .319-.212c.001-.003.038-.058.06-.303.023-.248.024-.584.024-1.1V5c0-.516 0-.852-.023-1.1-.023-.245-.06-.3-.061-.303a.5.5 0 0 0-.32-.213c-.002 0-.068-.013-.303.06ZM4.5 6.5v3h-.75c-.362 0-.59 0-.76-.015-.162-.013-.207-.034-.217-.04a.5.5 0 0 1-.219-.218c-.005-.01-.026-.055-.04-.217-.013-.17-.014-.398-.014-.76v-.5c0-.362 0-.59.015-.76.013-.162.034-.207.04-.217a.5.5 0 0 1 .218-.218c.01-.006.055-.027.217-.04.17-.014.398-.015.76-.015h.75Z',
        fillRule: 'evenodd',
      },
    ],
  },
  bug: {
    paths: [
      {
        d: 'M11 1a.75.75 0 0 1 .75.75c0 .819-.324 1.52-.611 1.987a5.039 5.039 0 0 1-.21.314c.482.286.918.64 1.296 1.05a.751.751 0 0 1 .16-.069c.524-.155 1.282-.284 2.068-.073a.75.75 0 1 1-.388 1.449 2.132 2.132 0 0 0-.938-.014c.29.57.489 1.195.574 1.856h.799a.75.75 0 0 1 0 1.5h-.799a5.717 5.717 0 0 1-.962 2.507l.065.02c.39.117.844.177 1.26.065a.75.75 0 1 1 .389 1.45c-.79.211-1.552.08-2.077-.077a5.027 5.027 0 0 1-.72-.277A5.726 5.726 0 0 1 8 14.75a5.727 5.727 0 0 1-3.656-1.312 5.02 5.02 0 0 1-.72.277c-.525.157-1.286.288-2.077.076a.75.75 0 1 1 .388-1.449c.417.112.872.052 1.26-.064a3.43 3.43 0 0 0 .066-.02 5.717 5.717 0 0 1-.963-2.508H1.5a.75.75 0 0 1 0-1.5h.798a5.71 5.71 0 0 1 .575-1.856 2.132 2.132 0 0 0-.938.014.75.75 0 0 1-.388-1.45c.807-.216 1.584-.074 2.112.087.042.013.083.03.121.05A5.776 5.776 0 0 1 5.071 4.05a5.037 5.037 0 0 1-.21-.314C4.574 3.27 4.25 2.569 4.25 1.75a.75.75 0 0 1 1.5 0c0 .431.176.855.389 1.2a3.529 3.529 0 0 0 .369.496 5.758 5.758 0 0 1 2.984 0c.02-.022.05-.055.086-.1.077-.092.18-.228.283-.395.213-.346.389-.77.389-1.201A.75.75 0 0 1 11 1ZM4.022 7.5a4.252 4.252 0 0 1 7.956 0H4.022ZM3.75 9a4.25 4.25 0 0 0 8.5 0h-8.5Z',
        fillRule: 'evenodd',
      },
    ],
  },
  forward: {
    paths: [
      {
        d: 'M8.455 2.06a.75.75 0 0 1 .813.147l5.5 5.25a.75.75 0 0 1 0 1.086l-5.5 5.25A.75.75 0 0 1 8 13.25v-1.759c-.19-.004-.369-.01-.539-.015l-.177-.006c-.309-.01-.578-.02-.828-.02-.592-.005-.983.036-1.323.16-.672.247-1.365.902-2.753 3.048A.75.75 0 0 1 1 14.25c0-3.1.223-5.58 1.364-7.264C3.47 5.354 5.304 4.624 8 4.515V2.75c0-.3.179-.571.455-.69ZM9.5 4.503v.747a.75.75 0 0 1-.75.75c-2.93 0-4.359.668-5.144 1.827-.605.893-.91 2.175-1.034 3.978.686-.828 1.316-1.335 2.045-1.603.597-.219 1.206-.257 1.849-.253a33.567 33.567 0 0 1 1.044.027c.375.013.784.024 1.24.024a.75.75 0 0 1 .75.75v.747L13.164 8 9.5 4.503Z',
        fillRule: 'evenodd',
      },
    ],
  },
  directions: {
    paths: [
      {
        d: 'M8 1a.75.75 0 0 1 .75.75v2c0-.001 0 0 0 0V6h3.75a.75.75 0 0 1 .53.22l1.75 1.75a.75.75 0 0 1 0 1.06l-1.75 1.75a.75.75 0 0 1-.53.22H8.75v3.25a.75.75 0 0 1-1.5 0V8H3.5a.75.75 0 0 1-.53-.22L1.22 6.03a.75.75 0 0 1 0-1.06l1.75-1.75A.75.75 0 0 1 3.5 3h3.75V1.75A.75.75 0 0 1 8 1Zm-.75 3.5H3.81l-1 1 1 1h3.44v-2Zm1.5 5v-2h3.44l1 1-1 1H8.75Z',
        fillRule: 'evenodd',
      },
    ],
  },
  directions_alt: {
    paths: [
      'M8.503 1.194a.747.747 0 0 0-1.007.001L4.998 3.443a.75.75 0 1 0 1.004 1.114L7.25 3.434v4.48a3.214 3.214 0 0 0-.1-.07C6.592 7.473 5.881 7.25 5 7.25H3.56l.97-.97a.75.75 0 0 0-1.06-1.06L1.22 7.47a.75.75 0 0 0 0 1.06l2.25 2.25a.75.75 0 1 0 1.06-1.06l-.97-.97H5c.619 0 1.033.153 1.318.343.29.193.493.456.636.742a2.938 2.938 0 0 1 .296 1.156v3.259a.75.75 0 0 0 1.5 0v-3.259l.004-.066a2.938 2.938 0 0 1 .292-1.09c.143-.286.346-.549.636-.742.285-.19.7-.343 1.318-.343h1.44l-.97.97a.75.75 0 1 0 1.06 1.06l2.25-2.25a.75.75 0 0 0 0-1.06l-2.25-2.25a.75.75 0 1 0-1.06 1.06l.97.97H11c-.881 0-1.592.222-2.15.595a3.214 3.214 0 0 0-.1.069v-4.48l1.248 1.123a.75.75 0 0 0 1.004-1.114l-2.5-2.25Z',
    ],
  },
  question_cards: {
    paths: [
      'M12.25 1.5c.363 0 .59 0 .76.015.162.013.207.034.217.04a.5.5 0 0 1 .219.218c.005.01.026.055.04.217.013.17.014.398.014.76V10a.5.5 0 0 1-.5.5V12a2 2 0 0 0 2-2V2.722c0-.326 0-.615-.02-.854a2.032 2.032 0 0 0-.198-.776 2 2 0 0 0-.874-.874 2.033 2.033 0 0 0-.776-.198c-.24-.02-.528-.02-.854-.02H7a2 2 0 0 0-2 2h1.5a.5.5 0 0 1 .5-.5h5.25Z',
      'M4.836 8.112a.761.761 0 0 1 .57-.772.756.756 0 0 1 .932.522.756.756 0 0 1-.546.919.75.75 0 0 0-.53.918l.131.492a.75.75 0 0 0 1.47-.272 2.247 2.247 0 0 0 .924-2.445c-.324-1.207-1.57-1.904-2.77-1.583A2.26 2.26 0 0 0 3.339 8.2a.75.75 0 1 0 1.498-.088Z',
      'M7.035 13.173a1 1 0 1 0-.517-1.932 1 1 0 0 0 .517 1.932Z',
      {
        d: 'm2.211 4.165 4.4-1.179c.316-.084.594-.16.83-.202.252-.046.52-.07.802-.01a2 2 0 0 1 1.07.619c.193.214.306.457.393.698.08.226.155.505.24.82l1.696 6.332c.085.315.16.594.202.83.046.252.07.519.01.801a2 2 0 0 1-.618 1.07 2.033 2.033 0 0 1-.699.393c-.226.081-.505.156-.82.24l-4.4 1.18c-.315.084-.594.158-.83.202-.252.045-.519.069-.801.009a2 2 0 0 1-1.07-.618 2.033 2.033 0 0 1-.393-.698c-.08-.227-.156-.505-.24-.82L.286 7.498c-.084-.315-.159-.594-.202-.83a2.032 2.032 0 0 1-.01-.8 2 2 0 0 1 .619-1.071c.214-.193.457-.307.698-.393.226-.08.505-.155.82-.24Zm-.315 1.653c-.153.054-.19.087-.2.094a.5.5 0 0 0-.154.268c-.002.011-.012.06.018.22.03.169.088.388.182.738l1.683 6.278c.093.35.153.57.21.73.055.154.087.191.095.2a.5.5 0 0 0 .268.154c.011.003.06.012.22-.017.168-.03.387-.089.738-.183l4.346-1.165c.35-.093.57-.153.73-.21.154-.055.191-.087.2-.095a.5.5 0 0 0 .154-.268c.003-.011.012-.06-.017-.22-.031-.168-.09-.387-.183-.738L8.504 5.327a10.54 10.54 0 0 0-.211-.73c-.055-.153-.087-.19-.095-.2a.5.5 0 0 0-.267-.154c-.012-.003-.06-.012-.22.018-.169.03-.388.088-.738.182L2.626 5.607c-.35.094-.569.153-.73.21Z',
        fillRule: 'evenodd',
      },
    ],
  },
  tag: {
    paths: [
      {
        d: 'M7.174 4.1a2.25 2.25 0 1 0-2.25 3.898A2.25 2.25 0 0 0 7.174 4.1ZM5.4 5.674a.75.75 0 1 1 1.299.75.75.75 0 0 1-1.3-.75Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M15.884 10.118a2.03 2.03 0 0 1-.408.689c-.155.183-.36.387-.59.618l-3.461 3.46c-.23.231-.435.436-.618.591a2.03 2.03 0 0 1-.689.408 2 2 0 0 1-1.236 0 2.031 2.031 0 0 1-.689-.408c-.183-.155-.387-.36-.618-.59l-5.81-5.81c-.176-.176-.345-.345-.47-.549a2 2 0 0 1-.24-.578C1 7.716 1 7.477 1 7.228V3.722c0-.326 0-.615.02-.854.02-.255.067-.519.198-.776a2 2 0 0 1 .874-.874c.257-.131.521-.178.776-.199C3.108 1 3.396 1 3.722 1h3.506c.25 0 .488 0 .721.055a2 2 0 0 1 .578.24c.205.125.373.294.55.47l5.809 5.81c.23.23.435.435.59.618.166.195.32.415.408.689.131.402.131.834 0 1.236Zm-2.079.266c.257-.256.417-.417.528-.548.105-.124.121-.17.125-.182a.5.5 0 0 0 0-.309c-.004-.01-.02-.057-.125-.181-.111-.13-.271-.292-.527-.548l-5.75-5.75c-.242-.241-.28-.272-.312-.292a.5.5 0 0 0-.145-.06c-.037-.01-.086-.014-.427-.014H3.75c-.362 0-.589 0-.76.015-.162.013-.207.034-.217.04a.5.5 0 0 0-.218.218c-.006.01-.027.055-.04.217-.014.17-.015.398-.015.76v3.422c0 .341.005.39.014.427a.5.5 0 0 0 .06.144c.02.033.05.071.292.312l5.75 5.75c.256.257.417.417.548.527.124.106.17.122.182.126.1.032.208.032.309 0 .01-.004.057-.02.181-.126.131-.11.292-.27.548-.527l3.421-3.421Z',
        fillRule: 'evenodd',
      },
    ],
  },
  chat: {
    paths: [
      'M2.722 0c-.326 0-.615 0-.854.02-.255.02-.519.067-.776.198a2 2 0 0 0-.874.874 2.032 2.032 0 0 0-.198.776c-.02.24-.02.528-.02.854V13.25a.75.75 0 0 0 1.21.592l2.25-1.75a.75.75 0 0 0-.92-1.184l-1.04.809V2.75c0-.362 0-.59.015-.76.013-.162.034-.207.04-.217a.5.5 0 0 1 .218-.218c.01-.006.055-.027.217-.04.17-.014.398-.015.76-.015h6.5c.362 0 .59 0 .76.015.162.013.207.034.217.04a.5.5 0 0 1 .218.218c.006.01.027.055.04.217.014.17.015.398.015.76V3A.75.75 0 0 0 12 3v-.278c0-.326 0-.615-.02-.854a2.032 2.032 0 0 0-.198-.776 2 2 0 0 0-.874-.874 2.033 2.033 0 0 0-.776-.198C9.892 0 9.604 0 9.278 0H2.722Z',
      'M10 9.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
      'M12 10.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
      {
        d: 'M5 8.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C6.52 5 7.08 5 8.2 5h4.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 6.52 16 7.08 16 8.2v6.857c0 .47 0 .706-.099.839a.5.5 0 0 1-.36.2c-.166.014-.366-.111-.765-.361l-1.998-1.249c-.29-.18-.434-.271-.59-.335a2 2 0 0 0-.428-.123C11.594 14 11.424 14 11.082 14H8.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C5 12.48 5 11.92 5 10.8V8.2Zm3.2-1.7h4.6c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.02.258.022.606.022 1.191v5.594l-.983-.615c-.232-.145-.48-.301-.757-.415a3.503 3.503 0 0 0-.75-.215c-.294-.05-.587-.05-.861-.05L8.2 12.5c-.585 0-.933-.001-1.191-.022a1.252 1.252 0 0 1-.242-.036.5.5 0 0 1-.21-.209 1.256 1.256 0 0 1-.035-.242c-.02-.258-.022-.606-.022-1.191V8.2c0-.585.001-.933.022-1.191.013-.158.03-.224.036-.242a.5.5 0 0 1 .209-.21c.018-.005.084-.022.242-.035.258-.02.606-.022 1.191-.022Z',
        fillRule: 'evenodd',
      },
    ],
  },
  highlight: {
    paths: [
      {
        d: 'M.75 15.25a.75.75 0 0 1 .75-.75h13a.75.75 0 1 1 0 1.5h-13a.75.75 0 0 1-.75-.75Z',
        fillRule: 'evenodd',
      },
      {
        d: 'm12.974 2.22.305.306c.21.21.398.398.542.566.154.18.298.383.388.635a2 2 0 0 1 .058 1.159c-.065.26-.187.475-.323.67-.127.182-.294.387-.483.618l-3.853 4.71c-.227.276-.426.52-.606.706-.192.197-.412.384-.7.5a2 2 0 0 1-1.31.065c-.296-.086-.535-.25-.744-.428-.199-.167-.42-.39-.674-.642l-1.159-1.16c-.253-.252-.475-.474-.642-.673-.177-.21-.342-.448-.428-.745a2 2 0 0 1 .065-1.31c.116-.287.303-.507.5-.699.186-.18.43-.38.707-.606l4.69-3.837.02-.016c.23-.189.435-.356.617-.483.195-.136.41-.258.67-.323a2 2 0 0 1 1.159.058c.252.09.454.234.635.388.168.144.355.331.566.542Zm-1.541.599a.6.6 0 0 0-.166-.116.5.5 0 0 0-.29-.015.598.598 0 0 0-.177.1c-.128.089-.287.218-.544.428L5.59 7.035c-.306.25-.5.409-.634.54-.13.125-.15.175-.154.184a.5.5 0 0 0-.017.328c.003.01.02.06.135.198.122.144.298.32.578.6l1.117 1.118c.28.28.457.456.6.578.139.116.19.132.2.135a.5.5 0 0 0 .327-.017c.01-.004.059-.024.184-.154.131-.135.29-.328.54-.634l3.819-4.667c.21-.257.34-.416.429-.544a.6.6 0 0 0 .099-.177.5.5 0 0 0-.015-.29.597.597 0 0 0-.116-.166 10.014 10.014 0 0 0-.48-.499l-.27-.268c-.234-.235-.38-.38-.498-.481Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M3.58 8.03a.75.75 0 0 1 1.061 0L7.47 10.86a.75.75 0 0 1 0 1.06l-.302.302c-.182.182-.349.35-.5.477a1.775 1.775 0 0 1-.602.355 1.75 1.75 0 0 1-1.082 0 1.774 1.774 0 0 1-.602-.355c-.15-.128-.318-.295-.5-.477a10.811 10.811 0 0 0-.019-.019l-.565-.566-.019-.018c-.182-.182-.35-.35-.477-.5a1.774 1.774 0 0 1-.355-.602 1.75 1.75 0 0 1 0-1.082c.08-.246.216-.439.355-.602.128-.151.295-.318.477-.5l.019-.019.283-.283Zm.532 1.592a3.73 3.73 0 0 0-.167.18.628.628 0 0 0-.073.099.25.25 0 0 0 0 .148.623.623 0 0 0 .073.098c.084.098.207.222.413.429l.566.566c.207.206.33.33.43.413.06.051.089.069.097.073.048.015.1.015.148 0a.622.622 0 0 0 .098-.073c.051-.043.109-.097.18-.167L4.113 9.622Zm1.485 2.007h.001-.001Zm-.143 0h-.002.002ZM3.87 10.046v.002-.002Zm0-.144v.001-.001Z',
        fillRule: 'evenodd',
      },
      'm3.404 10.682 1.414 1.414-.424.452c-.319.34-.478.509-.67.591a1 1 0 0 1-.535.072c-.207-.03-.405-.152-.8-.396l-.692-.426 1.707-1.707Z',
    ],
  },
  send: {
    paths: [
      {
        d: 'M14.58 8.674a.75.75 0 0 0 0-1.348l-12.25-6a.75.75 0 0 0-1.041.911L3.209 8l-1.92 5.763a.75.75 0 0 0 1.04.91l12.25-6ZM4.54 7.25 3.279 3.46 12.545 8l-9.267 4.54L4.54 8.75H8a.75.75 0 0 0 0-1.5H4.54Z',
        fillRule: 'evenodd',
      },
    ],
  },
  continuous_capture: {
    paths: [
      {
        d: 'M2.241 5.427C1.798 6.056 1.5 6.963 1.5 8s.298 1.944.741 2.573c.445.63.99.927 1.509.927.462 0 .938-.232 1.352-.724a.75.75 0 0 1 1.147.966C5.621 12.487 4.754 13 3.75 13c-1.137 0-2.093-.654-2.734-1.562C.374 10.528 0 9.31 0 8s.374-2.528 1.016-3.438C1.656 3.654 2.613 3 3.75 3c1.359 0 2.348.696 3.1 1.598.72.864 1.283 1.992 1.798 3.02l.023.047c.542 1.083 1.034 2.06 1.632 2.777.576.692 1.18 1.058 1.947 1.058.52 0 1.064-.297 1.509-.927.443-.629.741-1.536.741-2.573s-.298-1.944-.741-2.573c-.445-.63-.99-.927-1.509-.927-.461 0-.938.232-1.352.724a.75.75 0 1 1-1.147-.967C10.379 3.513 11.246 3 12.25 3c1.137 0 2.093.654 2.734 1.562C15.626 5.472 16 6.69 16 8s-.374 2.528-1.016 3.438c-.64.908-1.597 1.562-2.734 1.562-1.359 0-2.348-.696-3.1-1.598-.72-.864-1.283-1.992-1.798-3.02l-.023-.047c-.542-1.083-1.034-2.06-1.632-2.777C5.121 4.866 4.517 4.5 3.75 4.5c-.52 0-1.064.297-1.509.927Z',
        fillRule: 'evenodd',
      },
    ],
  },
  block: {
    paths: [
      {
        d: 'M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM1.5 8a6.5 6.5 0 0 1 10.535-5.096l-9.131 9.131A6.472 6.472 0 0 1 1.5 8Zm2.465 5.096a6.5 6.5 0 0 0 9.131-9.131l-9.131 9.131Z',
        fillRule: 'evenodd',
      },
    ],
  },
  crosshair: {
    paths: [
      {
        d: 'M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm1.543-.75A6.503 6.503 0 0 1 7.25 1.543V5a.75.75 0 0 0 1.5 0V1.543a6.503 6.503 0 0 1 5.707 5.707H11a.75.75 0 0 0 0 1.5h3.457a6.503 6.503 0 0 1-5.707 5.707V11a.75.75 0 0 0-1.5 0v3.457A6.503 6.503 0 0 1 1.543 8.75H5a.75.75 0 0 0 0-1.5H1.543Z',
        fillRule: 'evenodd',
      },
    ],
  },
  off: {
    paths: [
      {
        d: 'M8 0a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-1.5 0V.75A.75.75 0 0 1 8 0Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M4.55 1.578a.75.75 0 0 1-.2 1.042 6.5 6.5 0 1 0 7.299 0 .75.75 0 0 1 .844-1.24 8 8 0 1 1-8.985 0 .75.75 0 0 1 1.041.198Z',
        fillRule: 'evenodd',
      },
    ],
  },
  chart_pie: {
    paths: [
      {
        d: 'M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Zm-.75 1.543a6.501 6.501 0 1 0 4.785 11.553L7.47 8.53A.75.75 0 0 1 7.25 8V1.543Zm5.846 10.492A6.501 6.501 0 0 0 8.75 1.543v6.146l4.346 4.346Z',
        fillRule: 'evenodd',
      },
    ],
  },
  site: {
    paths: [
      {
        d: 'M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM1.543 7.25a6.507 6.507 0 0 1 4.37-5.408 7.088 7.088 0 0 0-.861 1.598c-.43 1.093-.68 2.385-.767 3.81H1.543Zm0 1.5a6.506 6.506 0 0 0 4.35 5.4 7.15 7.15 0 0 1-.832-1.462c-.508-1.184-.772-2.558-.807-3.938H1.543Zm4.212 0c.035 1.209.268 2.376.684 3.348.39.906.92 1.604 1.561 2.035.642-.431 1.172-1.129 1.56-2.035.417-.972.65-2.14.685-3.348h-4.49Zm5.99 0c-.034 1.38-.298 2.754-.806 3.938a7.153 7.153 0 0 1-.832 1.463 6.506 6.506 0 0 0 4.35-5.401h-2.711Zm2.712-1.5h-2.742c-.087-1.425-.338-2.717-.767-3.81a7.09 7.09 0 0 0-.862-1.598 6.507 6.507 0 0 1 4.371 5.408Zm-4.245 0H5.788c.085-1.268.31-2.368.66-3.262C6.836 3 7.364 2.296 8 1.868c.636.428 1.164 1.131 1.552 2.12.35.894.575 1.994.66 3.262Z',
        fillRule: 'evenodd',
      },
    ],
  },
  time: {
    paths: [
      {
        d: 'M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M7.5 3.25a.75.75 0 0 1 .75.75v4.19l2.28 2.28a.75.75 0 1 1-1.06 1.06l-2.5-2.5a.75.75 0 0 1-.22-.53V4a.75.75 0 0 1 .75-.75Z',
        fillRule: 'evenodd',
      },
    ],
  },
  time_back: {
    paths: [
      {
        d: 'M8.5 4.75a.75.75 0 0 0-.75.75v2.69l-2.78 2.78a.75.75 0 1 0 1.06 1.06l3-3a.75.75 0 0 0 .22-.53v-3a.75.75 0 0 0-.75-.75Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M8 1.5a6.5 6.5 0 0 0-5.757 3.48.75.75 0 1 1-1.327-.7 8 8 0 1 1-.607 5.926.75.75 0 1 1 1.441-.412A6.5 6.5 0 1 0 8 1.5Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M1.25 1a.75.75 0 0 1 .75.75V4h2a.75.75 0 1 1 0 1.5H1.25a.75.75 0 0 1-.75-.75v-3A.75.75 0 0 1 1.25 1Z',
        fillRule: 'evenodd',
      },
    ],
  },
  stopwatch: {
    paths: [
      {
        d: 'M8 14.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11ZM15 9A7 7 0 1 1 1 9a7 7 0 0 1 14 0Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M7.5 5.75a.75.75 0 0 1 .75.75v2.75H10a.75.75 0 0 1 0 1.5H7.5a.75.75 0 0 1-.75-.75V6.5a.75.75 0 0 1 .75-.75Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M11.97.97a.75.75 0 0 1 1.06 0l2 2a.75.75 0 0 1-1.06 1.06l-2-2a.75.75 0 0 1 0-1.06Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M4.03.97a.75.75 0 0 0-1.06 0l-2 2a.75.75 0 0 0 1.06 1.06l2-2a.75.75 0 0 0 0-1.06Z',
        fillRule: 'evenodd',
      },
    ],
  },
  target: {
    paths: [
      {
        d: 'M12.685.445A.75.75 0 0 0 11.44.252l-2 2.25a.75.75 0 0 0-.174.645l.42 2.107L7.47 7.47a.75.75 0 0 0 1.06 1.06l2.216-2.216 2.107.421a.75.75 0 0 0 .645-.174l2.25-2a.75.75 0 0 0-.193-1.246l-1.987-.883-.883-1.987Zm.096 4.746-1.644-.328-.328-1.644.978-1.1.528 1.186a.75.75 0 0 0 .38.38l1.187.528-1.101.978Z',
        fillRule: 'evenodd',
      },
      'M8 1.5A6.5 6.5 0 1 0 14.5 8 .75.75 0 0 1 16 8a8 8 0 1 1-8-8 .75.75 0 0 1 0 1.5Z',
      'M7.44 4.71a.75.75 0 0 1-.403.982 2.5 2.5 0 1 0 3.343 3.077.75.75 0 1 1 1.427.461 4.001 4.001 0 1 1-5.348-4.922.75.75 0 0 1 .98.403Z',
    ],
  },
  target_hit: {
    paths: [
      {
        d: 'M12.685.445A.75.75 0 0 0 11.44.252l-2 2.25a.75.75 0 0 0-.174.645l.42 2.107L7.47 7.47a.75.75 0 0 0 1.06 1.06l2.216-2.216 2.107.421a.75.75 0 0 0 .645-.174l2.25-2a.75.75 0 0 0-.193-1.246l-1.987-.883-.883-1.987Zm.096 4.746-1.644-.328-.328-1.644.978-1.1.528 1.186a.75.75 0 0 0 .38.38l1.187.528-1.101.978Z',
        fillRule: 'evenodd',
      },
      'M1.5 8A6.5 6.5 0 0 1 8 1.5.75.75 0 0 0 8 0a8 8 0 1 0 0 16 .75.75 0 0 0 0-1.5A6.5 6.5 0 0 1 1.5 8Z',
      'M15.786 11.469a.75.75 0 1 0-1.172-.938l-2.676 3.346-1.408-1.407a.75.75 0 1 0-1.06 1.06l2 2a.75.75 0 0 0 1.116-.061l3.2-4Z',
      'M7.44 4.71a.75.75 0 0 1-.403.982 2.5 2.5 0 1 0 3.343 3.077.75.75 0 1 1 1.427.461 4.001 4.001 0 1 1-5.348-4.922.75.75 0 0 1 .98.403Z',
    ],
  },
  hidden: {
    paths: [
      {
        d: 'M8 4.75a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5ZM6.25 8a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M15.948 7.726a.751.751 0 0 1 0 .547L15.25 8c.698.273.698.275.698.275v.001l-.003.006-.007.016a6.041 6.041 0 0 1-.111.259 12.918 12.918 0 0 1-1.748 2.796C12.818 12.876 10.815 14.5 8 14.5s-4.82-1.624-6.078-3.147A12.92 12.92 0 0 1 .173 8.557a7.963 7.963 0 0 1-.111-.259l-.007-.016-.002-.006v-.001l-.001-.002a.75.75 0 0 1 0-.546L.75 8c-.698-.273-.698-.275-.698-.275v-.001l.003-.006.007-.016a4.82 4.82 0 0 1 .111-.259 12.92 12.92 0 0 1 1.748-2.796C3.182 3.124 5.185 1.5 8 1.5s4.82 1.624 6.078 3.147a12.918 12.918 0 0 1 1.749 2.796 7.735 7.735 0 0 1 .111.259l.007.016.002.006.001.002Zm-14.107.818A10.502 10.502 0 0 1 1.568 8a11.421 11.421 0 0 1 1.51-2.397C4.195 4.25 5.816 3 8 3c2.184 0 3.805 1.251 4.922 2.603A11.421 11.421 0 0 1 14.432 8a11.42 11.42 0 0 1-1.51 2.397C11.805 11.75 10.184 13 8 13c-2.184 0-3.805-1.251-4.922-2.603a11.42 11.42 0 0 1-1.237-1.853ZM15.25 8l.698-.274L15.25 8Z',
        fillRule: 'evenodd',
      },
    ],
  },
  hidden_off: {
    paths: [
      {
        d: 'm2.03 15.03 13-13A.75.75 0 0 0 13.97.97l-1.85 1.85C11.013 2.055 9.641 1.5 8 1.5c-2.816 0-4.82 1.624-6.078 3.147A12.92 12.92 0 0 0 .173 7.443a7.963 7.963 0 0 0-.111.259l-.007.016-.002.006v.001S.051 7.727.75 8l-.698-.273a.75.75 0 0 0 0 .546L.75 8l-.698.273v.002l.001.003.003.007.01.025c.01.021.021.05.037.088a12.755 12.755 0 0 0 .695 1.35c.432.728 1.067 1.641 1.922 2.472L.97 13.97a.75.75 0 1 0 1.06 1.06Zm1.75-3.871a10.507 10.507 0 0 1-1.692-2.176A11.26 11.26 0 0 1 1.568 8a11.421 11.421 0 0 1 1.51-2.397C4.195 4.25 5.816 3 8 3c1.175 0 2.182.36 3.037.902L9.706 5.233a3.25 3.25 0 0 0-4.473 4.473L3.78 11.159Zm2.571-2.57a1.75 1.75 0 0 1 2.237-2.237L6.351 8.587Z',
        fillRule: 'evenodd',
      },
      'M13.565 5.166a.75.75 0 0 1 1.046.177 13.21 13.21 0 0 1 1.248 2.173l.065.15.017.042.005.012.001.004.001.002L15.25 8l.698.274v.002l-.003.006-.007.016a6.041 6.041 0 0 1-.111.259 12.918 12.918 0 0 1-1.748 2.796C12.818 12.876 10.815 14.5 8 14.5a6.987 6.987 0 0 1-1.68-.203.75.75 0 1 1 .36-1.456c.411.102.85.159 1.32.159 2.184 0 3.805-1.251 4.922-2.603A11.42 11.42 0 0 0 14.432 8a11.706 11.706 0 0 0-1.043-1.788.75.75 0 0 1 .176-1.046Z',
      'M15.948 8.274a.751.751 0 0 0 0-.547L15.25 8l.698.274Z',
      'M10.61 8.012c.397.121.62.54.5.936A3.256 3.256 0 0 1 9 11.093a.75.75 0 1 1-.462-1.428 1.756 1.756 0 0 0 1.135-1.154.75.75 0 0 1 .936-.499Z',
    ],
  },
  maintenance: {
    paths: [
      {
        d: 'M6.5 4.75A4.75 4.75 0 0 1 13.206.42a.75.75 0 0 1 .221 1.214l-2.093 2.093a.25.25 0 0 0 0 .354l.584.583a.25.25 0 0 0 .353 0l2.094-2.093a.75.75 0 0 1 1.214.22A4.75 4.75 0 0 1 9.787 9.27L4.238 14.82a1.75 1.75 0 0 1-2.475 0l-.583-.584a1.75 1.75 0 0 1 0-2.475l5.549-5.55A4.747 4.747 0 0 1 6.5 4.75Zm4.75-3.25a3.25 3.25 0 0 0-2.96 4.592.75.75 0 0 1-.235.914L2.24 12.82a.25.25 0 0 0 0 .354l.584.584a.25.25 0 0 0 .354 0l5.814-5.815a.75.75 0 0 1 .914-.233 3.25 3.25 0 0 0 4.59-3.148L13.33 5.725a1.75 1.75 0 0 1-2.475 0l-.584-.584a1.75 1.75 0 0 1 0-2.475l1.162-1.16a3.314 3.314 0 0 0-.185-.006Z',
        fillRule: 'evenodd',
      },
    ],
  },
  trophy: {
    paths: [
      {
        d: 'M5.25 1a2 2 0 0 0-2 2v.25H.75A.75.75 0 0 0 0 4a3.75 3.75 0 0 0 3.581 3.746 4.756 4.756 0 0 0 3.669 2.945V13.5H5A.75.75 0 0 0 5 15h6a.75.75 0 0 0 0-1.5H8.75v-2.809a4.756 4.756 0 0 0 3.669-2.945A3.75 3.75 0 0 0 16 4a.75.75 0 0 0-.75-.75h-2.5V3a2 2 0 0 0-2-2h-5.5Zm7.5 3.75V6c0 .065-.001.13-.004.195a2.254 2.254 0 0 0 1.626-1.445H12.75Zm-11.122 0H3.25V6c0 .065.001.13.004.195A2.254 2.254 0 0 1 1.628 4.75ZM8 9.25A3.25 3.25 0 0 0 11.25 6V3a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5v3A3.25 3.25 0 0 0 8 9.25Z',
        fillRule: 'evenodd',
      },
    ],
  },
  book_open: {
    paths: [
      {
        d: 'M15.076 13.98a.75.75 0 0 0 .924-.73V3.326c.001-.47.002-.928-.209-1.353a2.118 2.118 0 0 0-.842-.87c-.417-.225-.837-.238-1.26-.251l-.083-.003c-1.274-.042-3.114.047-4.821.7-.249.095-.422.161-.55.207-.104.036-.15.049-.161.052H8.07h.002a3.579 3.579 0 0 1-.073.01 3.6 3.6 0 0 1-.073-.01h.003-.004c-.012-.003-.057-.016-.16-.052a26.557 26.557 0 0 1-.55-.207C5.507.896 3.667.807 2.393.849l-.082.003c-.424.013-.844.026-1.26.25a2.118 2.118 0 0 0-.843.87c-.211.426-.21.885-.21 1.354L0 3.428v9.822a.75.75 0 0 0 .924.73l.004-.001.021-.005a7.77 7.77 0 0 1 .438-.088l.113-.02v1.384a.75.75 0 0 0 .91.733L8 14.767l5.59 1.216a.75.75 0 0 0 .91-.733v-1.383a20.583 20.583 0 0 1 .462.087l.089.02.021.005h.004ZM2.444 2.348c1.185-.039 2.796.051 4.235.602l.01.004c.229.087.415.158.561.21v9.53l-.987-.262c-1.291-.344-2.725-.311-3.798-.207-.361.035-.688.079-.965.122V3.428c0-.64.018-.718.052-.787.036-.071.141-.18.21-.218.073-.04.128-.057.682-.075ZM8.75 12.694l.987-.262c1.291-.344 2.726-.311 3.798-.207.361.035.688.079.965.122V3.428c0-.64-.018-.718-.052-.787a.647.647 0 0 0-.21-.218c-.073-.04-.128-.057-.681-.075-1.185-.039-2.796.051-4.236.602l-.01.004c-.229.087-.415.158-.561.21v9.53Zm4.25.991c-.78-.054-1.654-.048-2.453.101L13 14.32v-.634ZM3 14.32v-.634c.78-.054 1.654-.048 2.453.101L3 14.32Z',
        fillRule: 'evenodd',
      },
    ],
  },
  thumbs_up_down: {
    paths: [
      {
        d: 'M5.5 3.755V1.948L4.146 3.55a5.261 5.261 0 0 0-.135.165.105.105 0 0 0-.008.02A5.245 5.245 0 0 0 4 3.949v3.837a5.206 5.206 0 0 0 .003.193.106.106 0 0 0 .006.019 5.192 5.192 0 0 0 .113.156l.07.097a5.509 5.509 0 0 0 .18.232c.007.005.016.01.025.012a5.535 5.535 0 0 0 .293.006h3.73c.218 0 .34 0 .428-.007a.633.633 0 0 0 .06-.007.105.105 0 0 0 .029-.025.633.633 0 0 0 .016-.057c.021-.087.042-.206.078-.42l.462-2.758c.048-.288.076-.456.086-.58a.768.768 0 0 0 .003-.086.105.105 0 0 0-.027-.032.766.766 0 0 0-.086-.012 7.814 7.814 0 0 0-.586-.011H6.25a.75.75 0 0 1-.75-.75Zm-2.81-.752c-.042.08-.078.162-.107.247H.75A.75.75 0 0 0 0 4v4c0 .414.336.75.75.75h1.962c.058.1.124.189.183.268l.02.028.072.096.03.042c.118.16.255.345.438.485.16.122.34.213.532.268.222.064.453.064.65.063h.479l-.093.554c-.042.25-.081.484-.097.68-.017.211-.015.459.08.714.13.352.38.647.705.834.236.135.48.178.69.196.197.017.434.017.688.017H9v.952c0 .31 0 .59.019.808.016.19.056.542.301.815.277.308.69.46 1.1.403.364-.05.621-.293.757-.428.155-.155.336-.368.536-.605L13 13.42l.024-.03a2.28 2.28 0 0 0 .287-.393c.042-.08.078-.162.107-.247h1.833A.75.75 0 0 0 16 12V8a.75.75 0 0 0-.75-.75h-1.962c-.058-.1-.124-.189-.183-.268l-.02-.028-.072-.096-.03-.042c-.118-.16-.255-.345-.438-.485a1.606 1.606 0 0 0-.532-.269C11.79 6 11.56 6 11.363 6h-.479l.093-.554c.042-.25.081-.484.097-.68.017-.211.015-.459-.08-.714a1.605 1.605 0 0 0-.705-.834 1.638 1.638 0 0 0-.69-.196c-.197-.017-.434-.017-.688-.017H7v-.952c0-.31 0-.59-.019-.808-.016-.19-.056-.542-.301-.815a1.25 1.25 0 0 0-1.1-.403c-.364.05-.621.293-.757.428-.155.154-.336.368-.536.605L3 2.58l-.025.03a2.284 2.284 0 0 0-.286.393ZM10.633 7.5l-.127.754c-.03.184-.06.36-.097.509-.04.163-.1.345-.218.522a1.605 1.605 0 0 1-.68.575 1.615 1.615 0 0 1-.55.129C8.81 10 8.63 10 8.443 10H6.637l-.13.774a7.803 7.803 0 0 0-.086.58.767.767 0 0 0-.003.086.105.105 0 0 0 .027.032c.014.003.04.008.086.012.124.01.294.01.586.01H9.75a.75.75 0 0 1 .75.75v1.808l1.354-1.601a5.35 5.35 0 0 0 .12-.146l.011-.013.004-.006a.112.112 0 0 0 .008-.02l.001-.025a5.24 5.24 0 0 0 .002-.19V8.216l-.001-.17c0-.013-.001-.02-.002-.023a.111.111 0 0 0-.006-.019 5.24 5.24 0 0 0-.113-.156l-.07-.097a5.563 5.563 0 0 0-.18-.232.105.105 0 0 0-.024-.012 5.536 5.536 0 0 0-.293-.006h-.678ZM1.5 4.75h1v2.5h-1v-2.5Zm13 6.5v-2.5h-1v2.5h1Z',
        fillRule: 'evenodd',
      },
    ],
  },
  help: {
    paths: [
      {
        d: 'M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M8 4.25c-.846 0-1.553.6-1.715 1.4a.75.75 0 0 1-1.47-.3A3.25 3.25 0 1 1 8.75 9.164V10a.75.75 0 0 1-1.5 0V8.5A.75.75 0 0 1 8 7.75a1.75 1.75 0 1 0 0-3.5Z',
        fillRule: 'evenodd',
      },
      'M9 12.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
    ],
  },
  info: {
    paths: [
      {
        d: 'M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M8 12.75a.75.75 0 0 1-.75-.75V7.5a.75.75 0 0 1 1.5 0V12a.75.75 0 0 1-.75.75Z',
        fillRule: 'evenodd',
      },
      'M7 4.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z',
    ],
  },
  check: {
    paths: [
      {
        d: 'M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M11.469 4.914a.75.75 0 0 1 .117 1.055l-4 5a.75.75 0 0 1-1.116.061l-2-2a.75.75 0 0 1 1.06-1.06l1.408 1.407 3.476-4.346a.75.75 0 0 1 1.055-.117Z',
        fillRule: 'evenodd',
      },
    ],
  },
  warning: {
    paths: [
      {
        d: 'M8 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 8 5Z',
        fillRule: 'evenodd',
      },
      'M9 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
      {
        d: 'M2.014 13.5h11.973a.5.5 0 0 0 .43-.755L8.43 2.662a.5.5 0 0 0-.86 0L1.584 12.745a.5.5 0 0 0 .43.755ZM13.987 15H2.014c-1.55 0-2.512-1.688-1.72-3.021L6.28 1.896c.775-1.305 2.665-1.305 3.44 0l5.986 10.083c.792 1.333-.169 3.021-1.72 3.021Z',
        fillRule: 'evenodd',
      },
    ],
  },
  star_empty: {
    paths: [
      {
        d: 'M8 2.434 6.911 4.877a2.5 2.5 0 0 1-2.02 1.468l-2.66.28 1.987 1.79a2.5 2.5 0 0 1 .772 2.377l-.555 2.615 2.316-1.336a2.5 2.5 0 0 1 2.498 0l2.316 1.336-.554-2.616a2.5 2.5 0 0 1 .772-2.375l1.986-1.79-2.66-.281a2.5 2.5 0 0 1-2.02-1.468L8 2.434ZM8.913.8c-.352-.79-1.474-.79-1.826 0L5.54 4.266a1 1 0 0 1-.808.587l-3.775.399c-.86.09-1.207 1.158-.564 1.737l2.82 2.54a1 1 0 0 1 .308.951l-.787 3.713c-.18.847.728 1.506 1.478 1.074L7.5 13.371a1 1 0 0 1 1 0l3.288 1.896c.75.432 1.657-.227 1.477-1.074l-.787-3.713a1 1 0 0 1 .309-.95l2.82-2.541c.642-.58.296-1.647-.565-1.737l-3.775-.399a1 1 0 0 1-.808-.587L8.913.799Z',
        fillRule: 'evenodd',
      },
    ],
  },
  sidebar_right_close: {
    paths: [
      'M6.424 5.02a.75.75 0 0 1 1.056-.096l3 2.5a.75.75 0 0 1 0 1.152l-3 2.5a.75.75 0 0 1-.96-1.152L7.928 8.75H3a.75.75 0 0 1 0-1.5h4.928L6.52 6.076a.75.75 0 0 1-.096-1.056Z',
      {
        d: 'M.218 2.092C0 2.52 0 3.08 0 4.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C1.52 15 2.08 15 3.2 15h9.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C16 13.48 16 12.92 16 11.8V4.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 1 13.92 1 12.8 1H3.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874ZM11.25 2.5H3.2c-.585 0-.933.001-1.191.022-.158.013-.224.03-.242.036a.5.5 0 0 0-.21.209 1.254 1.254 0 0 0-.035.242c-.02.258-.022.606-.022 1.191v7.6c0 .585.001.933.022 1.191.013.158.03.224.036.242a.5.5 0 0 0 .209.21c.018.005.084.022.242.035.258.02.606.022 1.191.022h8.05v-11Zm1.5 0v11h.05c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .21-.209c.005-.018.022-.084.035-.242.02-.258.022-.606.022-1.191V4.2c0-.585-.001-.933-.022-1.191a1.252 1.252 0 0 0-.036-.242.5.5 0 0 0-.209-.21 1.255 1.255 0 0 0-.242-.035c-.258-.02-.606-.022-1.191-.022h-.05Zm1.488.06-.003-.002a.03.03 0 0 1 .003.001Zm.203.202v.003-.003Zm0 10.476v-.003a.014.014 0 0 1 0 .003Zm-.203.203h-.003.003Zm-12.476 0h.003-.003Zm-.203-.203Zm0-10.476v.003-.003Zm.203-.203h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  sidebar_right_open: {
    paths: [
      'M6.576 10.98a.75.75 0 0 1-1.056.096l-3-2.5a.75.75 0 0 1 0-1.152l3-2.5a.75.75 0 1 1 .96 1.152L5.072 7.25H10a.75.75 0 0 1 0 1.5H5.072L6.48 9.924a.75.75 0 0 1 .096 1.056Z',
      {
        d: 'M.218 2.092C0 2.52 0 3.08 0 4.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C1.52 15 2.08 15 3.2 15h9.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C16 13.48 16 12.92 16 11.8V4.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 1 13.92 1 12.8 1H3.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874ZM11.25 2.5H3.2c-.585 0-.933.001-1.191.022-.158.013-.224.03-.242.036a.5.5 0 0 0-.21.209 1.254 1.254 0 0 0-.035.242c-.02.258-.022.606-.022 1.191v7.6c0 .585.001.933.022 1.191.013.158.03.224.036.242a.5.5 0 0 0 .209.21c.018.005.084.022.242.035.258.02.606.022 1.191.022h8.05v-11Zm1.5 0v11h.05c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .21-.209c.005-.018.022-.084.035-.242.02-.258.022-.606.022-1.191V4.2c0-.585-.001-.933-.022-1.191a1.252 1.252 0 0 0-.036-.242.5.5 0 0 0-.209-.21 1.255 1.255 0 0 0-.242-.035c-.258-.02-.606-.022-1.191-.022h-.05Zm1.488.06-.003-.002a.03.03 0 0 1 .003.001Zm.203.202v.003-.003Zm0 10.476v-.003a.014.014 0 0 1 0 .003Zm-.203.203h-.003.003Zm-12.476 0h.003-.003Zm-.203-.203Zm0-10.476v.003-.003Zm.203-.203h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  circle: {
    paths: [
      {
        d: 'M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Z',
        fillRule: 'evenodd',
      },
    ],
  },
  webhooks: {
    paths: [
      {
        d: 'M3.254 7.01c.407-.076.746.267.746.682 0 .414-.343.738-.74.86a2.5 2.5 0 1 0 3.24 2.39.53.53 0 0 1 .084-.287.75.75 0 0 1 .666-.405h3.451l.056-.089a1.499 1.499 0 1 1-.056 1.59H7.918a4 4 0 1 1-4.664-4.74Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M8.918 13.57c-.27-.315-.142-.78.217-.987.358-.207.81-.073 1.115.21a2.5 2.5 0 1 0 .45-4 .531.531 0 0 1-.291.07.751.751 0 0 1-.683-.374L8 5.499l-.105-.003a1.499 1.499 0 0 1-.645-2.795A1.5 1.5 0 0 1 9.3 4.75l1.39 2.41a4 4 0 1 1-1.772 6.409Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M11.814 5.32c-.136.391-.604.513-.962.306-.359-.207-.468-.666-.377-1.071a2.5 2.5 0 1 0-3.688 1.61c.09.052.162.129.207.217a.75.75 0 0 1 .017.779L5.285 10.15l.05.092A1.499 1.499 0 0 1 3.236 12.2a1.5 1.5 0 0 1 .75-2.8l1.392-2.41a4 4 0 1 1 6.436-1.67Z',
        fillRule: 'evenodd',
      },
    ],
  },
  receipt: {
    paths: [
      {
        d: 'M4.25 4A.75.75 0 0 1 5 3.25h4a.75.75 0 1 1 0 1.5H5A.75.75 0 0 1 4.25 4Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M4.25 7A.75.75 0 0 1 5 6.25h6a.75.75 0 0 1 0 1.5H5A.75.75 0 0 1 4.25 7Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M4.25 10A.75.75 0 0 1 5 9.25h3a.75.75 0 1 1 0 1.5H5a.75.75 0 0 1-.75-.75Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M3.722 0H12.278c.326 0 .615 0 .854.02.255.02.519.067.776.198a2 2 0 0 1 .874.874c.131.257.178.521.198.776.02.24.02.528.02.854V14.74c0 .107 0 .233-.01.34-.01.103-.036.334-.199.544a1 1 0 0 1-.757.387 1.026 1.026 0 0 1-.558-.156 3.902 3.902 0 0 1-.28-.19l-.018-.013-1.556-1.12a7.201 7.201 0 0 0-.359-.25.529.529 0 0 0-.077-.042.249.249 0 0 0-.122 0 .529.529 0 0 0-.077.042c-.08.05-.182.123-.359.25l-1.255.903-.067.05c-.265.191-.547.395-.874.479a1.75 1.75 0 0 1-.864 0c-.327-.084-.609-.288-.874-.48a23.932 23.932 0 0 0-.067-.049l-1.255-.903a7.185 7.185 0 0 0-.359-.25.532.532 0 0 0-.077-.042.249.249 0 0 0-.122 0 .531.531 0 0 0-.077.042c-.08.05-.182.123-.359.25l-1.556 1.12-.017.013a3.915 3.915 0 0 1-.281.19c-.09.053-.293.165-.558.156a1 1 0 0 1-.757-.387c-.163-.21-.19-.44-.2-.545A3.92 3.92 0 0 1 1 14.74V2.722c0-.326 0-.615.02-.854.02-.255.067-.519.198-.776a2 2 0 0 1 .874-.874c.257-.131.521-.178.776-.198.24-.02.528-.02.854-.02Zm1.094 14.24h-.002.002Zm.118 0h.002-.002Zm6.132 0h-.002.002Zm.118 0h.002-.002ZM2.99 1.514c-.162.013-.207.034-.217.04a.5.5 0 0 0-.218.218c-.006.01-.027.055-.04.217-.014.17-.015.398-.015.76v11.286l1.002-.721.067-.05c.265-.191.547-.395.874-.479a1.75 1.75 0 0 1 .864 0c.327.084.609.288.874.48l.067.049 1.255.903c.177.127.279.2.359.25.049.03.071.04.077.042.04.01.082.01.122 0a.53.53 0 0 0 .077-.042c.08-.05.182-.123.359-.25l1.255-.903.067-.05c.265-.191.547-.395.874-.479a1.75 1.75 0 0 1 .864 0c.327.084.609.288.874.48l.067.049 1.002.72V2.75c0-.362 0-.59-.014-.76-.014-.162-.035-.207-.04-.217a.5.5 0 0 0-.219-.218c-.01-.006-.055-.027-.217-.04-.17-.014-.398-.015-.76-.015h-8.5c-.362 0-.59 0-.76.015ZM8.06 14.51h.002-.002Zm-.118 0H7.94h.002Zm-5.437.434v-.001.001Z',
        fillRule: 'evenodd',
      },
    ],
  },
  plug: {
    paths: [
      {
        d: 'M4.87 3A1.87 1.87 0 0 0 3 4.87v.38H1.75a.75.75 0 0 0 0 1.5H3v2.5H1.75a.75.75 0 0 0 0 1.5H3v.38A1.87 1.87 0 0 0 4.87 13H6a5.001 5.001 0 0 0 4.944-4.25h1.306c.362 0 .59 0 .76.015.162.013.207.034.217.04a.5.5 0 0 1 .218.218c.006.01.027.055.04.217.014.17.015.398.015.76v2a.75.75 0 0 0 1.5 0V9.972c0-.326 0-.615-.02-.854a2.032 2.032 0 0 0-.198-.776 2 2 0 0 0-.874-.874 2.033 2.033 0 0 0-.776-.198c-.24-.02-.528-.02-.854-.02h-1.334A5.001 5.001 0 0 0 6 3H4.87Zm-.37 8.13c0 .204.166.37.37.37H6a3.5 3.5 0 1 0 0-7H4.87a.37.37 0 0 0-.37.37v6.26Z',
        fillRule: 'evenodd',
      },
    ],
  },
  help_alt: {
    paths: [
      {
        d: 'M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm1-3.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM6.285 5.65A1.75 1.75 0 1 1 8 7.75a.75.75 0 0 0-.75.75V10a.75.75 0 0 0 1.5 0v-.837a3.251 3.251 0 1 0-3.935-3.812.75.75 0 0 0 1.47.298Z',
        fillRule: 'evenodd',
      },
    ],
  },
  info_alt: {
    paths: [
      {
        d: 'M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm0-3.25a.75.75 0 0 1-.75-.75V7.5a.75.75 0 0 1 1.5 0V12a.75.75 0 0 1-.75.75ZM8 3.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z',
        fillRule: 'evenodd',
      },
    ],
  },
  check_alt: {
    paths: [
      {
        d: 'M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Zm-4.414-2.031a.75.75 0 0 0-1.172-.938L6.938 9.377 5.53 7.97a.75.75 0 0 0-1.06 1.06l2 2a.75.75 0 0 0 1.116-.061l4-5Z',
        fillRule: 'evenodd',
      },
    ],
  },
  warning_alt: {
    paths: [
      {
        d: 'M2.013 15.083h11.973c1.55 0 2.512-1.688 1.72-3.021L9.72 1.979c-.775-1.305-2.665-1.305-3.44 0L.294 12.06c-.792 1.334.169 3.022 1.72 3.022ZM8 5.083a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75Zm0 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
        fillRule: 'evenodd',
      },
    ],
  },
  star_filled: {
    paths: [
      'M7.087.799c.352-.79 1.474-.79 1.826 0l1.546 3.467a1 1 0 0 0 .808.587l3.775.399c.86.09 1.207 1.158.564 1.737l-2.82 2.54a1 1 0 0 0-.308.951l.787 3.713c.18.847-.728 1.506-1.477 1.074L8.5 13.371a1 1 0 0 0-1 0l-3.287 1.896c-.75.432-1.658-.227-1.478-1.074l.787-3.713a1 1 0 0 0-.309-.95L.393 6.989c-.642-.58-.295-1.647.565-1.737l3.775-.399a1 1 0 0 0 .808-.587L7.087.799Z',
    ],
  },
  sidebar_right_close_alt: {
    paths: [
      {
        d: 'M11.25 1H3.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C0 2.52 0 3.08 0 4.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C1.52 15 2.08 15 3.2 15h8.05V1Zm1.5 14h.05c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C16 13.48 16 12.92 16 11.8V4.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 1 13.92 1 12.8 1h-.05v14ZM5.424 5.02a.75.75 0 0 1 1.056-.096l3 2.5a.75.75 0 0 1 0 1.152l-3 2.5a.75.75 0 0 1-.96-1.152L6.928 8.75H2a.75.75 0 0 1 0-1.5h4.928L5.52 6.076a.75.75 0 0 1-.096-1.056Z',
        fillRule: 'evenodd',
      },
    ],
  },
  sidebar_right_open_alt: {
    paths: [
      {
        d: 'M11.25 1H3.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C0 2.52 0 3.08 0 4.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C1.52 15 2.08 15 3.2 15h8.05V1Zm1.5 14h.05c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C16 13.48 16 12.92 16 11.8V4.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 1 13.92 1 12.8 1h-.05v14Zm-7.174-4.02a.75.75 0 0 1-1.056.096l-3-2.5a.75.75 0 0 1 0-1.152l3-2.5a.75.75 0 0 1 .96 1.152L4.072 7.25H9a.75.75 0 0 1 0 1.5H4.072L5.48 9.924a.75.75 0 0 1 .096 1.056Z',
        fillRule: 'evenodd',
      },
    ],
  },
  circle_alt: {
    paths: ['M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z'],
  },
  user_avatar: {
    paths: [
      {
        d: 'M5 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-6.5a6.5 6.5 0 0 0-4.728 10.96C4.355 11.005 6.058 10 8 10c1.942 0 3.645 1.005 4.728 2.46A6.5 6.5 0 0 0 8 1.5Zm3.578 11.928C10.74 12.26 9.436 11.5 8 11.5s-2.74.76-3.578 1.928A6.47 6.47 0 0 0 8 14.5a6.47 6.47 0 0 0 3.578-1.072Z',
        fillRule: 'evenodd',
      },
    ],
  },
  thumbs_up: {
    paths: [
      {
        d: 'M10.229 1.69a2 2 0 0 0-1.783-.63c-.512.08-.922.447-1.255.794-.355.37-.78.897-1.307 1.548L4.581 5.016c-.135.167-.264.326-.359.51a2 2 0 0 0-.21.724H1.75A.75.75 0 0 0 1 7v6c0 .414.336.75.75.75h2.88l.025.022c.148.135.323.24.507.35l.042.025.02.012c.093.056.181.109.276.153a2 2 0 0 0 .64.177c.104.011.207.011.315.011h5.92c.272 0 .517 0 .722-.015.22-.017.448-.053.676-.154a2 2 0 0 0 .84-.693c.143-.206.222-.422.28-.635.054-.199.1-.439.152-.706l.737-3.805c.074-.382.138-.715.167-.992.03-.291.032-.6-.077-.912a2 2 0 0 0-.878-1.065c-.285-.166-.59-.223-.88-.249a12.478 12.478 0 0 0-1.007-.024H10.75v-.128c0-.837 0-1.515-.043-2.026-.041-.479-.13-1.022-.478-1.406Zm-1.553.854.004-.002a.5.5 0 0 1 .436.154l.001.004c.01.024.063.147.095.523.037.44.038 1.053.038 1.936V6c0 .414.336.75.75.75h3.076c.43 0 .702 0 .907.019.197.017.247.045.254.05a.5.5 0 0 1 .22.266c.003.008.02.061 0 .259-.021.204-.072.472-.154.894l-.726 3.75a9.69 9.69 0 0 1-.131.621.583.583 0 0 1-.066.175.5.5 0 0 1-.21.174.584.584 0 0 1-.185.03 9.65 9.65 0 0 1-.635.012H6.479c-.147 0-.167 0-.184-.003a.5.5 0 0 1-.16-.044 2.29 2.29 0 0 1-.16-.092c-.252-.152-.288-.177-.311-.199a.5.5 0 0 1-.154-.272c-.006-.031-.01-.074-.01-.369V6.707c0-.292.004-.334.01-.366a.5.5 0 0 1 .046-.128c.015-.03.038-.064.222-.292l1.25-1.547c.555-.687.94-1.164 1.246-1.482.26-.273.38-.336.402-.348Zm.44.152ZM2.5 12.25v-4.5H4v4.5H2.5Z',
        fillRule: 'evenodd',
      },
    ],
  },
  thumbs_down: {
    paths: [
      {
        d: 'M10.229 14.31a2 2 0 0 1-1.783.63c-.512-.08-.922-.447-1.255-.794-.355-.37-.78-.897-1.307-1.548l-1.303-1.614c-.135-.167-.264-.326-.359-.51a2 2 0 0 1-.21-.724H1.75A.75.75 0 0 1 1 9V3a.75.75 0 0 1 .75-.75h2.88l.025-.022a3.12 3.12 0 0 1 .507-.35l.042-.025.02-.012c.093-.056.181-.109.276-.153a2 2 0 0 1 .64-.177c.104-.011.207-.011.315-.011h5.92c.272 0 .517 0 .722.015.22.017.448.054.676.154a2 2 0 0 1 .84.693c.143.206.222.422.28.635.054.199.1.439.152.706l.737 3.805c.074.382.138.716.167.992.03.291.032.6-.077.912a2 2 0 0 1-.878 1.065c-.285.166-.59.223-.88.249-.278.024-.618.024-1.007.024H10.75v.128c0 .837 0 1.515-.043 2.026-.041.479-.13 1.023-.478 1.406Zm-1.553-.854.004.002a.5.5 0 0 0 .437-.158c.01-.024.063-.147.095-.523.037-.44.038-1.053.038-1.936V10a.75.75 0 0 1 .75-.75h3.076c.43 0 .702 0 .907-.018.197-.018.247-.046.254-.05a.5.5 0 0 0 .22-.266c.003-.008.02-.062 0-.26a11.796 11.796 0 0 0-.154-.894l-.726-3.75a9.701 9.701 0 0 0-.131-.621.583.583 0 0 0-.066-.175.5.5 0 0 0-.21-.174.585.585 0 0 0-.185-.03A9.627 9.627 0 0 0 12.35 3H6.479c-.147 0-.167 0-.184.003a.5.5 0 0 0-.16.044 2.251 2.251 0 0 0-.16.093c-.252.151-.288.176-.311.198a.5.5 0 0 0-.154.272c-.006.031-.01.074-.01.369v5.314c0 .292.004.334.01.366a.5.5 0 0 0 .046.128c.015.03.038.064.222.292l1.25 1.547c.555.687.94 1.164 1.246 1.482.26.273.38.336.402.348ZM2.5 3.75v4.5H4v-4.5H2.5Z',
        fillRule: 'evenodd',
      },
    ],
  },
  pin: {
    paths: [
      {
        d: 'm13.482 1.171 1.347 1.347c.239.24.45.45.61.64.17.2.328.427.416.71a2 2 0 0 1-.025 1.267c-.1.28-.266.5-.444.694-.168.182-.387.385-.636.615l-1.399 1.29a2.213 2.213 0 0 0-.175.17.502.502 0 0 0-.052.075c-.01.02-.022.045-.091.226l-1.24 3.224c-.174.451-.323.837-.47 1.135-.15.305-.344.616-.659.835a2 2 0 0 1-1.515.322c-.377-.072-.68-.278-.942-.496a14.702 14.702 0 0 1-.89-.847L6 11.061l-3.47 3.47a.75.75 0 0 1-1.06-1.061L4.94 10 3.621 8.682c-.342-.342-.635-.634-.847-.889-.218-.262-.424-.565-.496-.942a2 2 0 0 1 .322-1.515c.219-.315.53-.51.835-.66.298-.147.684-.295 1.135-.468l3.224-1.24c.181-.07.206-.081.226-.092a.5.5 0 0 0 .076-.052c.017-.014.037-.033.168-.175L9.556 1.25c.23-.249.432-.468.615-.636.194-.178.414-.345.694-.444a2 2 0 0 1 1.266-.026c.284.089.51.247.711.417.19.16.4.371.64.61ZM6.536 9.475 6.53 9.47a.92.92 0 0 0-.005-.006L4.706 7.646c-.372-.373-.615-.617-.779-.813-.161-.194-.174-.26-.174-.263a.5.5 0 0 1 .08-.379c.001-.002.04-.058.267-.17.228-.112.55-.236 1.042-.426l3.221-1.239c.134-.051.261-.1.383-.167a2 2 0 0 0 .303-.206c.108-.088.2-.189.297-.294l1.293-1.4c.255-.277.415-.45.546-.57.125-.114.173-.132.183-.136a.5.5 0 0 1 .317-.007c.01.004.059.02.188.13.136.114.303.28.569.546l1.306 1.306c.265.266.432.433.546.569.11.13.126.178.13.188a.5.5 0 0 1-.007.317c-.004.01-.022.058-.136.183-.12.13-.293.291-.57.546l-1.4 1.293a3.02 3.02 0 0 0-.294.297 2 2 0 0 0-.206.303 2.99 2.99 0 0 0-.167.383l-1.24 3.221c-.189.492-.313.813-.426 1.042-.111.227-.167.265-.17.267a.5.5 0 0 1-.378.08c-.002 0-.069-.013-.263-.175-.196-.163-.44-.406-.813-.778L6.536 9.474Z',
        fillRule: 'evenodd',
      },
    ],
  },
  heart: {
    paths: [
      {
        d: 'M8 4.814 6.502 3.343a2.982 2.982 0 0 0-4.155 0 2.79 2.79 0 0 0 0 4.004L8 12.897l5.653-5.55a2.79 2.79 0 0 0 0-4.004 2.982 2.982 0 0 0-4.155 0L8 4.813Zm-.7 9.498L1.295 8.417a4.29 4.29 0 0 1 0-6.144 4.482 4.482 0 0 1 6.257 0L8 2.71l.447-.438a4.482 4.482 0 0 1 6.257 0 4.29 4.29 0 0 1 0 6.144l-6.003 5.895a1 1 0 0 1-1.402 0Z',
        fillRule: 'evenodd',
      },
    ],
  },
  crown: {
    paths: [
      {
        d: 'M8 2a.75.75 0 0 1 .634.35l2.52 3.988 2.587-2.39A.75.75 0 0 1 15 4.5v6.75A2.75 2.75 0 0 1 12.25 14h-8.5A2.75 2.75 0 0 1 1 11.25V4.5a.75.75 0 0 1 1.259-.551l2.588 2.389L7.366 2.35A.75.75 0 0 1 8 2Zm0 2.155L5.634 7.9a.75.75 0 0 1-1.143.151L2.5 6.213v5.037c0 .69.56 1.25 1.25 1.25h8.5c.69 0 1.25-.56 1.25-1.25V6.213l-1.991 1.838a.75.75 0 0 1-1.143-.15L8 4.154Z',
        fillRule: 'evenodd',
      },
    ],
  },
  user_avatar_alt: {
    paths: [
      {
        d: 'M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM8 4.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM5 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3 5.5c-1.253 0-2.404.577-3.235 1.502a.75.75 0 0 1-1.115-1.004C4.73 10.798 6.27 10 8 10c1.73 0 3.27.798 4.35 1.998a.75.75 0 0 1-1.115 1.004C10.404 12.077 9.253 11.5 8 11.5Z',
        fillRule: 'evenodd',
      },
    ],
  },
  thumbs_up_filled: {
    paths: [
      {
        d: 'M10.229 1.69a2 2 0 0 0-1.783-.63c-.512.08-.922.447-1.255.794-.355.37-.78.897-1.307 1.548L4.581 5.016c-.135.167-.264.326-.359.51a2 2 0 0 0-.21.724H1.75A.75.75 0 0 0 1 7v6c0 .414.336.75.75.75h2.88l.025.022c.148.135.323.24.507.35l.042.025.02.012c.093.056.181.109.276.153a2 2 0 0 0 .64.177c.104.011.207.011.315.011h5.92c.272 0 .517 0 .722-.015.22-.017.448-.053.676-.154a2 2 0 0 0 .84-.693c.143-.206.222-.422.28-.635.054-.199.1-.439.152-.706l.737-3.805c.074-.382.138-.715.167-.992.03-.291.032-.6-.077-.912a2 2 0 0 0-.878-1.065c-.285-.166-.59-.223-.88-.249a12.478 12.478 0 0 0-1.007-.024H10.75v-.128c0-.837 0-1.515-.043-2.026-.041-.479-.13-1.022-.478-1.406ZM2.5 7.75v4.5H4v-4.5H2.5Z',
        fillRule: 'evenodd',
      },
    ],
  },
  thumbs_down_filled: {
    paths: [
      {
        d: 'M10.229 14.31a2 2 0 0 1-1.783.63c-.512-.08-.922-.447-1.255-.794-.355-.37-.78-.897-1.307-1.548l-1.303-1.614c-.135-.167-.264-.326-.359-.51a2 2 0 0 1-.21-.724H1.75A.75.75 0 0 1 1 9V3a.75.75 0 0 1 .75-.75h2.88l.025-.022a3.12 3.12 0 0 1 .507-.35l.042-.025.02-.012c.093-.056.181-.109.276-.153a2 2 0 0 1 .64-.177c.104-.011.207-.011.315-.011h5.92c.272 0 .517 0 .722.015.22.017.448.054.676.154a2 2 0 0 1 .84.693c.143.206.222.422.28.635.054.199.1.439.152.706l.737 3.805c.074.382.138.716.167.992.03.291.032.6-.077.912a2 2 0 0 1-.878 1.065c-.285.166-.59.223-.88.249-.278.024-.618.024-1.007.024H10.75v.128c0 .837 0 1.515-.043 2.026-.041.479-.13 1.023-.478 1.406ZM2.5 8.25v-4.5H4v4.5H2.5Z',
        fillRule: 'evenodd',
      },
    ],
  },
  pin_filled: {
    paths: [
      'M14.829 2.518 13.482 1.17c-.24-.239-.45-.45-.64-.61-.2-.17-.427-.328-.71-.417a2 2 0 0 0-1.267.026c-.28.1-.5.266-.694.444-.183.168-.385.387-.615.636l-1.29 1.399a2.226 2.226 0 0 1-.17.175.5.5 0 0 1-.075.052c-.02.01-.045.022-.226.091l-3.224 1.24c-.451.174-.837.322-1.135.47-.305.15-.616.344-.835.659A2 2 0 0 0 2.28 6.85c.072.377.278.68.496.942.212.255.505.547.847.89L4.939 10l-3.47 3.47a.75.75 0 1 0 1.061 1.06L6 11.06l1.318 1.318c.342.342.634.635.889.847.261.218.565.424.942.495a2 2 0 0 0 1.515-.321c.315-.219.51-.53.66-.835.146-.298.295-.684.468-1.135l1.24-3.224c.07-.181.081-.206.092-.226a.502.502 0 0 1 .052-.076c.014-.017.033-.037.175-.168l1.399-1.291c.249-.23.468-.433.636-.615.178-.194.345-.414.444-.694a2 2 0 0 0 .025-1.266 2.038 2.038 0 0 0-.416-.711c-.16-.19-.371-.4-.61-.64Z',
    ],
  },
  heart_alt: {
    paths: [
      {
        d: 'm1.296 8.417 6.003 5.895a1 1 0 0 0 1.402 0l6.003-5.895a4.29 4.29 0 0 0 0-6.144 4.482 4.482 0 0 0-6.257 0L8 2.71l-.447-.438a4.482 4.482 0 0 0-6.257 0 4.29 4.29 0 0 0 0 6.144Z',
        fillRule: 'evenodd',
      },
    ],
  },
  crown_alt: {
    paths: [
      'M8.634 2.35a.75.75 0 0 0-1.268 0l-2.52 3.988-2.587-2.39A.75.75 0 0 0 1 4.5v6.75A2.75 2.75 0 0 0 3.75 14h8.5A2.75 2.75 0 0 0 15 11.25V4.5a.75.75 0 0 0-1.259-.551l-2.588 2.389L8.634 2.35Z',
    ],
  },
  time_alt: {
    paths: [
      {
        d: 'M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0ZM8.25 4a.75.75 0 0 0-1.5 0v4.5c0 .199.079.39.22.53l2.5 2.5a.75.75 0 1 0 1.06-1.06L8.25 8.19V4Z',
        fillRule: 'evenodd',
      },
    ],
  },
  sun: {
    paths: [
      'M8 0a.75.75 0 0 1 .75.75V2a.75.75 0 0 1-1.5 0V.75A.75.75 0 0 1 8 0Z',
      {
        d: 'M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-4 2.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z',
        fillRule: 'evenodd',
      },
      'M13.657 3.404a.75.75 0 1 0-1.06-1.06l-.885.883a.75.75 0 0 0 1.06 1.06l.885-.883Z',
      'M2.343 2.343a.75.75 0 0 1 1.06 0l.885.884a.75.75 0 0 1-1.061 1.06l-.884-.883a.75.75 0 0 1 0-1.06Z',
      'M.75 7.25a.75.75 0 0 0 0 1.5H2a.75.75 0 0 0 0-1.5H.75Z',
      'M8 13.25a.75.75 0 0 1 .75.75v1.25a.75.75 0 0 1-1.5 0V14a.75.75 0 0 1 .75-.75Z',
      'M4.288 12.773a.75.75 0 0 0-1.061-1.06l-.884.883a.75.75 0 0 0 1.06 1.06l.885-.883Z',
      'M11.712 11.712a.75.75 0 0 1 1.06 0l.885.884a.75.75 0 1 1-1.06 1.06l-.885-.883a.75.75 0 0 1 0-1.06Z',
      'M14 7.25a.75.75 0 0 0 0 1.5h1.25a.75.75 0 0 0 0-1.5H14Z',
    ],
  },
  moon: {
    paths: [
      {
        d: 'M0 8A8 8 0 0 1 9.078.072a.75.75 0 0 1 .278 1.391 5.25 5.25 0 0 0 4.686 9.375.75.75 0 0 1 .948 1.056A8 8 0 0 1 0 8Zm6.885-6.405A6.502 6.502 0 0 0 8 14.5c1.723 0 3.29-.67 4.453-1.765a6.75 6.75 0 0 1-5.568-11.14Z',
        fillRule: 'evenodd',
      },
    ],
  },
  sparkle: {
    paths: [
      'M8.75.75a.75.75 0 0 0-1.5 0v2.5a.75.75 0 0 0 1.5 0V.75Z',
      'M.75 7.25a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5H.75Z',
      'M8 12a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5A.75.75 0 0 1 8 12Z',
      'M12.75 7.25a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-2.5Z',
      'M13.657 2.343a.75.75 0 0 1 0 1.06L12.53 4.53a.75.75 0 1 1-1.06-1.06l1.126-1.127a.75.75 0 0 1 1.06 0Z',
      'M3.404 2.343a.75.75 0 1 0-1.06 1.06L3.47 4.53a.75.75 0 1 0 1.06-1.06L3.404 2.343Z',
      'M4.53 11.47a.75.75 0 0 1 0 1.06l-1.126 1.127a.75.75 0 0 1-1.06-1.06L3.47 11.47a.75.75 0 0 1 1.06 0Z',
      'M12.53 11.47a.75.75 0 0 0-1.06 1.06l1.126 1.127a.75.75 0 0 0 1.06-1.06L12.53 11.47Z',
    ],
  },
  flame: {
    paths: [
      'M11.685 9.35a.75.75 0 0 0-1.47.3 1.75 1.75 0 0 1-2.232 2.023.75.75 0 0 0-.442 1.433 3.25 3.25 0 0 0 4.144-3.755Z',
      {
        d: 'M7.25.075c-.336 0-.716.094-1.03.344a1.53 1.53 0 0 0-.555.931c-.062.351.003.715.187 1.027.48.84.765 2.286.772 3.292.002.266-.019.516-.06.749a3.896 3.896 0 0 0-.376-.45 1.844 1.844 0 0 0-.747-.481 1.348 1.348 0 0 0-1.057.108c-.818.458-1.416 1.26-1.802 2.085-.388.83-.601 1.769-.58 2.595v.019a5.987 5.987 0 0 0 1.949 4.165 6.009 6.009 0 0 0 4.34 1.531c1.864-.009 3.41-.605 4.507-1.681 1.094-1.073 1.63-2.514 1.695-4.012.15-3.488-2.199-8.03-6.435-10.022-.245-.13-.522-.2-.807-.2Zm-.105 1.529a.043.043 0 0 1 .01-.011l.018-.008a.266.266 0 0 1 .078-.01c.04 0 .078.01.109.027a.747.747 0 0 0 .043.022c3.697 1.73 5.716 5.717 5.592 8.608-.052 1.186-.47 2.244-1.247 3.006-.777.762-1.932 1.249-3.482 1.252-.015 0-.03 0-.045.002a4.508 4.508 0 0 1-3.263-1.144A4.487 4.487 0 0 1 3.5 10.233v-.001c-.013-.564.138-1.27.44-1.917.289-.617.678-1.101 1.1-1.365.02.016.047.04.081.074.092.092.193.222.308.389.075.11.142.213.213.322l.134.205c.113.171.251.373.403.536a.75.75 0 0 0 1.16-.078c.556-.782.792-1.744.784-2.74-.008-1.168-.323-2.895-.973-4.03l-.006-.011-.003-.006V1.61l.003-.005Z',
        fillRule: 'evenodd',
      },
    ],
  },
  dead: {
    paths: [
      'M7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
      'M10 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
      {
        d: 'M1.25 7.75a6.75 6.75 0 1 1 11.5 4.796V13a2 2 0 0 1-2 2h-5.5a2 2 0 0 1-2-2v-.454a6.731 6.731 0 0 1-2-4.796ZM8 2.5a5.25 5.25 0 0 0-3.5 9.163.75.75 0 0 1 .25.56V13a.5.5 0 0 0 .5.5H6V12a.75.75 0 0 1 1.5 0v1.5h1V12a.75.75 0 0 1 1.5 0v1.5h.75a.5.5 0 0 0 .5-.5v-.778a.75.75 0 0 1 .25-.559A5.25 5.25 0 0 0 8 2.5Z',
        fillRule: 'evenodd',
      },
    ],
  },
  rocketship: {
    paths: [
      {
        d: 'm2.434 13.566.206-.046c.331-.078.663-.169.937-.27.136-.05.248-.098.332-.143a.953.953 0 0 0 .094-.056l.028-.021a.75.75 0 0 0-1.061-1.06s-.007.007-.02.027a.975.975 0 0 0-.057.094 2.75 2.75 0 0 0-.144.332c-.1.274-.191.606-.269.937l-.046.206Zm-1.093-1.66c.12-.325.297-.726.568-.997a2.25 2.25 0 1 1 3.182 3.182c-.271.27-.672.448-.997.568-.355.13-.752.237-1.113.321a17.722 17.722 0 0 1-1.342.258l-.024.003c-.978.142-1 .146-.857-.85v-.007l.004-.023a11.298 11.298 0 0 1 .064-.386c.043-.25.109-.593.194-.956a9.74 9.74 0 0 1 .321-1.113Z',
        fillRule: 'evenodd',
      },
      'M12.5 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
      {
        d: 'M11.5.925a9.822 9.822 0 0 1 2.706.354.75.75 0 0 1 .515.515c.183.64.372 1.665.354 2.707-.018 1.01-.234 2.218-1.045 3.03-.56.56-1.495 1.239-2.47 1.884 1 2.68-.616 4.874-1.586 5.666a.75.75 0 0 1-1.125-.209l-1.912-3.346-1.353-.902a.75.75 0 0 1-.208-.208l-.902-1.353-3.346-1.912a.75.75 0 0 1-.21-1.125c.793-.97 2.986-2.586 5.667-1.587C7.23 3.465 7.91 2.53 8.47 1.97 9.28 1.16 10.488.944 11.5.926ZM5.77 5.754c-1.23-.336-2.302.083-3.017.599l1.98 1.131 1.037-1.73Zm.117 2.724.654.981.98.654 1.27-.76-2.142-2.148-.762 1.273Zm1.556-2.6 2.674 2.682.105-.063c1.16-.745 2.214-1.494 2.748-2.027.389-.39.59-1.098.605-1.996a8.354 8.354 0 0 0-.193-1.856 8.348 8.348 0 0 0-1.857-.193c-.897.016-1.606.216-1.995.605-.533.534-1.282 1.588-2.027 2.748l-.06.1Zm2.803 4.352-1.73 1.036 1.132 1.98c.515-.714.935-1.786.598-3.016Z',
        fillRule: 'evenodd',
      },
    ],
  },
  diamond: {
    paths: [
      {
        d: 'M3.033 1.772A2 2 0 0 1 4.61 1h6.778a2 2 0 0 1 1.578.772l2.498 3.212a2 2 0 0 1-.06 2.53L9.52 14.38a2 2 0 0 1-3.037 0L.595 7.513a2 2 0 0 1-.06-2.53l2.498-3.21Zm5.48.728H7.487l-1.333 3h3.692l-1.333-3Zm2.975 3-1.334-3h1.235a.5.5 0 0 1 .394.193L13.967 5.5h-2.48ZM10.119 7H5.881c.16.92.451 2.427.853 3.797.246.842.522 1.588.813 2.11.147.263.277.431.38.526.032.03.057.047.073.058a.503.503 0 0 0 .074-.058c.102-.095.233-.263.379-.525.291-.522.567-1.27.813-2.11.402-1.37.693-2.877.853-3.798ZM4.513 5.5l1.333-3H4.611a.5.5 0 0 0-.394.193L2.034 5.5h2.479ZM4.359 7c.127.758.372 2.096.72 3.44L2.132 7h2.228Zm6.561 3.44c.349-1.344.594-2.682.72-3.44h2.23l-2.95 3.44Z',
        fillRule: 'evenodd',
      },
    ],
  },
  special_offer: {
    paths: [
      'M8.154.345a.75.75 0 0 1 1.03.253c.39.645 1.061 2.38.014 4.266a.75.75 0 1 1-1.312-.728 2.807 2.807 0 0 0 .015-2.76.75.75 0 0 1 .253-1.03Z',
      {
        d: 'M3.686 5.485c.148-.31.34-.628.655-.851a2 2 0 0 1 1.523-.335c.38.071.688.28.952.499.257.215.553.51.9.858l2.628 2.628c.347.347.643.643.858.9.22.265.428.572.499.952a2 2 0 0 1-.335 1.523c-.223.316-.541.507-.851.655-.303.144-.696.289-1.156.459l-5.936 2.186a1.855 1.855 0 0 1-2.382-2.382l2.187-5.935c.17-.46.314-.854.458-1.157Zm1.355.645c-.112.233-.233.561-.418 1.062l-2.175 5.904a.355.355 0 0 0 .456.456l5.904-2.175c.501-.185.829-.306 1.062-.418.232-.11.272-.166.273-.167a.5.5 0 0 0 .083-.381c0-.001-.011-.068-.177-.267-.165-.199-.412-.446-.79-.824L6.68 6.74c-.378-.377-.625-.624-.824-.79-.198-.164-.265-.176-.267-.176a.5.5 0 0 0-.38.083c-.002.001-.058.04-.168.273Z',
        fillRule: 'evenodd',
      },
      'M12.03 6.03a.75.75 0 0 1-1.06-1.06l1-1a.75.75 0 0 1 1.06 1.06l-1 1Z',
      'M14.75 8a.75.75 0 0 0-.75-.75l-.503-.002a59.782 59.782 0 0 0-1.511.002.75.75 0 0 0 .028 1.5c.486-.01 1.001-.006 1.445-.003l.54.003a.75.75 0 0 0 .75-.75Z',
      'M13 2a1 1 0 1 0-2 0 1 1 0 0 0 2 0Z',
    ],
  },
  record: {
    paths: [
      {
        d: 'M8 2.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8Z',
        fillRule: 'evenodd',
      },
    ],
  },
  play: {
    paths: [
      {
        d: 'M4.882 2.528a.25.25 0 0 0-.382.212v10.52a.25.25 0 0 0 .382.213l8.5-5.26a.25.25 0 0 0 0-.426l-8.5-5.26ZM3 2.74C3 1.37 4.505.53 5.67 1.252l8.5 5.26a1.75 1.75 0 0 1 0 2.976l-8.5 5.26C4.506 15.47 3 14.631 3 13.26V2.74Z',
        fillRule: 'evenodd',
      },
    ],
  },
  pause: {
    paths: [
      {
        d: 'M2.75 1A1.75 1.75 0 0 0 1 2.75v10.5c0 .966.784 1.75 1.75 1.75h2.5A1.75 1.75 0 0 0 7 13.25V2.75A1.75 1.75 0 0 0 5.25 1h-2.5ZM2.5 2.75a.25.25 0 0 1 .25-.25h2.5a.25.25 0 0 1 .25.25v10.5a.25.25 0 0 1-.25.25h-2.5a.25.25 0 0 1-.25-.25V2.75Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M10.75 1A1.75 1.75 0 0 0 9 2.75v10.5c0 .966.784 1.75 1.75 1.75h2.5A1.75 1.75 0 0 0 15 13.25V2.75A1.75 1.75 0 0 0 13.25 1h-2.5Zm-.25 1.75a.25.25 0 0 1 .25-.25h2.5a.25.25 0 0 1 .25.25v10.5a.25.25 0 0 1-.25.25h-2.5a.25.25 0 0 1-.25-.25V2.75Z',
        fillRule: 'evenodd',
      },
    ],
  },
  stop: {
    paths: [
      {
        d: 'M3.722 1H12.278c.326 0 .615 0 .854.02.255.02.519.067.776.198a2 2 0 0 1 .874.874c.131.257.178.521.198.776.02.24.02.528.02.854v8.556c0 .326 0 .615-.02.854-.02.255-.067.519-.198.776a2 2 0 0 1-.874.874 2.032 2.032 0 0 1-.776.198c-.24.02-.528.02-.854.02H3.722c-.326 0-.615 0-.854-.02a2.032 2.032 0 0 1-.776-.198 2 2 0 0 1-.874-.874 2.033 2.033 0 0 1-.198-.776c-.02-.24-.02-.528-.02-.854V3.722c0-.326 0-.615.02-.854.02-.255.067-.519.198-.776a2 2 0 0 1 .874-.874c.257-.131.521-.178.776-.198.24-.02.528-.02.854-.02ZM2.99 2.515c-.162.013-.207.034-.217.04a.5.5 0 0 0-.219.218c-.005.01-.026.055-.04.217-.013.17-.014.398-.014.76v8.5c0 .362 0 .59.015.76.013.162.034.207.04.217a.5.5 0 0 0 .218.218c.01.006.055.027.217.04.17.014.398.015.76.015h8.5c.362 0 .59 0 .76-.014.162-.014.207-.035.217-.04a.5.5 0 0 0 .218-.219c.006-.01.027-.055.04-.217.014-.17.015-.398.015-.76v-8.5c0-.362 0-.59-.014-.76-.014-.162-.035-.207-.04-.217a.5.5 0 0 0-.219-.219c-.01-.005-.055-.026-.217-.04-.17-.013-.398-.014-.76-.014h-8.5c-.362 0-.59 0-.76.015Z',
        fillRule: 'evenodd',
      },
    ],
  },
  rewind: {
    paths: [
      {
        d: 'M12.134 2.777C13.275 1.833 15 2.645 15 4.126v7.748c0 1.481-1.725 2.293-2.866 1.349L8 9.8v2.025c0 1.495-1.754 2.301-2.889 1.329L.648 9.329a1.75 1.75 0 0 1 0-2.658L5.11 2.846C6.246 1.873 8 2.679 8 4.174V6.2l4.134-3.422ZM13.5 4.126a.25.25 0 0 0-.41-.193L8.41 7.807a.25.25 0 0 0 0 .386l4.68 3.874a.25.25 0 0 0 .41-.193V4.126Zm-7 .048a.25.25 0 0 0-.413-.19L1.624 7.81a.25.25 0 0 0 0 .38l4.463 3.826a.25.25 0 0 0 .413-.19V4.174Z',
        fillRule: 'evenodd',
      },
    ],
  },
  previous: {
    paths: [
      'M1 14.25a.75.75 0 0 0 1.5 0V1.75a.75.75 0 0 0-1.5 0v12.5Z',
      {
        d: 'M12.244 14.007c1.16.815 2.756-.015 2.756-1.432v-9.15c0-1.417-1.597-2.247-2.756-1.432l-6.51 4.575a1.75 1.75 0 0 0 0 2.864l6.51 4.575Zm1.256-1.432a.25.25 0 0 1-.394.205l-6.51-4.575a.25.25 0 0 1 0-.41l6.51-4.575a.25.25 0 0 1 .394.205v9.15Z',
        fillRule: 'evenodd',
      },
    ],
  },
  next: {
    paths: [
      'M15 1.75a.75.75 0 0 0-1.5 0v12.5a.75.75 0 0 0 1.5 0V1.75Z',
      {
        d: 'M3.756 1.993C2.596 1.178 1 2.008 1 3.425v9.15c0 1.417 1.597 2.247 2.756 1.432l6.51-4.575a1.75 1.75 0 0 0 0-2.864l-6.51-4.575ZM2.5 3.425a.25.25 0 0 1 .394-.205l6.51 4.575a.25.25 0 0 1 0 .41l-6.51 4.575a.25.25 0 0 1-.394-.205v-9.15Z',
        fillRule: 'evenodd',
      },
    ],
  },
  fast_forward: {
    paths: [
      {
        d: 'M3.866 2.777C2.725 1.833 1 2.645 1 4.126v7.748c0 1.481 1.725 2.293 2.866 1.349L8 9.8v2.025c0 1.495 1.754 2.301 2.889 1.329l4.463-3.826a1.75 1.75 0 0 0 0-2.658L10.89 2.846C9.754 1.873 8 2.679 8 4.174V6.2L3.866 2.777ZM2.5 4.126a.25.25 0 0 1 .41-.193l4.68 3.874c.122.1.122.286 0 .386l-4.68 3.874a.25.25 0 0 1-.41-.193V4.126Zm7 .048a.25.25 0 0 1 .413-.19l4.463 3.826a.25.25 0 0 1 0 .38l-4.463 3.826a.25.25 0 0 1-.413-.19V4.174Z',
        fillRule: 'evenodd',
      },
    ],
  },
  record_alt: {
    paths: ['M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8Z'],
  },
  play_alt: {
    paths: [
      {
        d: 'M3 2.74C3 1.37 4.505.53 5.67 1.252l8.5 5.26a1.75 1.75 0 0 1 0 2.976l-8.5 5.26C4.506 15.469 3 14.63 3 13.26V2.74Z',
        fillRule: 'evenodd',
      },
    ],
  },
  pause_alt: {
    paths: [
      {
        d: 'M2.75 1A1.75 1.75 0 0 0 1 2.75v10.5c0 .966.784 1.75 1.75 1.75h2a1.75 1.75 0 0 0 1.75-1.75V2.75A1.75 1.75 0 0 0 4.75 1h-2Zm8.5 0A1.75 1.75 0 0 0 9.5 2.75v10.5c0 .966.784 1.75 1.75 1.75h2A1.75 1.75 0 0 0 15 13.25V2.75A1.75 1.75 0 0 0 13.25 1h-2Z',
        fillRule: 'evenodd',
      },
    ],
  },
  stop_alt: {
    paths: [
      {
        d: 'M3.722 1H12.278c.326 0 .615 0 .854.02.255.02.519.067.776.198a2 2 0 0 1 .874.874c.131.257.178.521.198.776.02.24.02.528.02.854v8.556c0 .326 0 .615-.02.854-.02.255-.067.519-.198.776a2 2 0 0 1-.874.874 2.032 2.032 0 0 1-.776.198c-.24.02-.528.02-.854.02H3.722c-.326 0-.615 0-.854-.02a2.032 2.032 0 0 1-.776-.198 2 2 0 0 1-.874-.874 2.033 2.033 0 0 1-.198-.776c-.02-.24-.02-.528-.02-.854V3.722c0-.326 0-.615.02-.854.02-.255.067-.519.198-.776a2 2 0 0 1 .874-.874c.257-.131.521-.178.776-.198.24-.02.528-.02.854-.02Z',
        fillRule: 'evenodd',
      },
    ],
  },
  rewind_alt: {
    paths: [
      {
        d: 'M12.134 2.777C13.275 1.833 15 2.645 15 4.126v7.748c0 1.481-1.725 2.293-2.866 1.349L8 9.8v2.025c0 1.495-1.754 2.301-2.889 1.329L.648 9.329a1.75 1.75 0 0 1 0-2.658L5.11 2.846C6.246 1.873 8 2.679 8 4.174V6.2l4.134-3.422Z',
        fillRule: 'evenodd',
      },
    ],
  },
  previous_alt: {
    paths: [
      'M1 14.25a.75.75 0 0 0 1.5 0V1.75a.75.75 0 0 0-1.5 0v12.5Z',
      'M12.244 14.007c1.16.815 2.756-.015 2.756-1.432v-9.15c0-1.417-1.597-2.247-2.756-1.432l-6.51 4.575a1.75 1.75 0 0 0 0 2.864l6.51 4.575Z',
    ],
  },
  next_alt: {
    paths: [
      {
        d: 'M15 1.75a.75.75 0 0 0-1.5 0v12.5a.75.75 0 0 0 1.5 0V1.75Zm-11.244.243C2.596 1.178 1 2.008 1 3.425v9.15c0 1.417 1.597 2.247 2.756 1.432l6.51-4.575a1.75 1.75 0 0 0 0-2.864l-6.51-4.575Z',
        fillRule: 'evenodd',
      },
    ],
  },
  fast_forward_alt: {
    paths: [
      'M3.866 2.777C2.725 1.833 1 2.645 1 4.126v7.748c0 1.481 1.725 2.293 2.866 1.349L8 9.8v2.025c0 1.495 1.754 2.301 2.889 1.329l4.463-3.826a1.75 1.75 0 0 0 0-2.658L10.89 2.846C9.754 1.873 8 2.679 8 4.174V6.2L3.866 2.777Z',
    ],
  },
  jump_back: {
    paths: [
      {
        d: 'M4.75 13.5h7.5c.69 0 1.25-.56 1.25-1.25v-6.5c0-.69-.56-1.25-1.25-1.25H3.56l1.47 1.47a.75.75 0 0 1-1.06 1.06L1.22 4.28a.75.75 0 0 1-.017-1.043l.018-.02.05-.052a60.987 60.987 0 0 1 .842-.875A53.886 53.886 0 0 1 3.99.45.75.75 0 1 1 5.01 1.55 48.04 48.04 0 0 0 3.519 3h8.731A2.75 2.75 0 0 1 15 5.75v6.5A2.75 2.75 0 0 1 12.25 15h-7.5a.75.75 0 0 1 0-1.5Z',
        fillRule: 'evenodd',
      },
    ],
  },
  jump_back_10: {
    paths: [
      'M4.75 13.5h7.5c.69 0 1.25-.56 1.25-1.25v-6.5c0-.69-.56-1.25-1.25-1.25H3.56l1.47 1.47a.75.75 0 0 1-1.06 1.06L1.22 4.28a.75.75 0 0 1-.017-1.043l.018-.02.05-.052a60.987 60.987 0 0 1 .842-.875A53.896 53.896 0 0 1 3.99.45.75.75 0 1 1 5.01 1.55 48.04 48.04 0 0 0 3.519 3h8.731A2.75 2.75 0 0 1 15 5.75v6.5A2.75 2.75 0 0 1 12.25 15h-7.5a.75.75 0 0 1 0-1.5Z',
      'M6.736 7.06A.5.5 0 0 1 7 7.5V11h.5a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1h1V8.434l-.723.482a.5.5 0 1 1-.554-.832l1.5-1a.5.5 0 0 1 .513-.025Z',
      {
        d: 'M9.5 7a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-2Zm.5 4V8h1v3h-1Z',
        fillRule: 'evenodd',
      },
    ],
  },
  jump_forward_10: {
    paths: [
      {
        d: 'M11.25 13.5h-7.5c-.69 0-1.25-.56-1.25-1.25v-6.5c0-.69.56-1.25 1.25-1.25h8.69l-1.47 1.47a.75.75 0 0 0 1.06 1.06l2.75-2.75a.75.75 0 0 0 .017-1.043l-.018-.02-.05-.052a60.747 60.747 0 0 0-.842-.875A53.94 53.94 0 0 0 12.01.45.75.75 0 1 0 10.99 1.55c.496.458 1.029.982 1.49 1.449H3.75A2.75 2.75 0 0 0 1 5.75v6.5A2.75 2.75 0 0 0 3.75 15h7.5a.75.75 0 0 0 0-1.5ZM5.736 7.06A.5.5 0 0 1 6 7.5V11h.5a.5.5 0 0 1 0 1H4a.5.5 0 0 1 0-1h1V8.434l-.723.482a.5.5 0 1 1-.554-.832l1.5-1a.5.5 0 0 1 .513-.025ZM8.5 7a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5h-2Zm.5 4V8h1v3H9Z',
        fillRule: 'evenodd',
      },
    ],
  },
  jump_forward: {
    paths: [
      {
        d: 'M11.25 13.5h-7.5c-.69 0-1.25-.56-1.25-1.25v-6.5c0-.69.56-1.25 1.25-1.25h8.69l-1.47 1.47a.75.75 0 0 0 1.06 1.06l2.75-2.75a.75.75 0 0 0 .017-1.043l-.018-.02-.05-.052a60.747 60.747 0 0 0-.842-.875A53.94 53.94 0 0 0 12.01.45.75.75 0 1 0 10.99 1.55c.496.458 1.029.982 1.49 1.449H3.75A2.75 2.75 0 0 0 1 5.75v6.5A2.75 2.75 0 0 0 3.75 15h7.5a.75.75 0 0 0 0-1.5Z',
        fillRule: 'evenodd',
      },
    ],
  },
  shuffle: {
    paths: [
      'M4.748 12.5H1.75a.75.75 0 0 1 0-1.5h2.998a.5.5 0 0 0 .442-.266l3.539-6.671A2 2 0 0 1 10.496 3h1.943l-.47-.47a.75.75 0 0 1 1.061-1.06l1.75 1.75a.75.75 0 0 1 0 1.06l-1.75 1.75a.75.75 0 1 1-1.06-1.06l.47-.47h-1.944a.5.5 0 0 0-.442.266l-3.54 6.671A2 2 0 0 1 4.749 12.5Z',
      'M4.03 3H1.75a.75.75 0 0 0 0 1.5h2.28a.5.5 0 0 1 .33.124l1.646 1.44a.75.75 0 1 0 .988-1.128L5.347 3.495A2 2 0 0 0 4.03 3Z',
      'M9.531 9.47a.75.75 0 1 0-1.062 1.06l1.377 1.382a2 2 0 0 0 1.417.588h1.176l-.47.47a.75.75 0 1 0 1.061 1.06l1.75-1.75a.75.75 0 0 0 0-1.06l-1.75-1.75a.75.75 0 1 0-1.06 1.06l.47.47h-1.177a.5.5 0 0 1-.354-.147L9.53 9.47Z',
    ],
  },
  replay: {
    paths: [
      {
        d: 'M12.25 3.5c.69 0 1.25.56 1.25 1.25v6.5c0 .69-.56 1.25-1.25 1.25H9.56l.47-.47a.75.75 0 1 0-1.06-1.06l-1.75 1.75a.75.75 0 0 0 0 1.06l1.75 1.75a.75.75 0 1 0 1.06-1.06L9.56 14h2.69A2.75 2.75 0 0 0 15 11.25v-6.5A2.75 2.75 0 0 0 12.25 2h-8.5A2.75 2.75 0 0 0 1 4.75v6.5A2.75 2.75 0 0 0 3.75 14h1.496a.75.75 0 0 0 0-1.5H3.75c-.69 0-1.25-.56-1.25-1.25v-6.5c0-.69.56-1.25 1.25-1.25h8.5Z',
        fillRule: 'evenodd',
      },
    ],
  },
  replay_once: {
    paths: [
      'M9 2a.75.75 0 0 0-1.28-.53l-1.5 1.5a.75.75 0 0 0 1.06 1.06l.22-.22V5.5h-.75a.75.75 0 0 0 0 1.5H9.5a.75.75 0 1 0 0-1.5H9V2Z',
      'M13.5 4.75c0-.69-.56-1.25-1.25-1.25H11A.75.75 0 0 1 11 2h1.25A2.75 2.75 0 0 1 15 4.75v6.5A2.75 2.75 0 0 1 12.25 14H9.56l.47.47a.75.75 0 1 1-1.06 1.06l-1.75-1.75a.75.75 0 0 1 0-1.06l1.75-1.75a.75.75 0 1 1 1.06 1.06l-.47.47h2.69c.69 0 1.25-.56 1.25-1.25v-6.5Z',
      'M4.25 2a.75.75 0 0 1 0 1.5h-.5c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h1.496a.75.75 0 0 1 0 1.5H3.75A2.75 2.75 0 0 1 1 11.25v-6.5A2.75 2.75 0 0 1 3.75 2h.5Z',
    ],
  },
  uturn: {
    paths: [
      {
        d: 'M3.75 11.5h7.5a2.25 2.25 0 0 0 2.25-2.25v-1.5a2.25 2.25 0 0 0-2.25-2.25H3.56l1.47 1.47a.75.75 0 0 1-1.06 1.06L1.22 5.28a.75.75 0 0 1-.017-1.043l.018-.02.05-.052a60.987 60.987 0 0 1 .842-.875A53.887 53.887 0 0 1 3.99 1.45.75.75 0 0 1 5.01 2.55 48.04 48.04 0 0 0 3.519 4h7.731A3.75 3.75 0 0 1 15 7.75v1.5A3.75 3.75 0 0 1 11.25 13h-7.5a.75.75 0 0 1 0-1.5Z',
        fillRule: 'evenodd',
      },
    ],
  },
  text_field_tall: {
    paths: [
      'M5 1.5h-.75a.75.75 0 0 1 0-1.5h3a.75.75 0 0 1 0 1.5H6.5V10h.75a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5H5V1.5Z',
      'M14.5 4.75c0-.69-.56-1.25-1.25-1.25h-4.5a.75.75 0 0 1 0-1.5h4.5A2.75 2.75 0 0 1 16 4.75v6.5A2.75 2.75 0 0 1 13.25 14h-4.5a.75.75 0 0 1 0-1.5h4.5c.69 0 1.25-.56 1.25-1.25v-6.5Z',
      'M3.25 2a.75.75 0 0 1 0 1.5h-.5c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h1.5a.75.75 0 0 1 0 1.5h-1.5A2.75 2.75 0 0 1 0 11.25v-6.5A2.75 2.75 0 0 1 2.75 2h.5Z',
    ],
  },
  text_field_short: {
    paths: [
      'M5 2.5h-.75a.75.75 0 0 1 0-1.5h3a.75.75 0 0 1 0 1.5H6.5V13h.75a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5H5V2.5Z',
      'M14.5 6.75c0-.69-.56-1.25-1.25-1.25h-4.5a.75.75 0 0 1 0-1.5h4.5A2.75 2.75 0 0 1 16 6.75v2.5A2.75 2.75 0 0 1 13.25 12h-4.5a.75.75 0 0 1 0-1.5h4.5c.69 0 1.25-.56 1.25-1.25v-2.5Z',
      'M3.25 4a.75.75 0 0 1 0 1.5h-.5c-.69 0-1.25.56-1.25 1.25v2.5c0 .69.56 1.25 1.25 1.25h.5a.75.75 0 0 1 0 1.5h-.5A2.75 2.75 0 0 1 0 9.25v-2.5A2.75 2.75 0 0 1 2.75 4h.5Z',
    ],
  },
  text: {
    paths: [
      'M3 1a2 2 0 0 0-2 2v1.75a.75.75 0 0 0 1.5 0V3a.5.5 0 0 1 .5-.5h4.25v11h-1.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-1.5v-11H13a.5.5 0 0 1 .5.5v1.75a.75.75 0 0 0 1.5 0V3a2 2 0 0 0-2-2H3Z',
    ],
  },
  select: {
    paths: [
      'M13.28 7.78a.75.75 0 0 0-1.06-1.06l-1.47 1.47-1.47-1.47a.75.75 0 0 0-1.06 1.06l2 2a.75.75 0 0 0 1.06 0l2-2Z',
      {
        d: 'M16 5.75A2.75 2.75 0 0 0 13.25 3H2.75A2.75 2.75 0 0 0 0 5.75v4.5A2.75 2.75 0 0 0 2.75 13h10.5A2.75 2.75 0 0 0 16 10.25v-4.5ZM13.25 4.5c.69 0 1.25.56 1.25 1.25v4.5c0 .69-.56 1.25-1.25 1.25H7v-7h6.25Zm-10.5 7H5.5v-7H2.75c-.69 0-1.25.56-1.25 1.25v4.5c0 .69.56 1.25 1.25 1.25Z',
        fillRule: 'evenodd',
      },
    ],
  },
  rating_scale: {
    paths: [
      {
        d: 'M11 8a4 4 0 0 1-7.93.75H.75a.75.75 0 0 1 0-1.5h2.32A4.001 4.001 0 0 1 11 8ZM9.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z',
        fillRule: 'evenodd',
      },
      'M16 8a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5h2.5A.75.75 0 0 1 16 8Z',
    ],
  },
  radio_button: {
    paths: [
      'M12 8a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z',
      {
        d: 'M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0Z',
        fillRule: 'evenodd',
      },
    ],
  },
  nps: {
    paths: [
      'M5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
      'M11 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
      'M4.852 8.813a.75.75 0 0 0-1.452.374 4.752 4.752 0 0 0 9.2 0 .75.75 0 1 0-1.452-.374 3.252 3.252 0 0 1-6.296 0Z',
      {
        d: 'M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0Z',
        fillRule: 'evenodd',
      },
    ],
  },
  tab: {
    paths: [
      'M2.75 0a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5H2.75Z',
      'M1 3.25a.75.75 0 0 1 .75-.75h12.5a.75.75 0 0 1 0 1.5H1.75A.75.75 0 0 1 1 3.25Z',
      {
        d: 'M.218 6.092C0 6.52 0 7.08 0 8.2v4.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C1.52 16 2.08 16 3.2 16h9.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C16 14.48 16 13.92 16 12.8V8.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 5 13.92 5 12.8 5H3.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874ZM12.8 6.5H3.2c-.585 0-.933.001-1.191.022-.158.013-.224.03-.242.036a.5.5 0 0 0-.21.209 1.254 1.254 0 0 0-.035.242c-.02.258-.022.606-.022 1.191v4.6c0 .585.001.933.022 1.191.013.158.03.224.036.242a.5.5 0 0 0 .209.21c.018.005.084.022.242.035.258.02.606.022 1.191.022h9.6c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .21-.209c.005-.018.022-.084.035-.242.02-.258.022-.606.022-1.191V8.2c0-.585-.001-.933-.022-1.191a1.252 1.252 0 0 0-.036-.242.5.5 0 0 0-.209-.21 1.255 1.255 0 0 0-.242-.035c-.258-.02-.606-.022-1.191-.022Zm1.438.06-.003-.002.003.001Zm.203.202v.003-.003Zm0 7.476Zm-.203.203h-.003.003Zm-12.476 0h.003-.003Zm-.203-.203v-.003.003Zm.203-7.679h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  scroll: {
    paths: [
      {
        d: 'M4.22 4.53a.75.75 0 0 1 0-1.06L7.47.22a.75.75 0 0 1 1.06 0l3.25 3.25a.75.75 0 0 1-1.06 1.06L8 1.81 5.28 4.53a.75.75 0 0 1-1.06 0Zm7.56 6.94a.75.75 0 0 1 0 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0l-3.25-3.25a.75.75 0 1 1 1.06-1.06L8 14.19l2.72-2.72a.75.75 0 0 1 1.06 0ZM8.5 8a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0ZM10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z',
        fillRule: 'evenodd',
      },
    ],
  },
  key_press: {
    paths: [
      'M3 11.25a.75.75 0 0 1 .75-.75h8.5a.75.75 0 0 1 0 1.5h-8.5a.75.75 0 0 1-.75-.75Z',
      'M3.75 7a.75.75 0 1 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z',
      'M10 7.75a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 .75.75v1a.75.75 0 0 1-1.5 0V8.5h-.75a.75.75 0 0 1-.75-.75Z',
      {
        d: 'M10.25 0v.25C10.25.94 9.69 1.5 9 1.5H4.75A2.5 2.5 0 0 0 2.25 4s-.73 0-1.158.218a2 2 0 0 0-.874.874C0 5.52 0 6.08 0 7.2v4.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C1.52 15 2.08 15 3.2 15h9.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C16 13.48 16 12.92 16 11.8V7.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 4 13.92 4 12.8 4H3.75a1 1 0 0 1 1-1H9A2.75 2.75 0 0 0 11.75.25V0h-1.5Zm2.55 5.5H3.2c-.585 0-.933.001-1.191.022-.158.013-.224.03-.242.036a.5.5 0 0 0-.21.209 1.254 1.254 0 0 0-.035.242c-.02.258-.022.606-.022 1.191v4.6c0 .585.001.933.022 1.191.013.158.03.224.036.242a.5.5 0 0 0 .209.21c.018.005.084.022.242.035.258.02.606.022 1.191.022h9.6c.585 0 .933-.001 1.191-.022.158-.013.224-.03.242-.036a.5.5 0 0 0 .21-.209c.005-.018.022-.084.035-.242.02-.258.022-.606.022-1.191V7.2c0-.585-.001-.933-.022-1.191a1.253 1.253 0 0 0-.036-.242.5.5 0 0 0-.209-.21 1.256 1.256 0 0 0-.242-.035c-.258-.02-.606-.022-1.191-.022Zm1.438.06-.003-.002.003.001Zm.203.202v.003-.003Zm-.203 7.679h-.003.003Zm-12.476 0h.003a.035.035 0 0 1-.003 0Zm-.203-.203v-.003.003Zm.203-7.679h.003-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  window_resize: {
    paths: [
      {
        d: 'M2.722 1c-.326 0-.615 0-.854.02-.255.02-.519.067-.776.198a2 2 0 0 0-.874.874 2.032 2.032 0 0 0-.198.776c-.02.24-.02.528-.02.854v8.556c0 .326 0 .615.02.854.02.255.067.519.198.776a2 2 0 0 0 .874.874c.257.131.521.178.776.198.24.02.528.02.854.02H7.25a.75.75 0 0 0 0-1.5h-4.5c-.362 0-.59 0-.76-.014-.162-.014-.207-.035-.217-.04a.5.5 0 0 1-.218-.219c-.006-.01-.027-.055-.04-.217-.014-.17-.015-.398-.015-.76v-6.5h13v2.5a.75.75 0 0 0 1.5 0V3.722c0-.326 0-.615-.02-.854a2.032 2.032 0 0 0-.198-.776 2 2 0 0 0-.874-.874 2.033 2.033 0 0 0-.776-.198c-.24-.02-.528-.02-.854-.02H2.722ZM14.5 4.25v-.5c0-.362 0-.59-.014-.76-.014-.162-.035-.207-.04-.217a.5.5 0 0 0-.219-.219c-.01-.005-.055-.026-.217-.04-.17-.013-.398-.014-.76-.014H2.75c-.362 0-.59 0-.76.015-.162.013-.207.034-.217.04a.5.5 0 0 0-.218.218c-.006.01-.027.055-.04.217-.014.17-.015.398-.015.76v.5h13Z',
        fillRule: 'evenodd',
      },
      'M7.22 7.22a.75.75 0 0 0-.22.53v2.5a.75.75 0 0 0 1.5 0v-.69l1.47 1.47a.75.75 0 1 0 1.06-1.06L9.56 8.5h.69a.75.75 0 0 0 0-1.5h-2.5a.75.75 0 0 0-.53.22Z',
      'M16 15.25a.75.75 0 0 1-.75.75h-2.5a.75.75 0 0 1 0-1.5h.69l-1.47-1.47a.75.75 0 1 1 1.06-1.06l1.47 1.47v-.69a.75.75 0 0 1 1.5 0v2.5Z',
    ],
  },
  finger_tap: {
    paths: [
      'M2.5 7a5.5 5.5 0 1 1 9.9 3.3.75.75 0 1 0 1.2.901 7 7 0 1 0-11.2 0 .75.75 0 1 0 1.2-.9C2.909 9.38 2.5 8.238 2.5 7Z',
      'M7 8.5a.75.75 0 0 1 1.5 0v3.25a2 2 0 0 0 2 2h1.75c.69 0 1.25.56 1.25 1.25v.25a.75.75 0 0 0 1.5 0V15a2.75 2.75 0 0 0-2.75-2.75H10.5a.5.5 0 0 1-.5-.5V8.5a2.25 2.25 0 0 0-4.5 0v6.75a.75.75 0 0 0 1.5 0V8.5Z',
    ],
  },
  rage_click: {
    paths: [
      'M1.835.83a.75.75 0 0 0-.67 1.34l4 2a.75.75 0 1 0 .67-1.34l-4-2Z',
      'M6 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z',
      'M11.5 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z',
      'M15.17 1.165a.75.75 0 0 0-1.005-.336l-4 2a.75.75 0 1 0 .67 1.342l4-2a.75.75 0 0 0 .336-1.006Z',
      'M8 15c3.314 0 6-1.343 6-3s-2.686-3-6-3-6 1.343-6 3 2.686 3 6 3Z',
    ],
  },
  mad_mouse: {
    paths: [
      {
        d: 'M1.962 1.03a.75.75 0 0 0-.932.932l1.25 4.25a.75.75 0 0 0 1.25.318l.97-.968.968.968c.432.433.87.727 1.327.883.466.16.904.158 1.303.07.385-.086.724-.251 1.001-.403.128-.07.237-.133.337-.19.14-.081.261-.15.397-.22.364-.18.886-.249 1.261-.099a.85.85 0 0 1 .43.373c.119.2.224.528.224 1.056 0 .699-.473 1.521-1.337 2.298C8.83 9.425 6.96 8.75 4.998 8.75c-.983 0-1.84.286-2.378.864-.573.616-.675 1.456-.293 2.221.223.445.552.957 1.17 1.339.608.376 1.414.576 2.501.576 1.418 0 3.146-.672 4.53-1.637 1.392.89 2.512 1.916 3.163 2.639a.75.75 0 1 0 1.115-1.004c-.669-.742-1.742-1.734-3.073-2.638.858-.863 1.515-1.937 1.515-3.11 0-.722-.144-1.332-.432-1.819a2.349 2.349 0 0 0-1.164-1.002c-.876-.35-1.853-.168-2.49.15a10.77 10.77 0 0 0-.518.285l-.003.003a14.35 14.35 0 0 1-.26.146c-.238.13-.43.215-.608.255a.871.871 0 0 1-.494-.025c-.184-.062-.433-.206-.75-.523l-.97-.969.971-.97a.75.75 0 0 0-.318-1.25l-4.25-1.25ZM4 3.938l.575-.575-1.718-.505.505 1.718.573-.573a.753.753 0 0 1 .065-.065Zm.997 6.312c1.39 0 2.773.412 4.048 1.03-1.058.609-2.195.97-3.048.97-.913 0-1.416-.169-1.713-.352-.287-.177-.457-.416-.616-.733a.521.521 0 0 1-.066-.302.41.41 0 0 1 .116-.227c.16-.173.553-.386 1.279-.386Z',
        fillRule: 'evenodd',
      },
    ],
  },
  cursor_click: {
    paths: [
      'M9 1.75a.75.75 0 0 0-1.5 0v2.5a.75.75 0 1 0 1.5 0v-2.5Z',
      'M3.03 1.97a.75.75 0 0 0-1.06 1.06l1.75 1.75a.75.75 0 0 0 1.06-1.06L3.03 1.97Z',
      {
        d: 'M6.672 5.77a.75.75 0 0 0-.902.902l1.742 7.4a.75.75 0 0 0 1.26.358l1.415-1.414 2.121 2.12a.75.75 0 0 0 1.061 0l1.768-1.767a.75.75 0 0 0 0-1.06l-2.122-2.122 1.415-1.414a.75.75 0 0 0-.359-1.26l-7.4-1.743Zm1.992 6.647-1.156-4.91 4.91 1.157-.994.993a.75.75 0 0 0 0 1.06l2.122 2.122-.707.707-2.122-2.121a.75.75 0 0 0-1.06 0l-.993.992Z',
        fillRule: 'evenodd',
      },
      'M1 8.25a.75.75 0 0 1 .75-.75h2.5a.75.75 0 1 1 0 1.5h-2.5A.75.75 0 0 1 1 8.25Z',
    ],
  },
  cursor_move: {
    paths: [
      'M6.75 1.999a.75.75 0 1 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Z',
      {
        d: 'M1.95 4.269a.75.75 0 0 0-.902.901l1.743 7.4a.75.75 0 0 0 1.26.358l1.415-1.414 2.12 2.121a.75.75 0 0 0 1.062 0l1.767-1.767a.75.75 0 0 0 0-1.061L8.294 8.686 9.708 7.27a.75.75 0 0 0-.358-1.26L1.95 4.27Zm1.992 6.647-1.156-4.91 4.91 1.157-.993.992a.75.75 0 0 0 0 1.061l2.121 2.121-.707.707-2.121-2.12a.75.75 0 0 0-1.06 0l-.994.992Z',
        fillRule: 'evenodd',
      },
      'M12.75 10.5a.75.75 0 0 0 0 1.5h1.5a.75.75 0 0 0 0-1.5h-1.5Z',
      'M11 7a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5h-2.5A.75.75 0 0 1 11 7Z',
    ],
  },
  cursor_select: {
    paths: [
      'M2.53 1c-.122 0-.255 0-.37.01-.13.01-.3.036-.477.126a1.25 1.25 0 0 0-.547.547c-.09.176-.116.348-.127.478C1 2.275 1 2.408 1 2.53v.72a.75.75 0 1 0 1.5 0V2.5h.75a.75.75 0 0 0 0-1.5h-.72Z',
      'M10.5 2.5v.75a.75.75 0 0 0 1.5 0v-.72c0-.122 0-.255-.01-.37a1.259 1.259 0 0 0-.126-.477 1.25 1.25 0 0 0-.546-.547 1.259 1.259 0 0 0-.479-.127C10.725 1 10.592 1 10.47 1h-.72a.75.75 0 1 0 0 1.5h.75Z',
      'M6 1a.75.75 0 1 0 0 1.5h1A.75.75 0 0 0 7 1H6Z',
      'M2.5 6A.75.75 0 1 0 1 6v1a.75.75 0 1 0 1.5 0V6Z',
      'M2.5 9.75a.75.75 0 1 0-1.5 0v.72c0 .122 0 .255.01.37.01.13.036.3.126.478.12.235.311.426.547.546.176.09.348.116.478.127.114.01.247.009.369.009h.72a.75.75 0 0 0 0-1.5H2.5v-.75Z',
      {
        d: 'M6.672 5.77a.75.75 0 0 0-.902.902l1.743 7.4a.75.75 0 0 0 1.26.358l1.414-1.414 2.121 2.12a.75.75 0 0 0 1.061 0l1.768-1.767a.75.75 0 0 0 0-1.06l-2.122-2.122 1.415-1.414a.75.75 0 0 0-.359-1.26l-7.4-1.743Zm1.992 6.647-1.156-4.91 4.91 1.157-.993.993a.75.75 0 0 0 0 1.06l2.12 2.122-.706.707-2.122-2.121a.75.75 0 0 0-1.06 0l-.993.992Z',
        fillRule: 'evenodd',
      },
    ],
  },
  bold: {
    paths: [
      {
        d: 'M3.75 1a.75.75 0 0 0-.75.75v12.5c0 .414.336.75.75.75H9.5a.75.75 0 0 0 .179-.021 4.25 4.25 0 0 0 1.697-7.91 3.5 3.5 0 0 0-1.915-6.04.75.75 0 0 0-.211-.029h-5.5Zm5.37 5.5a.76.76 0 0 1 .063-.008 2 2 0 0 0 0-3.984.76.76 0 0 1-.062-.008H4.5v4h4.62ZM4.5 8v5.5h4.885a.74.74 0 0 1 .062-.007 2.75 2.75 0 0 0 0-5.486A.758.758 0 0 1 9.385 8H4.5Z',
        fillRule: 'evenodd',
      },
    ],
  },
  italic: {
    paths: [
      'm8.966 2.5-3.592 11H1.75a.75.75 0 0 0 0 1.5h9.5a.75.75 0 0 0 0-1.5H6.952l3.592-11h3.706a.75.75 0 0 0 0-1.5h-9.5a.75.75 0 0 0 0 1.5h4.216Z',
    ],
  },
  underline: {
    paths: [
      'M3.75 1a.75.75 0 0 0-.75.75v6.274a2.397 2.397 0 0 0 .011.198 4.978 4.978 0 0 0 .618 2.023c.662 1.168 1.972 2.255 4.372 2.255s3.709-1.087 4.37-2.255a4.978 4.978 0 0 0 .63-2.22V1.75a.75.75 0 0 0-1.5 0v6.247l-.001.017-.005.087a3.476 3.476 0 0 1-.428 1.405 2.69 2.69 0 0 1-.99 1.012c-.478.28-1.142.482-2.076.482-.934 0-1.6-.201-2.077-.482a2.69 2.69 0 0 1-.99-1.013 3.478 3.478 0 0 1-.433-1.491V1.75A.75.75 0 0 0 3.75 1Z',
      'M2.75 13.5a.75.75 0 0 0 0 1.5h10.5a.75.75 0 0 0 0-1.5H2.75Z',
    ],
  },
  strikethrough: {
    paths: [
      'M8 13.65c.968 0 1.813-.278 2.396-.69.585-.413.854-.913.854-1.384 0-.173-.084-.374-.332-.654a6.09 6.09 0 0 0-.541-.52c-.12-.107-.25-.222-.394-.359a.75.75 0 1 1 1.034-1.086c.069.065.16.146.26.236.238.213.537.48.762.733.35.393.711.94.711 1.65 0 1.09-.626 2-1.49 2.61-.864.61-2.02.964-3.26.964-1.24 0-2.396-.354-3.26-.964-.864-.61-1.49-1.52-1.49-2.61a.75.75 0 1 1 1.5 0c0 .471.27.971.854 1.384.583.412 1.428.69 2.396.69Z',
      'M12.09 2.745a.75.75 0 1 1-1.18.927c-.507-.645-1.575-1.17-2.91-1.17-.968 0-1.813.28-2.396.69-.585.414-.854.914-.854 1.384 0 .754.386 1.347 1.136 1.924h8.364a.75.75 0 0 1 0 1.5H1.75a.75.75 0 1 1 0-1.5h2.079a3.415 3.415 0 0 1-.579-1.924c0-1.088.626-2 1.49-2.609.864-.61 2.02-.964 3.26-.964 1.677 0 3.232.651 4.09 1.742Z',
    ],
  },
  hyperlink: {
    paths: [
      'M12.502 1.188a2 2 0 0 0-2.829 0L6.668 4.194a.75.75 0 0 0 1.06 1.06l3.006-3.005a.5.5 0 0 1 .707 0l2.31 2.31a.5.5 0 0 1 0 .707L10.746 8.27a.75.75 0 0 0 1.06 1.06l3.006-3.004a2 2 0 0 0 0-2.829l-2.31-2.31Z',
      'M10.473 5.527a.75.75 0 0 1 0 1.06l-3.886 3.887a.75.75 0 1 1-1.06-1.06l3.886-3.887a.75.75 0 0 1 1.06 0Z',
      'M1.188 9.674a2 2 0 0 0 0 2.828l2.31 2.31a2 2 0 0 0 2.828 0l3.005-3.005a.75.75 0 0 0-1.06-1.061l-3.005 3.005a.5.5 0 0 1-.708 0l-2.31-2.31a.5.5 0 0 1 0-.707L5.255 7.73a.75.75 0 0 0-1.06-1.06L1.187 9.674Z',
    ],
  },
  clear_formatting: {
    paths: [
      'M8.286 4.771 8.984 2.5H6.75a.75.75 0 0 1 0-1.5H13a2 2 0 0 1 2 2v1.75a.75.75 0 0 1-1.5 0V3a.5.5 0 0 0-.5-.5h-2.446l-.837 2.72-.006.017-.853 2.56 5.922 5.923a.75.75 0 1 1-1.06 1.06L7.48 8.542a.76.76 0 0 1-.022-.022l-6.24-6.24A.75.75 0 0 1 2.28 1.22l5.392 5.392.614-1.841Z',
      'M7.711 11.237a.75.75 0 0 0-1.423-.474L5.376 13.5H3.75a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5H6.957l.754-2.263Z',
    ],
  },
  translate: {
    paths: [
      {
        d: 'M6.75 1.272a.75.75 0 0 0-1.5 0V2.5h-3.5a.75.75 0 0 0 0 1.5h.662l.028.03 2.485 2.485L1.97 9.47a.75.75 0 1 0 1.06 1.06l2.955-2.955.985.985a.75.75 0 0 0 1.06-1.061l-.984-.984L9.53 4.03 9.56 4h.691a.75.75 0 0 0 0-1.5h-3.5V1.272Zm-.765 4.182L7.44 4H4.531l1.454 1.454Z',
        fillRule: 'evenodd',
      },
      {
        d: 'm9.273 12.003-1.084 2.53a.75.75 0 1 1-1.378-.591l3.104-7.247a1.135 1.135 0 0 1 2.093 0l3.105 7.247a.75.75 0 0 1-1.379.59l-1.084-2.53H9.273Zm.643-1.5 1.046-2.442 1.046 2.442H9.916Z',
        fillRule: 'evenodd',
      },
    ],
  },
  hate_smiley: {
    paths: [
      'M5 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
      'M5.562 11.85a.75.75 0 1 1-1.124-.992A4.74 4.74 0 0 1 8 9.25a4.74 4.74 0 0 1 3.562 1.608.75.75 0 1 1-1.124.992A3.24 3.24 0 0 0 8 10.75a3.24 3.24 0 0 0-2.438 1.1Z',
      'M11 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
      'M3.83 3.665a.75.75 0 0 1 1.005-.336l2 1a.75.75 0 0 1-.67 1.342l-2-1a.75.75 0 0 1-.336-1.006Z',
      'M11.165 3.33a.75.75 0 1 1 .67 1.34l-2 1a.75.75 0 1 1-.67-1.34l2-1Z',
      {
        d: 'M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0Z',
        fillRule: 'evenodd',
      },
    ],
  },
  dislike_smiley: {
    paths: [
      'M5.184 11.376a.75.75 0 1 1-1.298-.752A4.748 4.748 0 0 1 8 8.25c1.759 0 3.294.957 4.114 2.374a.75.75 0 1 1-1.298.752A3.249 3.249 0 0 0 8 9.75a3.249 3.249 0 0 0-2.816 1.626Z',
      'M6 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
      'M12 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
      {
        d: 'M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0Z',
        fillRule: 'evenodd',
      },
    ],
  },
  neutral_smiley: {
    paths: [
      'M6 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
      'M12 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
      {
        d: 'M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM1.5 8a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0Z',
        fillRule: 'evenodd',
      },
      'M4 10.25a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Z',
    ],
  },
  like_smiley: {
    paths: [
      'M5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
      'M12 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
      'M4.852 8.813a.75.75 0 0 0-1.452.374 4.752 4.752 0 0 0 9.2 0 .75.75 0 1 0-1.452-.374 3.252 3.252 0 0 1-6.296 0Z',
      {
        d: 'M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-6.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13Z',
        fillRule: 'evenodd',
      },
    ],
  },
  love_smiley: {
    paths: [
      'M10.5 8.5h-.009a1 1 0 0 1 .808.37v.002a1 1 0 0 1 .2.83 3.567 3.567 0 0 1-3.49 2.835A3.565 3.565 0 0 1 4.52 9.702a1.004 1.004 0 0 1 .2-.83l.002-.002A1 1 0 0 1 5.5 8.5h4.99-.012.02Z',
      'M7.172 5.935A1.124 1.124 0 0 0 5.95 4.102c-.136.056-.26.14-.364.244l-.333.307-.332-.327A1.127 1.127 0 0 0 3 5.137c.002.3.122.587.335.798l1.21 1.213a1 1 0 0 0 1.416 0l1.21-1.213Z',
      'M12.915 5.57c-.057.137-.14.26-.243.365l-1.21 1.213a1 1 0 0 1-1.416 0l-1.21-1.213A1.132 1.132 0 0 1 9.62 4c.3-.002.587.116.8.326l.332.327.333-.307a1.12 1.12 0 0 1 1.829 1.224Z',
      {
        d: 'M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-6.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13Z',
        fillRule: 'evenodd',
      },
    ],
  },
  hate_smiley_alt: {
    paths: [
      {
        d: 'M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM5.562 11.85a.75.75 0 1 1-1.124-.992A4.74 4.74 0 0 1 8 9.25a4.74 4.74 0 0 1 3.562 1.608.75.75 0 1 1-1.124.992A3.24 3.24 0 0 0 8 10.75a3.24 3.24 0 0 0-2.438 1.1ZM6 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM3.83 3.665a.75.75 0 0 1 1.005-.336l2 1a.75.75 0 0 1-.67 1.342l-2-1a.75.75 0 0 1-.336-1.006Zm7.335-.336a.75.75 0 1 1 .67 1.342l-2 1a.75.75 0 0 1-.67-1.342l2-1Z',
        fillRule: 'evenodd',
      },
    ],
  },
  dislike_smiley_alt: {
    paths: [
      {
        d: 'M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM5.184 11.376a.75.75 0 1 1-1.298-.752A4.748 4.748 0 0 1 8 8.25c1.76 0 3.294.957 4.114 2.374a.75.75 0 1 1-1.298.752A3.249 3.249 0 0 0 8 9.75a3.249 3.249 0 0 0-2.816 1.626ZM6 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
        fillRule: 'evenodd',
      },
    ],
  },
  neutral_smiley_alt: {
    paths: [
      {
        d: 'M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm5-1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm7-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM4.75 9.5a.75.75 0 0 0 0 1.5h6.5a.75.75 0 1 0 0-1.5h-6.5Z',
        fillRule: 'evenodd',
      },
    ],
  },
  like_smiley_alt: {
    paths: [
      {
        d: 'M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm7-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM4.852 8.813a.75.75 0 0 0-1.452.374 4.752 4.752 0 0 0 9.2 0 .75.75 0 0 0-1.452-.374 3.252 3.252 0 0 1-6.296 0Z',
        fillRule: 'evenodd',
      },
    ],
  },
  love_smiley_alt: {
    paths: [
      {
        d: 'M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm7.415-2.43c-.057.137-.14.26-.243.365l-1.21 1.213a1 1 0 0 1-1.416 0l-1.21-1.213A1.132 1.132 0 0 1 4.12 4c.3-.002.587.116.8.326l.332.327.333-.307A1.121 1.121 0 0 1 7.415 5.57Zm5.257.365a1.123 1.123 0 0 0-1.586-1.59l-.333.308-.332-.327a1.127 1.127 0 0 0-1.921.811c.002.3.122.587.335.798l1.21 1.213a1 1 0 0 0 1.416 0l1.21-1.213ZM10.49 9a1 1 0 0 1 .808.37v.002a1 1 0 0 1 .2.83 3.567 3.567 0 0 1-3.49 2.836 3.565 3.565 0 0 1-3.489-2.835 1.004 1.004 0 0 1 .2-.831l.002-.002A1 1 0 0 1 5.5 9h4.99Zm0 0h-.012.02-.008Z',
        fillRule: 'evenodd',
      },
    ],
  },
  hate: {
    paths: [
      'M6.562 11.85a.75.75 0 1 1-1.124-.992A4.74 4.74 0 0 1 9 9.25a4.74 4.74 0 0 1 3.562 1.608.75.75 0 1 1-1.124.992A3.24 3.24 0 0 0 9 10.75a3.24 3.24 0 0 0-2.438 1.1Z',
      'M7 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
      'M13 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
      'M4.829 3.665a.75.75 0 0 1 1.006-.336l2 1a.75.75 0 0 1-.67 1.342l-2-1a.75.75 0 0 1-.336-1.006Z',
      'M12.165 3.33a.75.75 0 1 1 .67 1.34l-2 1a.75.75 0 1 1-.67-1.34l2-1Z',
      {
        d: 'M12.8 1c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 2.52 16 3.08 16 4.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 15 13.92 15 12.8 15H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 13.48 2 12.92 2 11.8V5.533c0-.198 0-.296-.019-.392a1 1 0 0 0-.08-.243 2.112 2.112 0 0 0-.221-.325L.92 3.56C.302 2.736-.007 2.324 0 1.98a1 1 0 0 1 .383-.767C.655 1 1.17 1 2.2 1h10.6Zm1.7 3.2v7.6c0 .585-.001.933-.022 1.191-.013.158-.03.224-.036.242a.5.5 0 0 1-.209.21 1.253 1.253 0 0 1-.242.035c-.258.02-.606.022-1.191.022H5.2c-.585 0-.933-.001-1.192-.022a1.253 1.253 0 0 1-.241-.036.5.5 0 0 1-.21-.209 1.256 1.256 0 0 1-.035-.242c-.02-.258-.022-.606-.022-1.191V5.492c0-.148.002-.392-.047-.638a2.5 2.5 0 0 0-.202-.61 3.258 3.258 0 0 0-.346-.537l-.025-.034L2 2.5h10.8c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.02.258.022.606.022 1.191Zm-.06 9.038.002-.003a.034.034 0 0 1-.002.003Zm-.202.203h-.003.003Zm-10.476 0h.003-.003Zm-.203-.203v-.003.003ZM14.24 2.56h-.004.003Zm.201.203.002.003-.002-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  dislike: {
    paths: [
      'M6 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
      'M6.184 11.376a.75.75 0 1 1-1.298-.752A4.748 4.748 0 0 1 9 8.25c1.759 0 3.294.957 4.114 2.374a.75.75 0 1 1-1.299.752A3.249 3.249 0 0 0 9 9.75a3.249 3.249 0 0 0-2.816 1.626Z',
      'M12 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
      {
        d: 'M12.8 1c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 2.52 16 3.08 16 4.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 15 13.92 15 12.8 15H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 13.48 2 12.92 2 11.8V5.533c0-.198 0-.296-.019-.392a1 1 0 0 0-.08-.243 2.112 2.112 0 0 0-.221-.325L.92 3.56C.302 2.736-.007 2.324 0 1.98a1 1 0 0 1 .383-.767C.655 1 1.17 1 2.2 1h10.6Zm1.7 3.2v7.6c0 .585-.001.933-.022 1.191-.013.158-.03.224-.036.242a.5.5 0 0 1-.209.21 1.253 1.253 0 0 1-.242.035c-.258.02-.606.022-1.191.022H5.2c-.585 0-.933-.001-1.192-.022a1.253 1.253 0 0 1-.241-.036.5.5 0 0 1-.21-.209 1.256 1.256 0 0 1-.035-.242c-.02-.258-.022-.606-.022-1.191V5.492c0-.148.002-.392-.047-.638a2.5 2.5 0 0 0-.202-.61 3.258 3.258 0 0 0-.346-.537l-.025-.034L2 2.5h10.8c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.02.258.022.606.022 1.191Zm-.06 9.038.002-.003a.034.034 0 0 1-.002.003Zm-.202.203h-.003.003Zm-10.476 0h.003-.003Zm-.203-.203v-.003.003ZM14.24 2.56h-.004.003Zm.201.203.002.003-.002-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  neutral: {
    paths: [
      'M6 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
      'M12 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
      {
        d: 'M12.8 1c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 2.52 16 3.08 16 4.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 15 13.92 15 12.8 15H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 13.48 2 12.92 2 11.8V5.533c0-.198 0-.296-.019-.392a1 1 0 0 0-.08-.243 2.112 2.112 0 0 0-.221-.325L.92 3.56C.302 2.736-.007 2.324 0 1.98a1 1 0 0 1 .383-.767C.655 1 1.17 1 2.2 1h10.6Zm1.7 3.2v7.6c0 .585-.001.933-.022 1.191-.013.158-.03.224-.036.242a.5.5 0 0 1-.209.21 1.253 1.253 0 0 1-.242.035c-.258.02-.606.022-1.191.022H5.2c-.585 0-.933-.001-1.192-.022a1.253 1.253 0 0 1-.241-.036.5.5 0 0 1-.21-.209 1.256 1.256 0 0 1-.035-.242c-.02-.258-.022-.606-.022-1.191V5.492c0-.148.002-.392-.047-.638a2.5 2.5 0 0 0-.202-.61 3.258 3.258 0 0 0-.346-.537l-.025-.034L2 2.5h10.8c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.02.258.022.606.022 1.191Zm-.06 9.038.002-.003a.034.034 0 0 1-.002.003Zm-.202.203h-.003.003Zm-10.476 0h.003-.003Zm-.203-.203v-.003.003ZM14.24 2.56h-.004.003Zm.201.203.002.003-.002-.003Z',
        fillRule: 'evenodd',
      },
      'M5 10.25a.75.75 0 0 1 .75-.75h6.5a.75.75 0 0 1 0 1.5h-6.5a.75.75 0 0 1-.75-.75Z',
    ],
  },
  like: {
    paths: [
      'M6.184 8.624a.75.75 0 1 0-1.298.752A4.748 4.748 0 0 0 9 11.75c1.759 0 3.294-.957 4.114-2.374a.75.75 0 1 0-1.299-.752A3.249 3.249 0 0 1 9 10.25a3.248 3.248 0 0 1-2.816-1.626Z',
      'M7 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
      'M13 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
      {
        d: 'M12.8 1c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 2.52 16 3.08 16 4.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 15 13.92 15 12.8 15H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 13.48 2 12.92 2 11.8V5.533c0-.198 0-.296-.019-.392a1 1 0 0 0-.08-.243 2.112 2.112 0 0 0-.221-.325L.92 3.56C.302 2.736-.007 2.324 0 1.98a1 1 0 0 1 .383-.767C.655 1 1.17 1 2.2 1h10.6Zm1.7 3.2v7.6c0 .585-.001.933-.022 1.191-.013.158-.03.224-.036.242a.5.5 0 0 1-.209.21 1.253 1.253 0 0 1-.242.035c-.258.02-.606.022-1.191.022H5.2c-.585 0-.933-.001-1.192-.022a1.253 1.253 0 0 1-.241-.036.5.5 0 0 1-.21-.209 1.256 1.256 0 0 1-.035-.242c-.02-.258-.022-.606-.022-1.191V5.492c0-.148.002-.392-.047-.638a2.5 2.5 0 0 0-.202-.61 3.258 3.258 0 0 0-.346-.537l-.025-.034L2 2.5h10.8c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.02.258.022.606.022 1.191Zm-.06 9.038.002-.003a.034.034 0 0 1-.002.003Zm-.202.203h-.003.003Zm-10.476 0h.003-.003Zm-.203-.203v-.003.003ZM14.24 2.56h-.004.003Zm.201.203.002.003-.002-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  love: {
    paths: [
      {
        d: 'M11.49 8.5a1 1 0 0 1 .808.37l.001.002a1 1 0 0 1 .2.83 3.567 3.567 0 0 1-3.49 2.835A3.565 3.565 0 0 1 5.52 9.702a1.004 1.004 0 0 1 .2-.83l.001-.002a1 1 0 0 1 .78-.37h4.99Zm0 0h-.012.022-.01Z',
        fillRule: 'evenodd',
      },
      'M8.171 5.935a1.124 1.124 0 0 0-1.585-1.59l-.333.308-.332-.327A1.127 1.127 0 0 0 4 5.137c.002.3.122.587.335.798l1.21 1.213a1 1 0 0 0 1.416 0l1.21-1.213Z',
      'M13.915 5.57c-.057.137-.14.26-.243.365l-1.21 1.213a1 1 0 0 1-1.417 0l-1.21-1.213A1.132 1.132 0 0 1 10.621 4c.3-.002.587.116.8.326l.332.327.333-.307a1.12 1.12 0 0 1 1.829 1.224Z',
      {
        d: 'M12.8 1c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 2.52 16 3.08 16 4.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 15 13.92 15 12.8 15H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 13.48 2 12.92 2 11.8V5.533c0-.198 0-.296-.019-.392a1 1 0 0 0-.08-.243 2.112 2.112 0 0 0-.221-.325L.92 3.56C.302 2.736-.007 2.324 0 1.98a1 1 0 0 1 .383-.767C.655 1 1.17 1 2.2 1h10.6Zm1.7 3.2v7.6c0 .585-.001.933-.022 1.191-.013.158-.03.224-.036.242a.5.5 0 0 1-.209.21 1.253 1.253 0 0 1-.242.035c-.258.02-.606.022-1.191.022H5.2c-.585 0-.933-.001-1.192-.022a1.253 1.253 0 0 1-.241-.036.5.5 0 0 1-.21-.209 1.256 1.256 0 0 1-.035-.242c-.02-.258-.022-.606-.022-1.191V5.492c0-.148.002-.392-.047-.638a2.5 2.5 0 0 0-.202-.61 3.258 3.258 0 0 0-.346-.537l-.025-.034L2 2.5h10.8c.585 0 .933.001 1.191.022.158.013.224.03.242.036a.5.5 0 0 1 .21.209c.005.018.022.084.035.242.02.258.022.606.022 1.191Zm-.06 9.038.002-.003a.034.034 0 0 1-.002.003Zm-.202.203h-.003.003Zm-10.476 0h.003-.003Zm-.203-.203v-.003.003ZM14.24 2.56h-.004.003Zm.201.203.002.003-.002-.003Z',
        fillRule: 'evenodd',
      },
    ],
  },
  hate_alt: {
    paths: [
      {
        d: 'M14.908 1.218C14.48 1 13.92 1 12.8 1H2.2C1.17 1 .655 1 .383 1.213A1 1 0 0 0 0 1.979c-.007.345.302.757.92 1.581l.76 1.013c.119.159.178.238.22.325a1 1 0 0 1 .081.243C2 5.237 2 5.335 2 5.533V11.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 15 4.08 15 5.2 15h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C16 13.48 16 12.92 16 11.8V4.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874ZM6.562 11.85a.75.75 0 1 1-1.124-.992A4.74 4.74 0 0 1 9 9.25a4.74 4.74 0 0 1 3.562 1.608.75.75 0 1 1-1.124.992A3.24 3.24 0 0 0 9 10.75a3.24 3.24 0 0 0-2.438 1.1ZM7 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM4.83 3.665a.75.75 0 0 1 1.005-.336l2 1a.75.75 0 0 1-.67 1.342l-2-1a.75.75 0 0 1-.336-1.006Zm7.335-.336a.75.75 0 1 1 .67 1.342l-2 1a.75.75 0 1 1-.67-1.342l2-1Z',
        fillRule: 'evenodd',
      },
    ],
  },
  dislike_alt: {
    paths: [
      {
        d: 'M14.908 1.218C14.48 1 13.92 1 12.8 1H2.2C1.17 1 .655 1 .383 1.213A1 1 0 0 0 0 1.979c-.007.345.302.757.92 1.581l.76 1.013c.119.159.178.238.22.325a1 1 0 0 1 .081.243C2 5.237 2 5.335 2 5.533V11.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 15 4.08 15 5.2 15h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C16 13.48 16 12.92 16 11.8V4.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874ZM6.184 11.376a.75.75 0 1 1-1.298-.752A4.748 4.748 0 0 1 9 8.25c1.759 0 3.294.957 4.114 2.374a.75.75 0 1 1-1.298.752A3.249 3.249 0 0 0 9 9.75a3.249 3.249 0 0 0-2.816 1.626ZM7 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
        fillRule: 'evenodd',
      },
    ],
  },
  neutral_alt: {
    paths: [
      {
        d: 'M12.8 1c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 2.52 16 3.08 16 4.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 15 13.92 15 12.8 15H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 13.48 2 12.92 2 11.8V5.533c0-.198 0-.296-.019-.392a1 1 0 0 0-.08-.243 2.112 2.112 0 0 0-.221-.325L.92 3.56C.302 2.736-.007 2.324 0 1.98a1 1 0 0 1 .383-.767C.655 1 1.17 1 2.2 1h10.6ZM6 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm7-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM5.75 9.5a.75.75 0 0 0 0 1.5h6.5a.75.75 0 1 0 0-1.5h-6.5Z',
        fillRule: 'evenodd',
      },
    ],
  },
  like_alt: {
    paths: [
      {
        d: 'M14.908 1.218C14.48 1 13.92 1 12.8 1H2.2C1.17 1 .655 1 .383 1.213A1 1 0 0 0 0 1.979c-.007.345.302.757.92 1.581l.76 1.013c.119.159.178.238.22.325a1 1 0 0 1 .081.243C2 5.237 2 5.335 2 5.533V11.8c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 15 4.08 15 5.2 15h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C16 13.48 16 12.92 16 11.8V4.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874ZM6.184 8.624a.75.75 0 0 0-1.298.752A4.748 4.748 0 0 0 9 11.75c1.759 0 3.294-.957 4.114-2.374a.75.75 0 1 0-1.298-.752A3.249 3.249 0 0 1 9 10.25a3.248 3.248 0 0 1-2.816-1.626ZM7 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
        fillRule: 'evenodd',
      },
    ],
  },
  love_alt: {
    paths: [
      {
        d: 'M12.8 1c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C16 2.52 16 3.08 16 4.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C14.48 15 13.92 15 12.8 15H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 13.48 2 12.92 2 11.8V5.533c0-.198 0-.296-.019-.392a1 1 0 0 0-.08-.243 2.112 2.112 0 0 0-.221-.325L.92 3.56C.302 2.736-.007 2.324 0 1.98a1 1 0 0 1 .383-.767C.655 1 1.17 1 2.2 1h10.6ZM8.17 5.935a1.124 1.124 0 0 0-1.585-1.59l-.333.308-.332-.327A1.127 1.127 0 0 0 4 5.137c.002.3.122.587.335.798l1.21 1.213a1 1 0 0 0 1.416 0l1.21-1.213Zm5.744-.365c-.057.137-.14.26-.243.365l-1.21 1.213a1 1 0 0 1-1.417 0l-1.21-1.213A1.132 1.132 0 0 1 10.621 4c.3-.002.587.116.8.326l.332.327.333-.307a1.12 1.12 0 0 1 1.829 1.224ZM11.49 9a1 1 0 0 1 .808.37v.002a1 1 0 0 1 .2.83 3.567 3.567 0 0 1-3.49 2.836 3.565 3.565 0 0 1-3.489-2.835 1.004 1.004 0 0 1 .2-.831l.002-.002A1 1 0 0 1 6.5 9h4.99Z',
        fillRule: 'evenodd',
      },
    ],
  },
  hotjar: {
    paths: [
      'M6.902 6.725c1.62-.9 3.842-2.134 3.842-5.725H8.055c0 2.01-.978 2.552-2.458 3.375-1.621.9-3.842 2.134-3.842 5.725h2.689c0-2.009.978-2.552 2.458-3.375Z',
      'M11.555 5.9c0 2.008-.978 2.552-2.458 3.374-1.621.901-3.842 2.135-3.842 5.726h2.689c0-2.01.978-2.553 2.458-3.376 1.621-.9 3.842-2.134 3.842-5.725h-2.689Z',
    ],
  },
  npm: {
    paths: [
      {
        d: 'M1 1v14h14V1H1Zm11.375 2.625h-8.75v8.75H8v-7h2.625v7h1.75v-8.75Z',
        fillRule: 'evenodd',
      },
    ],
  },
  share_alt: {
    paths: [
      'M7.5 0A7.49 7.49 0 0 0 0 7.5C0 11.65 3.35 15 7.5 15S15 11.65 15 7.5 11.65 0 7.5 0Zm-2 12C4.1 12 3 10.9 3 9.5S4.1 7 5.5 7c.3 0 .5.2.5.5s-.2.5-.5.5C4.65 8 4 8.65 4 9.5S4.65 11 5.5 11 7 10.35 7 9.5c0-.3.2-.5.5-.5s.5.2.5.5C8 10.9 6.9 12 5.5 12Zm3.15-6.35c.2-.2.5-.2.7 0 .2.2.2.5 0 .7l-3 3c-.1.1-.2.15-.35.15-.15 0-.25-.05-.35-.15-.2-.2-.2-.5 0-.7l3-3ZM9.5 8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5c.85 0 1.5-.65 1.5-1.5S10.35 4 9.5 4 8 4.65 8 5.5c0 .3-.2.5-.5.5S7 5.8 7 5.5C7 4.1 8.1 3 9.5 3S12 4.1 12 5.5 10.9 8 9.5 8Z',
    ],
  },
  support: {
    paths: [
      'M8 11.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z',
      'M10.5 11.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z',
      'M13 11.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z',
      {
        d: 'M10.423 6.412a4.003 4.003 0 0 0-3.91 3.122 4.01 4.01 0 0 0 2.182 4.504 4.003 4.003 0 0 0 3.48-.015.572.572 0 0 1 .352-.049l1.587.286-.414-1.107a.571.571 0 0 1 .06-.518c.438-.655.671-1.425.669-2.213v-.002a4.01 4.01 0 0 0-4.006-4.008Zm0-1.143a5.147 5.147 0 0 1 5.148 5.15 5.099 5.099 0 0 1-.702 2.598l.666 1.783a.571.571 0 0 1-.636.762l-2.396-.43a5.147 5.147 0 0 1-7.1-3.555A5.154 5.154 0 0 1 8.186 5.78a5.148 5.148 0 0 1 2.238-.51Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M4.61.77a6.211 6.211 0 0 1 6.92 2.034.571.571 0 0 1-.9.706A5.072 5.072 0 0 0 1.572 6.65v.001a5.034 5.034 0 0 0 .851 2.817.571.571 0 0 1 .06.519l-.594 1.58 1.294-.232a.571.571 0 0 1 .202 1.125l-2.283.41a.571.571 0 0 1-.636-.764l.848-2.255a6.177 6.177 0 0 1-.885-3.202A6.22 6.22 0 0 1 4.61.771Z',
        fillRule: 'evenodd',
      },
    ],
  },
  chart_stacked: {
    paths: [
      {
        d: 'M13.5 14h-11a.5.5 0 0 1-.5-.5v-12a.5.5 0 1 0-1 0v12A1.5 1.5 0 0 0 2.5 15h11a.5.5 0 0 0 0-1ZM3 12.5v-.793l1.145-1.145a.501.501 0 0 1 .71 0l1.585 1.585a1.5 1.5 0 0 0 2.12 0l5.295-5.29.144-.161v5.808a.497.497 0 0 1-.5.496H3.5a.5.5 0 0 1-.5-.5Zm.44-2.643-.44.44V7.443a.5.5 0 0 1 .117-.322L4.32 5.69c.26-.262.61-.408.971-.408.362 0 .71.146.972.408l1.452 1.516a.458.458 0 0 0 .326.142.442.442 0 0 0 .325-.142l4.848-5.064A.45.45 0 0 1 13.54 2a.45.45 0 0 1 .325.14c.086.09.135.213.135.34v2.972l-.855.695-5.29 5.295a.5.5 0 0 1-.71 0L5.56 9.857a1.53 1.53 0 0 0-2.12 0Z',
        fillRule: 'evenodd',
      },
    ],
  },
  billing_usd: {
    paths: [
      'M12 7.04V5.065c.575.14 1 .5 1 .935a.5.5 0 0 0 1 0c0-.965-.86-1.775-2-1.96V3.5a.5.5 0 0 0-1 0v.54c-1.14.185-2 1-2 1.96s.86 1.775 2 1.96v2c-.575-.14-1-.5-1-.935a.5.5 0 1 0-1 0c0 .965.86 1.775 2 1.96v.515a.5.5 0 0 0 1 0v-.54c1.14-.185 2-1 2-1.96s-.86-1.775-2-1.96Zm-1-.105c-.575-.14-1-.5-1-.935 0-.435.425-.795 1-.935v1.87Zm1 3v-1.87c.575.14 1 .5 1 .935 0 .435-.425.795-1 .935Z',
      'M11.5 13a.5.5 0 0 0-.5.5.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5V5h2.5A1.5 1.5 0 0 0 6 3.5V1h4.5a.5.5 0 0 1 .5.5.5.5 0 1 0 1 0A1.5 1.5 0 0 0 10.5 0h-5a.5.5 0 0 0-.355.14l-4 4A.5.5 0 0 0 1 4.5v9A1.5 1.5 0 0 0 2.5 15h8a1.5 1.5 0 0 0 1.5-1.5.5.5 0 0 0-.5-.5ZM5 1.705V3.5a.5.5 0 0 1-.5.5H2.705L5 1.705Z',
    ],
  },
  billing_gbp: {
    paths: [
      'M11.5 13a.5.5 0 0 0-.5.5.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5V5h2.5A1.5 1.5 0 0 0 6 3.5V1h4.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 0 1 0v-1A1.5 1.5 0 0 0 10.5 0h-5a.5.5 0 0 0-.36.14l-4 4A.5.5 0 0 0 1 4.5v9A1.5 1.5 0 0 0 2.5 15h8a1.5 1.5 0 0 0 1.5-1.5.5.5 0 0 0-.5-.5ZM5 1.705V3.5a.5.5 0 0 1-.5.5H2.705L5 1.705Z',
      'M13.855 11.145c-.11-.105-.73-.645-2.355-.645a9.401 9.401 0 0 0-1.5.13A3.05 3.05 0 0 0 10.5 9a2.64 2.64 0 0 0-.195-1H11.5a.5.5 0 0 0 0-1H10v-.475a1.58 1.58 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.125.5.5.5 0 0 0 .75-.66A2.5 2.5 0 0 0 11.5 4 2.57 2.57 0 0 0 9 6.5v.475h-.5a.5.5 0 0 0 0 1h.73c.03.09.065.17.095.245.116.244.176.51.175.78 0 1.21-1.265 2.075-1.275 2.085A.507.507 0 0 0 8.66 12a10.402 10.402 0 0 1 2.84-.5c1.185 0 1.63.34 1.66.365a.5.5 0 0 0 .695-.72Z',
    ],
  },
  billing_eur: {
    paths: [
      'M13.14 10.27a2.376 2.376 0 0 1-3.425 0A1.89 1.89 0 0 1 9.5 10h2a.5.5 0 0 0 0-1H9.05a2.59 2.59 0 0 1 0-1h2.45a.5.5 0 0 0 0-1h-2c.065-.095.136-.186.215-.27a2.375 2.375 0 0 1 3.425 0 .502.502 0 1 0 .72-.7 3.38 3.38 0 0 0-4.86 0 3.5 3.5 0 0 0-.665.97H7.5a.5.5 0 1 0 0 1h.54a3.72 3.72 0 0 0 0 1H7.5a.5.5 0 1 0 0 1h.835a3.5 3.5 0 0 0 .665.97A3.37 3.37 0 0 0 11.43 12a3.38 3.38 0 0 0 2.43-1.03.502.502 0 0 0-.72-.7Z',
      'M11.5 13a.5.5 0 0 0-.5.5.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5V5h2.5A1.5 1.5 0 0 0 6 3.5V1h4.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 10.5 0h-5a.5.5 0 0 0-.36.14l-4 4A.5.5 0 0 0 1 4.5v9A1.5 1.5 0 0 0 2.5 15h8a1.5 1.5 0 0 0 1.5-1.5.5.5 0 0 0-.5-.5ZM5 1.705V3.5a.5.5 0 0 1-.5.5H2.705L5 1.705Z',
    ],
  },
  billing_card: {
    paths: [
      'M9.615 10.692h3.231',
      'M11.5 13a.5.5 0 0 0-.5.5.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5V5h2.5A1.5 1.5 0 0 0 6 3.5V1h4.5a.5.5 0 0 1 .5.5v3a.5.5 0 1 0 1 0v-3A1.5 1.5 0 0 0 10.5 0h-5a.5.5 0 0 0-.355.14l-4 4A.5.5 0 0 0 1 4.5v9A1.5 1.5 0 0 0 2.5 15h8a1.5 1.5 0 0 0 1.5-1.5.5.5 0 0 0-.5-.5ZM5 1.705V3.5a.5.5 0 0 1-.5.5H2.695L5 1.705Z',
      'M12.5 6h-5A1.5 1.5 0 0 0 6 7.5v3A1.5 1.5 0 0 0 7.5 12h5a1.5 1.5 0 0 0 1.5-1.5v-3A1.5 1.5 0 0 0 12.5 6Zm.5 4.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5V9h6v1.5ZM13 8H7v-.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5V8Z',
    ],
  },
  money_back_usd: {
    paths: [
      'M7.5 0C3.365 0 0 3.365 0 7.5c0 2.115.88 4.08 2.415 5.5H1.5c-.275 0-.5.225-.5.5s.225.5.5.5h2c.275 0 .5-.225.5-.5v-2c0-.275-.225-.5-.5-.5s-.5.225-.5.5v.685A6.464 6.464 0 0 1 1 7.5C1 3.915 3.915 1 7.5 1S14 3.915 14 7.5 11.085 14 7.5 14c-.275 0-.5.225-.5.5s.225.5.5.5c4.135 0 7.5-3.365 7.5-7.5S11.635 0 7.5 0Z',
      'M7.5 12c.275 0 .5-.225.5-.5v-.54c1.14-.185 2-.995 2-1.96s-.86-1.775-2-1.96V5.065c.575.14 1 .51 1 .935 0 .275.225.5.5.5s.5-.225.5-.5c0-.965-.86-1.775-2-1.96V3.5c0-.275-.225-.5-.5-.5s-.5.225-.5.5v.54C5.86 4.225 5 5.035 5 6s.86 1.775 2 1.96v1.975c-.575-.14-1-.51-1-.935 0-.275-.225-.5-.5-.5S5 8.725 5 9c0 .965.86 1.775 2 1.96v.54c0 .275.225.5.5.5ZM9 9c0 .425-.425.795-1 .935v-1.87c.575.14 1 .51 1 .935ZM6 6c0-.425.425-.795 1-.935V6.94c-.575-.145-1-.515-1-.94Z',
    ],
  },
  money_back_eur: {
    paths: [
      'M7.5 0C3.365 0 0 3.365 0 7.5c0 2.115.88 4.08 2.415 5.5H1.5c-.275 0-.5.225-.5.5s.225.5.5.5h2c.275 0 .5-.225.5-.5v-2c0-.275-.225-.5-.5-.5s-.5.225-.5.5v.685A6.464 6.464 0 0 1 1 7.5C1 3.915 3.915 1 7.5 1S14 3.915 14 7.5 11.085 14 7.5 14c-.275 0-.5.225-.5.5s.225.5.5.5c4.135 0 7.5-3.365 7.5-7.5S11.635 0 7.5 0Z',
      'M7.93 11c.92 0 1.78-.365 2.43-1.03a.494.494 0 0 0-.01-.705.498.498 0 0 0-.705.01c-.46.465-1.07.725-1.715.725s-1.255-.26-1.715-.73C6.13 9.185 6.065 9.09 6 9h2c.275 0 .5-.225.5-.5S8.275 8 8 8H5.55a2.588 2.588 0 0 1 0-1H8c.275 0 .5-.225.5-.5S8.275 6 8 6H6c.07-.095.135-.19.215-.27a2.38 2.38 0 0 1 3.43 0 .498.498 0 1 0 .715-.695A3.363 3.363 0 0 0 7.93 4c-.92 0-1.78.365-2.43 1.03-.285.29-.5.62-.665.97H4c-.275 0-.5.225-.5.5s.225.5.5.5h.54a3.72 3.72 0 0 0 0 1H4c-.275 0-.5.225-.5.5s.225.5.5.5h.835c.165.35.38.68.665.97A3.37 3.37 0 0 0 7.93 11Z',
    ],
  },
  money_back_gbp: {
    paths: [
      'M9.66 10.865c.095.09.215.135.34.135a.498.498 0 0 0 .355-.85c-.11-.11-.73-.65-2.355-.65-.345 0-.665.025-.955.065C7.305 9.13 7.5 8.6 7.5 8c0-.45-.09-.75-.185-1H8.5c.275 0 .5-.225.5-.5S8.775 6 8.5 6H7.025A4.685 4.685 0 0 1 7 5.5C7 4.79 7.495 4 8.2 4c.38 0 .725.13.945.35a.498.498 0 1 0 .71-.7c-.41-.42-1-.65-1.655-.65C6.885 3 6 4.295 6 5.5c0 .185.01.35.02.5H5.5c-.275 0-.5.225-.5.5s.225.5.5.5h.74c.03.08.06.15.085.22.1.25.175.43.175.78 0 1.21-1.265 2.075-1.275 2.085a.499.499 0 0 0-.155.665.5.5 0 0 0 .655.2c.005-.005.925-.45 2.275-.45 1.185 0 1.63.34 1.66.365Z',
      'M7.5 0C3.365 0 0 3.365 0 7.5c0 2.115.88 4.08 2.415 5.5H1.5c-.275 0-.5.225-.5.5s.225.5.5.5h2c.275 0 .5-.225.5-.5v-2c0-.275-.225-.5-.5-.5s-.5.225-.5.5v.685A6.464 6.464 0 0 1 1 7.5C1 3.915 3.915 1 7.5 1S14 3.915 14 7.5 11.085 14 7.5 14c-.275 0-.5.225-.5.5s.225.5.5.5c4.135 0 7.5-3.365 7.5-7.5S11.635 0 7.5 0Z',
    ],
  },
  dropdown_caret: {
    paths: [
      {
        d: 'M3 6h10l-5 6-5-6Z',
        fillRule: 'evenodd',
      },
    ],
  },
  error: {
    paths: [
      'M8 3.987c.292 0 .528.236.528.528v2.987a.528.528 0 1 1-1.056 0V4.515c0-.292.236-.528.528-.528Z',
      {
        d: 'M8 9.463a1.026 1.026 0 1 0 0 2.052 1.026 1.026 0 0 0 0-2.052Zm.03 1.026a.03.03 0 1 1-.06 0 .03.03 0 0 1 .06 0Z',
        fillRule: 'evenodd',
      },
      {
        d: 'M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8Zm7-5.943a5.943 5.943 0 1 0 0 11.886A5.943 5.943 0 0 0 8 2.057Z',
        fillRule: 'evenodd',
      },
    ],
  },
  error_alt: {
    paths: [
      'M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1Zm-.75 3.5a.75.75 0 0 1 1.5 0v3a.75.75 0 0 1-1.5 0v-3ZM8 12a1 1 0 1 1 0-2.001A1 1 0 0 1 8 12Z',
    ],
  },
  android: {
    paths: [
      {
        d: 'M9.67 16c.535 0 1.002-.466 1.002-1.002V12.66h.668c.402 0 .67-.268.67-.67V5.31H3.99v6.68c0 .402.267.67.669.67h.668v2.339c0 .534.467 1.001 1.002 1.001.535 0 1.001-.466 1.001-1.001v-2.34H8.67V15c0 .534.466 1.001 1.001 1.001Z',
        fill: '#3AD47E',
      },
      {
        d: 'M13.68 11.99c.534 0 1-.466 1-1V6.311c0-.533-.466-1.001-1-1.001-.536 0-1.002.468-1.002 1v4.678c0 .535.466 1.002 1.001 1.002Z',
        fill: '#3AD47E',
      },
      {
        d: 'M2.32 11.99c.536 0 1.002-.466 1.002-1V6.311c0-.533-.466-1.001-1.001-1.001-.535 0-1.002.468-1.002 1v4.678c0 .535.467 1.002 1.002 1.002Z',
        fill: '#3AD47E',
      },
      {
        d: 'M11.207.1a.32.32 0 0 0-.467 0l-.897.895-.041.041C9.27.77 8.674.636 8.01.636h-.02c-.664 0-1.26.134-1.792.4L6.157.995 5.26.1a.32.32 0 0 0-.467 0 .32.32 0 0 0 0 .466l.868.868c-.28.186-.533.415-.753.676a3.927 3.927 0 0 0-.911 2.322l-.002.027c-.003.06-.004.12-.004.181h8.018c0-.06-.001-.12-.004-.18l-.002-.028a3.925 3.925 0 0 0-.91-2.322 3.616 3.616 0 0 0-.754-.676l.868-.868a.32.32 0 0 0 0-.466ZM6.329 3.475a.501.501 0 1 1 0-1.002.501.501 0 0 1 0 1.002Zm3.343 0a.501.501 0 1 1 0-1.002.501.501 0 0 1 0 1.002Z',
        fill: '#3AD47E',
      },
    ],
  },
  apple: {
    paths: [
      {
        d: 'M12.362 8.5c-.018-2.023 1.653-2.994 1.728-3.041-.94-1.376-2.403-1.564-2.925-1.586-1.244-.126-2.429.732-3.06.732-.63 0-1.606-.714-2.637-.694-1.359.02-2.61.789-3.308 2.004-1.41 2.445-.36 6.07 1.012 8.055.672.97 1.472 2.063 2.524 2.023 1.014-.04 1.397-.655 2.62-.655s1.568.655 2.639.636c1.089-.021 1.78-.992 2.447-1.965.77-1.127 1.088-2.217 1.107-2.274-.025-.01-2.124-.815-2.147-3.235Z',
        fill: '#B3B3B3',
      },
      {
        d: 'M10.35 2.56c.558-.677.935-1.617.831-2.554-.804.033-1.777.536-2.354 1.212-.517.598-.97 1.555-.848 2.473.897.07 1.813-.456 2.371-1.131Z',
        fill: '#B3B3B3',
      },
    ],
  },
  blackberry: {
    paths: [
      {
        d: 'M5.156 3.725c0-.53-.326-1.203-1.693-1.203H1.358L.76 5.29h2.194c1.714 0 2.202-.812 2.202-1.566Z',
        fill: 'black',
      },
      {
        d: 'M10.826 3.725c0-.53-.324-1.203-1.69-1.203H7.03L6.432 5.29h2.193c1.714 0 2.201-.81 2.201-1.565Z',
        fill: 'black',
      },
      {
        d: 'M4.396 7.892c0-.53-.325-1.205-1.692-1.205H.598L0 9.457h2.194c1.714 0 2.202-.813 2.202-1.565Z',
        fill: 'black',
      },
      {
        d: 'M10.067 7.892c0-.53-.326-1.205-1.692-1.205H6.27l-.6 2.77h2.196c1.714 0 2.201-.813 2.201-1.565Z',
        fill: 'black',
      },
      {
        d: 'M16 6.202c0-.531-.326-1.205-1.692-1.205h-2.105l-.6 2.77h2.195c1.714 0 2.202-.811 2.202-1.565Z',
        fill: 'black',
      },
      {
        d: 'M15.182 10.541c0-.532-.325-1.204-1.691-1.204h-2.106l-.598 2.77h2.194c1.714 0 2.201-.814 2.201-1.566Z',
        fill: 'black',
      },
      {
        d: 'M9.252 12.231c0-.533-.324-1.207-1.69-1.207H5.455l-.598 2.77H7.05c1.714 0 2.201-.81 2.201-1.563Z',
        fill: 'black',
      },
    ],
  },
  linux: {
    paths: [
      {
        d: 'M14.091 12.565c-.113-.128-.166-.364-.224-.615-.058-.25-.122-.522-.328-.697l-.002-.001a.86.86 0 0 0-.253-.153c.287-.85.175-1.695-.115-2.46-.354-.938-.974-1.756-1.447-2.315-.53-.668-1.048-1.302-1.038-2.24C10.7 2.656 10.841.005 8.325 0c-.102 0-.209.004-.32.013C5.193.24 5.939 3.21 5.897 4.205c-.051.727-.199 1.3-.699 2.011-.588.7-1.415 1.83-1.807 3.008-.185.556-.273 1.123-.192 1.659-.025.023-.05.047-.073.071-.172.184-.3.407-.442.558-.133.132-.322.183-.53.257-.208.075-.436.185-.574.45l-.001.002a.802.802 0 0 0-.087.386c0 .123.019.248.037.368.038.25.077.486.026.646-.165.45-.186.761-.07.987.116.226.355.326.624.382.54.113 1.27.085 1.846.39l.05-.093-.05.093c.617.323 1.242.437 1.74.323.362-.082.656-.298.807-.629.39-.002.817-.167 1.503-.205.465-.037 1.046.166 1.714.128a.905.905 0 0 0 .077.209l.002.002c.259.518.74.755 1.253.714.513-.04 1.06-.343 1.501-.868l-.081-.068.082.067c.42-.51 1.119-.722 1.582-1.001.231-.14.419-.314.434-.569.014-.253-.135-.538-.478-.918Z',
        fill: '#202020',
      },
      {
        d: 'M14.357 13.471c-.009.157-.122.274-.332.4-.419.252-1.161.472-1.635 1.046-.412.49-.914.76-1.356.794-.442.035-.824-.148-1.049-.6v-.002c-.14-.265-.082-.684.036-1.126.117-.441.286-.895.309-1.264.024-.473.05-.886.13-1.204.079-.318.204-.534.425-.655l.03-.016c.026.41.229.827.587.917.391.103.956-.233 1.194-.507l.14-.006c.209-.005.384.007.563.164h.002c.137.118.203.338.26.585.056.247.102.516.272.708.328.364.433.61.424.766Z',
        fill: '#FFCD00',
      },
      {
        d: 'M6.397 14.63v.002c-.038.496-.318.767-.748.865-.43.098-1.013 0-1.595-.304-.644-.341-1.41-.307-1.901-.41-.246-.051-.407-.128-.48-.272-.073-.143-.075-.393.081-.82v-.002l.001-.002c.078-.238.02-.5-.017-.744-.038-.245-.056-.468.028-.623v-.002c.108-.206.265-.28.46-.35.195-.07.426-.125.608-.308l.002-.001c.17-.179.296-.402.444-.56.126-.134.251-.223.44-.224h.006a.71.71 0 0 1 .106.009c.25.037.469.213.68.498l.607 1.108v.001c.162.338.504.71.793 1.088.29.379.514.76.485 1.05Z',
        fill: '#FFCD00',
      },
      {
        d: 'M9.428 4.302c-.049-.096-.148-.187-.318-.256-.354-.152-.507-.163-.704-.29-.32-.207-.586-.28-.806-.278a.952.952 0 0 0-.31.052c-.269.093-.447.285-.558.391-.023.021-.05.04-.12.09l-.32.238c-.132.099-.175.228-.129.379.045.15.191.325.457.475h.001c.165.098.278.229.408.333a.912.912 0 0 0 .215.134.874.874 0 0 0 .298.065c.281.017.488-.068.671-.172.184-.105.339-.233.517-.29v-.001c.366-.114.626-.344.707-.562a.37.37 0 0 0-.009-.308Z',
        fill: '#FFCD00',
      },
      {
        d: 'M8.502 4.84c-.29.152-.63.336-.99.336-.361 0-.646-.167-.85-.33-.103-.08-.187-.162-.25-.22-.108-.086-.095-.207-.05-.203.075.01.086.108.133.152.064.06.144.137.24.214.195.154.453.303.777.303.323 0 .7-.19.93-.319.13-.073.297-.204.432-.303.104-.076.1-.168.185-.158.086.01.023.101-.097.206-.12.104-.307.243-.46.323Z',
        fill: '#202020',
      },
      {
        d: 'M12.949 11.037a1.883 1.883 0 0 0-.119 0h-.01c.1-.315-.121-.547-.71-.813-.609-.268-1.095-.241-1.176.303-.006.028-.01.057-.013.087a.935.935 0 0 0-.137.06c-.287.157-.443.441-.53.79-.087.348-.112.77-.135 1.242-.015.239-.113.56-.212.902-.999.712-2.385 1.02-3.561.217a5.23 5.23 0 0 0-.266-.374c-.06-.079-.122-.157-.183-.234a.74.74 0 0 0 .307-.057.388.388 0 0 0 .211-.219c.072-.193 0-.465-.23-.776-.23-.31-.619-.661-1.19-1.012-.42-.261-.655-.582-.765-.929-.11-.348-.094-.724-.01-1.095.163-.712.58-1.405.848-1.84.071-.053.025.098-.27.647-.265.501-.76 1.66-.082 2.563a5.373 5.373 0 0 1 .43-1.913c.375-.85 1.16-2.327 1.223-3.504a3.306 3.306 0 0 0 .192.126c.144.085.252.209.393.322a.97.97 0 0 0 .655.228 1.3 1.3 0 0 0 .664-.191c.193-.11.347-.233.493-.28.31-.097.555-.268.695-.467.24.946.797 2.311 1.156 2.978.19.353.57 1.104.733 2.01a1.23 1.23 0 0 1 .34.043c.43-1.11-.362-2.307-.724-2.64-.146-.142-.153-.205-.081-.202.393.347.908 1.046 1.096 1.834.085.36.104.737.012 1.11l.136.061c.688.335.942.626.82 1.023Z',
        fill: 'white',
      },
      {
        d: 'M9.46 3.213a1.2 1.2 0 0 1-.244.748 4.779 4.779 0 0 0-.248-.102c-.057-.022-.1-.036-.145-.052.032-.04.097-.086.12-.145a.765.765 0 0 0 .058-.277l.001-.012a.767.767 0 0 0-.04-.269.496.496 0 0 0-.123-.21.254.254 0 0 0-.177-.08h-.01a.26.26 0 0 0-.172.068.493.493 0 0 0-.14.2.768.768 0 0 0-.057.278v.011a.817.817 0 0 0 .01.16 2.025 2.025 0 0 0-.403-.137c-.007-.05-.01-.1-.011-.152v-.014a1.18 1.18 0 0 1 .1-.51.904.904 0 0 1 .286-.375.632.632 0 0 1 .394-.14h.007c.143 0 .265.042.39.132a.89.89 0 0 1 .293.37 1.188 1.188 0 0 1 .112.508Z',
        fill: 'white',
      },
      {
        d: 'M7.305 3.4a1.115 1.115 0 0 0-.316.143.708.708 0 0 0 .003-.171v-.01a.745.745 0 0 0-.055-.218.424.424 0 0 0-.11-.162.18.18 0 0 0-.136-.05c-.047.003-.087.027-.125.073a.424.424 0 0 0-.08.178.716.716 0 0 0-.015.233v.01c.009.082.026.15.055.22a.416.416 0 0 0 .132.178c-.046.036-.078.062-.117.09l-.088.065a.804.804 0 0 1-.183-.273 1.22 1.22 0 0 1-.102-.435V3.27c-.009-.162.007-.3.051-.445a.76.76 0 0 1 .19-.333.41.41 0 0 1 .302-.134c.095 0 .18.031.268.101a.78.78 0 0 1 .227.31c.06.137.092.274.101.435v.002c.004.068.004.131-.002.193Z',
        fill: 'white',
      },
      {
        d: 'M7.782 3.785c.012.04.074.033.11.051.031.016.057.052.092.053.034.001.086-.012.09-.045.007-.045-.058-.073-.1-.089-.053-.02-.122-.031-.172-.004-.012.007-.024.022-.02.034Z',
        fill: '#202020',
      },
      {
        d: 'M7.29 3.785c-.015.04-.09.033-.134.051-.038.016-.069.052-.112.053-.041.001-.105-.012-.11-.045-.007-.045.071-.073.122-.089.065-.02.148-.031.21-.004.013.007.028.022.024.034Z',
        fill: '#202020',
      },
    ],
  },
  windows: {
    paths: [
      {
        d: 'm0 2.268 6.519-.887v6.283l-6.515.039L0 2.268Z',
        fill: '#F8682C',
      },
      {
        d: 'M7.305 1.263 15.943 0v7.585l-8.638.07V1.263Z',
        fill: '#91C300',
      },
      {
        d: 'm6.514 8.389.005 6.292-6.515-.896V8.35l6.51.039Z',
        fill: '#00B4F1',
      },
      {
        d: 'M15.948 8.45V16l-8.643-1.223-.013-6.344 8.656.017Z',
        fill: '#FFC300',
      },
    ],
  },
  ubuntu: {
    paths: [
      {
        d: 'M15.977 7.98a7.98 7.98 0 1 1-15.96 0 7.98 7.98 0 0 1 15.96 0Z',
        fill: '#DD4814',
      },
      {
        d: 'M2.57 6.915a1.065 1.065 0 1 0 0 2.13 1.065 1.065 0 0 0 0-2.13Zm7.608 4.842a1.065 1.065 0 1 0 1.064 1.845 1.065 1.065 0 0 0-1.064-1.845ZM4.885 7.98c0-1.053.523-1.983 1.323-2.546L5.43 4.129a4.638 4.638 0 0 0-1.914 2.69 1.494 1.494 0 0 1 0 2.321 4.635 4.635 0 0 0 1.914 2.691l.78-1.305A3.107 3.107 0 0 1 4.884 7.98Zm3.112-3.112a3.112 3.112 0 0 1 3.1 2.836l1.518-.022A4.614 4.614 0 0 0 11.24 4.68a1.494 1.494 0 0 1-2.006-1.16 4.642 4.642 0 0 0-3.288.31l.74 1.327a3.1 3.1 0 0 1 1.311-.29Zm0 6.224a3.1 3.1 0 0 1-1.31-.29l-.741 1.327a4.607 4.607 0 0 0 3.288.311 1.493 1.493 0 0 1 2.006-1.16 4.614 4.614 0 0 0 1.375-3.002l-1.519-.022a3.111 3.111 0 0 1-3.099 2.836Zm2.18-6.89a1.065 1.065 0 1 0 1.066-1.843 1.065 1.065 0 0 0-1.065 1.844Z',
        fill: 'white',
      },
    ],
  },
  chrome: {
    paths: [
      {
        d: 'm15.09 4.29-6.478.003A3.758 3.758 0 0 1 11.757 8a3.757 3.757 0 0 1-.948 2.49l-3.212 5.5a8 8 0 0 0 7.493-11.7Z',
        fill: '#FFCD40',
      },
      {
        d: 'M8 0a7.994 7.994 0 0 0-6.807 3.796l3.121 4.917c.015.234-.07-.696-.07-.713A3.757 3.757 0 0 1 8 4.243c.195.002.39.018.581.05l6.508-.002A7.999 7.999 0 0 0 8 0Z',
        fill: '#DB4437',
      },
      {
        d: 'M1.193 3.796A8 8 0 0 0 7.597 15.99l3.212-5.5A3.757 3.757 0 0 1 8 11.757a3.757 3.757 0 0 1-3.686-3.044L1.193 3.796Z',
        fill: '#0F9D58',
      },
      {
        d: 'M8 11.757a3.757 3.757 0 1 0 0-7.514 3.757 3.757 0 0 0 0 7.514Z',
        fill: '#F1F1F1',
      },
      {
        d: 'M8 11.1a3.1 3.1 0 1 0 0-6.2 3.1 3.1 0 0 0 0 6.2Z',
        fill: '#4285F4',
      },
    ],
  },
  chromium: {
    paths: [
      {
        d: 'm15.09 4.29-6.478.003A3.758 3.758 0 0 1 11.757 8a3.757 3.757 0 0 1-.948 2.49l-3.212 5.5a8 8 0 0 0 7.493-11.7Z',
        fill: '#91B0E8',
      },
      {
        d: 'M8 0a7.994 7.994 0 0 0-6.807 3.796l3.121 4.917c.015.234-.07-.696-.07-.713A3.757 3.757 0 0 1 8 4.243c.195.002.39.018.581.05l6.508-.002A7.999 7.999 0 0 0 8 0Z',
        fill: '#245DC4',
      },
      {
        d: 'M1.193 3.796A8 8 0 0 0 7.597 15.99l3.212-5.5A3.757 3.757 0 0 1 8 11.757a3.757 3.757 0 0 1-3.686-3.044L1.193 3.796Z',
        fill: '#548AE6',
      },
      {
        d: 'M8 11.757a3.757 3.757 0 1 0 0-7.514 3.757 3.757 0 0 0 0 7.514Z',
        fill: 'white',
      },
      {
        d: 'M8 11.1a3.1 3.1 0 1 0 0-6.2 3.1 3.1 0 0 0 0 6.2Z',
        fill: '#367BF0',
      },
    ],
  },
  edge: {
    paths: [
      {
        d: 'M14.44 11.909c-.213.111-.433.21-.658.294a6.366 6.366 0 0 1-2.244.404c-2.957 0-5.534-2.035-5.534-4.645a1.968 1.968 0 0 1 1.027-1.707c-2.675.112-3.362 2.9-3.362 4.533 0 4.617 4.255 5.086 5.172 5.086.495 0 1.24-.144 1.688-.285l.082-.028a8.021 8.021 0 0 0 4.162-3.3.25.25 0 0 0-.332-.352Z',
        fill: '#0C59A4',
      },
      {
        d: 'M6.607 15.089a4.95 4.95 0 0 1-1.421-1.334 5.045 5.045 0 0 1 1.845-7.5c.195-.092.528-.258.972-.25a2.022 2.022 0 0 1 1.605.813c.253.337.392.745.398 1.166 0-.013 1.528-4.975-5-4.975-2.744 0-5 2.604-5 4.888a8.134 8.134 0 0 0 .757 3.5 8 8 0 0 0 9.773 4.194 4.723 4.723 0 0 1-3.923-.5l-.006-.002Z',
        fill: '#1B9DE2',
      },
      {
        d: 'M9.52 9.304c-.051.065-.207.156-.207.354 0 .163.106.32.295.451.899.625 2.593.543 2.598.543a3.722 3.722 0 0 0 1.892-.522 3.836 3.836 0 0 0 1.901-3.305c.017-1.4-.5-2.332-.708-2.744C13.966 1.49 11.107 0 7.999 0a8 8 0 0 0-8 7.888c.03-2.284 2.3-4.129 5-4.129.219 0 1.466.022 2.625.63 1.021.536 1.556 1.183 1.928 1.825.386.667.455 1.51.455 1.845 0 .336-.171.834-.488 1.245Z',
        fill: 'url(#paint0_radial_4686_8663)',
      },
      {
        d: 'M9.52 9.304c-.051.065-.207.156-.207.354 0 .163.106.32.295.451.899.625 2.593.543 2.598.543a3.722 3.722 0 0 0 1.892-.522 3.836 3.836 0 0 0 1.901-3.305c.017-1.4-.5-2.332-.708-2.744C13.966 1.49 11.107 0 7.999 0a8 8 0 0 0-8 7.888c.03-2.284 2.3-4.129 5-4.129.219 0 1.466.022 2.625.63 1.021.536 1.556 1.183 1.928 1.825.386.667.455 1.51.455 1.845 0 .336-.171.834-.488 1.245Z',
        fill: '#35C761',
      },
    ],
  },
  firefox: {
    paths: [
      {
        d: 'M7.968 6.76c-.013.193-.694.858-.933.858-2.205 0-2.563 1.334-2.563 1.334.098 1.123.88 2.049 1.827 2.538a4.275 4.275 0 0 0 .359.156c.324.115.664.18 1.008.194 3.865.182 4.614-4.621 1.825-6.015a2.677 2.677 0 0 1 1.87.454 3.914 3.914 0 0 0-3.398-1.984c-.092 0-.182.007-.273.013a3.879 3.879 0 0 0-2.134.823c.119.1.252.234.533.51.526.52 1.876 1.056 1.879 1.12Z',
        fill: '#9400FF',
      },
      {
        d: 'M15.129 5.367c-.337-.81-1.02-1.686-1.556-1.962.382.739.647 1.533.786 2.353l.001.013c-.877-2.185-2.363-3.067-3.578-4.986A9.242 9.242 0 0 1 10.6.488a2.45 2.45 0 0 1-.086-.16 1.41 1.41 0 0 1-.12-.32A.02.02 0 0 0 10.38 0a.028.028 0 0 0-.015 0l-.003.002-.006.003.003-.005c-1.948 1.14-2.609 3.252-2.67 4.308.091-.007.18-.014.273-.014a3.913 3.913 0 0 1 3.398 1.984 2.677 2.677 0 0 0-1.87-.454c2.79 1.394 2.04 6.197-1.824 6.015a3.448 3.448 0 0 1-1.01-.194 4.116 4.116 0 0 1-.227-.094c-.044-.02-.088-.04-.13-.062l.004.003a4.242 4.242 0 0 1-.112-.056c.036.018.07.037.107.053-.947-.49-1.729-1.414-1.826-2.538 0 0 .358-1.334 2.563-1.334.238 0 .92-.665.932-.858-.003-.063-1.352-.6-1.879-1.118-.28-.277-.414-.41-.532-.51a2.318 2.318 0 0 0-.2-.153 3.595 3.595 0 0 1-.022-1.895 5.743 5.743 0 0 0-1.867 1.443h-.003c-.308-.39-.286-1.674-.268-1.943-.091.037-.178.083-.26.138-.27.193-.524.41-.757.649-.266.27-.508.56-.725.87v.001-.001A6.55 6.55 0 0 0 .415 6.59l-.01.051c-.016.069-.081.415-.09.49 0-.006 0 .005 0 0-.06.357-.098.718-.115 1.08v.04a7.755 7.755 0 0 0 15.397 1.312c.013-.1.023-.2.035-.3a7.974 7.974 0 0 0-.503-3.896Zm-.77.399.002.008-.001-.008Z',
        fill: '#FF9400',
      },
    ],
  },
  ms_ie: {
    paths: [
      {
        d: 'M15.963 8.388a7.54 7.54 0 0 0-.897-3.565C17.532-.791 12.45.043 12.15.043a12.961 12.961 0 0 0-2.99.987c-3.438-.042-6.428 1.82-7.4 5.69C3.555 4.67 4.826 3.836 5.573 3.532c-.157.144-.314.296-.47.448a22.437 22.437 0 0 0-2.99 3.717C1.477 8.835.767 9.822.393 11.11c-2.017 7.434 4.336 4.324 5.233 3.793.971.485 2.018.75 3.214.75 3.139 0 5.83-2.047 6.801-4.854H11.83c-1.793 2.883-6.054 1.593-6.203-1.517H15.94c.04-.311.06-.622.06-.91l-.037.015Zm-1.346-7.206c.62.424 1.121 1.062.262 3.337-.822-1.365-2.018-2.427-3.513-2.958.665-.326 2.317-.986 3.289-.38h-.038Zm-13.23 13.73c-.508-.524-.597-1.821.524-4.173a7.156 7.156 0 0 0 3.14 3.87c-.726.401-2.617 1.289-3.663.25v.053Zm4.186-7.586c.058-1.669 1.495-3.034 3.289-3.034s3.214 1.365 3.289 3.034H5.573Z',
        fill: '#1EBBEE',
      },
    ],
  },
  opera: {
    paths: [
      {
        d: 'M7.951 0a7.951 7.951 0 1 0 5.299 13.88 5.736 5.736 0 0 1-3.186.973c-1.893 0-3.59-.94-4.73-2.42-.879-1.038-1.449-2.573-1.488-4.295v-.374c.04-1.722.609-3.256 1.488-4.294 1.14-1.48 2.836-2.42 4.73-2.42a5.74 5.74 0 0 1 3.186.974A7.92 7.92 0 0 0 7.981 0L7.951 0Z',
        fill: '#FF1B2D',
      },
      {
        d: 'M5.334 3.47c.73-.86 1.672-1.38 2.701-1.38 2.315 0 4.191 2.624 4.191 5.862 0 3.236-1.876 5.86-4.191 5.86-1.03 0-1.972-.519-2.701-1.38 1.14 1.482 2.836 2.421 4.73 2.421a5.736 5.736 0 0 0 3.185-.974 7.932 7.932 0 0 0 2.653-5.927 7.933 7.933 0 0 0-2.652-5.928 5.739 5.739 0 0 0-3.186-.974c-1.894 0-3.59.94-4.73 2.42Z',
        fill: '#9C0000',
      },
    ],
  },
  safari: {
    paths: [
      {
        d: 'M15.707 8.614c0 .97-.2 1.93-.587 2.826a7.375 7.375 0 0 1-1.67 2.397 7.738 7.738 0 0 1-2.5 1.6A7.997 7.997 0 0 1 8 16a7.997 7.997 0 0 1-2.95-.562 7.738 7.738 0 0 1-2.5-1.601A7.374 7.374 0 0 1 .88 11.44a7.12 7.12 0 0 1-.587-2.827c0-1.959.812-3.837 2.258-5.222C3.996 2.006 5.956 1.228 8 1.228c1.012 0 2.014.191 2.95.562a7.737 7.737 0 0 1 2.5 1.602 7.374 7.374 0 0 1 1.67 2.396 7.12 7.12 0 0 1 .587 2.826Z',
        fill: 'black',
      },
      {
        d: 'M16 7.962a7.928 7.928 0 0 1-2.343 5.63 8.032 8.032 0 0 1-11.314 0A7.943 7.943 0 0 1 0 7.962c0-2.111.843-4.137 2.343-5.63A8.02 8.02 0 0 1 11.062.606c.97.4 1.852.987 2.595 1.726A7.96 7.96 0 0 1 16 7.962Z',
        fill: 'white',
      },
      {
        d: 'M15.373 7.962a7.32 7.32 0 0 1-2.16 5.19A7.391 7.391 0 0 1 8 15.3a7.391 7.391 0 0 1-5.214-2.15A7.32 7.32 0 0 1 .627 7.962a7.32 7.32 0 0 1 2.16-5.189A7.39 7.39 0 0 1 8 .624c1.956 0 3.83.773 5.214 2.15a7.32 7.32 0 0 1 2.16 5.188Z',
        fill: '#1F86F9',
      },
      {
        d: 'M8 1.007a.107.107 0 0 0-.108.107v1.234c0 .059.048.107.108.107s.107-.048.107-.107V1.114A.107.107 0 0 0 8 1.007Zm-.703.044a.107.107 0 0 0-.118.118l.054.516a.107.107 0 0 0 .118.095.107.107 0 0 0 .096-.117l-.054-.517a.107.107 0 0 0-.096-.095Zm1.411 0a.107.107 0 0 0-.096.096l-.055.516a.107.107 0 0 0 .096.118.107.107 0 0 0 .118-.096l.055-.516a.107.107 0 0 0-.118-.118Zm-2.134.104a.107.107 0 0 0-.105.13l.257 1.207c.013.058.07.094.128.082a.107.107 0 0 0 .083-.127L6.68 1.24a.107.107 0 0 0-.106-.085Zm2.857.001a.107.107 0 0 0-.106.085l-.258 1.207a.107.107 0 0 0 .083.127.107.107 0 0 0 .127-.082l.258-1.208a.107.107 0 0 0-.104-.129Zm-3.546.193a.107.107 0 0 0-.111.14l.16.493a.107.107 0 0 0 .205-.066l-.161-.494a.107.107 0 0 0-.093-.073Zm4.231 0a.107.107 0 0 0-.093.073l-.161.494a.107.107 0 0 0 .204.066l.162-.493a.107.107 0 0 0-.112-.14Zm-4.913.248a.108.108 0 0 0-.096.15l.503 1.128a.107.107 0 0 0 .197-.087l-.504-1.127a.107.107 0 0 0-.1-.064Zm5.603.004a.108.108 0 0 0-.1.063L10.2 2.791a.108.108 0 0 0 .196.087l.506-1.127a.106.106 0 0 0-.096-.15Zm-6.236.33a.107.107 0 0 0-.061.013.106.106 0 0 0-.04.146l.261.45a.108.108 0 0 0 .187-.107l-.261-.45a.107.107 0 0 0-.086-.053Zm6.86 0a.107.107 0 0 0-.086.052l-.26.45a.108.108 0 0 0 .186.107l.26-.45a.106.106 0 0 0-.04-.146.108.108 0 0 0-.06-.014Zm-7.474.38a.108.108 0 0 0-.06.021.106.106 0 0 0-.024.15l.728.998a.108.108 0 0 0 .15.024.106.106 0 0 0 .025-.15l-.729-.998a.107.107 0 0 0-.09-.044Zm8.096.006a.107.107 0 0 0-.09.044l-.73.998a.107.107 0 0 0 .023.15.108.108 0 0 0 .15-.024l.73-.998a.107.107 0 0 0-.083-.17Zm-8.646.453a.107.107 0 0 0-.085.179l.349.385c.04.044.107.048.152.008a.106.106 0 0 0 .008-.15l-.35-.387a.107.107 0 0 0-.074-.035Zm9.188 0a.108.108 0 0 0-.074.036l-.35.386a.106.106 0 0 0 .009.151c.044.04.112.036.152-.008l.349-.386a.107.107 0 0 0-.085-.179Zm-9.714.503a.108.108 0 0 0-.074.036.106.106 0 0 0 .008.15l.921.826c.045.04.112.037.152-.007a.106.106 0 0 0-.008-.152l-.921-.825a.107.107 0 0 0-.078-.028Zm10.243.004a.107.107 0 0 0-.077.027l-.923.825a.106.106 0 0 0-.008.151c.04.044.108.048.152.008l.922-.825a.106.106 0 0 0 .008-.15.107.107 0 0 0-.074-.036Zm-10.68.557a.107.107 0 0 0-.068.193l.422.305a.108.108 0 0 0 .15-.023.106.106 0 0 0-.023-.15l-.422-.305a.108.108 0 0 0-.06-.02Zm11.117.003a.108.108 0 0 0-.059.02l-.422.306a.106.106 0 0 0-.024.15.108.108 0 0 0 .15.023l.422-.305a.107.107 0 0 0 .024-.15.107.107 0 0 0-.09-.044Zm-11.527.594a.107.107 0 0 0-.046.2l1.074.617c.051.03.117.012.147-.04a.106.106 0 0 0-.04-.146l-1.074-.617a.108.108 0 0 0-.06-.014Zm11.934 0a.107.107 0 0 0-.062.014l-1.073.617a.106.106 0 0 0-.04.147c.03.05.095.068.147.039l1.074-.617a.107.107 0 0 0-.046-.2Zm-12.243.637a.107.107 0 0 0-.046.205l.476.211c.055.025.118 0 .142-.054a.107.107 0 0 0-.054-.141l-.476-.211a.108.108 0 0 0-.042-.01Zm12.554.005a.108.108 0 0 0-.042.009l-.476.211a.107.107 0 0 0-.055.141.108.108 0 0 0 .142.055l.477-.212a.107.107 0 0 0 .054-.14.107.107 0 0 0-.1-.064Zm-12.83.66a.107.107 0 0 0-.024.21l1.179.382a.107.107 0 0 0 .136-.069.107.107 0 0 0-.07-.135L1.492 5.74a.108.108 0 0 0-.043-.005Zm13.105.006a.105.105 0 0 0-.042.004l-1.18.382a.107.107 0 0 0-.068.135.107.107 0 0 0 .135.068l1.18-.381a.107.107 0 0 0-.025-.208Zm-13.277.694a.107.107 0 0 0-.023.212l.51.107a.107.107 0 1 0 .045-.209l-.51-.108a.106.106 0 0 0-.022-.002Zm13.448 0a.133.133 0 0 0-.022.003l-.51.108a.107.107 0 0 0-.083.127c.012.058.07.095.127.082l.51-.108a.107.107 0 0 0-.022-.211Zm-13.578.703a.107.107 0 0 0 0 .213l1.233.13a.107.107 0 1 0 .022-.213l-1.233-.13h-.022Zm13.709.009a.1.1 0 0 0-.022 0l-1.233.128a.107.107 0 1 0 .022.213l1.233-.128a.107.107 0 0 0 0-.213Zm-13.73.71a.107.107 0 1 0 0 .214h.522a.107.107 0 1 0 0-.214h-.521Zm13.228 0a.107.107 0 1 0 0 .214h.521a.107.107 0 1 0 0-.214h-.521ZM2.4 8.44h-.022l-1.233.128a.107.107 0 1 0 .022.213L2.4 8.652a.107.107 0 0 0 0-.213Zm11.2.007a.107.107 0 0 0-.001.213l1.233.13a.107.107 0 1 0 .022-.213l-1.233-.13H13.6ZM1.784 9.17a.1.1 0 0 0-.022.002l-.51.108a.107.107 0 1 0 .045.21l.51-.108a.107.107 0 0 0-.023-.212Zm12.43.001a.107.107 0 0 0-.023.212l.51.108a.107.107 0 1 0 .045-.21l-.51-.108a.101.101 0 0 0-.022-.002Zm-11.57.421a.105.105 0 0 0-.043.005l-1.18.382a.107.107 0 0 0-.068.135.107.107 0 0 0 .135.068L2.67 9.8a.107.107 0 0 0-.025-.209Zm10.71.004a.107.107 0 0 0-.025.209l1.18.382a.107.107 0 0 0 .135-.069.107.107 0 0 0-.07-.135L13.398 9.6a.107.107 0 0 0-.043-.005Zm-11.16.832a.105.105 0 0 0-.042.01l-.477.21a.107.107 0 0 0-.054.142.107.107 0 0 0 .142.054l.476-.211a.107.107 0 0 0 .055-.141.107.107 0 0 0-.1-.064Zm11.609.004a.107.107 0 0 0-.046.205l.476.211c.055.024.118 0 .142-.054a.107.107 0 0 0-.054-.141l-.476-.212a.106.106 0 0 0-.042-.009Zm-10.682.232a.107.107 0 0 0-.061.014l-1.074.617a.107.107 0 0 0-.04.146c.03.052.096.07.147.04l1.074-.618a.107.107 0 0 0 .04-.146.107.107 0 0 0-.086-.053Zm9.756 0a.107.107 0 0 0-.046.2l1.073.616c.052.03.118.013.147-.039a.107.107 0 0 0-.039-.146l-1.074-.617a.108.108 0 0 0-.061-.014Zm-10.024.905a.108.108 0 0 0-.06.02l-.421.306a.106.106 0 0 0-.024.15.108.108 0 0 0 .15.023l.422-.305a.107.107 0 0 0-.067-.194Zm10.29.004a.107.107 0 0 0-.068.194l.422.305a.108.108 0 0 0 .15-.024.106.106 0 0 0-.024-.15l-.421-.305a.107.107 0 0 0-.06-.02Zm-9.334.037a.107.107 0 0 0-.077.027l-.922.825a.106.106 0 0 0-.008.151c.04.044.107.048.151.008l.922-.824a.107.107 0 0 0-.066-.187Zm8.377.003a.108.108 0 0 0-.074.035.106.106 0 0 0 .008.151l.921.826c.044.04.112.036.152-.008a.106.106 0 0 0-.008-.151l-.921-.826a.108.108 0 0 0-.078-.027Zm-7.502.784a.107.107 0 0 0-.09.044l-.73.998a.106.106 0 0 0 .024.15.108.108 0 0 0 .15-.024l.73-.998a.107.107 0 0 0-.083-.17Zm6.624.004a.107.107 0 0 0-.084.17l.728.999a.108.108 0 0 0 .15.024.106.106 0 0 0 .024-.15l-.728-.999a.107.107 0 0 0-.09-.044Zm-7.565.154a.107.107 0 0 0-.075.036l-.349.385a.106.106 0 0 0 .008.152c.044.04.112.036.152-.008l.349-.386a.107.107 0 0 0-.085-.178Zm8.512 0a.107.107 0 0 0-.086.18l.35.385c.039.044.107.048.15.008a.106.106 0 0 0 .009-.151l-.349-.386a.107.107 0 0 0-.074-.035Zm-6.552.429a.107.107 0 0 0-.1.063l-.506 1.127a.108.108 0 0 0 .196.087l.506-1.127a.107.107 0 0 0-.096-.15Zm4.585.003a.107.107 0 0 0-.096.15l.504 1.128a.107.107 0 0 0 .196-.087l-.504-1.128a.107.107 0 0 0-.1-.063Zm-5.473.345a.107.107 0 0 0-.086.053l-.26.45a.107.107 0 0 0 .186.107l.26-.45a.106.106 0 0 0-.039-.146.108.108 0 0 0-.061-.014Zm6.368 0a.107.107 0 0 0-.1.16l.26.45a.107.107 0 0 0 .186-.107l-.26-.45a.108.108 0 0 0-.086-.053Zm-4.356.016a.107.107 0 0 0-.105.085l-.258 1.207a.107.107 0 0 0 .083.127.107.107 0 0 0 .127-.082l.258-1.207a.107.107 0 0 0-.105-.13Zm2.34.001a.107.107 0 0 0-.105.13l.257 1.207c.012.057.07.094.127.082a.107.107 0 0 0 .083-.127l-.257-1.207a.107.107 0 0 0-.105-.085ZM8 13.47a.107.107 0 0 0-.108.107v1.234c0 .06.048.107.108.107s.107-.048.107-.107v-1.234A.107.107 0 0 0 8 13.47Zm-1.973.399a.107.107 0 0 0-.093.073l-.162.494a.107.107 0 0 0 .204.066l.162-.494a.107.107 0 0 0-.111-.14Zm3.945 0a.107.107 0 0 0-.111.14l.161.493a.107.107 0 0 0 .205-.066l-.162-.493a.107.107 0 0 0-.093-.074Zm-2.647.275a.107.107 0 0 0-.096.095l-.055.516a.107.107 0 0 0 .096.118.107.107 0 0 0 .118-.095l.055-.517a.107.107 0 0 0-.118-.117Zm1.345 0H8.65a.107.107 0 0 0-.096.118l.054.516a.107.107 0 0 0 .118.095.107.107 0 0 0 .096-.117l-.054-.516a.107.107 0 0 0-.097-.096Z',
        fill: '#F4F2F3',
      },
      {
        d: 'm13.039 3.683-5.882 3.4-3.719 5.827 5.44-4.01 4.16-5.217Z',
        fill: 'black',
      },
      {
        d: 'M8.843 8.84 7.157 7.085l5.98-4.004-4.294 5.76Z',
        fill: '#FF5150',
      },
      {
        d: 'M8.843 8.84 7.157 7.085l-4.294 5.76 5.98-4.003Z',
        fill: '#F1F1F1',
      },
      {
        d: 'm2.863 12.845 5.98-4.004 4.294-5.761-10.274 9.765Z',
        fill: 'black',
      },
    ],
  },
  facebook: {
    paths: [
      {
        d: 'M7.987 0C3.594 0 0 3.594 0 7.987a7.945 7.945 0 0 0 6.722 7.854V10.25H4.726V7.987h1.996v-1.73c0-1.997 1.198-3.129 2.995-3.129.666 0 1.198.067 1.798.133v1.997h-.999c-.665 0-1.264.4-1.264.998V7.987h2.196l-.333 2.33H9.252v5.59c4.326-.665 7.321-4.792 6.655-9.118C15.242 2.862 11.914 0 7.987 0Z',
        fill: '#1877F2',
      },
    ],
  },
  twitter: {
    paths: [
      {
        d: 'M16 3.54a6.77 6.77 0 0 1-1.883.516 3.285 3.285 0 0 0 1.44-1.816 6.622 6.622 0 0 1-2.084.797 3.278 3.278 0 0 0-5.584 2.99 9.29 9.29 0 0 1-6.756-3.425 3.278 3.278 0 0 0 1.012 4.377 3.218 3.218 0 0 1-1.488-.41v.041a3.284 3.284 0 0 0 2.607 3.218 3.352 3.352 0 0 1-1.474.053 3.284 3.284 0 0 0 3.063 2.28 6.623 6.623 0 0 1-4.075 1.407c-.262 0-.523 0-.778-.047a9.318 9.318 0 0 0 5.02 1.468 9.264 9.264 0 0 0 9.351-9.33v-.423A6.704 6.704 0 0 0 16 3.54Z',
        fill: '#1DA1F2',
      },
    ],
  },
  linkedin: {
    paths: [
      {
        d: 'M14.667 0H1.333A1.333 1.333 0 0 0 0 1.333v13.334A1.333 1.333 0 0 0 1.333 16h13.334A1.334 1.334 0 0 0 16 14.667V1.333A1.334 1.334 0 0 0 14.667 0Zm-10 13.647H2.353V6.12h2.354l-.04 7.527ZM3.487 4.98a1.44 1.44 0 1 1 1.44-1.44 1.44 1.44 0 0 1-1.4 1.427l-.04.013Zm10.12 8.667h-2.314V9.873c0-1.246-.246-1.933-1.153-1.933-1.233 0-1.667.94-1.667 1.933v3.774H6.12V6.12h2.233v1.12A2.627 2.627 0 0 1 10.667 6c2.213 0 2.966 1 2.966 3.373l-.026 4.274Z',
        fill: '#007BB5',
        fillRule: 'evenodd',
      },
    ],
  },
  slack: {
    paths: [
      {
        d: 'M5.866 0a1.6 1.6 0 1 0 .001 3.2h1.6V1.6c0-.882-.716-1.599-1.6-1.6Zm0 4.267H1.6a1.6 1.6 0 0 0 0 3.2h4.266a1.6 1.6 0 1 0 0-3.2Z',
        fill: '#36C5F0',
        fillRule: 'evenodd',
      },
      {
        d: 'M16 5.866a1.6 1.6 0 0 0-3.2 0v1.6h1.6a1.6 1.6 0 0 0 1.6-1.6Zm-4.266 0V1.6a1.6 1.6 0 0 0-3.2 0v4.266a1.6 1.6 0 1 0 3.2 0Z',
        fill: '#2EB67D',
        fillRule: 'evenodd',
      },
      {
        d: 'M10.133 16a1.6 1.6 0 1 0 0-3.2h-1.6v1.6a1.6 1.6 0 0 0 1.6 1.6Zm0-4.267H14.4a1.6 1.6 0 0 0 0-3.2h-4.266a1.6 1.6 0 0 0-.001 3.2Z',
        fill: '#ECB22E',
        fillRule: 'evenodd',
      },
      {
        d: 'M0 10.133a1.6 1.6 0 0 0 3.2 0v-1.6H1.6a1.6 1.6 0 0 0-1.6 1.6Zm4.267 0V14.4a1.6 1.6 0 0 0 3.2 0v-4.266a1.6 1.6 0 0 0-3.2 0Z',
        fill: '#E01E5A',
        fillRule: 'evenodd',
      },
    ],
  },
  figma: {
    paths: [
      {
        d: 'M8 8.125a2.375 2.375 0 1 1 4.75 0 2.375 2.375 0 0 1-4.75 0Z',
        fill: '#1ABCFE',
      },
      {
        d: 'M3.25 12.875A2.375 2.375 0 0 1 5.625 10.5H8v2.375a2.375 2.375 0 1 1-4.75 0Z',
        fill: '#0ACF83',
      },
      {
        d: 'M8 1v4.75h2.375a2.375 2.375 0 1 0 0-4.75H8Z',
        fill: '#FF7262',
      },
      {
        d: 'M3.25 3.375A2.375 2.375 0 0 0 5.625 5.75H8V1H5.625A2.375 2.375 0 0 0 3.25 3.375Z',
        fill: '#F24E1E',
      },
      {
        d: 'M3.25 8.125A2.375 2.375 0 0 0 5.625 10.5H8V5.75H5.625A2.375 2.375 0 0 0 3.25 8.125Z',
        fill: '#A259FF',
      },
    ],
  },
  zeroheight: {
    paths: [
      {
        d: 'm3.06 1 1.062 2.183H2L3.06 1ZM2 3.528h2.122v9.77H2v-9.77Zm0 10.114h2.122v1.188H2v-1.188ZM5.775 3.178l1.47-1.418L14 8.287 7.21 15l-1.466-1.346 5.333-5.357-5.302-5.119Z',
        fill: 'white',
      },
      {
        d: 'm3.06 1 1.062 2.183H2L3.06 1ZM2 3.528h2.122v9.77H2v-9.77Zm0 10.114h2.122v1.188H2v-1.188ZM5.775 3.178l1.47-1.418L14 8.287 7.21 15l-1.466-1.346 5.333-5.357-5.302-5.119Z',
        fill: '#ED407C',
      },
    ],
  },
  storybook: {
    paths: [
      {
        d: 'M3.386 13.244 3 2.948a.626.626 0 0 1 .586-.65l8.73-.547a.626.626 0 0 1 .664.626v11.22a.626.626 0 0 1-.653.626l-8.345-.376a.626.626 0 0 1-.596-.603Z',
        fill: 'white',
      },
      {
        d: 'M3.386 13.244 3 2.948a.626.626 0 0 1 .586-.65l8.73-.547a.626.626 0 0 1 .664.626v11.22a.626.626 0 0 1-.653.626l-8.345-.376a.626.626 0 0 1-.596-.603Z',
        fill: '#FF4785',
      },
      {
        d: 'm10.37 3.283.06-1.439 1.198-.094.052 1.484a.093.093 0 0 1-.15.076l-.463-.365-.548.417a.093.093 0 0 1-.15-.079ZM8.837 6.451c0 .244 1.638.127 1.858-.044 0-1.661-.889-2.535-2.516-2.535-1.628 0-2.54.887-2.54 2.217 0 2.317 3.117 2.361 3.117 3.625 0 .354-.173.565-.554.565-.497 0-.693-.255-.67-1.119 0-.188-1.893-.246-1.95 0-.147 2.095 1.154 2.7 2.643 2.7 1.443 0 2.574-.772 2.574-2.169 0-2.482-3.163-2.416-3.163-3.646 0-.499.37-.565.589-.565.23 0 .646.04.612.971Z',
        fill: 'white',
      },
    ],
  },
  miro: {
    paths: [
      {
        d: 'M0 0h16v16H0V0Z',
        fill: '#FFD02F',
      },
      {
        d: 'M10.903 2.133H9.195l1.516 2.35-3.206-2.35H5.797l1.517 3.08-3.206-3.08H2.4L3.89 6.11 2.4 13.867h1.708l3.206-8.319-1.517 8.319h1.708l3.206-9.048-1.516 9.048h1.708l3.23-9.939-3.23-1.795Z',
        fill: '#050038',
      },
    ],
  },
  google: {
    paths: [
      {
        d: 'M15.683 8.184c0-.544-.044-1.09-.139-1.626H8v3.08h4.32a3.703 3.703 0 0 1-1.598 2.432v1.999h2.578c1.514-1.394 2.384-3.451 2.384-5.885Z',
        fill: '#4285F4',
      },
      {
        d: 'M7.999 16c2.157 0 3.977-.709 5.303-1.931l-2.578-2c-.718.489-1.644.765-2.722.765-2.088 0-3.857-1.408-4.492-3.301H.85v2.06A8.001 8.001 0 0 0 7.999 16Z',
        fill: '#34A853',
      },
      {
        d: 'M3.507 9.533a4.792 4.792 0 0 1 0-3.063V4.41H.85a8.007 8.007 0 0 0 0 7.184l2.657-2.06Z',
        fill: '#FBBC04',
      },
      {
        d: 'M7.999 3.166a4.347 4.347 0 0 1 3.069 1.2l2.284-2.285A7.689 7.689 0 0 0 7.998.001a7.998 7.998 0 0 0-7.15 4.408L3.508 6.47c.632-1.896 2.405-3.304 4.492-3.304Z',
        fill: '#EA4335',
      },
    ],
  },
  gmail: {
    paths: [
      {
        d: 'M1.09 13.292h2.546V7.475L0 4.908v7.358c0 .567.489 1.026 1.09 1.026Z',
        fill: '#4285F4',
      },
      {
        d: 'M12.362 13.292h2.546c.602 0 1.09-.46 1.09-1.027V4.908l-3.636 2.567v5.817Z',
        fill: '#34A853',
      },
      {
        d: 'M12.362 3.026v4.449l3.636-2.567V3.54c0-.85-.732-1.54-1.636-1.54-.354 0-.698.108-.982.308l-1.018.718Z',
        fill: '#FBBC04',
      },
      {
        d: 'M3.637 7.475V3.027L8 6.107l4.363-3.08v4.448L8 10.555l-4.363-3.08Z',
        fill: '#EA4335',
      },
      {
        d: 'M0 3.54v1.368l3.637 2.567V3.027l-1.018-.719c-.723-.51-1.749-.372-2.29.308A1.48 1.48 0 0 0 0 3.54Z',
        fill: '#C5221F',
      },
    ],
  },
  google_drive: {
    paths: [
      {
        d: 'M5.206 1.019h5.563l5.231 9.1h-5.575l-5.219-9.1Z',
        fill: '#F6C338',
      },
      {
        d: 'm16 10.119-2.788 4.862H2.775l2.794-4.862h10.43Z',
        fill: '#286EE6',
      },
      {
        d: 'M2.775 14.98 0 10.12l5.206-9.1L8 5.894 2.775 14.98Z',
        fill: '#069B5A',
      },
    ],
  },
  google_analytics: {
    paths: [
      {
        d: 'M15.453 13.998a1.988 1.988 0 0 1-2.222 1.985 2.039 2.039 0 0 1-1.74-2.067V2.081A2.04 2.04 0 0 1 13.233.014a1.989 1.989 0 0 1 2.22 1.985v11.999Z',
        fill: '#F9AB00',
      },
      {
        d: 'M2.982 12.036a1.982 1.982 0 1 1 0 3.964 1.982 1.982 0 0 1 0-3.964ZM8.196 6.03a2.04 2.04 0 0 0-1.927 2.084v5.323c0 1.445.636 2.322 1.567 2.508a1.985 1.985 0 0 0 2.38-1.95V8.022A1.989 1.989 0 0 0 8.23 6.03h-.034Z',
        fill: '#E37400',
      },
    ],
  },
  google_tag_manager: {
    paths: [
      {
        d: 'm9.218 14.468-2.43-2.433 5.22-5.275 2.476 2.475-5.266 5.233Z',
        fill: '#8AB4F8',
      },
      {
        d: 'M9.236 3.988 6.76 1.512 1.513 6.76a1.749 1.749 0 0 0 0 2.475l5.248 5.248 2.428-2.439-3.966-4.043 4.013-4.013Z',
        fill: '#4285F4',
      },
      {
        d: 'M14.483 6.76 9.236 1.512A1.75 1.75 0 0 0 6.76 3.987l5.25 5.248a1.75 1.75 0 1 0 2.476-2.475h-.003Z',
        fill: '#8AB4F8',
      },
      {
        d: 'M7.979 15a1.735 1.735 0 1 0 0-3.469 1.735 1.735 0 0 0 0 3.47Z',
        fill: '#246FDB',
      },
    ],
  },
  google_optimize: {
    paths: [
      {
        d: 'M10.512 7.965c-.028-1.212-1.055-2.176-2.302-2.162H2.273v4.323h3.845v3.635c-.067 1.17.855 2.17 2.058 2.236l.079.002c1.259-.012 2.27-1.014 2.257-2.238V7.965Z',
        fill: '#B366F6',
      },
      {
        d: 'M2.247 10.175c1.24 0 2.246-.978 2.246-2.184 0-1.206-1.006-2.184-2.246-2.184C1.006 5.807 0 6.785 0 7.991c0 1.206 1.006 2.184 2.247 2.184Z',
        fill: '#8430CE',
      },
      {
        d: 'M15.994 2.173C15.982.969 14.975 0 13.737 0H7.664C6.51.113 5.633 1.056 5.633 2.184c0 1.127.877 2.07 2.031 2.183h3.89v3.631c-.05 1.193.905 2.2 2.132 2.248 1.227.048 2.262-.88 2.312-2.072a1.907 1.907 0 0 0 0-.175l-.004-5.826Z',
        fill: '#C58AF8',
      },
    ],
  },
  google_optimize_alt: {
    paths: [
      {
        d: 'M10.512 7.965c-.028-1.212-1.055-2.176-2.302-2.162H2.273v4.323h3.845v3.635c-.067 1.17.855 2.17 2.058 2.236l.079.002c1.259-.012 2.27-1.014 2.257-2.238V7.965Z',
        fill: '#8D8D8D',
      },
      {
        d: 'M2.247 10.175c1.24 0 2.246-.978 2.246-2.184 0-1.206-1.006-2.184-2.246-2.184C1.006 5.807 0 6.785 0 7.991c0 1.206 1.006 2.184 2.247 2.184Z',
        fill: '#5B5B5B',
      },
      {
        d: 'M15.994 2.173C15.982.969 14.975 0 13.737 0H7.664C6.51.113 5.633 1.056 5.633 2.184c0 1.127.877 2.07 2.031 2.183h3.89v3.631c-.05 1.193.905 2.2 2.132 2.248 1.227.048 2.262-.88 2.312-2.072a1.907 1.907 0 0 0 0-.175l-.004-5.826Z',
        fill: '#A8A8A8',
      },
    ],
  },
  jira: {
    paths: [
      {
        d: 'M15.806 7.552 8.69.667 7.999 0 2.641 5.183l-2.45 2.37A.625.625 0 0 0 0 8c0 .168.069.329.191.448l4.895 4.735L8 16l5.357-5.183.084-.08 2.367-2.286a.633.633 0 0 0 .193-.45.616.616 0 0 0-.194-.449ZM8 10.366 5.553 8 8 5.634 10.444 8l-2.445 2.366Z',
        fill: '#2684FF',
      },
      {
        d: 'M7.605 6.006 7.61 6 8 5.624A3.908 3.908 0 0 1 6.794 2.82a3.86 3.86 0 0 1 .164-1.126c.19-.63.539-1.21 1.024-1.685l-1.59 1.537-.047.508-.028.305a4.4 4.4 0 0 0 .943 3.192l.12.154.23.295-.006.005Z',
        fill: '#0156D3',
        fillRule: 'evenodd',
      },
      {
        d: 'm8.395 10.008-.006.006-.389.377a3.908 3.908 0 0 1 1.206 2.804 3.86 3.86 0 0 1-.164 1.125c-.19.63-.539 1.21-1.024 1.686l1.59-1.538.047-.508.028-.305a4.399 4.399 0 0 0-.943-3.191l-.12-.154a94.727 94.727 0 0 0-.23-.296l.006-.004v-.002Z',
        fill: '#0156D3',
        fillRule: 'evenodd',
      },
    ],
  },
  confluence: {
    paths: [
      {
        d: 'M.579 12.184c-.165.28-.35.605-.508.864a.541.541 0 0 0 .17.719l3.301 2.114a.491.491 0 0 0 .388.064.51.51 0 0 0 .316-.244c.132-.23.302-.528.488-.848 1.307-2.246 2.623-1.971 4.995-.793l3.273 1.62a.49.49 0 0 0 .396.019.517.517 0 0 0 .287-.283l1.572-3.7a.537.537 0 0 0-.253-.692c-.691-.338-2.065-1.012-3.302-1.633C7.252 7.14 3.472 7.287.58 12.184Z',
        fill: '#2684FF',
      },
      {
        d: 'M15.382 3.787c.165-.28.35-.605.508-.864a.541.541 0 0 0-.17-.719L12.418.09a.492.492 0 0 0-.398-.076.51.51 0 0 0-.325.25c-.132.23-.303.53-.488.849-1.308 2.246-2.623 1.971-4.995.793L2.948.294a.49.49 0 0 0-.395-.019.517.517 0 0 0-.288.283l-1.572 3.7a.537.537 0 0 0 .254.692c.691.339 2.065 1.012 3.302 1.634 4.46 2.246 8.24 2.095 11.133-2.797Z',
        fill: '#2684FF',
      },
    ],
  },
  trello: {
    paths: [
      {
        d: 'M13.998 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h11.998A2 2 0 0 0 16 14V2a2 2 0 0 0-2.002-2Zm-7.04 12.117a.963.963 0 0 1-.962.95h-2.96a.96.96 0 0 1-.959-.96V3.035a.96.96 0 0 1 .96-.96h2.96a.962.962 0 0 1 .962.96v9.082Zm6.96-4a.959.959 0 0 1-.96.96h-2.96a.96.96 0 0 1-.96-.96V3.035a.96.96 0 0 1 .96-.96h2.96a.96.96 0 0 1 .96.96v5.082Z',
        fill: '#2684FF',
      },
    ],
  },
  outlook: {
    paths: [
      {
        d: 'M16 7.814a.357.357 0 0 0-.17-.307h-.002l-.007-.004-5.544-3.282a.744.744 0 0 0-.831 0L3.9 7.503l-.006.004a.361.361 0 0 0 .008.619l5.544 3.282c.024.016.05.03.075.044a.745.745 0 0 0 .757-.044l5.544-3.282A.357.357 0 0 0 16 7.814Z',
        fill: '#0A2767',
      },
      {
        d: 'M4.548 5.623h3.638v3.335H4.548V5.623Zm10.708-3.39V.707A.691.691 0 0 0 14.58 0H5.14a.691.691 0 0 0-.675.707v1.526l5.581 1.488 5.21-1.488Z',
        fill: '#0364B8',
      },
      {
        d: 'M4.465 2.233h3.721v3.349h-3.72v-3.35Z',
        fill: '#0078D4',
      },
      {
        d: 'M11.907 2.233H8.186v3.349l3.721 3.348h3.349V5.582l-3.349-3.35Z',
        fill: '#28A8EA',
      },
      {
        d: 'M8.186 5.581h3.721v3.35H8.186V5.58Z',
        fill: '#0078D4',
      },
      {
        d: 'M8.186 8.93h3.721v3.349H8.186V8.93Z',
        fill: '#0364B8',
      },
      {
        d: 'M4.548 8.958h3.638v3.032H4.548V8.958Z',
        fill: '#14447D',
      },
      {
        d: 'M11.907 8.93h3.349v3.349h-3.349V8.93Z',
        fill: '#0078D4',
      },
      {
        d: 'm15.83 8.105-.008.004-5.544 3.118a.772.772 0 0 1-.375.116l-.303-.177a.76.76 0 0 1-.074-.043L3.907 7.917h-.002l-.184-.103v6.312c.003.421.346.76.768.758h10.755c.007 0 .012-.003.019-.003a.94.94 0 0 0 .26-.055.746.746 0 0 0 .105-.054.751.751 0 0 0 .372-.646V7.814c0 .12-.065.232-.17.291Z',
        fill: 'url(#paint0_linear_4686_8850)',
      },
      {
        d: 'M15.702 7.789v.387l-5.797 3.991L3.903 7.92a.004.004 0 0 0-.003-.004l-.551-.33v-.28l.227-.003.48.275.011.004.04.026 5.657 3.226.216.126a.967.967 0 0 1 .06-.022c.01-.008 5.6-3.152 5.6-3.152l.062.004Z',
        fill: '#1E4498',
      },
      {
        d: 'm15.83 8.105-.008.004-5.544 3.118a.777.777 0 0 1-.831 0L3.903 8.11l-.007-.004a.335.335 0 0 1-.175-.291v6.312c.003.421.346.76.767.758h10.745a.762.762 0 0 0 .767-.758V7.814c0 .12-.065.232-.17.291Z',
        fill: '#1490DF',
      },
      {
        d: 'm10.735 10.97-.459.258a.771.771 0 0 1-.367.12l.989 2.724 4.801.655c.19-.142.3-.364.301-.6v-.082l-5.265-3.075Z',
        fill: '#158CCE',
      },
      {
        d: 'M4.499 14.884h10.733a.771.771 0 0 0 .46-.15L9.6 11.168a.74.74 0 0 1-.074-.043L3.907 7.917h-.003l-.183-.103v6.29c0 .43.348.78.778.78Z',
        fill: '#28A8EA',
      },
      {
        d: 'M8.558 4.03v7.938c.001.09-.018.178-.056.26a.678.678 0 0 1-.625.423H3.721V3.35h4.156a.625.625 0 0 1 .31.078.676.676 0 0 1 .371.604Z',
        fill: '#1279AA',
      },
      {
        d: 'M8.558 4.03v7.193a.687.687 0 0 1-.68.684H3.72V3.349h4.156a.625.625 0 0 1 .31.078.676.676 0 0 1 .371.604Z',
        fill: '#0F6188',
      },
      {
        d: 'M8.186 4.03v7.193a.684.684 0 0 1-.68.684H3.72V3.349h3.784a.681.681 0 0 1 .681.682Z',
        fill: '#154F86',
      },
      {
        d: 'M.682 3.349h6.822c.377 0 .682.305.682.682v6.822a.682.682 0 0 1-.682.682H.682A.682.682 0 0 1 0 10.853V4.03c0-.377.305-.682.682-.682Z',
        fill: '#1784D9',
      },
      {
        d: 'M2.132 6.21c.168-.359.44-.658.779-.861a2.355 2.355 0 0 1 1.238-.31c.401-.01.798.093 1.145.294.327.195.59.48.758.822.183.377.274.791.266 1.21.009.437-.085.87-.273 1.265-.172.354-.444.65-.782.85a2.28 2.28 0 0 1-1.188.303 2.24 2.24 0 0 1-1.171-.298 1.997 1.997 0 0 1-.768-.824 2.59 2.59 0 0 1-.269-1.195 2.877 2.877 0 0 1 .265-1.256Zm.83 2.02c.09.226.242.423.439.566.2.14.44.213.684.206a1.2 1.2 0 0 0 .731-.212c.194-.143.342-.34.426-.567.093-.252.139-.52.135-.79a2.405 2.405 0 0 0-.128-.8 1.265 1.265 0 0 0-.412-.59 1.132 1.132 0 0 0-.724-.223 1.181 1.181 0 0 0-.7.208c-.201.144-.356.342-.447.571a2.27 2.27 0 0 0-.003 1.632V8.23Z',
        fill: 'white',
      },
      {
        d: 'M11.907 2.233h3.349v3.349h-3.349v-3.35Z',
        fill: '#50D9FF',
      },
    ],
  },
  microsoft_teams: {
    paths: [
      {
        d: 'M11.16 6.58h4.133c.39 0 .707.317.707.707v3.764a2.598 2.598 0 0 1-2.598 2.598h-.012a2.598 2.598 0 0 1-2.6-2.597V6.95a.37.37 0 0 1 .37-.37Z',
        fill: '#5059C9',
      },
      {
        d: 'M13.954 5.837a1.674 1.674 0 1 0 0-3.349 1.674 1.674 0 0 0 0 3.349Z',
        fill: '#5059C9',
      },
      {
        d: 'M8.744 5.837a2.418 2.418 0 1 0 0-4.837 2.418 2.418 0 0 0 0 4.837Z',
        fill: '#7B83EB',
      },
      {
        d: 'M11.969 6.58H5.147a.7.7 0 0 0-.682.716v4.293a4.196 4.196 0 0 0 4.093 4.293 4.197 4.197 0 0 0 4.093-4.293V7.296a.7.7 0 0 0-.682-.715Z',
        fill: '#7B83EB',
      },
      {
        d: 'M8.558 6.58v6.389a.685.685 0 0 1-.68.68h-2.91a4.829 4.829 0 0 1-.176-.372 4.53 4.53 0 0 1-.327-1.689V7.295a.698.698 0 0 1 .681-.714h3.412Z',
        fill: '#616BBE',
      },
      {
        d: 'M8.558 6.58v5.645a.686.686 0 0 1-.68.68H4.661a4.53 4.53 0 0 1-.197-1.317V7.295a.698.698 0 0 1 .681-.714h3.412Z',
        fill: '#4D5598',
      },
      {
        d: 'M8.186 6.58v5.645a.686.686 0 0 1-.681.68H4.662a4.53 4.53 0 0 1-.197-1.317V7.295a.698.698 0 0 1 .681-.714h3.04Z',
        fill: '#404681',
      },
      {
        d: 'M8.558 5.03v.8a2.419 2.419 0 0 1-2.047-1.48h1.366c.376 0 .68.304.681.68Z',
        fill: 'black',
      },
      {
        d: 'M8.558 5.03v.8a2.419 2.419 0 0 1-2.047-1.48h1.366c.376 0 .68.304.681.68Z',
        fill: '#4D5598',
      },
      {
        d: 'M8.186 5.03v.74a2.419 2.419 0 0 1-1.674-1.422h.993c.376.002.68.306.681.681Z',
        fill: 'black',
      },
      {
        d: 'M.682 4.348h6.822c.377 0 .682.306.682.682v6.821a.682.682 0 0 1-.682.682H.682A.682.682 0 0 1 0 11.851v-6.82c0-.377.305-.683.682-.683Z',
        fill: '#4A55BD',
      },
      {
        d: 'M5.888 6.944H4.524v3.713h-.869V6.944H2.298v-.72h3.59v.72Z',
        fill: 'white',
      },
    ],
  },
  excel: {
    paths: [
      {
        d: 'M10.046 8.07 3.721 6.953v8.249c0 .376.305.682.682.682h10.915a.682.682 0 0 0 .682-.682v-3.04L10.046 8.07Z',
        fill: '#185C37',
      },
      {
        d: 'M10.046 1H4.404a.682.682 0 0 0-.682.682v3.039l6.325 3.72 3.35 1.117L16 8.442V4.72L10.046 1Z',
        fill: '#21A366',
      },
      {
        d: 'M3.721 4.721h6.325v3.72H3.721v-3.72Z',
        fill: '#107C41',
      },
      {
        d: 'M7.876 4.349H3.721v9.302h4.155a.684.684 0 0 0 .682-.682V5.031a.684.684 0 0 0-.682-.682Z',
        fill: '#0F4126',
      },
      {
        d: 'M7.876 4.349H3.721v8.558h4.155a.684.684 0 0 0 .682-.682V5.031a.684.684 0 0 0-.682-.682Z',
        fill: '#0C341E',
      },
      {
        d: 'M7.504 4.349H3.721v8.558h3.783a.684.684 0 0 0 .682-.682V5.031a.684.684 0 0 0-.682-.682Z',
        fill: '#072515',
      },
      {
        d: 'M.682 4.349h6.822c.377 0 .682.305.682.682v6.822a.682.682 0 0 1-.682.682H.682A.682.682 0 0 1 0 11.853V5.03c0-.377.305-.682.682-.682Z',
        fill: '#007A3F',
      },
      {
        d: 'm2.112 10.659 1.435-2.223-1.315-2.211H3.29l.717 1.414c.067.134.112.234.137.3h.009c.047-.108.097-.212.149-.313l.767-1.4h.97L4.691 8.422l1.383 2.236H5.04l-.829-1.552a1.302 1.302 0 0 1-.099-.207h-.012a.981.981 0 0 1-.096.2l-.853 1.559h-1.04Z',
        fill: 'white',
      },
      {
        d: 'M15.318 1h-5.271v3.72H16V1.683A.682.682 0 0 0 15.318 1Z',
        fill: '#33C481',
      },
      {
        d: 'M10.047 8.442H16v3.72h-5.953v-3.72Z',
        fill: '#107C41',
      },
    ],
  },
  optimizely: {
    paths: [
      {
        d: 'M5.371 8.695v1.89a5.277 5.277 0 0 0 5.27-5.272H8.759A3.387 3.387 0 0 1 5.37 8.695Z',
        fill: '#3BE081',
      },
      {
        d: 'M5.371 13.901a3.357 3.357 0 0 1 0-6.712V5.314a5.233 5.233 0 1 0-.015 10.467h.015v-1.88Z',
        fill: '#0037FF',
      },
      {
        d: 'M5.371 13.901v1.875a5.233 5.233 0 0 0 5.233-5.233H8.728A3.36 3.36 0 0 1 5.37 13.9Z',
        fill: '#00CCFF',
      },
      {
        d: 'M5.371 3.438v1.875A5.233 5.233 0 0 0 10.604.08H8.728A3.36 3.36 0 0 1 5.37 3.438Z',
        fill: '#861DFF',
      },
      {
        d: 'M10.636 3.438v1.875A5.234 5.234 0 0 0 15.87.08H13.99a3.36 3.36 0 0 1-3.354 3.358Z',
        fill: '#FC7F10',
      },
    ],
  },
  optimizely_alt: {
    paths: [
      {
        d: 'M5.371 8.695v1.89a5.277 5.277 0 0 0 5.27-5.272H8.759A3.387 3.387 0 0 1 5.37 8.695Z',
        fill: '#A4A4A4',
      },
      {
        d: 'M5.371 13.901a3.357 3.357 0 0 1 0-6.712V5.314a5.233 5.233 0 1 0-.015 10.467h.015v-1.88Z',
        fill: '#3C3C3C',
      },
      {
        d: 'M5.371 13.901v1.875a5.233 5.233 0 0 0 5.233-5.233H8.728A3.36 3.36 0 0 1 5.37 13.9Z',
        fill: '#949494',
      },
      {
        d: 'M5.371 3.438v1.875A5.233 5.233 0 0 0 10.604.08H8.728A3.36 3.36 0 0 1 5.37 3.438Z',
        fill: '#555555',
      },
      {
        d: 'M10.636 3.438v1.875A5.234 5.234 0 0 0 15.87.08H13.99a3.36 3.36 0 0 1-3.354 3.358Z',
        fill: '#989898',
      },
    ],
  },
  gitlab: {
    paths: [
      {
        d: 'm8 15 2.762-8.613H5.238L8 15Z',
        fill: '#E24329',
      },
      {
        d: 'M8 15 5.238 6.387h-3.87L8 15Z',
        fill: '#FC6D26',
      },
      {
        d: 'M1.367 6.387.528 9.005a.587.587 0 0 0 .208.648L8 15 1.367 6.388Z',
        fill: '#FCA326',
      },
      {
        d: 'M1.367 6.387h3.87L3.575 1.2a.285.285 0 0 0-.543 0L1.367 6.387Z',
        fill: '#E24329',
      },
      {
        d: 'm8 15 2.761-8.613h3.871L8 15Z',
        fill: '#FC6D26',
      },
      {
        d: 'm14.633 6.387.839 2.618a.587.587 0 0 1-.208.648L8 15l6.633-8.612Z',
        fill: '#FCA326',
      },
      {
        d: 'M14.633 6.387h-3.871L12.425 1.2a.285.285 0 0 1 .544 0l1.664 5.187Z',
        fill: '#E24329',
      },
    ],
  },
  omniconvert: {
    paths: [
      {
        d: 'M12.323 6.035v.004a5.092 5.092 0 0 0-1.332-.015c-.352.043-.942.229-1.205.312l-.011.003c.19-.105.773-.372 1.274-.5.465-.12.976-.185 1.375-.173a4.537 4.537 0 1 0-8.682.357H3.74c.12.327.351.77.623 1.146.208.287.657.714.857.904l.009.008a6.677 6.677 0 0 1-1.056-.872 5.256 5.256 0 0 1-.809-1.102 4.539 4.539 0 0 0 1.172 8.92A4.527 4.527 0 0 0 8 13.421l.003.004c.223-.267.493-.69.682-1.115.145-.324.29-.926.354-1.194l.003-.011c-.008.217-.08.854-.227 1.35a5.253 5.253 0 0 1-.55 1.252 4.537 4.537 0 1 0 4.06-7.672ZM10.39 4.494a2.376 2.376 0 1 1-4.752 0 2.376 2.376 0 0 1 4.752 0Zm-3.492 6.04a2.376 2.376 0 1 1-4.751 0 2.376 2.376 0 0 1 4.751 0Zm4.608 2.375a2.376 2.376 0 1 0 0-4.751 2.376 2.376 0 0 0 0 4.751Z',
        fill: '#1661D4',
        fillRule: 'evenodd',
      },
    ],
  },
  segment: {
    paths: [
      {
        d: 'M9.974 11.149H.768a.768.768 0 1 1 0-1.537h9.206a.768.768 0 1 1 0 1.537Zm5.258-3.904H6.027a.768.768 0 1 1 0-1.536h9.205a.768.768 0 1 1 0 1.536ZM13.329 3.55a.768.768 0 1 1-1.537 0 .768.768 0 0 1 1.537 0Zm-9.121 9.76a.768.768 0 1 1-1.537 0 .768.768 0 0 1 1.537 0Z',
        fill: '#93C8A2',
      },
      {
        d: 'M7.996 15.845c-.75 0-1.49-.111-2.2-.331a.768.768 0 0 1 .454-1.468 5.88 5.88 0 0 0 1.746.263 5.855 5.855 0 0 0 5.63-4.162.767.767 0 1 1 1.468.45 7.384 7.384 0 0 1-7.098 5.248ZM1.632 7.24a.768.768 0 0 1-.735-.993A7.383 7.383 0 0 1 7.996 1c.75 0 1.49.111 2.2.332a.768.768 0 1 1-.455 1.467 5.94 5.94 0 0 0-1.745-.261A5.855 5.855 0 0 0 2.366 6.7a.768.768 0 0 1-.734.543V7.24Z',
        fill: '#43AF79',
      },
    ],
  },
  zapier_small: {
    paths: [
      {
        d: 'M13.6 0H2.4A2.4 2.4 0 0 0 0 2.4v11.2A2.4 2.4 0 0 0 2.4 16h11.2a2.4 2.4 0 0 0 2.4-2.4V2.4A2.4 2.4 0 0 0 13.6 0Z',
        fill: '#FF4F00',
      },
      {
        d: 'M13.6 10.4H2.4v3.2h11.2v-3.2Z',
        fill: '#FFFDF9',
      },
    ],
  },
  zapier: {
    paths: [
      {
        d: 'M14.08 0H1.92C.86 0 0 .86 0 1.92v12.16C0 15.14.86 16 1.92 16h12.16c1.06 0 1.92-.86 1.92-1.92V1.92C16 .86 15.14 0 14.08 0Z',
        fill: '#FF4F00',
      },
      {
        d: 'm2.411 13.016-.002-.007 1.443-1.32v-.637H1.537v.636H2.92l.002.006-1.429 1.322v.636h2.382v-.636H2.41Z',
        fill: '#FFFDF9',
      },
      {
        d: 'M5.296 10.991c-.267 0-.485.04-.653.12a.856.856 0 0 0-.379.333c-.086.147-.14.31-.159.48l.703.099c.025-.15.076-.256.152-.319a.466.466 0 0 1 .302-.093c.142 0 .246.038.31.114a.484.484 0 0 1 .096.321v.07h-.675c-.344 0-.59.076-.74.228-.151.152-.226.354-.226.604 0 .256.075.446.225.571.15.125.339.187.566.187.281 0 .498-.097.65-.291.09-.12.153-.256.188-.4h.025l.097.636h.636v-1.612c0-.333-.088-.59-.263-.774-.176-.183-.46-.274-.855-.274Zm.222 1.986a.6.6 0 0 1-.397.127c-.136 0-.23-.024-.283-.072a.232.232 0 0 1-.08-.18.238.238 0 0 1 .066-.176.244.244 0 0 1 .181-.066h.664v.043a.404.404 0 0 1-.15.324Z',
        fill: '#FFFDF9',
      },
      {
        d: 'M10.262 11.052H9.51v2.6h.752v-2.6Z',
        fill: '#FFFDF9',
      },
      {
        d: 'M14.7 11.052a.613.613 0 0 0-.502.225c-.087.107-.154.266-.2.477h-.022l-.098-.702h-.642v2.6h.751V12.32c0-.169.04-.297.118-.387.08-.09.224-.135.436-.135h.286v-.745H14.7Z',
        fill: '#FFFDF9',
      },
      {
        d: 'M12.49 11.137c-.176-.105-.398-.157-.665-.157-.42 0-.75.12-.987.36-.238.24-.357.57-.357.99-.006.255.05.507.162.736.103.203.263.372.46.485.2.115.437.173.712.173.237 0 .436-.036.595-.11a.958.958 0 0 0 .379-.299c.093-.128.163-.272.205-.425l-.647-.181a.6.6 0 0 1-.153.264c-.073.073-.196.11-.368.11-.204 0-.357-.06-.457-.176a.677.677 0 0 1-.139-.362h1.774c.007-.073.011-.135.011-.184v-.162a1.442 1.442 0 0 0-.131-.631.988.988 0 0 0-.395-.431Zm-.687.463c.305 0 .478.15.52.45h-1.08a.62.62 0 0 1 .121-.274c.1-.117.246-.176.44-.176Z',
        fill: '#FFFDF9',
      },
      {
        d: 'M9.894 10.003a.423.423 0 0 0-.307.119.406.406 0 0 0-.12.304.413.413 0 0 0 .427.428.407.407 0 0 0 .423-.428.408.408 0 0 0-.258-.395.406.406 0 0 0-.164-.027Z',
        fill: '#FFFDF9',
      },
      {
        d: 'M8.341 10.98c-.256 0-.461.08-.617.242-.115.119-.2.297-.253.533h-.024l-.099-.702h-.642V14.4h.752V13.02h.028c.022.092.055.182.096.267.063.14.167.256.299.335.136.074.289.11.444.107.315 0 .554-.123.719-.368.165-.245.247-.587.247-1.026 0-.424-.08-.756-.239-.996-.16-.24-.396-.36-.71-.36Zm.077 1.885c-.088.127-.225.19-.412.19a.486.486 0 0 1-.403-.183c-.097-.123-.146-.29-.146-.502v-.05c0-.215.049-.38.146-.495a.495.495 0 0 1 .403-.17c.19 0 .328.06.414.181.086.12.13.289.13.505 0 .223-.044.398-.132.524Z',
        fill: '#FFFDF9',
      },
    ],
  },
  hubspot: {
    paths: [
      {
        d: 'M12.095 5.268V3.363a1.467 1.467 0 0 0 .846-1.323v-.043c0-.81-.657-1.467-1.468-1.467h-.043c-.81 0-1.468.656-1.468 1.467v.043a1.467 1.467 0 0 0 .846 1.323v1.905c-.723.111-1.405.411-1.975.87l-5.226-4.07c.038-.135.057-.273.06-.412a1.653 1.653 0 1 0-1.656 1.65c.286-.001.567-.078.814-.221l5.146 4.004a4.168 4.168 0 0 0 .063 4.694L6.47 13.35a1.346 1.346 0 0 0-.39-.064 1.358 1.358 0 1 0 1.358 1.358 1.34 1.34 0 0 0-.064-.39l1.548-1.55a4.175 4.175 0 1 0 3.174-7.435Zm-.642 6.267a2.142 2.142 0 1 1 0-4.283 2.142 2.142 0 0 1 .002 4.282',
        fill: '#FF7A59',
      },
    ],
  },
  woo_commerce: {
    paths: [
      {
        d: 'M1.485 4H14.51A1.49 1.49 0 0 1 16 5.491v4.972a1.49 1.49 0 0 1-1.491 1.491h-4.67l.64 1.57-2.819-1.57H1.492A1.49 1.49 0 0 1 0 10.463V5.49A1.485 1.485 0 0 1 1.485 4Z',
        fill: '#7F54B3',
      },
      {
        d: 'M.911 5.36c.091-.124.228-.19.41-.202.332-.026.52.13.566.468.201 1.36.423 2.51.657 3.454l1.424-2.713c.13-.247.293-.377.488-.39.286-.02.462.163.533.547.163.865.371 1.6.618 2.224.17-1.652.455-2.842.859-3.577a.5.5 0 0 1 .429-.287.565.565 0 0 1 .41.13.51.51 0 0 1 .201.371.564.564 0 0 1-.065.313c-.253.468-.461 1.255-.63 2.347-.163 1.06-.222 1.887-.183 2.479a.772.772 0 0 1-.078.429.42.42 0 0 1-.344.234c-.17.013-.345-.065-.514-.24-.605-.619-1.086-1.542-1.438-2.771-.422.832-.735 1.456-.936 1.873-.384.735-.71 1.112-.982 1.131-.176.013-.325-.136-.456-.448C1.55 9.88 1.191 8.234.807 5.795a.554.554 0 0 1 .104-.436ZM14.89 6.38a1.498 1.498 0 0 0-1.04-.754 1.708 1.708 0 0 0-.352-.04c-.624 0-1.132.326-1.529.977a3.447 3.447 0 0 0-.507 1.834c0 .5.104.93.312 1.287.235.41.58.657 1.04.755.124.026.242.039.352.039.631 0 1.138-.325 1.529-.976.338-.559.507-1.17.507-1.84.006-.508-.104-.93-.312-1.282Zm-.82 1.802c-.09.43-.253.748-.494.963-.189.169-.364.24-.527.208-.156-.033-.286-.17-.384-.423a1.652 1.652 0 0 1-.117-.592c0-.162.013-.325.046-.475.058-.266.169-.526.345-.774.214-.318.442-.448.676-.403.156.033.286.17.384.423.078.202.117.403.117.592 0 .169-.013.331-.046.481ZM10.817 6.38a1.512 1.512 0 0 0-1.04-.754 1.708 1.708 0 0 0-.352-.04c-.624 0-1.131.326-1.528.977a3.446 3.446 0 0 0-.507 1.834c0 .5.104.93.312 1.287.234.41.579.657 1.04.755.124.026.241.039.352.039.63 0 1.138-.325 1.528-.976.338-.559.507-1.17.507-1.84 0-.508-.104-.93-.312-1.282Zm-.826 1.802c-.09.43-.253.748-.494.963-.189.169-.364.24-.527.208-.156-.033-.286-.17-.384-.423a1.65 1.65 0 0 1-.117-.592c0-.162.013-.325.046-.475.058-.266.169-.526.344-.774.215-.318.443-.448.677-.403.156.033.286.17.384.423.078.202.117.403.117.592a1.92 1.92 0 0 1-.046.481Z',
        fill: 'white',
      },
    ],
  },
  squarespace: {
    paths: [
      {
        d: 'M9.91 4.224a.675.675 0 0 0-.955 0L4.657 8.523a1.351 1.351 0 0 1-1.91-1.911l4.215-4.216a1.35 1.35 0 0 0-1.91 0l-3.26 3.26a2.702 2.702 0 0 0 3.82 3.822L9.91 5.179a.676.676 0 0 0 0-.955Zm1.433-1.433a2.701 2.701 0 0 0-3.82 0L3.223 7.09a.676.676 0 0 0 .955.955l4.299-4.298a1.35 1.35 0 0 1 1.91 0 .676.676 0 0 0 .955-.956Zm1.433 4.299a.676.676 0 0 0-.955 0l-4.299 4.298a1.351 1.351 0 0 1-1.91 0 .675.675 0 1 0-.955.955 2.701 2.701 0 0 0 3.82 0l4.299-4.298a.676.676 0 0 0 0-.955Zm1.433-1.433a2.702 2.702 0 0 0-3.82 0l-4.3 4.298a.675.675 0 1 0 .956.956l4.298-4.299a1.35 1.35 0 1 1 1.91 1.91l-4.215 4.216a1.351 1.351 0 0 0 1.91 0l3.26-3.26a2.702 2.702 0 0 0 0-3.821Z',
        fill: '#1A1918',
      },
    ],
  },
  magento: {
    paths: [
      {
        d: 'M8.79 5.19v7.955l-.794.479-.794-.481V5.196L5.145 6.444v6.804l2.851 1.72 2.875-1.733V6.44L8.79 5.19ZM7.996 1 2 4.58v6.806l1.557.904V5.485l4.44-2.662 4.445 2.658.018.01-.002 6.789L14 11.386V4.58L7.996 1Z',
        fill: '#EC6737',
      },
    ],
  },
  drupal: {
    paths: [
      {
        d: 'M5.975 3.258C3.562 4.295 2.043 6.33 2.043 8.945c0 3.342 2.676 6.051 5.977 6.051 3.3 0 5.976-2.71 5.976-6.05 0-4.019-3.687-5.616-3.687-5.616s-.805-.339-1.256-.643c0 0-.569-.352-1.56-1.647 0 0 .022 1.472-1.518 2.218',
        fill: '#136DA9',
      },
      {
        d: 'M7.421 13.825c-.21-.148-.16-.618.409-.282 0 0 1.211.9 3.129-.18.149-.084.332.212-.142.484 0 0-1.938 1.004-3.396-.022Z',
        fill: '#F0F0F0',
      },
      {
        d: 'M7.421 13.825c-.21-.148-.16-.618.409-.282 0 0 1.211.9 3.129-.18.149-.084.332.212-.142.484 0 0-1.938 1.004-3.396-.022Z',
        fill: 'white',
      },
      {
        d: 'M9.892 12.33c.705.084.463.428.652.48.385.109.22-.317.22-.317-.285-.576-.777-.54-.777-.54-.77-.12-1.345.624-1.345.624-.142.318.057.334.13.3.373-.174.6-.608 1.12-.546Z',
        fill: '#F0F0F0',
      },
      {
        d: 'M9.892 12.33c.705.084.463.428.652.48.385.109.22-.317.22-.317-.285-.576-.777-.54-.777-.54-.77-.12-1.345.624-1.345.624-.142.318.057.334.13.3.373-.174.6-.608 1.12-.546Z',
        fill: 'white',
      },
      {
        d: 'M2.827 11.988s2.142 1.795 7.357-2.204c0 0 2.62-1.665 2.54-4.52 0 0-.847-1.232-2.277-1.868-.204-.091-1.99-1.078-2.956-2.316 0 0-.175 3.591-4.719 5.01 0 0-1.145 1.71-.52 4.488 0 0 .399 1.127.575 1.41Z',
        fill: '#008ECE',
      },
      {
        d: 'M6.223 12.655s-1.777.048-1.564-1.872c0 0 .371-2.16 2.868-1.68 0 0 .545.12 1.565.912 0 0 .672.525 1.042.515 0 0 .288.028.886-.355 0 0 1.218-.952 1.644-.924.01.001.86-.094.86 1.292 0 0 .016 1.528-1.122 2.04 0 0-.3.104-.624-.24 0 0-.932-1.072-1.39-1.248 0 0-.265-.105-.617.024 0 0-.23.024-1.17.656 0 0-1.58 1-2.378.88Z',
        fill: '#F0F0F0',
      },
      {
        d: 'M6.223 12.655s-1.777.048-1.564-1.872c0 0 .371-2.16 2.868-1.68 0 0 .545.12 1.565.912 0 0 .672.525 1.042.515 0 0 .288.028.886-.355 0 0 1.218-.952 1.644-.924.01.001.86-.094.86 1.292 0 0 .016 1.528-1.122 2.04 0 0-.3.104-.624-.24 0 0-.932-1.072-1.39-1.248 0 0-.265-.105-.617.024 0 0-.23.024-1.17.656 0 0-1.58 1-2.378.88Z',
        fill: 'white',
      },
      {
        d: 'M7.164 5.767c1.151-1.669.325-4.736.325-4.736-.101 1.664-1.488 2.213-1.488 2.213-2.482 1.085-3.23 2.797-3.23 2.797.532.764 1.944 3.278 4.393-.274Z',
        fill: '#008ECE',
      },
      {
        d: 'M7.49 1.031s.15 1.4-.601 1.856c0 0-1.204.568-1.572.754 0 0-1.545.944-2.055 1.832 0 0-1.09 1.477.415 1.128 0 0 2.722-.778 3.828-3.126 0 0 .065-.198-.142-.402 0 0 .83-.634.127-2.042Z',
        fill: '#A0D8F1',
      },
      {
        d: 'M7.49 1.031s.062.956-.722 1.749c0 0-.236.335-1.451.86 0 0-1.392.735-2.016 1.754 0 0-.925 1.13.343.827 0 0 2.57-.959 3.51-2.72 0 0 .128-.184-.066-.375 0 0 .922-.729.402-2.095Z',
        fill: 'white',
      },
    ],
  },
  click_funnel: {
    paths: [
      {
        d: 'M14.2 2H1.8c-.439 0-.8.371-.8.823v10.354c0 .452.361.823.8.823h12.4c.439 0 .8-.371.8-.823V2.823A.816.816 0 0 0 14.2 2Zm-.758.79c.28 0 .51.238.51.526a.52.52 0 0 1-.51.524.52.52 0 0 1-.511-.524.52.52 0 0 1 .51-.525Zm-1.822 0c.28 0 .51.238.51.526a.52.52 0 0 1-.51.524.52.52 0 0 1-.511-.524.52.52 0 0 1 .51-.525Zm-1.823 0c.28 0 .511.238.511.526a.52.52 0 0 1-.51.524.52.52 0 0 1-.511-.524.52.52 0 0 1 .51-.525Zm4.175 10.145H2.022V4.55h11.95v8.386Z',
        fill: '#394C60',
      },
      {
        d: 'M5.747 12.044a.736.736 0 0 1 .355-.31c.147-.06.31-.07.464-.027a.541.541 0 0 0 .606-.17.576.576 0 0 0 .106-.2.624.624 0 0 0-.012-.455.6.6 0 0 0-.315-.319.697.697 0 0 1-.324-.314.726.726 0 0 1-.07-.453.702.702 0 0 1 .224-.416.668.668 0 0 1 .43-.173.59.59 0 0 0 .413-.183.622.622 0 0 0-.003-.858.589.589 0 0 0-.42-.18h-.01a.695.695 0 0 1-.434-.17.73.73 0 0 1-.237-.412.816.816 0 0 1 .12-.592.672.672 0 0 1 .24-.207.61.61 0 0 0 .284-.351.63.63 0 0 0-.03-.455.595.595 0 0 0-.296-.344.57.57 0 0 0-.446-.028.654.654 0 0 1-.463.013.838.838 0 0 1-.46-.567.803.803 0 0 1-.005-.326H2.737c1.265.698 2.47 2.101 2.5 3.964.032 2.019-1.007 3.649-2.536 4.423h3.08a.728.728 0 0 1-.034-.89Z',
        fill: '#3C9BD6',
      },
      {
        d: 'M9.6 5.356a.733.733 0 0 1 .174.883.745.745 0 0 1-.306.362.714.714 0 0 1-.456.098.542.542 0 0 0-.427.095.566.566 0 0 0-.228.383.623.623 0 0 0 .076.446c.08.133.207.23.354.269a.688.688 0 0 1 .368.26.72.72 0 0 1-.021.871.675.675 0 0 1-.387.238.593.593 0 0 0-.354.209.623.623 0 0 0 .035.824.59.59 0 0 0 .52.172.69.69 0 0 1 .454.1c.137.085.24.215.296.369a.821.821 0 0 1 .042.291.702.702 0 0 1-.28.56.627.627 0 0 0-.131.841c.081.13.194.234.328.303H13.3c-1.16-.59-2.236-1.7-2.5-3.28-.373-2.24.655-4.191 2.382-5.103H9.468a.611.611 0 0 0 .131.81Z',
        fill: '#E74F38',
      },
      {
        d: 'M10.649 13.053h-.107c.035.01.072.01.107 0Z',
        fill: '#3C9BD6',
      },
    ],
  },
  prestashop: {
    paths: [
      {
        d: 'M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Z',
        fill: '#A2DBEB',
      },
      {
        d: 'M12.578 13.296a7.014 7.014 0 0 1-1.675 1.075A6.972 6.972 0 0 1 8 15a6.971 6.971 0 0 1-4.578-1.704A6.245 6.245 0 0 1 8 11.306c1.807 0 3.435.766 4.578 1.99Z',
        fill: '#525353',
      },
      {
        d: 'M11.514 14.055A6.97 6.97 0 0 1 8 15a6.968 6.968 0 0 1-3.513-.945c.956-.887 2.18-1.419 3.513-1.419 1.334 0 2.557.532 3.514 1.42Z',
        fill: 'black',
      },
      {
        d: 'M6.46 11.508h-.793l-.63 1.973h.793l.63-1.973Z',
        fill: '#BFB098',
      },
      {
        d: 'M9.54 11.508h.793l.63 1.973h-.793l-.63-1.973Z',
        fill: '#BFB098',
      },
      {
        d: 'M12.934 8.047V8.1a4.909 4.909 0 0 1-.508 2.132 4.958 4.958 0 0 1-1.344 1.671 4.944 4.944 0 1 1 1.852-3.857Z',
        fill: '#525353',
      },
      {
        d: 'm11.173 11.773-.09.131a4.944 4.944 0 0 1-7.704-2.082 4.278 4.278 0 0 1 4.269-3.988c.695 0 1.366.256 1.993.655l.257.554.264.685 1.011 4.045Z',
        fill: 'white',
      },
      {
        d: 'M12.934 8.047V8.1a4.908 4.908 0 0 1-.508 2.131l-.747-.497-.977-1.634-.412-.688c.105-.829.759-1.599 1.412-1.599.035 0 .07.004.105.01.166.03.334.13.494.27.141.123.275.276.398.441.153.477.236.984.236 1.512Z',
        fill: 'white',
      },
      {
        d: 'M10.337 7.18s.105-1.855 1.108-1.984c1.004-.128 1.342 2.194 1.342 2.194l-2.45-.21Z',
        fill: 'black',
      },
      {
        d: 'M12.301 6.094v2.007h-1.6l-.41-.688c.104-.829.758-1.599 1.41-1.599.201 0 .406.111.6.28Z',
        fill: '#BCBEBF',
      },
      {
        d: 'M10.272 12.433c1.546-.215 3.079-1.843 3.079-1.843-.584-.82-1.696-2.52-3.087-3.65a6.892 6.892 0 0 0-.623-.451c-.01.444-.035 1.091-.095 1.612l-.006.047c-.08.655-.645 1.802-.934 2.457-.103.232-.17.403-.17.468 0 .248-.14 1.384 1.508 1.384l.063-.001c.088-.002.176-.01.265-.023Z',
        fill: '#F9B138',
      },
      {
        d: 'M9.641 6.489C8.774 4.776 7.188 4.873 6.5 5.126c-.922.339-1.645 1.214-1.587 2.007',
        fill: 'black',
      },
      {
        d: 'M8.327 5.914c.454.105.894.308 1.314.575a23.7 23.7 0 0 1-.029.777 13.67 13.67 0 0 1-.066.835H3.87a4.278 4.278 0 0 1 3.777-2.267c.23 0 .457.028.68.08Z',
        fill: '#BCBEBF',
      },
      {
        d: 'M8.902 10.901c-.684-.14-2.022-.964-2.022-.964s.933 1.26 2.193 1.618l-.17-.654Z',
        fill: 'black',
      },
      {
        d: 'm11.593 10.077-1.321 2.356-.265.023h-.063c-1.649 0-1.509-1.135-1.509-1.383 0-.065.068-.236.17-.468.266-.586 1.88-1.764 1.944-2.997.064-1.233 1.044 2.469 1.044 2.469Z',
        fill: 'black',
      },
      {
        d: 'M13.35 10.59v.001c-.047.05-1.556 1.63-3.078 1.842-.546-.419-.727-.818-.631-1.315.063-.325.244-.692.521-1.135.7-1.12.575-2.24.102-3.043 1.391 1.129 2.504 2.83 3.087 3.65Z',
        fill: '#E1006D',
      },
      {
        d: 'M13.35 10.59v.002c-.047.048-1.556 1.63-3.078 1.841-.546-.419-.727-.818-.631-1.315 2.419.351 3.677-.505 3.71-.527Z',
        fill: '#9D1D54',
      },
      {
        d: 'M9.641 6.489c-.004.222-.013.495-.029.777-.015.283-.036.575-.066.835H8.387l-.06-.668V5.914c.454.105.894.308 1.314.575Z',
        fill: '#E2DEDC',
      },
      {
        d: 'M12.935 8.047V8.1h-1.128V5.824c.167.03.334.13.494.27.141.123.276.276.398.441.153.477.236.984.236 1.512Z',
        fill: '#E2DEDC',
      },
      {
        d: 'm8.871 7.961-.56-1.758-.434 1.403-1.806.495 2.411.513.389-.653Z',
        fill: '#919494',
      },
      {
        d: 'M8.327 8.77a.669.669 0 1 0 0-1.338.669.669 0 0 0 0 1.338Z',
        fill: 'black',
      },
      {
        d: 'm12.301 6.818-.26 1.147.522.008-.262-1.155Z',
        fill: '#919494',
      },
      {
        d: 'M12.302 8.59c.15 0 .271-.22.271-.489 0-.27-.122-.488-.271-.488-.15 0-.272.218-.272.488s.121.488.272.488Z',
        fill: 'black',
      },
      {
        d: 'M12.302 8.038c.058 0 .105-.085.105-.19 0-.104-.047-.188-.105-.188-.059 0-.106.084-.106.189 0 .104.047.189.106.189Z',
        fill: 'white',
      },
      {
        d: 'M8.326 8.012a.237.237 0 1 0 0-.474.237.237 0 0 0 0 .474Z',
        fill: '#E2DEDC',
      },
      {
        d: 'M11.063 13.481v.815A6.969 6.969 0 0 1 8 15a6.968 6.968 0 0 1-3.064-.705v-.813h6.127Z',
        fill: '#BFB098',
      },
      {
        d: 'M11.063 13.481v.815A6.968 6.968 0 0 1 8 15v-1.519h3.063Z',
        fill: '#AA9676',
      },
      {
        d: 'M11.31 14.169c-.133.072-.269.14-.407.202l-.06-.763H5.157l-.06.763a6.869 6.869 0 0 1-.407-.202l.078-.888h6.464l.078.888Z',
        fill: '#8A7460',
      },
    ],
  },
  shopify: {
    paths: [
      {
        d: 'M12.49 3.75a.133.133 0 0 0-.12-.114l-1.096-.083-.806-.82c-.08-.082-.236-.057-.297-.039l-.406.129C9.522 2.108 9.093 1.45 8.34 1.45l-.064.002c-.214-.29-.48-.416-.71-.416-1.755 0-2.594 2.246-2.857 3.387l-1.23.39c-.38.122-.392.134-.442.502-.038.277-1.035 8.161-1.035 8.161l7.766 1.488 4.207-.93S12.498 3.818 12.49 3.748Zm-3.155-.792-.657.209v-.145c0-.445-.06-.802-.156-1.086.388.05.647.502.813 1.022ZM8.04 2.024c.108.277.178.674.178 1.21v.078l-1.357.43c.261-1.031.75-1.53 1.18-1.718Zm-.522-.505a.39.39 0 0 1 .226.078c-.563.27-1.166.953-1.421 2.316l-1.073.34c.298-1.04 1.007-2.734 2.268-2.734Z',
        fill: '#95BF46',
      },
      {
        d: 'M12.37 3.636a890.62 890.62 0 0 0-1.096-.083l-.807-.82a.197.197 0 0 0-.112-.053l-.587 12.285 4.207-.93S12.498 3.818 12.49 3.748a.133.133 0 0 0-.12-.113Z',
        fill: '#5E8E3E',
      },
      {
        d: 'm8.34 6.014-.52 1.579s-.454-.248-1.011-.248c-.817 0-.858.524-.858.656 0 .721 1.837.998 1.837 2.686 0 1.33-.824 2.185-1.934 2.185-1.333 0-2.015-.849-2.015-.849l.357-1.206s.7.615 1.292.615c.386 0 .543-.311.543-.538 0-.94-1.507-.983-1.507-2.528 0-1.3.913-2.56 2.755-2.56.71 0 1.06.208 1.06.208Z',
        fill: 'white',
      },
    ],
  },
  wordpress: {
    paths: [
      {
        d: 'M1.995 8a6.006 6.006 0 0 0 3.385 5.404L2.515 5.556A5.982 5.982 0 0 0 1.995 8Z',
        fill: '#464342',
      },
      {
        d: 'M12.054 7.697c0-.742-.267-1.256-.495-1.656-.305-.495-.59-.914-.59-1.408 0-.552.419-1.066 1.008-1.066.027 0 .052.003.078.005A5.983 5.983 0 0 0 8 1.995a5.998 5.998 0 0 0-5.017 2.707c.14.004.273.007.386.007.628 0 1.6-.076 1.6-.076.324-.02.362.456.039.494 0 0-.325.039-.687.058l2.186 6.504 1.315-3.941-.936-2.564c-.323-.019-.63-.057-.63-.057-.323-.019-.285-.514.038-.494 0 0 .992.076 1.582.076.628 0 1.6-.076 1.6-.076.324-.02.362.456.039.494 0 0-.326.038-.687.057l2.17 6.456.599-2.002c.26-.83.457-1.427.457-1.941Z',
        fill: '#464342',
      },
      {
        d: 'm8.105 8.525-1.801 5.236a6.003 6.003 0 0 0 3.69-.096.528.528 0 0 1-.043-.083L8.105 8.525Z',
        fill: '#464342',
      },
      {
        d: 'M13.27 5.119c.025.191.04.397.04.617 0 .61-.114 1.295-.457 2.151l-1.834 5.304a6.002 6.002 0 0 0 2.25-8.072Z',
        fill: '#464342',
      },
      {
        d: 'M8 1C4.14 1 1 4.14 1 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7Zm0 13.68A6.687 6.687 0 0 1 1.321 8a6.687 6.687 0 0 1 6.68-6.679A6.686 6.686 0 0 1 14.678 8 6.687 6.687 0 0 1 8 14.68Z',
        fill: '#464342',
      },
    ],
  },
  wix: {
    paths: [
      {
        d: 'M9.158 5.118c-.31.155-.443.443-.443 1.225 0 0 .154-.155.401-.247a1.64 1.64 0 0 0 .402-.221c.267-.201.308-.443.308-.865-.005 0-.427-.025-.668.108Z',
        fill: '#FBBD71',
      },
      {
        d: 'M7.27 5.299c-.268.221-.335.602-.335.602l-.864 3.313-.71-2.711c-.067-.288-.2-.643-.402-.89-.246-.314-.76-.335-.823-.335-.046 0-.555.021-.823.335-.2.247-.334.602-.401.89l-.669 2.711-.864-3.313s-.067-.355-.335-.602C.623 4.919 0 5.011 0 5.011l1.646 6.2s.535.046.803-.088c.355-.18.535-.309.736-1.158.2-.756.735-2.958.776-3.112.021-.067.067-.268.201-.268s.18.18.2.268c.047.154.577 2.356.778 3.112.22.844.375.978.735 1.158.268.134.803.087.803.087l1.636-6.2s-.623-.087-1.045.289Z',
        fill: 'black',
      },
      {
        d: 'M9.821 6.008s-.113.155-.334.288c-.155.088-.288.134-.443.222-.267.133-.334.267-.334.468v4.203s.422.046.69-.088c.354-.18.421-.354.421-1.11V6.007Z',
        fill: 'black',
      },
      {
        d: 'M13.911 8.123 16 5.03s-.864-.154-1.312.247c-.288.247-.576.71-.576.71l-.756 1.111c-.047.067-.088.113-.155.113s-.133-.067-.154-.113l-.756-1.111s-.31-.443-.577-.71c-.442-.401-1.312-.247-1.312-.247l2.022 3.087-2.068 3.086s.91.114 1.358-.288c.288-.247.556-.668.556-.668l.756-1.112c.047-.067.088-.113.155-.113s.133.067.154.113l.756 1.112s.288.421.556.668c.442.402 1.332.288 1.332.288l-2.068-3.081Z',
        fill: 'black',
      },
    ],
  },
  mixpanel: {
    paths: [
      {
        d: 'M2.888 10.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z',
        fill: '#A086D3',
      },
      {
        d: 'M9.013 10.25a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z',
        fill: '#A086D3',
      },
      {
        d: 'M14.013 9.75a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75Z',
        fill: '#A086D3',
      },
    ],
  },
  unbounce: {
    paths: [
      {
        d: 'M8 0c4.421 0 8 3.579 8 8 0 4.421-3.579 8-8 8-4.421 0-8-3.579-8-8 0-4.421 3.579-8 8-8Zm1.865 2.647a.763.763 0 0 0-.873.315A5.125 5.125 0 0 0 2.902 8a5.108 5.108 0 0 0 2.782 4.556c-.045.331.166.662.496.782a.68.68 0 0 0 .587-.045c.12-.06.21-.15.286-.27.03-.046.06-.09.075-.15l.586-1.73 2.045-5.82.587-1.729a.772.772 0 0 0-.075-.617.744.744 0 0 0-.406-.33Zm1.458 1.458-.707 2.136c.346.496.542 1.112.542 1.759a3.15 3.15 0 0 1-2.09 2.977l-.707 2.136A5.148 5.148 0 0 0 13.128 8a5.103 5.103 0 0 0-1.805-3.895ZM8 4.842c.09 0 .195 0 .286.015L6.3 10.662A3.188 3.188 0 0 1 4.842 8 3.157 3.157 0 0 1 8 4.842Z',
        fill: '#303030',
      },
    ],
  },
  unbounce_alt: {
    paths: [
      {
        d: 'M8 0c4.421 0 8 3.579 8 8 0 4.421-3.579 8-8 8-4.421 0-8-3.579-8-8 0-4.421 3.579-8 8-8Zm1.865 2.647a.763.763 0 0 0-.873.315A5.125 5.125 0 0 0 2.902 8a5.108 5.108 0 0 0 2.782 4.556c-.045.331.166.662.496.782a.68.68 0 0 0 .587-.045c.12-.06.21-.15.286-.27.03-.046.06-.09.075-.15l.586-1.73 2.045-5.82.587-1.729a.772.772 0 0 0-.075-.617.744.744 0 0 0-.406-.33Zm1.458 1.458-.707 2.136c.346.496.542 1.112.542 1.759a3.15 3.15 0 0 1-2.09 2.977l-.707 2.136A5.148 5.148 0 0 0 13.128 8a5.103 5.103 0 0 0-1.805-3.895ZM8 4.842c.09 0 .195 0 .286.015L6.3 10.662A3.188 3.188 0 0 1 4.842 8 3.157 3.157 0 0 1 8 4.842Z',
        fill: '#8D8D8D',
      },
    ],
  },
  bug_label: {
    paths: [
      {
        d: 'M15.556 9.333H.444a.444.444 0 1 1 0-.889h15.112a.444.444 0 1 1 0 .89Zm-9.857-.889h-.03c-.041-.004-4.096-.318-4.771-3.66a.444.444 0 1 1 .87-.176c.544 2.686 3.927 2.947 3.96 2.949a.445.445 0 0 1-.029.887Zm-4.366 5.334a.445.445 0 0 1-.402-.633c1.407-3.009 4.906-3.432 5.054-3.448a.446.446 0 0 1 .1.884c-.032.003-3.156.389-4.349 2.94a.446.446 0 0 1-.403.257Zm8.78-5.334a.444.444 0 0 1-.03-.888c.037-.002 3.608-.274 4.148-2.949a.444.444 0 1 1 .872.176c-.676 3.345-4.787 3.649-4.961 3.66l-.03.001Zm4.554 5.334a.445.445 0 0 1-.403-.256c-1.197-2.562-4.5-2.938-4.532-2.941a.444.444 0 1 1 .092-.884c.157.016 3.838.437 5.246 3.448a.445.445 0 0 1-.403.633Z',
        fill: '#31373D',
      },
      {
        d: 'M11.106 3.452c-.03-1.168-.567-1.874-1.375-2.24.03-.1.047-.209.047-.323C9.778.398 9.479 0 9.11 0c-.368 0-.666.398-.666.889v.019A5.62 5.62 0 0 0 8 .888c-.152 0-.3.008-.446.02l.002-.02c0-.49-.299-.888-.667-.888-.368 0-.667.398-.667.889 0 .114.018.222.047.323-.807.366-1.344 1.072-1.375 2.24-1.347.793-2.227 2.176-2.227 4.104 0 3.181 2.388 7.52 5.333 7.52 2.946 0 5.333-4.339 5.333-7.52 0-1.928-.88-3.312-2.227-4.104Z',
        fill: '#31373D',
      },
      {
        d: 'M7.112 15.537C4.25 15.273 2 12.473 2 9.057 2 5.641 4.25 4.265 7.111 4c.147-.013.445-.02.445 1.02v10.018c0 .52-.298.514-.444.5Zm1.776 0c2.86-.264 5.112-3.064 5.112-6.48C14 5.641 11.749 4.265 8.889 4c-.147-.013-.445-.02-.445 1.02v10.018c0 .52.298.514.444.5Z',
        fill: '#DD2E44',
      },
      {
        d: 'M5.778 7.555a.889.889 0 1 0 0-1.777.889.889 0 0 0 0 1.777Z',
        fill: '#31373D',
      },
      {
        d: 'M4.444 11.111a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667Z',
        fill: '#31373D',
      },
      {
        d: 'M5.778 13.778a.889.889 0 1 0 0-1.778.889.889 0 0 0 0 1.778Z',
        fill: '#31373D',
      },
      {
        d: 'M10.889 7.555a1.111 1.111 0 1 0 0-2.222 1.111 1.111 0 0 0 0 2.222Z',
        fill: '#31373D',
      },
      {
        d: 'M10 9.778a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334Z',
        fill: '#31373D',
      },
      {
        d: 'M12.444 11.111a.889.889 0 1 0 0-1.778.889.889 0 0 0 0 1.778Z',
        fill: '#31373D',
      },
      {
        d: 'M10.667 14.222a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667Z',
        fill: '#31373D',
      },
    ],
  },
  ui_ux_issue_label: {
    paths: [
      {
        d: 'M1.18 15.556c-.82 0-1.18-.595-.804-1.322L7.314.877c.377-.727.994-.727 1.372 0l6.937 13.358c.378.726.017 1.32-.802 1.32H1.179Z',
        fill: '#FFCC4D',
      },
      {
        d: 'M6.926 12.868a1.076 1.076 0 0 1 2.15 0 1.076 1.076 0 0 1-2.15 0Zm.082-8.13c0-.579.428-.937.992-.937.552 0 .993.372.993.937v5.305c0 .565-.441.937-.993.937-.564 0-.992-.358-.992-.937V4.738Z',
        fill: '#231F20',
      },
    ],
  },
  confusion_label: {
    paths: [
      {
        d: 'M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Z',
        fill: '#FFCC4D',
      },
      {
        d: 'M5.111 8.889c.614 0 1.111-.696 1.111-1.556 0-.859-.497-1.555-1.11-1.555C4.496 5.778 4 6.474 4 7.333c0 .86.497 1.556 1.111 1.556Z',
        fill: '#664500',
      },
      {
        d: 'M10.889 8.889c.614 0 1.111-.696 1.111-1.556 0-.859-.497-1.555-1.111-1.555s-1.111.696-1.111 1.555c0 .86.497 1.556 1.11 1.556Z',
        fill: '#664500',
      },
      {
        d: 'M5.333 12.444c.89-2.222 5.778-2.222 5.778-1.333 0 .444-3.556-.444-5.778 1.333Z',
        fill: '#664500',
      },
    ],
  },
  frustration_label: {
    paths: [
      {
        d: 'M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0Z',
        fill: '#F39C11',
      },
      {
        d: 'M11.326 13.28c-.02-.08-.519-1.947-3.326-1.947-2.808 0-3.307 1.867-3.327 1.947a.222.222 0 0 0 .106.246.225.225 0 0 0 .266-.034c.009-.009.869-.825 2.955-.825 2.086 0 2.947.816 2.954.824a.223.223 0 0 0 .266.036c.087-.05.131-.15.106-.247ZM6.981 7.686C5.534 6.239 3.209 6.222 3.11 6.222a.444.444 0 1 0 0 .89c.012 0 .855.009 1.77.327-.264.284-.437.726-.437 1.228 0 .86.498 1.555 1.111 1.555.614 0 1.112-.696 1.112-1.555 0-.078-.009-.152-.017-.226.006 0 .011.003.017.003a.443.443 0 0 0 .314-.758Zm5.908-1.464c-.098 0-2.423.017-3.87 1.464a.444.444 0 0 0 .314.758c.006 0 .01-.003.016-.003-.007.074-.016.148-.016.226 0 .86.498 1.555 1.111 1.555.614 0 1.111-.696 1.111-1.555 0-.502-.172-.944-.436-1.228a6.19 6.19 0 0 1 1.77-.328.445.445 0 0 0 0-.889Z',
        fill: '#292F33',
      },
    ],
  },
  success_label: {
    paths: [
      {
        d: 'M5.167 3.328a.628.628 0 0 0-.12.175L5.045 3.5.06 14.73l.005.004c-.092.18.063.544.38.861.316.317.68.472.86.38l.004.004 11.23-4.986-.004-.004a.614.614 0 0 0 .176-.12c.694-.694-.432-2.945-2.514-5.027-2.083-2.083-4.334-3.208-5.029-2.514Z',
        fill: '#DD2E44',
      },
      {
        d: 'M5.778 5.333.185 14.447l-.126.282.005.005c-.092.18.063.544.38.861.103.103.21.181.315.248l6.796-8.288-1.777-2.222Z',
        fill: '#EA596E',
      },
      {
        d: 'M10.227 5.807c2.076 2.077 3.229 4.29 2.573 4.944-.654.655-2.868-.497-4.944-2.572C5.78 6.102 4.628 3.888 5.282 3.233c.655-.654 2.869.498 4.945 2.574Z',
        fill: '#A0041E',
      },
      {
        d: 'M8.262 6.049a.44.44 0 0 1-.326.095c-.386-.042-.71-.176-.937-.388a.987.987 0 0 1-.327-.827c.057-.53.588-1.016 1.495-.919.352.038.51-.075.515-.13.006-.053-.123-.198-.476-.236-.386-.042-.71-.176-.938-.388a.986.986 0 0 1-.326-.827c.058-.53.589-1.016 1.494-.918.257.027.392-.026.45-.06.046-.028.064-.054.066-.07.005-.054-.123-.198-.476-.236A.444.444 0 1 1 8.572.26c.905.097 1.32.685 1.264 1.216-.058.53-.59 1.016-1.496.918-.256-.028-.39.026-.448.06-.046.027-.065.054-.067.07-.005.054.123.198.476.236.906.098 1.322.685 1.264 1.216-.057.53-.588 1.016-1.494.917-.257-.027-.392.026-.45.06-.046.028-.064.055-.065.07-.006.054.122.198.475.237a.444.444 0 0 1 .231.788Z',
        fill: '#AA8DD8',
      },
      {
        d: 'M13.627 10.159c.877-.248 1.482.143 1.626.657.144.513-.168 1.162-1.044 1.409-.343.096-.445.26-.432.311.016.053.19.139.53.042.877-.246 1.482.145 1.626.658.145.513-.168 1.161-1.045 1.409-.342.096-.445.26-.43.312.015.052.188.138.53.042a.445.445 0 1 1 .24.855c-.876.247-1.481-.143-1.626-.657-.144-.513.168-1.161 1.046-1.408.342-.097.444-.26.43-.312-.015-.052-.188-.14-.53-.043-.877.247-1.481-.143-1.626-.657-.144-.513.168-1.162 1.045-1.41.341-.095.444-.26.43-.31-.015-.053-.188-.14-.53-.044a.444.444 0 1 1-.24-.854Z',
        fill: '#77B255',
      },
      {
        d: 'M10.223 8.96a.445.445 0 0 1-.279-.791c.097-.078 2.408-1.893 5.675-1.426a.444.444 0 1 1-.126.88c-2.886-.41-4.972 1.223-4.993 1.24a.444.444 0 0 1-.277.097Z',
        fill: '#AA8DD8',
      },
      {
        d: 'M2.557 7.111a.444.444 0 0 1-.426-.572c.504-1.677.96-4.353.4-5.05-.063-.08-.158-.157-.375-.141-.416.032-.377.912-.376.92a.444.444 0 1 1-.887.067C.848 1.722 1.038.54 2.09.462c.47-.036.859.127 1.134.47 1.054 1.311-.016 5.113-.24 5.863a.445.445 0 0 1-.427.316Z',
        fill: '#77B255',
      },
      {
        d: 'M11.333 4.889a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333Z',
        fill: '#5C913B',
      },
      {
        d: 'M.889 8.889a.889.889 0 1 0 0-1.778.889.889 0 0 0 0 1.778Z',
        fill: '#9266CC',
      },
      {
        d: 'M14.444 9.333a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333Z',
        fill: '#5C913B',
      },
      {
        d: 'M10.444 14.667a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334Z',
        fill: '#5C913B',
      },
      {
        d: 'M12.445 2.667a.889.889 0 1 0 0-1.778.889.889 0 0 0 0 1.778Z',
        fill: '#FFCC4D',
      },
      {
        d: 'M14.444 4.444a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333Z',
        fill: '#FFCC4D',
      },
      {
        d: 'M13.111 6.222a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333Z',
        fill: '#FFCC4D',
      },
      {
        d: 'M3.333 11.111a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333Z',
        fill: '#FFCC4D',
      },
    ],
  },
  conversion_label: {
    paths: [
      {
        d: 'M2.277 2.222h2.667c.49 0 .834-.046.834.445v-.89c0-.49-.344-.888-.834-.888H1.388C.499.889-.204 1.833.055 3.11c0 0 .796 4.167.852 4.426.148.685.944 1.352 1.796 1.352h3.092c.491 0-.017-.843-.017-1.333v-.89c0 .491-.344.89-.834.89H3.166c-.49 0-.815-.464-.89-.89-.073-.425-.703-3.258-.703-3.258-.148-.852.213-1.186.704-1.186Zm11.472 0h-2.667c-.49 0-1.304-.046-1.304.445v-.89c0-.49.813-.888 1.304-.888h3.556c.889 0 1.593.944 1.333 2.222 0 0-.726 4.186-.787 4.445-.157.666-.908 1.333-1.778 1.333H10.23c-.49 0-.452-.843-.452-1.333v-.89c0 .491.813.89 1.304.89h1.778c.49 0 .815-.464.889-.89.074-.425.704-3.258.704-3.258.147-.852-.213-1.186-.704-1.186Zm-4.49 7.556c0-3.093-1.204 0-1.204 0s-1.334-3.093-1.334 0c0 3.092-1.462 4.444-1.462 4.444h5.463S9.259 12.87 9.259 9.778Z',
        fill: '#FFAC33',
      },
      {
        d: 'M12.944 2.923c0 3.011-3.01 8.085-4.89 8.085S3.167 5.934 3.167 2.923C3.166.614 3.61.115 4.499.115c.61 0 2.678-.012 3.556-.012h3.11c1.297-.001 1.779.303 1.779 2.82Z',
        fill: '#FFCC4D',
      },
      {
        d: 'M12 14.667c0 .49.1.889-.39.889H4.5c-.492 0-.5-.399-.5-.89v-.444c0-.49.517-.889.98-.889h6.186c.463 0 .834.399.834.89v.444Z',
        fill: '#C1694F',
      },
      {
        d: 'M12.889 15.389c0 .338.073.611-.557.611H3.777c-.574 0-.666-.273-.666-.611v-.111c0-.338.328-.611.666-.611h8.555c.338 0 .557.273.557.61v.112Z',
        fill: '#C1694F',
      },
    ],
  },
};
